var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// src/components/tracker/tracker.ts
var Tracker = class _Tracker {
  constructor() {
    this.mixpanel = window.mixpanel;
    this.debug = localStorage.getItem("debug") === "true" || window.debug_9am;
    this.setupComplete = false;
    this.isWebsite = () => {
      const domain = window.location.hostname;
      return domain === "join9am.com" || domain === "www.join9am.com";
    };
    this.lastPageViewTracked = "";
    this.trackPageView = () => {
      var _a2, _b, _c, _d, _e, _f;
      if (this.lastPageViewTracked === window.location.href) return;
      this.lastPageViewTracked = window.location.href;
      if (!this.mixpanel) {
        console.warn("Mixpanel is not loaded");
        return;
      }
      if (!window.initTracked && this.isWebsite()) {
        const h1OnPage = (_c = (_b = (_a2 = document.querySelector("h1")) == null ? void 0 : _a2.textContent) == null ? void 0 : _b.trim()) != null ? _c : "";
        const footerTitle = (_f = (_e = (_d = document.querySelector("footer h4")) == null ? void 0 : _d.textContent) == null ? void 0 : _e.trim()) != null ? _f : "";
        this.mixpanelTrack("Page View", {
          Title: document.title,
          "H1 on Page": h1OnPage,
          "Footer Title": footerTitle
        });
        window.initTracked = true;
      }
    };
    this.utmSetupComplete = false;
    if (this.mixpanel && window.MIXPANEL_TOKEN) {
      this.mixpanel.init(window.MIXPANEL_TOKEN, {
        debug: this.debug,
        verbose: this.debug,
        cross_subdomain_cookie: true,
        cross_site_cookie: true
      });
    } else if (!this.mixpanel) {
      console.warn("WCL - Mixpanel is not loaded");
    } else if (!window.MIXPANEL_TOKEN) {
      console.warn("WCL - MIXPANEL_TOKEN is not set");
    }
    this.setup();
  }
  track(event, eventProperties) {
    var _a2;
    if (!this.isWebsite()) return;
    if (!this.mixpanel) {
      console.warn("Mixpanel is not loaded");
      return;
    }
    const props = __spreadValues(__spreadValues({}, (_a2 = window.TRACK_DATA) != null ? _a2 : {}), eventProperties != null ? eventProperties : {});
    if (this.debug) {
      console.log("track", {
        event,
        props
      });
    }
    this.mixpanelTrack(event, props);
    try {
      this.trackGoogle(event);
    } catch (error) {
      console.error("Error tracking with Google Analytics", error);
    }
  }
  trackGoogle(event) {
    if (typeof window !== "undefined" && typeof window.dataLayer !== "undefined") {
      window.dataLayer.push({ event });
    }
  }
  setup() {
    if (this.setupComplete) return;
    this.setupComplete = true;
    this.setupUTM();
    window.addEventListener("load", this.trackPageView);
  }
  static getQueryParam(url, param) {
    var _a2;
    const re = new RegExp(`(\\?|&)${param}=([^&]*)`);
    const match = re.exec(url);
    return (_a2 = match == null ? void 0 : match[2]) != null ? _a2 : "";
  }
  setupUTM() {
    var _a2, _b;
    if (this.utmSetupComplete) return;
    this.utmSetupComplete = true;
    const campaignKeywords = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
    const utmParams = {};
    const firstTouch = {};
    const location = window.location.href;
    for (const key of campaignKeywords) {
      const value = _Tracker.getQueryParam(location, key);
      if (value) {
        utmParams[`${key} [last touch]`] = value;
        firstTouch[`${key} [first touch]`] = value;
      }
    }
    if (!this.mixpanel) {
      console.warn("Mixpanel is not loaded");
      return;
    }
    (_a2 = this.mixpanel.people) == null ? void 0 : _a2.set_once(firstTouch);
    (_b = this.mixpanel.people) == null ? void 0 : _b.set(utmParams);
  }
  get cachedTrackingId() {
    var _a2;
    return (_a2 = sessionStorage.getItem("9am.analyticsToken")) != null ? _a2 : "";
  }
  set cachedTrackingId(value) {
    sessionStorage.setItem("9am.analyticsToken", value);
  }
  alias(analyticsToken) {
    if (analyticsToken && analyticsToken !== this.cachedTrackingId) {
      if (!this.mixpanel) {
        console.warn("Mixpanel is not loaded");
        return;
      }
      try {
        this.mixpanel.identify();
        this.mixpanel.alias(analyticsToken);
      } catch (error) {
        console.error("Error aliasing with Mixpanel", error);
      }
      this.cachedTrackingId = analyticsToken;
    }
    if (typeof window !== "undefined" && typeof window._hsq !== "undefined") {
      window._hsq.push(["identify", { token: analyticsToken }]);
    }
  }
  mixpanelTrack(event, eventProperties) {
    if (!this.mixpanel) {
      console.warn("Mixpanel is not loaded");
      return;
    }
    try {
      this.mixpanel.track(event, eventProperties);
    } catch (error) {
      console.error("Error tracking with Mixpanel", error);
    }
  }
};
var tracker = new Tracker();
window.tracker = tracker;
var tracker_default = tracker;

// src/components/actionButton/actionButton.component.ts
import { html as html2, nothing, unsafeCSS } from "lit";
import { property as property2, queryAssignedNodes } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";

// src/constants/icons.ts
import { html } from "lit";
var UploadPictureIcon = html`
  <svg
    width="1000"
    height="1000"
    viewBox="0 0 1000 1000"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M637.5 663.542v5.208h-275v-5.208c0-23.611 11.979-41.493 35.938-53.646 23.958-12.153 57.812-18.229 101.562-18.229s77.604 6.076 101.562 18.229c23.959 12.153 35.938 30.035 35.938 53.646Zm-95.312-169.271c-11.459 11.458-25.521 17.187-42.188 17.187s-30.729-5.729-42.187-17.187c-11.459-11.458-17.188-25.521-17.188-42.188 0-16.666 5.729-30.729 17.188-42.187 11.458-11.458 25.52-17.188 42.187-17.188 16.667 0 30.729 5.73 42.188 17.188 11.458 11.458 17.187 25.521 17.187 42.187 0 16.667-5.729 30.73-17.187 42.188ZM141.667 816.667c11.111 11.111 24.652 16.666 40.625 16.666h635.416c15.973 0 29.514-5.555 40.625-16.666S875 792.014 875 776.042V311.458c0-15.972-5.556-29.687-16.667-41.145-11.111-11.459-24.652-17.188-40.625-17.188H684.375l-77.083-86.458H392.708l-77.083 86.458H182.292c-15.973 0-29.514 5.729-40.625 17.188C130.556 281.771 125 295.486 125 311.458v464.584c0 15.972 5.556 29.514 16.667 40.625ZM779.2 285.417H669.792l-77.084-86.459H407.292l-77.084 86.459H182.292c-6.945 0-12.848 2.604-17.709 7.812-4.861 5.209-7.291 11.285-7.291 18.229v464.584c0 6.944 2.43 12.847 7.291 17.708 4.861 4.861 10.764 7.292 17.709 7.292h360.949C712.221 671.631 768.417 356.854 779.2 285.417Z"
      fill="#212121"
    />
  </svg>
`;
var UploadIDIcon = html`
  <svg
    width="1000"
    height="1000"
    viewBox="0 0 1000 1000"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M783.333 104.167H937.5v155.208h-32.292V136.458H783.333v-32.291Zm0 759.375h121.875V741.667H937.5v154.166H783.333v-32.291ZM62.5 104.167h155.208v32.291H94.792v122.917H62.5V104.167Zm0 637.5h32.292v121.875h122.916v32.291H62.5V741.667Z"
      fill="#212121"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M183.786 724.292c9.805 9.805 21.755 14.708 35.85 14.708h560.729c14.095 0 26.045-4.903 35.85-14.708s14.708-21.755 14.708-35.85V311.558c0-14.094-4.903-26.044-14.708-35.849-9.805-9.806-21.755-14.708-35.85-14.708H219.636c-14.095 0-26.045 4.902-35.85 14.708-9.805 9.805-14.708 21.755-14.708 35.849v376.884c0 14.095 4.903 26.045 14.708 35.85Zm391.476-13.788H219.636c-6.128 0-11.337-2.145-15.627-6.435-4.29-4.29-6.435-9.499-6.435-15.627V311.558c0-6.128 2.145-11.337 6.435-15.626 4.29-4.29 9.499-6.435 15.627-6.435h533.053c-3.126 21.904-12.008 77.071-30.133 142.48H576.297v28.496h137.945c-5.627 18.334-11.965 37.177-19.083 56.073H576.297v28.497h107.522c-26.337 62.644-61.68 123.364-108.557 165.461Zm-90.888-105.712H287.659v-3.677c0-8.579 2.145-16.392 6.434-23.44 4.29-7.047 10.418-12.103 18.385-15.167 13.482-4.903 26.504-8.58 39.067-11.031 12.563-2.451 24.36-3.677 35.39-3.677 11.031 0 22.215 1.073 33.552 3.217 11.337 2.145 24.666 5.976 39.987 11.491 7.354 3.064 13.175 8.12 17.465 15.167 4.29 7.048 6.435 14.861 6.435 23.44v3.677Zm-68.023-100.655c-7.967 8.273-17.772 12.409-29.416 12.409-11.03 0-20.682-4.136-28.955-12.409s-12.41-17.619-12.41-28.037c0-11.643 4.137-21.601 12.41-29.875 8.273-8.273 17.925-12.409 28.955-12.409 11.644 0 21.449 4.136 29.416 12.409 7.966 8.274 11.95 17.925 11.95 28.956 0 11.031-3.984 20.683-11.95 28.956Z"
      fill="#212121"
    />
  </svg>
`;
var LockIcon = html`
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.11321 21.125C6.64654 21.125 6.24654 20.9583 5.91321 20.625C5.57987 20.2917 5.41321 19.8917 5.41321 19.425V10.15C5.41321 9.66667 5.57987 9.2625 5.91321 8.9375C6.24654 8.6125 6.64654 8.45 7.11321 8.45H8.56321V6.25C8.56321 5.06667 8.97154 4.0625 9.78821 3.2375C10.6049 2.4125 11.6049 2 12.7882 2C13.9715 2 14.9715 2.4125 15.7882 3.2375C16.6049 4.0625 17.0132 5.06667 17.0132 6.25V8.45H18.4632C18.9299 8.45 19.3299 8.6125 19.6632 8.9375C19.9965 9.2625 20.1632 9.66667 20.1632 10.15V19.425C20.1632 19.8917 19.9965 20.2917 19.6632 20.625C19.3299 20.9583 18.9299 21.125 18.4632 21.125H7.11321ZM7.11321 20.025H18.4632C18.6299 20.025 18.7715 19.9667 18.8882 19.85C19.0049 19.7333 19.0632 19.5917 19.0632 19.425V10.15C19.0632 9.98333 19.0049 9.84167 18.8882 9.725C18.7715 9.60833 18.6299 9.55 18.4632 9.55H7.11321C6.94654 9.55 6.80487 9.60833 6.68821 9.725C6.57154 9.84167 6.51321 9.98333 6.51321 10.15V19.425C6.51321 19.5917 6.57154 19.7333 6.68821 19.85C6.80487 19.9667 6.94654 20.025 7.11321 20.025ZM12.7882 16.45C13.2382 16.45 13.6257 16.2917 13.9507 15.975C14.2757 15.6583 14.4382 15.275 14.4382 14.825C14.4382 14.3917 14.2757 14.0083 13.9507 13.675C13.6257 13.3417 13.2382 13.175 12.7882 13.175C12.3382 13.175 11.9507 13.3417 11.6257 13.675C11.3007 14.0083 11.1382 14.4 11.1382 14.85C11.1382 15.2833 11.3007 15.6583 11.6257 15.975C11.9507 16.2917 12.3382 16.45 12.7882 16.45ZM9.63821 8.45H15.9382V6.25C15.9382 5.36667 15.6299 4.62083 15.0132 4.0125C14.3965 3.40417 13.6549 3.1 12.7882 3.1C11.9215 3.1 11.1799 3.40417 10.5632 4.0125C9.94654 4.62083 9.63821 5.36667 9.63821 6.25V8.45ZM6.51321 20.025V9.55V20.025Z"
      fill="#212121"
    />
  </svg>
`;
var CheckSmallWhiteIcon = html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 4.58509L5.90746 12L2 8.41973L2.64052 7.83464L5.90746 10.828L13.3595 4L14 4.58509Z"
      fill="#fff"
    />
  </svg>
`;
var CheckSmallIcon = html`<svg
  width="16"
  height="16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 4.585 5.907 12 2 8.42l.64-.585 3.267 2.993L13.36 4l.64.585Z"
    fill="#212121"
  />
</svg>`;
var CaretDownIcon = html`<svg
  width="24"
  height="24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="m12 10.36-5.29 4.7-.66-.75 5.94-5.29 5.95 5.29-.67.74L12 10.36Z"
    fill="#212121"
  />
</svg>`;
var EyeIcon = html`<svg
  width="25"
  height="24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.771 15.725a3.69 3.69 0 0 0 2.725-1.137c.75-.759 1.125-1.663 1.125-2.713a3.69 3.69 0 0 0-1.137-2.725c-.759-.75-1.663-1.125-2.713-1.125-1.067 0-1.975.38-2.725 1.137-.75.759-1.125 1.663-1.125 2.713A3.69 3.69 0 0 0 10.06 14.6c.758.75 1.662 1.125 2.712 1.125Zm0-1.075c-.767 0-1.42-.275-1.962-.825-.542-.55-.813-1.2-.813-1.95 0-.767.275-1.42.825-1.963.55-.541 1.2-.812 1.95-.812.767 0 1.421.275 1.963.825.541.55.812 1.2.812 1.95 0 .767-.275 1.42-.825 1.963-.55.541-1.2.812-1.95.812Zm0 4.1c-2.25 0-4.308-.625-6.175-1.875s-3.267-2.917-4.2-5c.933-2.083 2.333-3.75 4.2-5A10.863 10.863 0 0 1 12.771 5c2.25 0 4.308.625 6.175 1.875s3.267 2.917 4.2 5c-.933 2.083-2.333 3.75-4.2 5a10.863 10.863 0 0 1-6.175 1.875Zm0-1.1c1.983 0 3.792-.517 5.425-1.55s2.892-2.442 3.775-4.225c-.883-1.783-2.142-3.192-3.775-4.225-1.633-1.033-3.442-1.55-5.425-1.55-1.983 0-3.796.517-5.437 1.55-1.642 1.033-2.896 2.442-3.763 4.225.867 1.783 2.121 3.192 3.763 4.225 1.641 1.033 3.454 1.55 5.437 1.55Z"
    fill="#212121"
  />
</svg>`;
var EyeClosedIcon = html`<svg
  width="25"
  height="24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="m16.296 12.925-.825-.85c.25-1.1-.02-1.987-.812-2.662-.792-.675-1.63-.896-2.513-.663l-.85-.825c.167-.083.384-.158.65-.225.267-.067.542-.1.825-.1 1.067 0 1.975.375 2.725 1.125s1.125 1.658 1.125 2.725c0 .283-.029.558-.087.825a2.17 2.17 0 0 1-.238.65Zm3.225 3.175-.775-.75a12.372 12.372 0 0 0 1.913-1.813 8.328 8.328 0 0 0 1.312-2.087c-.85-1.783-2.091-3.192-3.725-4.225a9.855 9.855 0 0 0-5.375-1.55c-.566 0-1.154.05-1.762.15A8.84 8.84 0 0 0 9.57 6.2l-.85-.875c.55-.217 1.196-.396 1.938-.538.741-.141 1.47-.212 2.187-.212 2.2 0 4.246.62 6.138 1.862 1.891 1.242 3.279 2.913 4.162 5.013a10.65 10.65 0 0 1-1.487 2.525A13.223 13.223 0 0 1 19.52 16.1Zm1.35 5.45-4.05-4.025c-.433.217-1.008.404-1.725.563-.716.158-1.492.237-2.325.237-2.25 0-4.317-.62-6.2-1.863-1.883-1.241-3.275-2.912-4.175-5.012.367-.9.875-1.75 1.525-2.55.65-.8 1.375-1.517 2.175-2.15L3.071 3.775 3.846 3l17.75 17.75-.725.8Zm-14-13.975c-.6.433-1.225 1.004-1.875 1.712-.65.709-1.125 1.43-1.425 2.163.85 1.783 2.1 3.192 3.75 4.225 1.65 1.033 3.492 1.55 5.525 1.55.633 0 1.263-.058 1.888-.175.625-.117 1.046-.233 1.262-.35l-1.7-1.725a5.859 5.859 0 0 1-.687.213c-.292.074-.571.112-.838.112-1.067 0-1.975-.37-2.725-1.113-.75-.741-1.125-1.654-1.125-2.737 0-.233.038-.496.113-.787.075-.292.145-.538.212-.738l-2.375-2.35Z"
    fill="#212121"
  />
</svg>`;
var ErrorIcon = html`<svg
  width="24"
  height="24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0 .96a10.96 10.96 0 1 0 0-21.92 10.96 10.96 0 0 0 0 21.92Z"
    fill="#BF1902"
  />
  <path
    d="M11.59 14.07h.92l.42-4.2V6.69h-1.76v3.2l.42 4.19Zm-.52 3.21h1.96v-1.95h-1.96v1.95Z"
    fill="#BF1902"
  />
</svg>`;
var BulletIcon = html`<svg
  width="16"
  height="16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="8" cy="8" r="2" fill="#212121" />
</svg>`;
var BulletErrorIcon = html`<svg
  width="16"
  height="16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="8" cy="8" r="2" fill="#BF1902" />
</svg>`;
var PlusIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
>
  <path
    fill="currentColor"
    fill-opacity=".8"
    d="M13.742 6.497H7.594V.347H6.496v6.15H.348v1.097h6.148v6.148h1.098V7.594h6.148V6.497Z"
  />
</svg>`;

// src/internal/nine-element.ts
import { LitElement } from "lit";
import { property } from "lit/decorators.js";
var NineElement = class extends LitElement {
  constructor() {
    super();
    this.dir = "ltr";
    this.lang = "en";
    Object.entries(this.constructor.dependencies).forEach(([name, component]) => {
      this.constructor.define(name, component);
    });
  }
  emit(name, options) {
    const event = new CustomEvent(name, __spreadValues({
      bubbles: true,
      cancelable: false,
      composed: true,
      detail: {}
    }, options));
    this.dispatchEvent(event);
    return event;
  }
  get isReactElement() {
    return Object.keys(this).some((key) => key.startsWith("__react"));
  }
  /* eslint-enable */
  static define(name, elementConstructor = this, options = {}) {
    const currentlyRegisteredConstructor = customElements.get(name);
    if (!currentlyRegisteredConstructor) {
      customElements.define(name, class extends elementConstructor {
      }, options);
      return;
    }
    let newVersion = " (unknown version)";
    let existingVersion = newVersion;
    if ("version" in elementConstructor && elementConstructor.version) {
      newVersion = " v" + elementConstructor.version;
    }
    if ("version" in currentlyRegisteredConstructor && currentlyRegisteredConstructor.version) {
      existingVersion = " v" + currentlyRegisteredConstructor.version;
    }
    if (newVersion && existingVersion && newVersion === existingVersion) {
      return;
    }
    console.warn(
      `Attempted to register <${name}>${newVersion}, but <${name}>${existingVersion} has already been registered.`
    );
  }
};
/* eslint-disable */
// @ts-ignore
NineElement.version = true ? "2.0.34-localdev-1725354404084" : "dev";
NineElement.dependencies = {};
__decorateClass([
  property()
], NineElement.prototype, "dir", 2);
__decorateClass([
  property()
], NineElement.prototype, "lang", 2);

// src/lib/animator.ts
var loadPlayer = () => {
  let tries = 0;
  const attemptLoad = () => {
    return new Promise((resolve, reject) => {
      if (tries > 100) {
        return reject(new Error("Lottie player not found"));
      }
      tries += 1;
      setTimeout(
        () => {
          const player = window.lottiePlayer;
          if (player) {
            return resolve(player);
          }
          return attemptLoad().then(resolve).catch(reject);
        },
        // increase timeout slowly to allow for slower connections
        tries === 1 ? 0 : 0.2 * tries
      );
    });
  };
  return attemptLoad();
};
var animator = () => {
  return loadPlayer();
};
var animator_default = animator;

// src/components/actionButton/actionButton.scss?inline
import { css } from "lit-element/lit-element.js";
var actionButton_default = css`:host {
  --size: 3.4em;
  display: inline-block;
}

.custom-trigger {
  display: block;
  border: none;
  position: relative;
  padding: 0;
  margin: 0;
  background: none;
}

.trigger {
  display: block;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  border: 1px solid var(--color-charcoal-80);
  position: relative;
  padding: 0;
  margin: 0;
  color: var(--color-charcoal-80);
  transition: all 0.22s ease-out;
  cursor: pointer;
  background: transparent;
}
.trigger svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1.3em;
  height: auto;
}
.trigger:hover {
  background: var(--color-charcoal);
  border-color: var(--color-charcoal);
  color: var(--color-white);
}

.options {
  padding: var(--options-padding, 1.2em) 0;
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  grid-gap: var(--options-gap, 0.7em);
  transition: all 0.22s ease-out;
  transform: scale(1);
  align-items: flex-start;
}
.options[aria-hidden=true] {
  pointer-events: none;
  opacity: 0;
  transform: scale(0.95);
}
.options[align=right] {
  align-items: flex-end;
  right: 0;
}
.options[side=top] {
  top: auto;
  bottom: 100%;
}

.wrap {
  position: relative;
}
.wrap[aria-expanded=true] .trigger {
  border-color: var(--color-charcoal);
  background-color: var(--color-charcoal);
  color: var(--color-white);
  transform: rotate(45deg);
}

.pulse {
  --size: 128px;
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(-32.3%, -32.2%);
  width: var(--size);
  height: var(--size);
  z-index: 0;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.22s ease-out;
}
.pulse[active=true] {
  opacity: 1;
}

:host([no-backdrop=true]) .backdrop {
  display: none;
}`;

// src/components/actionButton/actionButton.component.ts
var NineActionButton = class extends NineElement {
  constructor() {
    super(...arguments);
    this.open = false;
    this.pulse = false;
    this.side = "bottom";
    this.align = "left";
    this.animationPath = "";
    this.customTrigger = false;
    this.noBackdrop = false;
    this.animationTargetRef = createRef();
    this.setOpen = (open) => {
      this.open = open;
    };
    this.startPulse = () => {
      if (this.pulse) return;
      this.pulse = true;
      setTimeout(() => {
        this.pulse = false;
      }, 6e3);
    };
    this.handleBlur = () => {
      setTimeout(() => {
        if (this.open) {
          this.handleTriggerClick();
        }
      }, 600);
    };
  }
  firstUpdated() {
    const container = this.animationTargetRef.value;
    if (this.animationPath && container) {
      animator_default().then((anim) => {
        this.pulseAnimation = anim.loadAnimation({
          container,
          path: this.animationPath
        });
      });
    }
    setTimeout(() => {
      if (this._triggerNodes.length) {
        this.customTrigger = true;
        this._triggerNodes[0].addEventListener("blur", this.handleBlur);
      }
    }, 0);
  }
  disconnectedCallback() {
    if (this._triggerNodes.length) {
      this._triggerNodes[0].removeEventListener("blur", this.handleBlur);
    }
  }
  updated(_changedProperties) {
    var _a2, _b;
    if (_changedProperties.has("pulse")) {
      if (this.pulse) {
        (_a2 = this.pulseAnimation) == null ? void 0 : _a2.play();
      } else {
        (_b = this.pulseAnimation) == null ? void 0 : _b.stop();
      }
    }
  }
  handleTriggerClick() {
    this.open = !this.open;
    this.dispatchEvent(
      new CustomEvent("nine-action-button:toggle", {
        detail: {
          open: this.open
        }
      })
    );
    this.pulse = false;
  }
  get getTriggerLabel() {
    return this.open ? "Close Actions" : "Open Actions";
  }
  render() {
    return html2`
      <div class="wrap" aria-expanded="${this.open}">
        <div active="${this.pulse}" class="pulse" ${ref(this.animationTargetRef)}></div>
        <div class="options" aria-hidden="${!this.open}" side="${this.side}" align="${this.align}">
          <slot></slot>
        </div>
        <button
          class="${this.customTrigger ? "custom-trigger" : "trigger"}"
          @click="${this.handleTriggerClick}"
          @blur="${this.handleBlur}"
          aria-label="${this.getTriggerLabel}"
        >
          <slot name="trigger"></slot>
          ${this.customTrigger ? nothing : html2`<div class="plus">${PlusIcon}</div>`}
        </button>
      </div>
    `;
  }
};
NineActionButton.styles = unsafeCSS(actionButton_default);
__decorateClass([
  property2({ type: Boolean, reflect: true })
], NineActionButton.prototype, "open", 2);
__decorateClass([
  property2({ type: Boolean, reflect: true })
], NineActionButton.prototype, "pulse", 2);
__decorateClass([
  property2({ type: String })
], NineActionButton.prototype, "side", 2);
__decorateClass([
  property2({ type: String })
], NineActionButton.prototype, "align", 2);
__decorateClass([
  property2({ type: String, attribute: "animation-path" })
], NineActionButton.prototype, "animationPath", 2);
__decorateClass([
  property2({ type: Boolean, reflect: false })
], NineActionButton.prototype, "customTrigger", 2);
__decorateClass([
  property2({ type: Boolean, attribute: "no-backdrop" })
], NineActionButton.prototype, "noBackdrop", 2);
__decorateClass([
  queryAssignedNodes({ slot: "trigger", flatten: true })
], NineActionButton.prototype, "_triggerNodes", 2);

// src/components/actionButton/actionButton.ts
var actionButton_default2 = NineActionButton;
NineActionButton.define("nine-action-button");

// src/components/actions/actions.component.ts
import { css as css2, html as html3 } from "lit";
var NineActions = class extends NineElement {
  render() {
    return html3`<slot></slot>`;
  }
};
NineActions.styles = css2`
    :host {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: var(--actions-mt, var(--space-sm));
      width: 100%;
    }
  `;

// src/components/actions/actions.ts
var actions_default = NineActions;
NineActions.define("nine-actions");

// src/components/additional-benefits/additional-benefits.component.ts
import { css as css3, html as html4 } from "lit";

// src/constants/layout.ts
var LAYOUT_SWITCH_AT = 960;

// src/components/additional-benefits/additional-benefits.component.ts
var NineAdditionalBenefits = class extends NineElement {
  render() {
    return html4`
      <section>
        <div class="center">
          <div class="flex">
            <slot></slot>
          </div>
        </div>
      </section>
    `;
  }
};
NineAdditionalBenefits.styles = css3`
    :host {
      display: block;
      margin: var(--section-gap-sm) 0;
    }

    .center {
      max-width: var(--page-max-width-narrow);
      margin: 0 auto;
      padding: 0 var(--space-md);
    }

    .flex {
      display: flex;
      flex-direction: column;
      padding: 0 calc(var(--space-sm) * 0.75);
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      .flex {
        flex-direction: row;
        grid-gap: var(--space-lg);
        justify-content: center;
        align-items: center;
      }
    }
  `;

// src/components/additional-benefits/additional-benefits.ts
var additional_benefits_default = NineAdditionalBenefits;
NineAdditionalBenefits.define("nine-additional-benefits");

// src/components/answer-item/answer-item-list.component.ts
import { html as html5, unsafeCSS as unsafeCSS2 } from "lit";
import { property as property3 } from "lit/decorators.js";

// src/components/answer-item/answer-item-list.scss?inline
import { css as css4 } from "lit-element/lit-element.js";
var answer_item_list_default = css4`:host {
  display: block;
  width: 100%;
}

.main {
  display: flex;
  width: 100%;
  position: relative;
  z-index: 1;
  flex-direction: column;
  grid-gap: var(--list-gap-m, 1em);
}

:host([direction=horizontal]) .main {
  flex-direction: row;
}

@media (min-width: 768px) {
  .main {
    grid-gap: var(--list-gap-dk, 1.3em);
  }
}

.main[condensed] {
  grid-gap: var(--list-gap-condensed, 0.2em);
  --option-p: 0.6em var(--space-sm);
  --option-mh: 3em;
  --option-br: 0.5em;
}

.labels {
  display: flex;
  flex-direction: row;
  gap: var(--space-sm);
  width: 100%;
  justify-content: space-between;
  padding: var(--space-sm) 0 0;
}

.label {
  font-weight: 500;
  font-size: calc(var(--scale) * 0.8);
  line-height: 140%;
  color: var(--color-charcoal-80);
  text-align: center;
}`;

// src/components/answer-item/answer-item-list.component.ts
var NineAnswerItemList = class extends NineElement {
  constructor() {
    super(...arguments);
    this.direction = "vertical";
    this.condensed = false;
    this.startLabel = "";
    this.endLabel = "";
  }
  renderLabels() {
    if (this.startLabel || this.endLabel) {
      return html5`<div class="labels">
        ${this.startLabel ? html5`<div class="label label-start">${this.startLabel}</div>` : ""}
        ${this.endLabel ? html5`<div class="label label-end">${this.endLabel}</div>` : ""}
      </div>`;
    }
    return "";
  }
  render() {
    return html5`<div class="main" ?condensed=${this.condensed}>
        <slot></slot>
      </div>
      ${this.renderLabels()} `;
  }
};
NineAnswerItemList.styles = unsafeCSS2(answer_item_list_default);
__decorateClass([
  property3({ type: String })
], NineAnswerItemList.prototype, "direction", 2);
__decorateClass([
  property3({ type: Boolean, reflect: true })
], NineAnswerItemList.prototype, "condensed", 2);
__decorateClass([
  property3({ type: String, attribute: "start-label" })
], NineAnswerItemList.prototype, "startLabel", 2);
__decorateClass([
  property3({ type: String, attribute: "end-label" })
], NineAnswerItemList.prototype, "endLabel", 2);

// src/components/answer-item/answer-item-list.ts
var answer_item_list_default2 = NineAnswerItemList;
NineAnswerItemList.define("nine-answer-item-list");

// src/components/answer-item/answer-item.component.ts
import { html as html7, unsafeCSS as unsafeCSS4 } from "lit";
import { property as property5 } from "lit/decorators.js";
import { createRef as createRef3, ref as ref3 } from "lit/directives/ref.js";

// src/components/input/defaultErrorMessages.ts
var defaultErrorMessages = {
  required: ({ label }) => {
    var _a2, _b;
    return ((_b = (_a2 = window.nineConfig) == null ? void 0 : _a2.language) == null ? void 0 : _b.slice(0, 2)) === "es" ? `${label != null ? label : "Campo"} es necesario` : `${label != null ? label : "Field"} is required`;
  },
  invalid: ({ label }) => {
    var _a2, _b;
    return ((_b = (_a2 = window.nineConfig) == null ? void 0 : _a2.language) == null ? void 0 : _b.slice(0, 2)) === "es" ? `${label != null ? label : "Campo"} no es v\xE1lido` : `${label != null ? label : "Field"} is invalid`;
  },
  file_type_invalid: ({ context }) => {
    var _a2, _b;
    return ((_b = (_a2 = window.nineConfig) == null ? void 0 : _a2.language) == null ? void 0 : _b.slice(0, 2)) === "es" ? `S\xF3lo se admiten archivos de ${context}` : `Only ${context} files are allowed`;
  },
  incomplete: ({ label }) => {
    var _a2, _b;
    return ((_b = (_a2 = window.nineConfig) == null ? void 0 : _a2.language) == null ? void 0 : _b.slice(0, 2)) === "es" ? `${label != null ? label : "Campo"} no es v\xE1lido` : `${label != null ? label : "Field"} is invalid`;
  },
  out_of_range: () => {
    var _a2, _b;
    return ((_b = (_a2 = window.nineConfig) == null ? void 0 : _a2.language) == null ? void 0 : _b.slice(0, 2)) === "es" ? "Fecha fuera de rango" : `Date is out of range`;
  },
  above_max: ({ max }) => {
    var _a2, _b;
    return ((_b = (_a2 = window.nineConfig) == null ? void 0 : _a2.language) == null ? void 0 : _b.slice(0, 2)) === "es" ? `Esto es demasiado alto${max ? `, el m\xE1ximo es ${max}` : ""}` : `This is too high${max ? `, the maximum is ${max}` : ""}`;
  },
  below_min: ({ min }) => {
    var _a2, _b;
    return ((_b = (_a2 = window.nineConfig) == null ? void 0 : _a2.language) == null ? void 0 : _b.slice(0, 2)) === "es" ? `Esto es demasiado bajo${min ? `, el m\xEDnimo es ${min}` : ""}` : `This is too low${min ? `, the minimum is ${min}` : ""}`;
  },
  password_invalid: () => {
    var _a2, _b;
    return ((_b = (_a2 = window.nineConfig) == null ? void 0 : _a2.language) == null ? void 0 : _b.slice(0, 2)) === "es" ? `La contrase\xF1a debe tener al menos 12 caracteres` : `Password must be at least 12 characters long`;
  },
  login_credentials: () => {
    var _a2, _b;
    return ((_b = (_a2 = window.nineConfig) == null ? void 0 : _a2.language) == null ? void 0 : _b.slice(0, 2)) === "es" ? `No se puede iniciar sesi\xF3n con las credenciales proporcionadas. Si a\xFAn no ha verificado su direcci\xF3n de correo electr\xF3nico, compruebe su bandeja de entrada y haga clic en el enlace que le hemos enviado.` : `Unable to login with the provided credentials. If you have not verified your email address yet, please check your inbox and click the link we sent you.`;
  }
};
var defaultErrorMessages_default = defaultErrorMessages;

// src/components/answer-item/answer-item.scss?inline
import { css as css5 } from "lit-element/lit-element.js";
var answer_item_default = css5`:host {
  display: block;
  width: 100%;
  position: relative;
  z-index: 1;
}

.option {
  width: 100%;
  outline: none;
  border: none;
  font-size: 1em;
  font-family: var(--font-family);
  padding: 0;
  display: flex;
  min-height: var(--option-mh, 4em);
  cursor: pointer;
  box-sizing: border-box;
}

.option[large] {
  font-size: var(--font-size-h5);
  font-weight: 500;
}

.option[center=true] {
  justify-content: center;
  align-items: center;
}

.option[disabled=true] {
  cursor: not-allowed;
  opacity: 0.6;
}

.option[padding=true] {
  padding: var(--option-p, var(--space-md));
}

input {
  position: absolute;
  left: 50%;
  opacity: 0;
  height: 0;
  width: 0;
  pointer-events: none;
}

input:focus ~ .active::after,
input:active ~ .active::after {
  opacity: 0.15;
}

input:checked ~ .active {
  --border: 2.5px;
}

.content {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 2;
}

nine-checkbox {
  margin-right: 0.8em;
  pointer-events: none;
}

nine-checkbox[variant=""] {
  opacity: 0;
  position: absolute;
  left: -100vw;
}

nine-checkbox + .slotted {
  transform: translateY(1px);
}

.help {
  padding: 0.5rem 0;
  font-size: 0.88em;
  color: var(--color-error);
  z-index: 2;
  display: flex;
  align-items: center;
  gap: calc(var(--space-sm) * 0.25);
  font-weight: 400;
  display: none;
}

:host(:not([error=""])) .help {
  display: block;
}

:host([type=checkbox]) .help {
  margin-left: 3em;
  padding-top: 0.25rem;
}

@media screen and (min-width: 960px) {
  :host([type=checkbox]) .help {
    padding-top: 0;
  }
}
.tooltip {
  position: absolute;
  bottom: calc(100% + 0.75rem);
  top: auto;
  left: 0;
  right: 0;
  margin: 0;
  padding: 1rem;
  background: var(--color-sunrise-blue);
  border-radius: 0.5rem;
  box-shadow: var(--light-shadow);
  opacity: 0;
  visibility: hidden;
  transition: all var(--ease-time) var(--ease-type);
  word-break: break-word;
}
.tooltip::after {
  content: "";
  position: absolute;
  width: 1rem;
  height: 1rem;
  background: var(--color-sunrise-blue);
  bottom: -0.5rem;
  left: 1rem;
  transform: rotate(45deg);
}
@media (pointer: fine) {
  .tooltip {
    pointer-events: none;
  }
}

label:hover ~ .tooltip {
  opacity: 1;
  visibility: visible;
}

:host(:not([styling=false])) label:hover .active {
  box-shadow: var(--option-box-s, var(--light-shadow));
}
:host(:not([styling=false])) label:not([hover-only-shadow]) .active {
  box-shadow: var(--option-box-s, var(--light-shadow));
}
:host(:not([styling=false])) .active {
  --br: var(--option-br, var(--border-radius));
  --border: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: var(--br);
  overflow: hidden;
  background-image: var(--wcl-bg-gradient-sunrise, linear-gradient(var(--gradient-dir), var(--color-sunrise-blue) 13.49%, var(--color-sunrise-pink) 51.22%, var(--color-sunrise-orange) 85.11%));
}
:host(:not([styling=false])) .active[custom-border] {
  background-image: none;
  background: var(--option-border-color, transparent);
  --border: 2px;
}
:host(:not([styling=false])) .active[custom-border][checked] {
  background: var(--option-selected-border-color, transparent);
}
:host(:not([styling=false])) .active::before {
  content: "";
  position: absolute;
  left: var(--border);
  top: var(--border);
  right: var(--border);
  bottom: var(--border);
  transition: all 0.1s ease-in-out;
  background-color: var(--option-bg-color, white);
  border-radius: calc(var(--br) - 2px);
}
:host(:not([styling=false])) .active::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  transition: all 0.1s ease-in-out;
  background-image: var(--wcl-bg-gradient-sunrise, linear-gradient(var(--gradient-dir), var(--color-sunrise-blue) 13.49%, var(--color-sunrise-pink) 51.22%, var(--color-sunrise-orange) 85.11%));
  opacity: 0;
}
:host(:not([styling=false])) .active[custom-border]::after {
  background-image: none;
  background: var(--option-border-color, transparent);
}
:host(:not([styling=false])) .active[custom-border][checked]::after {
  background: var(--option-selected-border-color, transparent);
}
:host(:not([styling=false])) input:focus-visible ~ .active::before {
  background: rgba(255, 255, 255, 0.6862745098);
}
:host(:not([styling=false])) input:checked ~ .active::before {
  --border: 2px;
}

:host([styling=false]) .active {
  --border: 2px;
}
:host([styling=false]) .active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  transition: all 0.1s ease-in-out;
  border-radius: var(--border-radius);
}
:host([styling=false]) input:focus-visible ~ .active::before {
  border: var(--border) solid var(--color-sunrise-blue);
}`;

// src/components/input/input.component.ts
import { html as html6, unsafeCSS as unsafeCSS3 } from "lit";
import { property as property4, queryAssignedNodes as queryAssignedNodes2 } from "lit/decorators.js";
import { createRef as createRef2, ref as ref2 } from "lit/directives/ref.js";

// src/lib/animate.ts
var easeOutCubic = (t) => {
  return 1 - Math.pow(1 - t, 3);
};
var animate = (duration, callback, options = {}) => {
  let stopped = false;
  const { easing = easeOutCubic, range = [0, 1] } = options;
  const [from, to] = range;
  if (duration === 0) {
    callback(to);
    return {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      stop: () => {
      }
    };
  }
  const start = performance.now();
  requestAnimationFrame(function frame(time) {
    const timeFraction = (time - start) / duration;
    const progress = easing(timeFraction);
    const clean = progress < 0 ? 0 : progress > 1 ? 1 : progress;
    const stepValue = from + (to - from) * clean;
    callback(stepValue);
    if (clean < 1 && !stopped) {
      requestAnimationFrame(frame);
    }
  });
  return {
    stop: () => {
      stopped = true;
    }
  };
};

// src/lib/config.ts
var _a;
var defaultNineConfig = {
  mainScrollTarget: (_a = document.scrollingElement) != null ? _a : window,
  disableProblematicDeviceCheck: false,
  language: "en"
};
var addScrollListener = (listener, options) => {
  const conf = getConfig();
  conf.mainScrollTarget.addEventListener("scroll", listener, options);
  if (conf.mainScrollTarget !== window) {
    window.addEventListener("scroll", listener, options);
  }
};
var removeScrollListener = (listener) => {
  const conf = getConfig();
  conf.mainScrollTarget.removeEventListener("scroll", listener);
  window.removeEventListener("scroll", listener);
};
window.nineConfig = window.nineConfig || defaultNineConfig;
var getConfig = () => {
  const fullConfig = __spreadValues(__spreadValues({}, defaultNineConfig), window.nineConfig);
  if (typeof fullConfig.mainScrollTarget !== "object") {
    console.warn("mainScrollTarget is not an object, using default");
    fullConfig.mainScrollTarget = document.querySelector("*");
  }
  return fullConfig;
};
var getPlatform = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (/android/.test(ua)) {
    return "android";
  }
  if (/ipad|iphone|ipod/.test(ua)) {
    return "ios";
  }
  return "other";
};
var getDeviceType = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (/android|ipad|iphone|ipod/.test(ua)) {
    return "mobile";
  }
  if (/ipad/.test(ua)) {
    return "tablet";
  }
  return "desktop";
};
var getBrowser = () => {
  const detection = {
    isChrome: window.navigator.userAgent.indexOf("Chrome") > -1,
    isIE: window.navigator.userAgent.indexOf("MSIE ") > -1 || !!navigator.userAgent.match(/Trident.*rv:11\./),
    isEdge: window.navigator.userAgent.indexOf("Edge/") > -1,
    isSafari: window.navigator.userAgent.indexOf("Safari") > -1 && window.navigator.userAgent.indexOf("Chrome") == -1,
    isFirefox: window.navigator.userAgent.indexOf("Firefox") > -1,
    isChromiumEdge: window.navigator.userAgent.indexOf("Edg/") > -1
    // for new edge chromium
  };
  if (detection.isChrome) return "chrome";
  if (detection.isFirefox) return "firefox";
  if (detection.isSafari) return "safari";
  if (detection.isChromiumEdge) return "edge";
  if (detection.isEdge || detection.isIE) return "ie";
  return "other";
};
var getMainScrollPosition = () => {
  const conf = getConfig();
  if (conf.mainScrollTarget instanceof Window) {
    return {
      x: conf.mainScrollTarget.scrollX,
      y: conf.mainScrollTarget.scrollY
    };
  }
  return {
    x: conf.mainScrollTarget.scrollLeft,
    y: conf.mainScrollTarget.scrollTop
  };
};
var setScrollPositionX = (x) => {
  const conf = getConfig();
  if (conf.mainScrollTarget instanceof Window) {
    conf.mainScrollTarget.scrollTo(x, conf.mainScrollTarget.scrollY);
  } else {
    conf.mainScrollTarget.scrollTo(x, conf.mainScrollTarget.scrollTop);
  }
};
var setScrollPositionY = (y) => {
  const conf = getConfig();
  if (conf.mainScrollTarget instanceof Window) {
    conf.mainScrollTarget.scrollTo(conf.mainScrollTarget.scrollX, y);
  } else {
    conf.mainScrollTarget.scrollTo(conf.mainScrollTarget.scrollLeft, y);
  }
};
var scrollMainTo = (x, y, smooth = false) => {
  const currentScrollPost = getMainScrollPosition();
  if (!smooth) {
    if (typeof x !== "undefined") setScrollPositionX(x);
    if (typeof y !== "undefined") setScrollPositionY(y);
  } else {
    animate(400, (p) => {
      if (typeof x !== "undefined")
        setScrollPositionX(currentScrollPost.x + (x - currentScrollPost.x) * p);
      if (typeof y !== "undefined")
        setScrollPositionY(currentScrollPost.y + (y - currentScrollPost.y) * p);
    });
  }
};
var getMainScrollElementHeight = () => {
  const conf = getConfig();
  if (conf.mainScrollTarget instanceof Window || conf.mainScrollTarget instanceof HTMLHtmlElement) {
    return window.innerHeight;
  }
  return conf.mainScrollTarget.scrollHeight;
};

// src/lib/escapeHTML.ts
var escapeHTML = (str) => {
  let result = str;
  result = result.replace(/[&<>"']/g, (match) => {
    switch (match) {
      case "&":
        return "&amp;";
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case '"':
        return "&quot;";
      case "'":
        return "&#039;";
      default:
        return match;
    }
  });
  result = result.replace(/\r?\n/g, "<br />");
  return result + "<br />";
};
var escapeHTML_default = escapeHTML;

// src/components/input/customMask.ts
var NUM_MASK_REGEX = /^num\{(\d+)?,?(\d+)?\}$/;
var parseCustomMask = (mask) => {
  const match = mask.match(NUM_MASK_REGEX);
  if (match) {
    const [, min, max] = match;
    return {
      mask: Number,
      min: min ? parseInt(min) : void 0,
      max: max ? parseInt(max) : void 0
    };
  }
  return { mask };
};

// src/components/input/input.scss?inline
import { css as css6 } from "lit-element/lit-element.js";
var input_default = css6`body {
  opacity: 0.5;
}

:host {
  display: block;
  width: 100%;
  --border-color: var(--color-charcoal-60);
  position: relative;
  height: 4em;
  font-size: 16px;
  --padding: 1em;
  --border-radius: 8px;
}

:host([input=textarea]) {
  height: auto;
}

:host([error]:not([error=""])),
:host([force-error]:not([force-error=""])),
:host([help]:not([help=""])) {
  height: auto;
}

:host([smallRadius=true]) {
  --border-radius: 4px;
}
:host([smallRadius=true]) .wrap::after {
  border-radius: calc(var(--border-radius) * 0.76);
}

.wrap {
  background-color: var(--color-white);
  border-radius: var(--border-radius);
  height: 4em;
  display: flex;
  position: relative;
  padding: 0 var(--padding);
  transition: all 0.2s ease-in-out;
  --border: 1px;
}
.wrap[data-input=textarea] {
  height: 12em;
}
.wrap[ta-grow] {
  height: auto;
}
.wrap[ta-grow] .taSizer {
  position: relative;
  opacity: 0;
  pointer-events: none;
  min-height: var(--tas-min, 2em);
  padding: var(--padding) 0;
  max-height: var(--tas-max, 12em);
}

.wrap::before,
.wrap::after,
.gradient {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  border-radius: inherit;
  background: var(--border-color);
  transition: all 0.2s ease-in-out;
}

@keyframes moveBackgroundX {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100% 0;
  }
}
.gradient {
  background-image: var(--wcl-bg-gradient-sunrise-repeating, linear-gradient(var(--gradient-dir, 90deg), #80b6ff 0%, #f7bde6 16.666%, #ffbd70 33.332%, #f7bde6 50%, #80b6ff 66.66%, #f7bde6 83.33%, #ffbd70 100%));
  background-size: 300% 100%;
  animation: moveBackgroundX 4s linear infinite;
  opacity: 0;
  transition: all 0.2s ease-in-out;
}

.wrap::after {
  left: var(--border);
  top: var(--border);
  right: var(--border);
  bottom: var(--border);
  background: white;
  border-radius: calc(var(--border-radius) * 0.86);
}

label {
  position: absolute;
  left: var(--padding);
  top: 2em;
  transform: translateY(-50%);
  color: var(--color-charcoal-60);
  transform-origin: 0 0;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  font-weight: 400;
}

.icon,
::slotted([slot=decoration-end]),
.unit {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
  padding: 1em;
  display: flex;
  align-items: center;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.password-icon {
  opacity: 1;
  cursor: pointer;
  pointer-events: all;
  background-color: transparent;
  border: none;
  border-radius: var(--border-radius);
}

::slotted([slot=decoration-end]),
.unit {
  opacity: 1;
  pointer-events: all;
}

.wrap[data-error=true]:not([data-password=true]) ::slotted([slot=decoration-end]),
.wrap[data-error=true]:not([data-password=true]) .unit {
  color: var(--color-error);
}
.wrap[data-error=true]:not([data-password=true]):not([data-hasunit=true]) .icon {
  opacity: 1;
}

:host([hover=true]) .wrap,
.wrap[data-focused=true],
.wrap:hover,
.wrap[data-draghover] {
  box-shadow: var(--light-shadow);
}

.wrap[data-focused=true],
.wrap[data-error=true],
.wrap[data-draghover] {
  --border: 2px;
  --border-color: transparent;
}

.wrap[data-focused=true] .gradient,
.wrap[data-draghover] .gradient {
  opacity: 1;
}

.wrap[data-error=true]::before {
  background-color: var(--color-error);
}

.wrap[data-error=true] label {
  color: var(--color-error);
}

::slotted(.nine-input-element) {
  all: initial;
  position: absolute;
  left: 0;
  right: 0;
  display: block;
  top: 0;
  bottom: 0;
  border: none;
  background: none;
  padding: 1.3em calc(var(--padding)) 0;
  font-size: 1rem;
  outline: none;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  font-family: var(--font-family);
  font-size: 1em;
  line-height: 1.35;
  resize: none;
  background-color: transparent !important;
  border-radius: var(--border-radius);
  border: none !important;
  outline: none !important;
  width: 100%;
  height: 100%;
  box-sizing: border-box !important;
  /* fix styling problem with blue background on form autofill */
}
::slotted(.nine-input-element):-webkit-autofill, ::slotted(.nine-input-element):-webkit-autofill:hover, ::slotted(.nine-input-element):-webkit-autofill:focus, ::slotted(.nine-input-element):-webkit-autofill:active {
  z-index: 1;
  border-radius: var(--border-radius);
  width: calc(100% - var(--padding) * 2);
}

.wrap[data-password=true] ::slotted(.nine-input-element) {
  right: 3em;
}

.wrap[data-hasunit=true] ::slotted(.nine-input-element) {
  padding-right: 3em;
}

.wrap[data-focused=true] label,
.wrap[data-dirty=true] label {
  transform: translateY(-90%) scale(0.8);
}

.wrap[data-focused=true] ::slotted(.nine-input-element),
.wrap[data-dirty=true] ::slotted(.nine-input-element) {
  opacity: 1;
}

.wrap[data-input=textarea] ::slotted(.nine-input-element) {
  margin-top: 2em !important;
  padding-top: 0.2em;
  padding-bottom: 1em;
  height: auto;
}

.wrap[data-input=textarea][data-haslabel=false] ::slotted(.nine-input-element) {
  padding-top: 1em;
  margin-top: 0 !important;
  opacity: 1;
}

.help {
  position: absolute;
  text-align: left;
  bottom: 0;
  transform: translateY(100%);
  left: 3px;
  padding: 0.5rem 0 0;
  font-size: 0.88em;
  color: var(--color-charcoal-80);
  z-index: 2;
  display: flex;
  align-items: center;
  gap: calc(var(--space-sm) * 0.25);
  font-weight: 400;
}

.wrap[data-error=true] .help {
  color: var(--color-error);
}

.wrap[data-disabled=true] {
  pointer-events: none;
  opacity: 0.5;
}

.drop {
  position: absolute;
  top: 0;
  right: 0;
  width: 2.5em;
  bottom: 0;
  align-items: center;
  z-index: 3;
  pointer-events: none;
  transform: rotateX(180deg);
  transition: all 0.2s ease-in-out;
  display: flex;
  opacity: 0;
}

.wrap[data-input=select] .drop {
  opacity: 1;
}

.wrap[data-error=true] .drop {
  opacity: 0;
}

.wrap[data-focused=true] .drop {
  transform: rotateX(0deg);
}

.wrap[data-haslabel=false] ::slotted(.nine-input-element) {
  padding-top: 0;
}

@media screen and (min-width: 960px) {
  :host([size=half]) {
    width: calc(50% - 0.5em);
  }
  :host([size=half][colGap2=true]),
  :host([size=half][colgap2=true]) {
    width: calc(50% - 1em);
  }
}
.fakeValue {
  display: none;
}

.wrap[data-input=file] ::slotted(.nine-input-element) {
  opacity: 0.0001;
}
.wrap[data-input=file] .fakeValue {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 2em 1em 1em;
  box-sizing: border-box;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.wrap[data-input=file][data-focused=true] .fakeValue, .wrap[data-input=file][data-hasfile] .fakeValue {
  opacity: 1;
}
.wrap[data-input=file][data-draghover] .fakeValue {
  opacity: 0;
}`;

// src/components/input/input.component.ts
var _NineInput = class _NineInput extends NineElement {
  constructor() {
    super(...arguments);
    this.uniqueId = `nine-input-${Math.random()}`;
    this.wrapRef = createRef2();
    this.iconRef = createRef2();
    this.helpRef = createRef2();
    this.taSizer = createRef2();
    this.isPasswordInput = false;
    this.file = null;
    this.errorMessages = defaultErrorMessages_default;
    this.name = "";
    this.label = "";
    this.help = "";
    this.type = "text";
    this.input = "text";
    this.error = "";
    this.forceError = "";
    this.mask = "";
    this.lazy = "true";
    this.hideWarningIcon = "false";
    this.size = "full";
    this.required = "false";
    this.hideRequiredAsterisk = false;
    this.disabled = "false";
    this.validateOnBlur = false;
    this.validateOnInput = false;
    this.validateOnConnect = false;
    this.value = "";
    this.fakeValue = "";
    this.dragHover = false;
    this.acceptFileTypes = "*";
    this.placeholder = "";
    this.autoCorrect = "";
    this.autoCapitalize = "";
    this.inputMode = "";
    this.maxLength = "";
    this.focused = "false";
    this.hover = "false";
    this.dirty = "false";
    this.colGap2 = "false";
    this.smallRadius = "false";
    this.showPasswordHelp = "true";
    this.useMaskedValue = false;
    this.multiple = false;
    this.textareaGrow = false;
    this.unit = "";
    this.scrollIntoViewOnFocus = false;
    this.disableValidation = false;
    this.handleKeyPress = (e) => {
      if (this.input === "textarea") return;
      if (e.key === "Enter") {
        this.dispatchEvent(
          new CustomEvent(_NineInput.customEvents.submit, {
            detail: {},
            bubbles: true,
            composed: true
          })
        );
      }
    };
    this.dispatchCouldHaveChangedEvent = () => {
      this.dispatchEvent(
        new CustomEvent(_NineInput.customEvents.couldHaveChanged, {
          detail: {},
          bubbles: true,
          composed: true
        })
      );
    };
    this.handleFileInputChange = () => {
      var _a2;
      if (this.input !== "file") return;
      const el = this.inputEl;
      const file = (_a2 = el.files) == null ? void 0 : _a2[0];
      if (!file) return;
      this.file = file;
      this.fakeValue = file.name;
      this.validate(true);
    };
    this.handleInput = (e, resetError = true) => {
      setTimeout(() => {
        var _a2, _b, _c, _d, _e, _f;
        if (e) {
          this.value = (_b = (_a2 = this.inputEl) == null ? void 0 : _a2.value) != null ? _b : "";
        } else {
          if (this.inputEl) this.inputEl.value = this.value;
        }
        if (resetError && !this.disableValidation && !this.forceError)
          this.error = "";
        if (this.textareaGrow && this.taSizer.value) {
          this.taSizer.value.innerHTML = escapeHTML_default(this.value);
        }
        this.handleFileInputChange();
        this.dirty = this.value.trim() ? "true" : "false";
        let parsedValue = this.value;
        if (this.maskInstance && !this.useMaskedValue) {
          parsedValue = (_c = this.maskInstance) == null ? void 0 : _c.unmaskedValue;
        }
        const hasChanged = this.lastValidatedValue !== this.valueKey;
        if (hasChanged) {
          this.lastValidatedValue = this.valueKey;
          const details = {
            originalEvent: e,
            name: this.name,
            value: parsedValue,
            maskedValue: (_d = this.maskInstance) == null ? void 0 : _d.value,
            required: this.required === "true",
            maskFilled: this.maskFilled,
            root: this,
            type: this.type,
            file: (_e = this.file) != null ? _e : void 0
          };
          if (this.value && this.validateOnInput) this.validate();
          this.emit("nine-change", {
            detail: {
              value: parsedValue,
              maskedValue: (_f = this.maskInstance) == null ? void 0 : _f.value,
              maskFilled: this.maskFilled,
              inputRef: this.inputEl,
              ref: this
            }
          });
          this.dispatchEvent(
            new CustomEvent(_NineInput.customEvents.change, {
              detail: details,
              bubbles: true
            })
          );
        }
        this.dispatchCouldHaveChangedEvent();
      });
    };
    this.lastValidatedValue = null;
    this.setValue = (value, resetError = true) => {
      this.value = value;
      if (this.inputEl) {
        this.inputEl.value = value;
      }
      this.handleInput(void 0, resetError);
      this.updateMask();
    };
    this.onFocusValue = "";
    this.handleFocus = () => {
      var _a2;
      this.onFocusValue = this.value;
      this.focused = "true";
      const details = {
        name: this.name,
        value: this.rawValue,
        maskedValue: this.mask ? this.value : void 0,
        required: this.required === "true",
        maskFilled: this.maskFilled,
        root: this,
        file: (_a2 = this.file) != null ? _a2 : void 0
      };
      this.emit("nine-focus");
      this.dispatchEvent(
        new CustomEvent(_NineInput.customEvents.focus, {
          detail: details,
          bubbles: true
        })
      );
      this.dispatchCouldHaveChangedEvent();
      if (this.scrollIntoViewOnFocus) {
        setTimeout(() => {
          this.customScrollIntoView();
        }, 100);
      }
    };
    this.customScrollIntoView = () => {
      const isTouchDevice = "ontouchstart" in window;
      if (!isTouchDevice) return;
      const position = this.getBoundingClientRect();
      const y = position.top + window.scrollY - window.innerHeight / 4;
      const x = position.left + window.scrollX;
      scrollMainTo(x, y, true);
    };
    this.handleBlur = (e) => {
      var _a2;
      this.focused = "false";
      const details = {
        originalEvent: e,
        name: this.name,
        value: this.rawValue,
        maskedValue: this.mask ? this.value : void 0,
        required: this.required === "true",
        maskFilled: this.maskFilled,
        root: this,
        file: (_a2 = this.file) != null ? _a2 : void 0
      };
      this.emit("nine-blur");
      this.dispatchEvent(
        new CustomEvent(_NineInput.customEvents.blur, {
          detail: details,
          bubbles: true
        })
      );
      this.dispatchCouldHaveChangedEvent();
      if (this.validateOnBlur) this.validate();
    };
    this.hidePasswordIcon = false;
    this.maskInstance = void 0;
    this.maskOptions = {};
    this.setMask = (maskOptions) => {
      if (this.maskInstance) {
        this.maskInstance.updateOptions(maskOptions);
      }
      this.maskOptions = maskOptions;
    };
    this.updateMockInput = () => {
      if (this.inputEl) {
        this.setInputElementAttributes(this.inputEl, false);
      }
    };
    this.validateEmail = () => {
      const value = String(this.value).trim();
      if (value === "" && this.required === "false") {
        return void 0;
      }
      const re = /^[^@]+@[^@]+\.[^@]+$/;
      const valid = re.test(String(this.value).toLowerCase());
      return valid ? void 0 : "invalid";
    };
    this.validate = (setError = true) => {
      var _a2;
      this.updateMask();
      let error = this.forceError;
      const v = (_a2 = this.value) != null ? _a2 : "";
      const validateFunction = this.customValidate || this.defaultValidate;
      if (this.forceError) {
        return this.forceError;
      }
      if (!error) {
        error = validateFunction(this, v);
      }
      if (setError && !this.disableValidation) {
        this.error = error != null ? error : "";
      }
      requestAnimationFrame(this.dispatchCouldHaveChangedEvent);
      return error;
    };
    this.validateFile = () => {
      let error = "";
      const file = this.file;
      if (this.input === "file" && file && this.acceptFileTypes !== "*") {
        const types = this.acceptFileTypes.split(",");
        if (types.indexOf(file.type) === -1) {
          error = "file_type_invalid";
        }
      }
      return error;
    };
    this.defaultValidate = (_, v) => {
      let error = void 0;
      if (!error && this.required === "true" && !v.trim()) {
        error = "required";
      }
      if (!error && this.isPasswordInput && v.length < 12 && this.showPasswordHelp === "true") {
        error = "password_invalid";
      }
      if (!error && this.type === "email") {
        error = this.validateEmail();
      }
      if (!error && this.required === "true" && !this.customMask && this.mask && this.maskFilled === false) {
        error = "incomplete";
      }
      if (!error && this.customMask) {
        const { mask, min, max } = this.customMask;
        if (mask === Number) {
          const n = Number(v);
          if (min && n < min) {
            error = "below_min";
          }
          if (max && n > max) {
            error = "above_max";
          }
        }
      }
      if (!error) {
        error = this.validateFile();
      }
      return error;
    };
    this.handleAttributeChange = (mutations) => {
      mutations.forEach((m) => {
        var _a2;
        const attrName = (_a2 = m.attributeName) != null ? _a2 : "";
        const isDataAttribute = attrName.startsWith("data-");
        const isLessThanThreeWords = attrName.split("-").length <= 3;
        if (m.type === "attributes" && isDataAttribute && !isLessThanThreeWords) {
          const el = this.inputEl;
          el.removeAttribute(attrName);
        }
      });
    };
    this.handleNativeInput = (e) => {
      this.handleInput(e, true);
    };
  }
  get unmaskedValue() {
    var _a2;
    return (_a2 = this.maskInstance) == null ? void 0 : _a2.unmaskedValue;
  }
  get valueKey() {
    var _a2, _b;
    return (_b = (_a2 = this.maskInstance) == null ? void 0 : _a2.unmaskedValue) != null ? _b : this.value;
  }
  updateMask() {
    var _a2;
    if (this.maskInstance) {
      this.maskInstance.value = (_a2 = this.value) != null ? _a2 : "";
      this.maskInstance.updateValue();
      this.maskInstance.updateControl();
    }
  }
  get rawValue() {
    if (this.maskInstance) {
      return this.maskInstance.unmaskedValue;
    }
    return this.value;
  }
  handlePasswordVisibilityIconClick() {
    this.type = this.type === "password" ? "text" : "password";
    this.hidePasswordIcon = !this.hidePasswordIcon;
    this.dispatchEvent(
      new CustomEvent("nineInputPasswordVisibilityIconClick", {
        detail: {
          hidePasswordIcon: this.hidePasswordIcon
        },
        bubbles: true,
        composed: true
      })
    );
  }
  setupFileInput() {
    if (this.input === "file") this.type = "file";
    if (this.type === "file") this.input = "file";
    if (this.input !== "file") return;
    if (this.input === "file") {
      this.fakeValue = "No file chosen, yet.";
    }
    this.validate(false);
  }
  setupMockInput() {
    this.inputEl = this.createInputElement();
    this.appendChild(this.inputEl);
  }
  connectedCallback() {
    var _a2, _b;
    super.connectedCallback();
    if (this.name) {
      const details = {
        name: this.name,
        value: this.value,
        maskedValue: (_a2 = this.maskInstance) == null ? void 0 : _a2.value,
        required: this.required === "true",
        maskFilled: this.maskFilled,
        root: this,
        type: this.type,
        file: (_b = this.file) != null ? _b : void 0
      };
      this.dispatchEvent(
        new CustomEvent(_NineInput.customEvents.register, {
          detail: details,
          bubbles: true
        })
      );
    }
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("value")) {
      this.dirty = "true";
    }
    const errDefined = this.error === "undefined" || this.error === "null";
    if (changedProperties.has("error") && errDefined) {
      this.error = "";
    }
    this.dispatchCouldHaveChangedEvent();
  }
  firstUpdated() {
    var _a2, _b;
    this.setupMockInput();
    this.setupFileInput();
    if (this._decorationEndNodes.length) {
      (_a2 = this.iconRef.value) == null ? void 0 : _a2.style.setProperty("opacity", "0");
    }
    this.dirty = this.value.trim() ? "true" : "false";
    this.setupMask();
    if (this.textareaGrow && this.taSizer.value) {
      this.taSizer.value.innerHTML = escapeHTML_default(this.value);
    }
    if (this.focused === "true") {
      this.handleFocus();
    }
    if (this.type === "password") {
      this.isPasswordInput = true;
      if (this.showPasswordHelp === "true") {
        this.help = ((_b = window.nineConfig) == null ? void 0 : _b.language) == "es" ? "La contrase\xF1a debe tener al menos 12 caracteres" : "Password must be at least 12 characters long";
      }
    }
    window.addEventListener("resize", this.updateErrorHeight, {
      passive: true
    });
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this.updateErrorHeight();
        }
      });
    }).observe(this);
    if (this.value && this.validateOnConnect) this.validate();
    this.dispatchCouldHaveChangedEvent();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("resize", this.updateErrorHeight);
    if (this.name) {
      const details = {
        root: this,
        name: this.name,
        required: this.required === "true",
        value: this.value
      };
      this.dispatchEvent(
        new CustomEvent(_NineInput.customEvents.unregister, {
          detail: details,
          bubbles: true
        })
      );
    }
  }
  get maskParsed() {
    var _a2;
    if (this.mask.startsWith("/") && this.mask.endsWith("/")) {
      return new RegExp(this.mask.slice(1, -1), "g");
    }
    if (((_a2 = this.customMask) == null ? void 0 : _a2.mask) === Number) {
      return "0[0000000000]";
    }
    return this.mask;
  }
  get maskFilled() {
    var _a2, _b, _c;
    if (this.maskInstance) {
      return ((_b = (_a2 = this.maskInstance.value) == null ? void 0 : _a2.replace(/_/g, "")) == null ? void 0 : _b.length) === ((_c = this.mask) == null ? void 0 : _c.length);
    }
    return false;
  }
  setupMask() {
    const IMask = window.IMask;
    if (this.mask && !IMask) {
      console.error(
        "IMask is not installed. Please install it to use the mask feature."
      );
    }
    if (this.mask && IMask && this.inputEl) {
      this.customMask = parseCustomMask(this.mask);
      this.maskInstance = IMask(this.inputEl, __spreadValues({
        mask: this.maskParsed,
        lazy: this.lazy === "true"
      }, this.maskOptions));
    }
  }
  updateErrorHeight() {
    requestAnimationFrame(() => {
      var _a2;
      if (((_a2 = this.wrapRef) == null ? void 0 : _a2.value) && this.helpRef.value) {
        const helpHeight = this.helpRef.value.clientHeight;
        this.wrapRef.value.style.marginBottom = `calc(${helpHeight}px)`;
        this.dispatchCouldHaveChangedEvent();
      }
    });
  }
  updated(updated) {
    super.updated(updated);
    this.updateMockInput();
    this.updateErrorHeight();
    if (updated.has("mask")) {
      this.setupMask();
    }
    requestAnimationFrame(() => this.dispatchCouldHaveChangedEvent());
  }
  handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dragHover = true;
  }
  handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dragHover = false;
  }
  handleDrop(e) {
    var _a2, _b;
    e.preventDefault();
    e.stopPropagation();
    this.dragHover = false;
    const file = (_a2 = e.dataTransfer) == null ? void 0 : _a2.files[0];
    if (file) {
      this.file = file;
      this.value = file.name;
      const el = this.inputEl;
      if (el == null ? void 0 : el.files) {
        el.files = (_b = e.dataTransfer) == null ? void 0 : _b.files;
        el.dispatchEvent(new Event("input"));
      }
    }
  }
  createErrorContext() {
    let context = "";
    if (this.input === "file") {
      const types = this.acceptFileTypes.split(",");
      const humanReadableTypes = types.map((t) => {
        if (t.endsWith("pdf")) {
          return "PDF";
        }
        if (t.startsWith("image")) {
          return "Image";
        }
        return t;
      });
      context = `${humanReadableTypes.join(", ")}`;
    }
    return context;
  }
  get errorMessage() {
    var _a2, _b, _c, _d;
    const currentError = this.forceError || this.error;
    const e = (_a2 = this.errorMessages) == null ? void 0 : _a2[currentError];
    return (_d = e == null ? void 0 : e({
      label: this.label,
      min: (_b = this.customMask) == null ? void 0 : _b.min,
      max: (_c = this.customMask) == null ? void 0 : _c.max,
      context: this.createErrorContext()
    })) != null ? _d : currentError;
  }
  renderHelpMessage() {
    let icon2 = html6``;
    let errorMessage = html6``;
    if (this.isPasswordInput && this.showPasswordHelp === "true") {
      if (this.value.length >= 12) {
        icon2 = html6`${CheckSmallIcon}`;
      } else {
        icon2 = this.error || this.forceError ? html6`${BulletErrorIcon}` : html6`${BulletIcon}`;
      }
    }
    if (this.error || this.forceError) {
      errorMessage = html6`${this.errorMessage}`;
    } else if (this.help) {
      errorMessage = html6`${this.help}`;
    }
    return html6`${icon2} ${errorMessage}`;
  }
  setInputElementAttributes(el, initial) {
    var _a2;
    if (el instanceof HTMLInputElement) {
      el.type = this.type;
      el.accept = this.acceptFileTypes;
    }
    el.classList.add("nine-input-element");
    el.placeholder = this.placeholder;
    el.required = this.required === "true";
    el.disabled = this.disabled === "true";
    if (this.autocomplete) el.autocomplete = this.autocomplete;
    el.autocapitalize = this.autocapitalize === "true" ? "on" : "off";
    el.inputMode = (_a2 = this.inputMode) != null ? _a2 : "text";
    el.name = this.name;
    if (initial) {
      el.value = this.value;
    }
  }
  createInputElement() {
    let el;
    if (this.input === "textarea") {
      el = document.createElement("textarea");
    } else {
      el = document.createElement("input");
    }
    this.setInputElementAttributes(el, true);
    el.addEventListener("input", this.handleNativeInput);
    el.addEventListener("focus", this.handleFocus);
    el.addEventListener("blur", this.handleBlur);
    el.addEventListener("keypress", this.handleKeyPress);
    this.attributeObserver = new MutationObserver(this.handleAttributeChange);
    this.attributeObserver.observe(el, {
      attributes: true
    });
    return el;
  }
  renderInputElement() {
    return html6` <slot></slot>`;
  }
  renderPasswordVisibilityIcon() {
    if (this.isPasswordInput) {
      return html6`
        <button
          class="icon password-icon"
          @click="${this.handlePasswordVisibilityIconClick}"
          aria-label="Toggle password visibility"
        >
          ${this.hidePasswordIcon ? html6`${EyeClosedIcon}` : html6`${EyeIcon}`}
        </button>
      `;
    }
    return html6``;
  }
  get fullLabel() {
    const showAsterisk = !this.hideRequiredAsterisk && this.required === "true";
    return this.label + (this.label && showAsterisk ? "*" : "");
  }
  handleClick() {
    var _a2;
    (_a2 = this.onClick) == null ? void 0 : _a2.call(this);
  }
  render() {
    return html6`
      <div
        class="wrap"
        data-error="${Boolean(this.error) || Boolean(this.forceError)}"
        data-help="${Boolean(this.help)}"
        ${ref2(this.wrapRef)}
        data-focused="${this.focused}"
        data-dirty="${this.dirty}"
        data-disabled="${this.disabled}"
        data-input="${this.input}"
        data-password="${this.isPasswordInput}"
        data-haslabel="${Boolean(this.label)}"
        data-hasunit="${Boolean(this.unit)}"
        ?data-hasvalue=${Boolean(this.value)}
        ?data-hasfile=${Boolean(this.file)}
        ?data-draghover=${this.dragHover}
        ?ta-grow=${this.textareaGrow}
        @dragenter="${this.handleDragOver}"
        @dragleave="${this.handleDragLeave}"
        @drop="${this.handleDrop}"
        @click=${this.handleClick}
      >
        <div class="gradient"></div>
        <label>${this.fullLabel}</label>

        ${this.renderInputElement()}
        <div class="taSizer" ${ref2(this.taSizer)}></div>
        ${this.input === "file" ? html6` <div class="fakeValue">${this.fakeValue}</div>
              <div class="dropzone"></div>` : ""}
        ${this.hideWarningIcon === "false" ? html6` <div class="icon" ${ref2(this.iconRef)}>${ErrorIcon}</div>` : html6``}

        <div class="help" ${ref2(this.helpRef)}>${this.renderHelpMessage()}</div>
        <slot name="decoration-end"></slot>
        <slot name="root"></slot>

        <!-- display unit -->
        ${this.unit.length ? html6`<span class="unit">${this.unit}</span>` : html6``}

        <!-- render icon for showing or hiding password -->
        ${this.renderPasswordVisibilityIcon()}
      </div>
    `;
  }
};
_NineInput.styles = unsafeCSS3(input_default);
_NineInput.customEvents = {
  change: "nineInputChange",
  focus: "nineInputFocus",
  blur: "nineInputBlur",
  submit: "nineInputSubmit",
  couldHaveChanged: "nineInputCouldHaveChanged",
  passwordVisibilityIconClick: "nineInputPasswordVisibilityIconClick",
  register: "nineInputRegister",
  unregister: "nineInputUnregister"
};
__decorateClass([
  property4({})
], _NineInput.prototype, "errorMessages", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "name", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "label", 2);
__decorateClass([
  property4({ type: String, reflect: true })
], _NineInput.prototype, "help", 2);
__decorateClass([
  property4({ type: String, reflect: true })
], _NineInput.prototype, "type", 2);
__decorateClass([
  property4({ type: String, reflect: true })
], _NineInput.prototype, "input", 2);
__decorateClass([
  property4({ type: String, reflect: true })
], _NineInput.prototype, "error", 2);
__decorateClass([
  property4({ type: String, attribute: "force-error", reflect: true })
], _NineInput.prototype, "forceError", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "mask", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "lazy", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "hideWarningIcon", 2);
__decorateClass([
  property4({ type: String, reflect: true })
], _NineInput.prototype, "size", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "required", 2);
__decorateClass([
  property4({ type: Boolean, attribute: "hide-required-asterisk" })
], _NineInput.prototype, "hideRequiredAsterisk", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "disabled", 2);
__decorateClass([
  property4({ type: Boolean, attribute: "validate-on-blur" })
], _NineInput.prototype, "validateOnBlur", 2);
__decorateClass([
  property4({ type: Boolean, attribute: "validate-on-input" })
], _NineInput.prototype, "validateOnInput", 2);
__decorateClass([
  property4({ type: Boolean, attribute: "validate-on-connect" })
], _NineInput.prototype, "validateOnConnect", 2);
__decorateClass([
  property4({ type: String, reflect: true })
], _NineInput.prototype, "value", 2);
__decorateClass([
  property4({ type: String, reflect: false })
], _NineInput.prototype, "fakeValue", 2);
__decorateClass([
  property4({ type: Boolean, reflect: false })
], _NineInput.prototype, "dragHover", 2);
__decorateClass([
  property4({ type: String, attribute: "accept-file-types" })
], _NineInput.prototype, "acceptFileTypes", 2);
__decorateClass([
  property4({ type: Function })
], _NineInput.prototype, "onClick", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "placeholder", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "autoCorrect", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "autoCapitalize", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "inputMode", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "maxLength", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "focused", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "hover", 2);
__decorateClass([
  property4({ type: Boolean })
], _NineInput.prototype, "dirty", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "colGap2", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "smallRadius", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "showPasswordHelp", 2);
__decorateClass([
  property4({ type: Boolean })
], _NineInput.prototype, "useMaskedValue", 2);
__decorateClass([
  property4({ type: Boolean })
], _NineInput.prototype, "multiple", 2);
__decorateClass([
  property4({ type: Boolean, attribute: "textarea-grow" })
], _NineInput.prototype, "textareaGrow", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "autocomplete", 2);
__decorateClass([
  property4({ type: String })
], _NineInput.prototype, "unit", 2);
__decorateClass([
  property4({ type: Function })
], _NineInput.prototype, "customValidate", 2);
__decorateClass([
  property4({ type: Boolean, attribute: "scroll-into-view-on-focus" })
], _NineInput.prototype, "scrollIntoViewOnFocus", 2);
__decorateClass([
  property4({ type: Boolean, attribute: "disable-validation" })
], _NineInput.prototype, "disableValidation", 2);
__decorateClass([
  queryAssignedNodes2({ slot: "decoration-end", flatten: true })
], _NineInput.prototype, "_decorationEndNodes", 2);
var NineInput = _NineInput;

// src/components/input/input.ts
var input_default2 = NineInput;
NineInput.define("nine-input");

// src/components/answer-item/answer-item.component.ts
var NineAnswerItem = class extends NineElement {
  constructor() {
    super(...arguments);
    this.inputElementRef = createRef3();
    this.value = "";
    this.center = "true";
    this.type = "";
    this.checked = "";
    this.isControlled = false;
    this.padding = "false";
    this.disabled = "false";
    this.name = "";
    this.styling = "true";
    this.required = "false";
    this.errorMessages = defaultErrorMessages_default;
    this.error = "";
    this.label = "";
    this.tooltip = "";
    this.large = false;
    this.hoverOnlyShadow = false;
    this.customBorder = false;
    this.validate = () => {
      let error = void 0;
      if (!error && this.required === "true" && this.isChecked === false) {
        error = "required";
      }
      this.error = error != null ? error : "";
      return error;
    };
  }
  get isChecked() {
    return this.checked === "true";
  }
  get isDisabled() {
    return this.disabled === "true";
  }
  setChecked(checked) {
    if (checked !== this.isChecked) {
      this.checked = checked ? "true" : "false";
    }
    this.updateInputElChecked(checked);
  }
  updateInputElChecked(checked) {
    if (this.inputElementRef.value) {
      this.inputElementRef.value.checked = checked;
    }
  }
  dispatchChange(checked) {
    if (this.isDisabled) return;
    const changed = this.isChecked !== checked;
    if (!this.isControlled) {
      this.setChecked(checked);
    } else {
      this.updateInputElChecked(!checked);
    }
    if (!changed) return;
    setTimeout(() => {
      const eventDetails = {
        type: this.type,
        name: this.name,
        value: this.value,
        checked,
        root: this
      };
      this.dispatchEvent(
        new CustomEvent("nineInputChange", {
          detail: eventDetails,
          bubbles: true
        })
      );
      this.dispatchEvent(new CustomEvent("change", { detail: eventDetails }));
    });
  }
  firstUpdated() {
    if (this.checked !== "") this.isControlled = true;
    if (this.name) {
      this.dispatchEvent(
        new CustomEvent(input_default2.customEvents.register, {
          detail: {
            name: this.name,
            value: this.isChecked ? this.value : void 0,
            root: this
          },
          bubbles: true
        })
      );
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.name) {
      this.dispatchEvent(
        new CustomEvent(input_default2.customEvents.unregister, {
          detail: {
            name: this.name,
            value: this.isChecked ? this.value : void 0,
            root: this
          },
          bubbles: true
        })
      );
    }
  }
  updated(updated) {
    const el = this.inputElementRef.value;
    if (el) {
      el.checked = this.isChecked;
      el.disabled = this.isDisabled;
    }
    if (updated.has("value") || updated.has("checked")) {
      requestAnimationFrame(() => {
        if (this.isControlled) {
          this.updateInputElChecked(this.isChecked);
        }
      });
    }
  }
  handleChange() {
    var _a2;
    if (this.isDisabled) return;
    if (this.isControlled) {
      this.dispatchChange(!this.isChecked);
    } else {
      this.error = "";
      const setValue = (_a2 = this.inputElementRef.value) == null ? void 0 : _a2.checked;
      this.dispatchChange(Boolean(setValue));
    }
  }
  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.dispatchEvent(
        new CustomEvent("nineInputSubmit", {
          detail: {},
          bubbles: true
        })
      );
    }
  }
  get errorMessage() {
    var _a2, _b;
    const e = (_a2 = this.errorMessages) == null ? void 0 : _a2[this.error];
    return (_b = e == null ? void 0 : e({
      label: this.label
    })) != null ? _b : this.error;
  }
  render() {
    return html7`
            <label
                    class="option"
                    center="${this.center}"
                    padding="${this.padding}"
                    disabled="${this.disabled}"
                    ?large="${this.large}"
                    ?hover-only-shadow=${this.hoverOnlyShadow}
            >
                <input
                        type="checkbox"
                        name="${this.name}"
                        value="${this.value}"
                        ?checked="${this.isChecked}"
                        ${ref3(this.inputElementRef)}
                        @keypress="${this.handleKeyPress}"
                        @change="${this.handleChange}"
                />
                <div
                    class="active"
                    ?custom-border=${this.customBorder}
                    ?checked="${this.isChecked}"
                ></div>
                <div class="content">
                    <nine-checkbox
                            variant="${this.type}"
                            name="${this.name}"
                            ?checked="${this.isChecked}"
                            aria-hidden="true"
                            tabindex="-1"
                    ></nine-checkbox>
                    <div class="slotted">
                        <slot></slot>
                    </div>
                </div>
            </label>
            <div class="help">${this.errorMessage}</div>
            ${this.tooltip.trim().length ? html7`
                        <div class="tooltip">${this.tooltip}</div>` : html7``}
        `;
  }
};
NineAnswerItem.styles = unsafeCSS4(answer_item_default);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "value", 2);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "center", 2);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "type", 2);
__decorateClass([
  property5({ type: String, reflect: true })
], NineAnswerItem.prototype, "checked", 2);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "padding", 2);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "disabled", 2);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "name", 2);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "styling", 2);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "required", 2);
__decorateClass([
  property5({})
], NineAnswerItem.prototype, "errorMessages", 2);
__decorateClass([
  property5({ type: String, reflect: true })
], NineAnswerItem.prototype, "error", 2);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "label", 2);
__decorateClass([
  property5({ type: String })
], NineAnswerItem.prototype, "tooltip", 2);
__decorateClass([
  property5({ type: Boolean })
], NineAnswerItem.prototype, "large", 2);
__decorateClass([
  property5({ type: Boolean, attribute: "hover-only-shadow" })
], NineAnswerItem.prototype, "hoverOnlyShadow", 2);
__decorateClass([
  property5({ type: Boolean, attribute: "custom-border" })
], NineAnswerItem.prototype, "customBorder", 2);

// src/components/answer-item/answer-item.ts
var answer_item_default2 = NineAnswerItem;
NineAnswerItem.define("nine-answer-item");

// src/components/article-card/article-card.component.ts
import { css as css7, html as html8 } from "lit";
import { property as property6 } from "lit/decorators.js";
var NineArticleCard = class extends NineElement {
  constructor() {
    super(...arguments);
    this.image = "";
    this.tags = "";
    this.mobile = "";
    this.desktop = "";
    this.link = "";
    this.hide = () => {
      this.setAttribute("aria-hidden", "true");
    };
    this.show = () => {
      this.setAttribute("aria-hidden", "false");
    };
    this.filterByTags = (tags) => {
      if (tags.size === 0) {
        this.show();
        return;
      }
      let match = false;
      for (const tag of tags) {
        if (this.tagsArray.includes(tag.trim().toLowerCase())) {
          match = true;
          break;
        }
      }
      if (match) {
        this.show();
      } else {
        this.hide();
      }
    };
  }
  get tagsArray() {
    return this.tags.split(",").map((tag) => tag.trim().toLowerCase());
  }
  render() {
    return html8`
      <div class="wrap" mobile="${this.mobile}" dk="${this.desktop}">
        ${this.link ? html8`<a href="${this.link}"></a>` : html8``}
        <div class="image" style="--bg-img: url('${this.image}')"></div>
        <div class="content">
          <div class="before">
            <slot name="before"></slot>
          </div>
          <div class="title">
            <slot name="title"></slot>
          </div>
          <div class="text">
            <slot name="text"></slot>
          </div>
          <div class="after">
            <slot name="after"></slot>
          </div>
        </div>
      </div>
    `;
  }
};
NineArticleCard.styles = css7`
    :host {
      display: block;
      width: 100%;
      position: relative;
      text-align: left;

      background: white;
      border-radius: var(--border-radius, 8px);
      box-shadow: var(--light-shadow);
      box-sizing: border-box;

      transition: all 0.5s ease-in-out;
    }

    :host([aria-hidden="true"]) {
      display: none;
      opacity: 0;
      overflow: hidden;
      pointer-events: none;
      transform: translateY(-1em);
    }

    :host([aria-hidden="false"]) {
      display: block;
      opacity: 1;
      position: relative;
      pointer-events: auto;
      transform: translateY(0);
    }

    .image {
      width: 100%;
      aspect-ratio: 1.73;
      background-color: var(--color-cream);
      background-image: var(--bg-img);
      background-size: cover;
      background-position: 50% 25%;
      border-radius: var(--border-radius, 8px);
      margin-bottom: var(--space-md);
    }

    .before {
      margin-bottom: var(--space-sm);
    }

    .title {
      margin-bottom: var(--space-sm);
    }

    .text {
      flex: 1;
    }

    .after {
      margin-top: var(--space-sm);
      font-weight: 400;
      font-size: calc(var(--sm-scale) * 0.88);
      line-height: 140%;
      letter-spacing: -0.02em;
      opacity: 0.6;
    }

    ::slotted(p),
    ::slotted(h5) {
      margin: 0 !important;
    }

    ::slotted(h5) {
      --font-size-h5: calc(var(--font-size) * 1.13);
    }

    .wrap {
      padding: var(--space-sm);
      position: relative;
    }

    .wrap > a {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    .wrap,
    .content {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      height: 100%;
    }

    .content {
      flex: 1;
      height: auto;
    }

    @media screen and (min-width: 400px) {
      .wrap {
        padding: var(--space-md);
      }
    }

    .wrap[dk="mini"] {
      position: relative;
      flex-direction: row;
      padding: var(--space-sm);
    }
    .wrap[dk="mini"] .image {
      aspect-ratio: 1;
      height: 6.3em;
      left: 0;
      min-width: 80px;
      top: 0;
      width: calc(36% - var(--space-xs));
      margin: 0 var(--space-md) 0 0;
    }
    .wrap[dk="mini"] .title {
      margin-bottom: 0;
      flex: 1;
    }
    .wrap[dk="mini"] .text {
      display: none;
    }
    .wrap[dk="mini"] .before {
      display: none;
    }

    @media screen and (max-width: 420px) {
      .wrap[mobile="mini"] {
        position: relative;
        flex-direction: row;
        padding: var(--space-sm);
      }
      .wrap[mobile="mini"] .image {
        aspect-ratio: 1;
        height: 6.3em;
        left: 0;
        min-width: 80px;
        top: 0;
        width: calc(36% - var(--space-xs));
        margin: 0 var(--space-md) 0 0;
      }
      .wrap[mobile="mini"] .title {
        margin-bottom: 0;
        flex: 1;
      }
      .wrap[mobile="mini"] .text {
        display: none;
      }
      .wrap[mobile="mini"] .before {
        display: none;
      }
    }
  `;
__decorateClass([
  property6({ type: String })
], NineArticleCard.prototype, "image", 2);
__decorateClass([
  property6({ type: String })
], NineArticleCard.prototype, "tags", 2);
__decorateClass([
  property6({ type: String })
], NineArticleCard.prototype, "mobile", 2);
__decorateClass([
  property6({ type: String })
], NineArticleCard.prototype, "desktop", 2);
__decorateClass([
  property6({ type: String })
], NineArticleCard.prototype, "link", 2);

// src/components/article-card/article-card.ts
var article_card_default = NineArticleCard;
NineArticleCard.define("nine-article-card");

// src/components/article-detail/article-detail.component.ts
import { html as html9, unsafeCSS as unsafeCSS5 } from "lit";

// src/components/article-detail/article-detail.scss?inline
import { css as css8 } from "lit-element/lit-element.js";
var article_detail_default = css8`:host {
  display: block;
  box-sizing: border-box;
  position: relative;
  padding: var(--space-md) var(--space-md) var(--space-lg);
  z-index: 5;
}

.article {
  max-width: var(--section-max-width, var(--page-max-width));
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.main {
  width: 100%;
}

::slotted([slot=intro]) {
  margin-bottom: 2.5em;
}

.side {
  padding-left: var(--space-xxxl);
}

.recent {
  margin-top: var(--space-xl);
}

.form {
  margin-top: var(--space-xl);
}

.share {
  margin-top: var(--space-xl);
}

.extra {
  margin-top: var(--space-xl);
}

@media screen and (max-width: 959px) {
  .side {
    padding-left: 0;
    padding-top: var(--space-xl);
  }
}
@media screen and (min-width: 960px) {
  .article {
    flex-direction: row;
  }
  .main {
    width: 53%;
  }
  .side {
    max-width: 47%;
    box-sizing: border-box;
  }
}
@media screen and (min-width: 1024px) {
  :host {
    padding-top: 0;
  }
}`;

// src/components/article-detail/article-detail.component.ts
var NineArticleDetail = class extends NineElement {
  render() {
    return html9`
      <div class="article">
        <div class="main">
          <div class="intro"><slot name="intro"></slot></div>
          <div class="content"><slot name="content"></slot></div>
        </div>
        <div class="side">
          <div class="authors"><slot name="authors"></slot></div>
          <div class="recent"><slot name="recent"></slot></div>
          <div class="form"><slot name="form"></slot></div>
          <div class="share"><slot name="share"></slot></div>
          <div class="extra"><slot name="extra"></slot></div>
        </div>
      </div>
    `;
  }
};
NineArticleDetail.styles = unsafeCSS5(article_detail_default);

// src/components/article-detail/article-detail.ts
var article_detail_default2 = NineArticleDetail;
NineArticleDetail.define("nine-article-detail");

// src/components/article-filter/article-filter.component.ts
import { css as css9, html as html10 } from "lit";
import { property as property7 } from "lit/decorators.js";
var NineArticleFilter = class extends NineElement {
  constructor() {
    super(...arguments);
    this.title = "";
  }
  render() {
    return html10`
      <div class="wrap">
        <h5>${this.title}</h5>
        <slot></slot>
      </div>
    `;
  }
};
NineArticleFilter.styles = css9`
    :host {
      display: block;
      width: 100%;
    }

    .wrap {
      display: flex;
      min-width: 100%;
      position: relative;
      align-items: center;
      grid-gap: var(--space-xs);
      overflow-x: auto;
      margin: -1em calc(var(--pad-x, var(--space-md)) * -1) -3em;
      padding: 1em var(--pad-x, var(--space-md)) 5em;
    }

    h5 {
      font-weight: 500;
      /* mobile 20px */
      font-size: var(--font-size-h5);
      line-height: 140%;
      letter-spacing: -0.02em;
      display: none;
      margin: 0 0.5em 0 0;
    }

    @media (min-width: 768px) {
      h5 {
        display: block;
      }
    }
  `;
__decorateClass([
  property7({ type: String })
], NineArticleFilter.prototype, "title", 2);

// src/components/article-filter/article-filter.ts
var article_filter_default = NineArticleFilter;
NineArticleFilter.define("nine-article-filter");

// src/components/article-grid/article-grid.component.ts
import { css as css10, html as html11 } from "lit";
import { property as property8 } from "lit/decorators.js";
var NineArticleGrid = class extends NineElement {
  constructor() {
    super(...arguments);
    this.pageSize = 99;
    this.total = 0;
    this.visible = this.pageSize;
    this.tags = "";
    this.dir = "";
    this.gap = "lg";
    this.activeTags = /* @__PURE__ */ new Set();
    this.allArticles = [];
    this.updateArticleVisibility = () => {
      this.allArticles.forEach((article, index) => {
        if (index < this.visible) {
          article.show();
        } else {
          article.hide();
        }
      });
    };
  }
  get tagsArray() {
    return this.tags.split(",").map((tag) => tag.trim()).filter(Boolean).sort();
  }
  get hasMore() {
    return this.total > this.visible;
  }
  firstUpdated() {
    this.indexArticles();
    this.updateArticleVisibility();
    this.listenForArticleUpdates();
  }
  listenForArticleUpdates() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          this.indexArticles();
          this.updateArticleVisibility();
        }
      });
    });
    observer.observe(this, {
      childList: true,
      subtree: true
    });
  }
  indexArticles() {
    this.allArticles = [
      ...this.querySelectorAll("nine-article-card")
    ];
  }
  loadMore() {
    this.visible += this.pageSize;
    this.updateArticleVisibility();
  }
  toggleTag(tag) {
    const newSet = new Set(this.activeTags);
    if (newSet.has(tag)) {
      newSet.delete(tag);
    } else {
      newSet.add(tag);
    }
    this.activeTags = newSet;
    this.allArticles.forEach((article, index) => {
      const isOnPage = index < this.visible;
      if (isOnPage) {
        article.filterByTags(this.activeTags);
      }
    });
  }
  render() {
    return html11`
            ${this.tagsArray.length > 0 ? html11`
                        <nine-article-filter title="Filter by categories:">
                            ${this.tagsArray.map(
      (tag) => html11`
                                                <nine-pill
                                                        type="outline"
                                                        action="true"
                                                        checked="${this.activeTags.has(tag)}"
                                                        @click="${() => this.toggleTag(tag)}"
                                                        tabindex="0"
                                                >${tag}
                                                </nine-pill
                                                >`
    )}
                        </nine-article-filter>` : ""}
            <div
                    class="wrap"
                    dir="${this.dir}"
                    style="--gap: var(--space-${this.gap})"
            >
                <slot></slot>
            </div>
        `;
  }
};
NineArticleGrid.styles = css10`
      .wrap {
        display: grid;
        width: 100%;
        grid-gap: calc(var(--gap) * 0.6);
      }

      .btn {
        margin: var(--space-xl) 0 0;
        display: flex;
        justify-content: center;
      }

      @media (min-width: 660px) {
        .wrap {
          /* 2 columns */
          grid-template-columns: repeat(2, 1fr);
        }

        .wrap[dir="v"] {
          grid-template-columns: repeat(1, 1fr);
        }
      }

      @media (min-width: 990px) {
        .wrap {
          /* 3 columns */
          grid-template-columns: repeat(3, 1fr);
          grid-gap: var(--gap);
        }

        .wrap[dir="v"] {
          grid-template-columns: repeat(1, 1fr);
        }
      }
    `;
__decorateClass([
  property8({ type: Number })
], NineArticleGrid.prototype, "pageSize", 2);
__decorateClass([
  property8({ type: Number })
], NineArticleGrid.prototype, "total", 2);
__decorateClass([
  property8({ type: Number })
], NineArticleGrid.prototype, "visible", 2);
__decorateClass([
  property8({ type: String })
], NineArticleGrid.prototype, "tags", 2);
__decorateClass([
  property8({ type: String })
], NineArticleGrid.prototype, "dir", 2);
__decorateClass([
  property8({ type: String })
], NineArticleGrid.prototype, "gap", 2);
__decorateClass([
  property8({ type: Array })
], NineArticleGrid.prototype, "activeTags", 2);

// src/components/article-grid/article-grid.ts
var article_grid_default = NineArticleGrid;
NineArticleGrid.define("nine-article-grid");

// src/components/article-preview/article-preview.component.ts
import { css as css11, html as html12 } from "lit";
var NineArticlePreview = class extends NineElement {
  render() {
    return html12`
      <div>
        <slot></slot>
      </div>
    `;
  }
};
NineArticlePreview.styles = css11`
    :host {
      display: block;
    }

    ::slotted(.as-eyebrow),
    ::slotted(p) {
      color: var(--color-charcoal-80);
    }
  `;

// src/components/article-preview/article-preview.ts
var article_preview_default = NineArticlePreview;
NineArticlePreview.define("nine-article-preview");

// src/components/avatar/avatar-list.component.ts
import { css as css12, html as html13 } from "lit";
var NineAvatarList = class extends NineElement {
  render() {
    return html13`<slot></slot>`;
  }
};
NineAvatarList.styles = css12`
    :host {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin: 0 0 1rem 0;
    }

    ::slotted(nine-avatar) {
      margin: 0 -0.6em;
    }
  `;

// src/components/avatar/avatar-list.ts
var avatar_list_default = NineAvatarList;
NineAvatarList.define("nine-avatar-list");

// src/components/avatar/avatar.component.ts
import { html as html14, unsafeCSS as unsafeCSS6 } from "lit";
import { property as property9 } from "lit/decorators.js";

// src/components/avatar/avatar.scss?inline
import { css as css13 } from "lit-element/lit-element.js";
var avatar_default = css13`:host {
  display: block;
}

@keyframes showAvatar {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.avatar {
  display: block;
  --size: 3.25rem;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  background-color: white;
  border: 2px solid white;
  /* background image */
  background-size: cover;
  background-position: center;
  background-image: var(--img);
  /* animation */
  opacity: 0;
  animation: showAvatar var(--ease-time-long) var(--ease-type) forwards;
}`;

// src/components/avatar/avatar.component.ts
var NineAvatar = class extends NineElement {
  constructor() {
    super(...arguments);
    this.img = "";
    this.name = "";
  }
  render() {
    return html14`
      <div
        class="avatar"
        style="--img: url(${this.img})"
        aria-label="${this.name}"
      ></div>
    `;
  }
};
NineAvatar.styles = unsafeCSS6(avatar_default);
__decorateClass([
  property9({ type: String })
], NineAvatar.prototype, "img", 2);
__decorateClass([
  property9({ type: String })
], NineAvatar.prototype, "name", 2);

// src/components/avatar/avatar.ts
var avatar_default2 = NineAvatar;
NineAvatar.define("nine-avatar");

// src/components/benefit/benefit.component.ts
import { css as css14, html as html15 } from "lit";
import { property as property10 } from "lit/decorators.js";
var NineBenefit = class extends NineElement {
  constructor() {
    super(...arguments);
    this.icon = "delivery";
    this.content = "Content";
    this.icons = {
      delivery: html15`
      <svg
        width="1000"
        height="1000"
        viewBox="0 0 1000 1000"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M963.88 185.21H289.67C277.6 185.21 267.28 193.9 265.24 205.8L248.32 304.29H11.3301V332.09H243.55L229.26 415.3H84.6901V443.1H224.48L210.19 526.31H18.6801V554.11H205.41L191.12 637.32H109.14V665.12H186.34L165.61 785.8C163.01 800.94 174.67 814.78 190.04 814.78H864.26C876.33 814.78 886.64 806.08 888.69 794.19L988.31 214.18C990.91 199.04 979.25 185.2 963.88 185.2V185.21ZM693.22 222.52L653.76 428.81H514.87L550.74 222.52H693.22ZM292.21 213.01H524.32C524.2 213.5 524.02 213.95 523.93 214.45L486.67 428.71C484.14 443.28 495.35 456.61 510.14 456.61H657.06C668.48 456.61 678.3 448.49 680.45 437.27L721.44 223.01C722.1 219.56 721.96 216.18 721.2 213.01H848.85C800.64 518.11 542.18 719.75 411.08 786.99H193.62L292.21 213.01Z"
          fill="var(--color-charcoal-60)"
        />
      </svg>
    `,
      moneyBack: html15`
      <svg
        width="1000"
        height="1000"
        viewBox="0 0 1000 1000"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M604.026 529.372C605.729 503.035 591.679 483.693 577.629 472.171C569.114 464.352 550.381 455.71 540.589 452.006C535.905 449.949 529.093 447.479 520.153 444.187V362.706C538.034 366.41 550.807 377.521 558.044 395.216L599.342 372.171C584.441 339.661 558.044 320.731 520.153 315.792V279.167H492.479V315.381C469.062 317.438 449.052 325.669 433.299 340.072C417.546 354.475 409.457 372.994 409.457 396.039C409.457 421.142 418.398 440.072 435.854 453.241C454.161 466.41 466.934 471.759 492.479 481.224V566.821C466.082 563.94 447.775 550.772 437.982 526.492L395.833 549.949C410.734 587.809 445.22 610.442 492.479 613.323V649.537H520.153V612.912C569.966 606.739 604.026 575.875 604.026 529.372ZM458.419 396.039C458.419 377.932 471.617 365.175 492.479 361.883V433.488C468.211 422.377 458.419 412.912 458.419 396.039ZM520.153 491.512C543.995 501.8 555.064 511.677 555.064 529.784C555.064 547.891 542.717 561.883 520.153 566.41V491.512Z"
          fill="var(--color-charcoal-60)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M194 456V228.428L500.5 113.891L725.428 197.945C722.3 458.282 616.69 748.676 357.678 808.216C272.795 738.612 194 624.274 194 456ZM500.15 84.1309C500.376 84.0465 500.624 84.0465 500.85 84.1309L835 209V456C835 747.5 612 886.667 500.5 916C389 886.667 166 747.5 166 456V209L500.15 84.1309Z"
          fill="var(--color-charcoal-60)"
        />
      </svg>
    `
    };
  }
  render() {
    var _a2;
    return html15`
      <div class="icon">${(_a2 = this.icons[this.icon]) != null ? _a2 : ""}</div>
      <p>${this.content}</p>
    `;
  }
};
NineBenefit.styles = css14`
    :host {
      display: flex;
      align-items: center;
      grid-gap: calc(var(--sm-scale) * 0.5);
    }

    .icon {
      width: calc(var(--sm-scale) * 2.5);
      height: calc(var(--sm-scale) * 2.5);
    }

    svg {
      width: 100%;
      height: 100%;
    }

    p {
      font-weight: 500;
      font-size: var(--font-size);
      line-height: 140%;
      letter-spacing: -0.02em;
      margin: 0;
      color: var(--color-charcoal-60);
    }
  `;
__decorateClass([
  property10({ type: String })
], NineBenefit.prototype, "icon", 2);
__decorateClass([
  property10({ type: String })
], NineBenefit.prototype, "content", 2);

// src/components/benefit/benefit.ts
var benefit_default = NineBenefit;
NineBenefit.define("nine-benefit");

// src/components/bg/bg.component.ts
import { html as html16, unsafeCSS as unsafeCSS7 } from "lit";
import { property as property11 } from "lit/decorators.js";

// src/components/bg/bg.scss?inline
import { css as css15 } from "lit-element/lit-element.js";
var bg_default = css15`:host {
  display: block;
  width: 100%;
}

.bg {
  position: relative;
  height: 100%;
}

.shape {
  display: none;
}

.linear {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  --gradient-dir: 180deg;
}

.bg[wide-gradient] .linear {
  left: 50%;
  transform: translateX(-50%);
  width: 120%;
}

.ball {
  position: absolute;
  top: -15rem;
  left: 0;
  width: 100%;
  pointer-events: none;
  overflow: hidden;
  height: calc(100% + 15rem);
}
.ball::before {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -40%);
  --gradient-dir: 180deg;
  top: 0;
  width: min(200vw, 1100px);
  aspect-ratio: 1;
  border-radius: 50%;
}
.ball::after {
  content: "";
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  right: 0;
  height: 30rem;
  background: linear-gradient(180deg, #fffcf3 0%, rgba(255, 252, 243, 0) 100%);
}

/* Curve */
.curve {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}
.curve::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: scale(1.2);
}

.content {
  position: relative;
  height: 100%;
}

.bg[curve=sunrise] .shape {
  display: block;
  width: var(--img-width);
  height: var(--img-height);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scaleX(var(--scale-x)) scaleY(var(--scale-y));
}

/* Ball */
.bg[ball=sunrise] .ball::before {
  background-image: var(--wcl-bg-gradient-sunrise, linear-gradient(var(--gradient-dir), var(--color-sunrise-blue) 13.49%, var(--color-sunrise-pink) 51.22%, var(--color-sunrise-orange) 85.11%));
}
.bg[ball=sunrise-light] .ball::before {
  background-image: var(--wcl-bg-gradient-sunrise-light, linear-gradient(var(--gradient-dir), #a6c6ff 5.3%, #fad0e8 48.44%, #ffd199 90.45%));
}

/* Linear */
.bg[variant=sunrise] .linear {
  background-image: var(--wcl-bg-gradient-sunrise, linear-gradient(var(--gradient-dir), var(--color-sunrise-blue) 13.49%, var(--color-sunrise-pink) 51.22%, var(--color-sunrise-orange) 85.11%));
}
.bg[variant=sunrise-light] .linear {
  background-image: var(--wcl-bg-gradient-sunrise-light, linear-gradient(var(--gradient-dir), #a6c6ff 5.3%, #fad0e8 48.44%, #ffd199 90.45%));
}
.bg[variant=sunrise][fade=true] .linear {
  box-shadow: 0 5em 4em 1em var(--color-sunrise-orange), 0 -5em 4em 1em var(--color-sunrise-blue);
}
.bg[variant=sunrise-light][fade=true] .linear {
  box-shadow: 0 5em 4em 1em #ffd199, 0 -5em 4em 1em #a6c6ff;
}

@keyframes moveBackgroundX {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100% 0;
  }
}
.bg[variant=animate-primary] {
  overflow: hidden;
}
.bg[variant=animate-primary] .linear[fixed] {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100vw;
}
.bg[variant=animate-primary] .linear::before, .bg[variant=animate-primary] .linear::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 150%;
  height: 100%;
}
.bg[variant=animate-primary] .linear::after {
  background-image: linear-gradient(180deg, #fffcf3 10.42%, rgba(255, 252, 243, 0) 100%);
}
.bg[variant=animate-primary] .linear::before {
  background-image: var(--wcl-bg-gradient-sunrise-repeating, linear-gradient(var(--gradient-dir, 90deg), #80b6ff 0%, #f7bde6 16.666%, #ffbd70 33.332%, #f7bde6 50%, #80b6ff 66.66%, #f7bde6 83.33%, #ffbd70 100%));
  background-size: 300% 100%;
  transform: rotate(-20deg) scaleX(2.2) scaleY(1.8);
  transform-origin: 50% 55%;
}
.bg[variant=animate-primary] .linear[fullcolor]::after {
  content: none;
}
.bg[variant=animate-primary] .linear[active]::before {
  animation: moveBackgroundX 12s linear infinite;
}`;

// src/components/bg/bg.component.ts
var NineBg = class extends NineElement {
  constructor() {
    super(...arguments);
    // set width and height of image and scale it adequately
    this.imgWidth = 100;
    this.imgHeight = 217;
    this.handleScale = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const scaleX = windowWidth / this.imgWidth;
      const scaleY = windowHeight / this.imgHeight;
      this.style.setProperty("--scale-x", `${scaleX}`);
      this.style.setProperty("--scale-y", `${scaleY * 1.2}`);
    };
    this.variant = "sunrise-light";
    this.ball = "";
    this.curve = "";
    this.fade = "false";
    this.fixed = false;
    this.active = false;
    this.fullcolor = false;
    this.hideBg = false;
    this.wideGradient = false;
  }
  firstUpdated() {
    this.handleScale();
    window.addEventListener("resize", this.handleScale, { passive: true });
    this.checkSupport();
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this.handleScale);
  }
  checkSupport() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.active = !isSafari;
  }
  render() {
    if (this.hideBg) {
      return html16` <slot></slot>`;
    }
    return html16`
      <div
        class="bg"
        fade="${this.fade}"
        variant="${this.variant}"
        ball="${this.ball}"
        curve="${this.curve}"
        ?wide-gradient=${this.wideGradient}
      >
        <div class="linear" ?fixed=${this.fixed} ?active=${this.active} ?fullcolor=${this.fullcolor}></div>
        <div class="ball"></div>
        <div class="curve"></div>
        <img
          src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzc1IiBoZWlnaHQ9IjgxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGZpbGw9InVybCgjYikiIGQ9Ik0tNzM5LjAyOS00NjloMTQ4MC4wNXYxNTU1aC0xNDgwLjA1eiIvPjxwYXRoIGQ9Ik0xNDAuMjUzIDQ0MS41MDdDMTAuMTI3IDcyOS4yMjEtNDguNTE0IDc0Ni4wNDEtMTU3LjY1NiA3NDYuMDQxVjgxMmg2MDYuMjYyVjkzYy0xNDYuOTExIDAtMTg3LjI4NiA4MC44MjItMzA4LjM1MyAzNDguNTA3WiIgZmlsbD0idXJsKCNjKSIvPjwvZz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSI3LjE5NCIgeTE9Ii0yNjQuNzU5IiB4Mj0iLTQuNDA3IiB5Mj0iODU5Ljc2OSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiM4MEFFRkYiLz48c3RvcCBvZmZzZXQ9Ii41MjciIHN0b3AtY29sb3I9IiNGN0JERTYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRkJENzAiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iYyIgeDE9IjM4NS45NDEiIHkxPSItNzIuNSIgeDI9IjIyLjAwMyIgeTI9IjkwMi41NzQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjRkZCRDcwIi8+PHN0b3Agb2Zmc2V0PSIuNTI3IiBzdG9wLWNvbG9yPSIjRjdCREU2Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODBBRUZGIi8+PC9saW5lYXJHcmFkaWVudD48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMzc1djgxMkgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg=="
          class="shape"
          style="
            --img-width: ${this.imgWidth}px;
            --img-height: ${this.imgHeight}px;
          "
        />
        <div class="content">
          <slot></slot>
        </div>
      </div>
    `;
  }
};
NineBg.styles = unsafeCSS7(bg_default);
__decorateClass([
  property11({ type: String })
], NineBg.prototype, "variant", 2);
__decorateClass([
  property11({ type: String })
], NineBg.prototype, "ball", 2);
__decorateClass([
  property11({ type: String })
], NineBg.prototype, "curve", 2);
__decorateClass([
  property11({ type: String })
], NineBg.prototype, "fade", 2);
__decorateClass([
  property11({ type: Boolean })
], NineBg.prototype, "fixed", 2);
__decorateClass([
  property11({ type: Boolean })
], NineBg.prototype, "active", 2);
__decorateClass([
  property11({ type: Boolean })
], NineBg.prototype, "fullcolor", 2);
__decorateClass([
  property11({ type: Boolean, attribute: "hide-bg" })
], NineBg.prototype, "hideBg", 2);
__decorateClass([
  property11({ type: Boolean, attribute: "wide-gradient" })
], NineBg.prototype, "wideGradient", 2);

// src/components/bg/bg.ts
var bg_default2 = NineBg;
NineBg.define("nine-bg");

// src/components/bottom-navbar/bottom-navbar.component.ts
import { css as css16, html as html17 } from "lit";
import { property as property12 } from "lit/decorators.js";
var NineBottomNavbar = class extends NineElement {
  constructor() {
    super(...arguments);
    this.backgroundColor = "";
  }
  render() {
    return html17`
      <div style="--background-color: ${this.backgroundColor};">
        <div class="center">
          <slot name="content"></slot>
          <slot name="button"></slot>
        </div>
      </div>
    `;
  }
};
NineBottomNavbar.styles = css16`
    :host {
      display: block;
      --background-color: #fff;
      background-color: var(--background-color);
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .center {
      box-sizing: border-box;
      width: min(var(--page-max-width-narrow), 100%);
      margin: 0 auto;
      padding: calc(var(--space-sm) * 1.25) var(--space-md);
      display: flex;
      justify-content: space-between;
      align-items: center;
      grid-gap: calc(var(--space-sm) * 1.5);
    }
  `;
__decorateClass([
  property12({ type: String })
], NineBottomNavbar.prototype, "backgroundColor", 2);

// src/components/bottom-navbar/bottom-navbar.ts
var bottom_navbar_default = NineBottomNavbar;
NineBottomNavbar.define("nine-bottom-navbar");

// src/components/breadcrumbs/breadcrumbs.component.ts
import { css as css17, html as html18 } from "lit";
var NineBreadcrumbs = class extends NineElement {
  render() {
    return html18`
      <div class="wrap">
        <div class="mob"><slot name="back"></slot></div>
        <div class="links"><slot></slot></div>
      </div>
    `;
  }
};
NineBreadcrumbs.styles = css17`
    :host {
      display: flex;
      align-items: center;
      padding: 0 var(--space-md);
      --arrow-icon: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB0SURBVHgB7dQxCoAwDADAoHOW0sWptIN9rd/wAfoOnyKl4B4J6GYtBLLlli4hTUIIgDHMe48gNPQCQggTIq4ppRkExl5ArfVyzh1EtPBbSjlBA3cQY9ylndgnTd0t+kGg4al+UxmRJf+Uc0a15C++R2BMyw2vLiQ1bFLWtQAAAABJRU5ErkJggg==");
    }

    .wrap {
      max-width: var(--section-max-width, var(--page-max-width));
      width: 100%;
      margin: 6em auto 1em;
    }

    ::slotted(a) {
      color: var(--color-text);
      font-weight: 450 !important;
      font-size: 0.9em !important;
      display: flex;
      align-items: center;
      color: var(--color-charcoal-80) !important;
    }

    .links ::slotted(a)::after {
      content: "";
      background-image: var(--arrow-icon);
      background-size: contain;
      background-repeat: none;
      background-position: center;
      width: 24px;
      height: 24px;
      margin-bottom: 2px;
      display: inline-block;
    }

    .links ::slotted(a:last-of-type)::after {
      display: none;
    }

    .mob {
      display: flex;
      align-items: center;
    }
    .mob::before {
      content: "";
      background-image: var(--arrow-icon);
      transform: rotate(180deg);
      background-size: contain;
      background-repeat: none;
      background-position: center;
      width: 24px;
      height: 24px;
      margin-bottom: 2px;
      display: inline-block;
    }

    .links {
      display: none;
    }
    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      .links {
        display: flex;
      }
      .mob {
        display: none;
      }
    }
  `;

// src/components/breadcrumbs/breadcrumbs.ts
var breadcrumbs_default = NineBreadcrumbs;
NineBreadcrumbs.define("nine-breadcrumbs");

// src/components/button/button.component.ts
import { html as html19, unsafeCSS as unsafeCSS8 } from "lit";
import { property as property13 } from "lit/decorators.js";

// src/lib/styleInject.ts
function styleInject(css120) {
  if (!css120 || typeof document === "undefined") {
    return;
  }
  const head = document.head || document.getElementsByTagName("head")[0];
  const style = document.createElement("style");
  style.type = "text/css";
  head.appendChild(style);
  style.appendChild(document.createTextNode(css120));
}
var styleInject_default = styleInject;

// src/components/button/button.global.scss?inline
import { css as css18 } from "lit-element/lit-element.js";
var button_global_default = css18`nine-button a, nine-button a span {
  color: inherit !important;
  -webkit-background-clip: initial !important;
  -webkit-text-fill-color: initial !important;
  background: transparent !important;
  font-family: var(--font-family) !important;
  text-decoration: none !important;
  font-weight: 500 !important;
}

nine-button strong {
  font-weight: 700 !important;
}`;

// src/components/button/button.scss?inline
import { css as css19 } from "lit-element/lit-element.js";
var button_default = css19`:host {
  --size: calc(var(--scale) * 2.82);
  font-family: var(--font-family);
  text-decoration: none;
  font-weight: 500;
  display: inline-block;
  z-index: 1;
  border-radius: 500px;
}

:host([ml]),
:host([mx]) {
  margin-left: var(--space-sm);
}

:host([mr]),
:host([mx]) {
  margin-right: var(--space-sm);
}

:host([mt]),
:host([my]) {
  margin-top: var(--space-sm);
}

:host([mb]),
:host([my]) {
  margin-bottom: var(--space-sm);
}

:host([fullWidth=true]) {
  width: 100%;
}

.wrap {
  display: inline-block;
  min-width: var(--size);
  border-radius: inherit;
  font-weight: 500;
  box-shadow: 0 0 0 1px transparent;
  transition: box-shadow calc(var(--ease-time) * 3) var(--ease-type);
  transition-property: box-shadow, background, opacity, filter;
  opacity: 1;
  filter: grayscale(0);
  /* overflow: hidden; */
  display: block;
  position: relative;
  cursor: pointer;
  z-index: 1;
}

.wrap[fontWeight=light] {
  font-weight: 300;
}

.wrap[fontWeight=normal] {
  font-weight: 400;
}

.wrap[fontWeight=bold] {
  font-weight: 700;
}

.wrap::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  z-index: -1;
}

.ui-el {
  --side-gap: calc(var(--scale) * 1.6);
  display: block;
  font-family: inherit;
  padding: 1em calc(var(--side-gap) * 0.8) 0.83em var(--side-gap);
  font-size: inherit;
  outline: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: inherit;
  background: transparent;
  color: inherit;
  text-decoration: none;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background var(--ease-time) var(--ease-type);
  border-radius: inherit;
  color: var(--button-color);
  /* No line breaks */
  white-space: nowrap;
}
.ui-el[breakText=true] {
  white-space: normal;
  text-align: center;
}
.ui-el:hover {
  color: var(--button-color-hover);
}

.ui-el * {
  pointer-events: none;
}

.wrap[size=sm] .ui-el {
  --side-gap: calc(var(--scale) * 1);
  padding: 0.4em calc(var(--side-gap) * 0.8) 0.3em var(--side-gap);
}

.wrap[size=md] .ui-el {
  --side-gap: calc(var(--scale) * 1);
  padding: 0.7em calc(var(--side-gap) * 1.3) 0.4em calc(var(--side-gap) * 1.2);
}

.wrap[variant=ghost] .ui-el {
  background: transparent;
}

.wrap[variant=fill][color=sunrise] {
  background: var(--gradient-sunrise);
  background-position: var(--gradient-pos);
  background-size: var(--gradient-size);
}

.wrap[variant=fill][color=sunrise-light] {
  background: var(--gradient-sunrise-light);
  background-position: var(--gradient-pos);
  background-size: var(--gradient-size);
}

.wrap[variant=fill][color=black],
.wrap[active=true][color=black] {
  background: transparent;
  color: var(--color-white);
}

.wrap[variant=fill][color=black]::after,
.wrap[active=true][color=black]::after {
  background: var(--black-to-gradient-dusk);
  background-size: 300% 100%;
  background-position-x: 0;
  transform: translateX(0);
  transition: background-position-x calc(var(--ease-time) * 50) var(--ease-type);
}

.wrap[variant=outline],
.wrap[variant=outline-fill] {
  background: var(--gradient-sunrise);
  background-position: var(--gradient-pos);
  background-size: var(--gradient-size);
}

.wrap[variant=outline] .wrap {
  background: transparent;
}

.wrap[variant=outline]::after,
.wrap[variant=outline-fill]::after {
  background: var(--button-background, var(--color-cream));
  position: absolute;
  --padding: 1px;
  left: var(--padding);
  top: var(--padding);
  right: var(--padding);
  bottom: var(--padding);
  border-radius: inherit;
  width: auto;
  height: auto;
}

.wrap[variant=outline][active=true]::after {
  --padding: 0;
}

.wrap[variant=outline] .ui-el {
  background: transparent;
}

.wrap[variant=outline][color=black]:not([active=true]) {
  background: transparent;
}

.wrap[variant=outline][color=black]:not([active=true])::after {
  box-shadow: var(--btn-outline-black-shadow, 0 0 0 1.3px var(--color-charcoal));
  background: transparent;
  border-radius: inherit;
}

.wrap[variant=outline-fill]::after {
  opacity: var(--button-opacity-overlay, 1);
  transition: opacity var(--ease-time) var(--ease-type);
}
.wrap[variant=outline-fill]:hover::after {
  opacity: var(--button-opacity-overlay-hover, 0.4);
}

.arrow {
  display: block;
  height: calc(var(--scale) * 1);
  line-height: 0;
  padding-left: 0.4em;
  transform: translate(0, -5%);
}

.arrow svg {
  height: 100%;
}

.check-icon {
  width: 0;
  opacity: 0;
  padding-right: 0;
  position: relative;
  bottom: -2px;
  transition: all 0.3s ease-out;
}

.wrap[active=true] .check-icon {
  opacity: 1;
  width: 16px;
  padding-right: calc(var(--space-sm) * 0.375);
}

.wrap[shadow=hover]:hover, .wrap[shadow=hover]:focus {
  box-shadow: var(--large-shadow);
  transition: box-shadow calc(var(--ease-time) * 1) var(--ease-type);
}

.wrap[shadow=always] {
  box-shadow: var(--large-shadow);
  transition: box-shadow calc(var(--ease-time) * 1) var(--ease-type);
}

:host(:hover) .wrap[variant=outline][color=black],
:host(:focus) .wrap[variant=outline][color=black] {
  box-shadow: var(--large-shadow);
}

:host(:hover) .wrap[variant=fill][color=black]::after,
:host(:focus) .wrap[variant=fill][color=black]::after,
:host(:hover) .wrap[active=true][color=black]::after,
:host(:focus) .wrap[active=true][color=black]::after {
  background-position-x: 100%;
  transition: background-position-x calc(var(--ease-time) * 2) var(--ease-type);
}

:host(:hover) .ui-el,
:host(:focus) .ui-el,
.wrap[variant=outline] .ui-el,
.wrap[color=black] .ui-el {
  background-color: transparent;
}

.wrap[variant=outline][color=black]:not([active=true]):hover {
  background: white;
}

.wrap[direction=left] .ui-el {
  flex-direction: row-reverse;
  padding: 1em var(--side-gap) 0.83em calc(var(--side-gap) * 0.8);
}

.wrap[rounded=true] {
  border-radius: 8px;
}

.wrap[round=true],
.wrap[rounded=true] {
  width: var(--size);
  height: var(--size);
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrap[round=true] .ui-el,
.wrap[rounded=true] .ui-el {
  border-radius: var(--size);
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: center;
}

.wrap[round=true] .arrow,
.wrap[rounded=true] .arrow {
  padding: 0;
}

.wrap[direction=right] .arrow {
  transform: rotate(0) translate(0, 0%);
}

.wrap[direction=left] .arrow {
  transform: rotate(180deg) translate(0, 0%);
}

.wrap[direction=up] .arrow {
  transform: rotate(-90deg) translate(0, 5%);
}

.wrap[direction=down] .arrow {
  transform: rotate(90deg) translate(0, -3%);
}

.wrap[disabled=true] {
  opacity: 0.5;
  filter: grayscale(100%);
  pointer-events: none;
}

.wrap[round=true][color=sunrise],
.wrap[round=true][color=sunrise]::after {
  background: transparent;
}

.wrap[padding=equal] .ui-el {
  padding: 1em var(--side-gap) 0.83em;
}
.wrap[padding=equal][size=sm] .ui-el {
  --side-gap: calc(var(--scale) * 1);
  padding: 0.4em var(--side-gap) 0.3em;
}
.wrap[padding=equal][size=md] .ui-el {
  --side-gap: calc(var(--scale) * 1);
  padding: 0.7em calc(var(--side-gap) * 1.2) 0.4em;
}

.wrap[fullWidth=true],
.wrap[fullWidth=true] .ui-el {
  width: 100%;
}

.bg svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

::slotted(*[slot=pre]) {
  position: relative;
  left: -0.32em;
  top: 0.1em;
}

::slotted([slot=icon-gradient]) {
  position: absolute;
  opacity: 0;
  transition: all 0.3s var(--ease-type);
}

:host(:hover) ::slotted([slot=icon-gradient]) {
  opacity: 1;
}

@media screen and (min-width: 960px) {
  :host {
    --size: calc(var(--scale) * 3.2);
  }
}`;

// src/components/button/button.component.ts
styleInject_default(button_global_default);
var NineButton = class extends NineElement {
  constructor() {
    super(...arguments);
    this.name = "";
    this.value = "";
    this.variant = "fill";
    this.type = "";
    this.size = "";
    this.active = "false";
    this.handleActiveState = "false";
    this.color = "sunrise";
    this.href = "";
    this.target = "";
    this.rel = "";
    this.round = "false";
    this.track = "true";
    this.rounded = "false";
    this.disabled = "false";
    this.arrow = ">";
    this.checkmark = "false";
    this.direction = "right";
    this.shadow = "hover";
    this.fontWeight = "";
    this.padding = "default";
    this.parse = false;
    this.breakText = false;
    this.fullWidth = false;
    this.onClick = () => {
    };
    this.arrows = {
      ">": html19` <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m7.25 4.5 4.5 4.5-4.5 4.5"
        stroke="currentColor"
        stroke-width="1.5"
      />
    </svg>`,
      "->": html19` <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.11084 0.719971L7.40427 1.42653L11.6129 5.63517H0.568115V6.63261H11.42L7.40427 10.6483L8.11084 11.3549L13.4273 6.03741L8.11084 0.719971Z"
        fill="#212121"
      />
    </svg>`
    };
    this.textOptions = {};
    this.parseTextOptions = (text) => {
      let newText = text;
      const scrollRegex = /\[scroll=(.*)\]/;
      const scrollMatch = text.match(scrollRegex);
      if (scrollMatch) {
        newText = text.replace(scrollRegex, "").trim();
        this.textOptions.scroll = scrollMatch[1].toLowerCase().trim().replace(/ /g, "-");
      }
      return newText.trim();
    };
    this.checkForContentType = () => {
      const childLink = this.querySelector("a");
      if (childLink) {
        const href = childLink.getAttribute("href");
        if (href) this.href = href;
        const target = childLink.getAttribute("target");
        if (target) this.target = target;
        const currentText = childLink.innerHTML;
        const setText = this.parseTextOptions(currentText);
        if (setText !== currentText) {
          childLink.innerHTML = setText;
        }
      }
    };
    this.toggleActive = () => {
      if (this.handleActiveState === "true") {
        const activeValue = this.active === "true" ? "false" : "true";
        this.active = activeValue;
      }
    };
    this.handleClick = (e) => {
      var _a2, _b, _c;
      this.toggleActive();
      const textContent = (_a2 = this.textContent) == null ? void 0 : _a2.split("hbspt")[0].trim();
      const type = this.href ? "link" : "button";
      const innerLinkHsTarget = (_b = this.querySelector("a")) == null ? void 0 : _b.getAttribute("cta_dest_link");
      const innerLinkHref = (_c = this.querySelector("a")) == null ? void 0 : _c.getAttribute("href");
      const buttonTarget = this.target;
      const target = innerLinkHsTarget || innerLinkHref || buttonTarget;
      const data = {
        "Button Type": type,
        "Link Target": target,
        "Button Text": textContent
      };
      if (this.track === "true") {
        tracker_default.track("ButtonComponent Click", data);
        if (this.href) {
          tracker_default.track("ClickRequestAccess", data);
        }
      }
      if (this.type === "submit") {
        e.preventDefault();
        this.dispatchEvent(
          new CustomEvent("nineInputSubmit", {
            bubbles: true
          })
        );
      }
      this.handleScrollOptionClick(e);
    };
  }
  updated() {
    this.checkForContentType();
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.parse) {
      setInterval(this.checkForContentType, 500);
    }
  }
  renderContent() {
    if (!this.arrow)
      return html19`
        <slot name="pre"></slot>
        ${this.checkmark === "true" ? html19`<span class="check-icon">${CheckSmallWhiteIcon}</span>` : ""}
        <slot></slot>
        <slot name="icon-gradient"></slot>
      `;
    const arrowContent = this.arrows[this.arrow];
    return html19`
      <slot name="pre"></slot>
      ${this.checkmark === "true" ? html19`<span class="check-icon">${CheckSmallWhiteIcon}</span>` : ""}
      <slot></slot>
      ${arrowContent ? html19` <div class="arrow">${arrowContent}</div>` : ""}
    `;
  }
  handleScrollOptionClick(e) {
    if (!this.textOptions.scroll) {
      return;
    }
    const target = this.textOptions.scroll;
    const scrollTarget = document.getElementById(target);
    if (scrollTarget) {
      e.preventDefault();
      const targetPosY = scrollTarget.getBoundingClientRect().top + window.scrollY;
      scrollMainTo(0, targetPosY - 100, true);
    }
  }
  renderMarkup() {
    const content = this.renderContent();
    if (this.href) {
      return html19`<a
        class="ui-el"
        href=${this.href}
        target=${this.target}
        rel=${this.rel}
        variant=${this.variant}
        active=${this.active}
        color=${this.color}
        aria-disabled="${this.disabled === "true"}"
        @click=${this.disabled === "true" ? void 0 : this.handleClick}
      >
        ${content}
      </a>`;
    }
    return html19` <button
      type="${this.type}"
      class="ui-el"
      variant=${this.variant}
      active=${this.active}
      color=${this.color}
      breakText=${this.breakText}
      @click=${this.disabled === "true" ? void 0 : this.handleClick}
      aria-disabled="${this.disabled === "true"}"
    >
      ${content}
    </button>`;
  }
  renderBackground() {
    if (this.color === "sunrise" && this.round === "true" && this.variant === "outline") {
      return html19` <div class="bg">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x=".5"
            y=".5"
            width="39"
            height="39"
            rx="19.5"
            stroke="url(#a)"
          />
          <defs>
            <linearGradient
              id="a"
              x1="20.168"
              y1="5.254"
              x2="19.883"
              y2="34.181"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#80AEFF" />
              <stop offset=".527" stop-color="#F7BDE6" />
              <stop offset="1" stop-color="#FFBD70" />
            </linearGradient>
          </defs>
        </svg>
      </div>`;
    }
    return html19``;
  }
  render() {
    return html19`
      <div
        class="wrap"
        variant=${this.variant}
        active=${this.active}
        size=${this.size}
        color=${this.color}
        round=${this.round}
        rounded=${this.rounded}
        direction=${this.direction}
        shadow=${this.shadow}
        disabled=${this.disabled}
        fontWeight=${this.fontWeight}
        padding=${this.padding}
        fullWidth=${this.fullWidth}
        @click=${this.disabled === "true" ? void 0 : this.onClick}
      >
        ${this.renderBackground()} ${this.renderMarkup()}
      </div>
    `;
  }
};
NineButton.styles = unsafeCSS8(button_default);
__decorateClass([
  property13()
], NineButton.prototype, "name", 2);
__decorateClass([
  property13()
], NineButton.prototype, "value", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "variant", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "type", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "size", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "active", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "handleActiveState", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "color", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "href", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "target", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "rel", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "round", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "track", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "rounded", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "disabled", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "arrow", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "checkmark", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "direction", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "shadow", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "fontWeight", 2);
__decorateClass([
  property13({ type: String })
], NineButton.prototype, "padding", 2);
__decorateClass([
  property13({ type: Boolean })
], NineButton.prototype, "parse", 2);
__decorateClass([
  property13({ type: Boolean })
], NineButton.prototype, "breakText", 2);
__decorateClass([
  property13({ type: Boolean })
], NineButton.prototype, "fullWidth", 2);
__decorateClass([
  property13({ type: Function })
], NineButton.prototype, "onClick", 2);

// src/components/button/button.ts
var button_default2 = NineButton;
NineButton.define("nine-button");

// src/components/card/card-list.component.ts
import { css as css20, html as html20 } from "lit";
import { property as property14 } from "lit/decorators.js";
var NineCardList = class extends NineElement {
  constructor() {
    super(...arguments);
    this.cards = this.querySelectorAll("nine-card");
    this.smallLayoutStyles = (size) => css20`
      @media (max-width: ${size}px) {
        :host .list {
          display: flex;
          flex-direction: column-reverse;
          align-items: stretch;
        }
      }
    `;
    this.layoutSwitch = LAYOUT_SWITCH_AT;
    this.largeVariant = "card";
    this.smallVariant = "row";
    this.gap = "md";
    this.align = "false";
    this.handleResize = () => {
      if (this.layoutSwitch <= 0) {
        return;
      }
      let haveReadMore = true;
      for (const card of this.cards) {
        if (card.moreContent === "false") {
          haveReadMore = false;
        }
        card.variant = window.innerWidth < this.layoutSwitch ? this.smallVariant : this.largeVariant;
      }
      if (!haveReadMore) {
        this.align = "true";
      }
    };
    this.updateCardsList = () => {
      this.cards = this.querySelectorAll("nine-card");
      this.handleResize();
    };
  }
  firstUpdated() {
    this.updateCardsList();
    setTimeout(() => {
      this.updateCardsList();
    }, 200);
    window.addEventListener("resize", this.handleResize, { passive: true });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("resize", this.handleResize);
  }
  render() {
    return html20`
            <style>
                ${this.smallLayoutStyles(this.layoutSwitch)}
            </style>
            <div
                    class="list"
                    align=${this.align}
                    style="${`--gap: var(--space-${this.gap})`}"
            >
                <slot></slot>
            </div>
        `;
  }
};
NineCardList.styles = css20`
      :host {
        display: block;
        width: 100%;
        --list-max-size: 600px;
      }

      .list {
        display: flex;
        width: 100%;
        grid-gap: var(--gap);
        justify-content: flex-start;
        flex-direction: row-reverse;
        align-items: flex-start;
      }

      .list[align="true"] {
        align-items: stretch;
      }
    `;
__decorateClass([
  property14({ type: Number })
], NineCardList.prototype, "layoutSwitch", 2);
__decorateClass([
  property14({ type: String })
], NineCardList.prototype, "largeVariant", 2);
__decorateClass([
  property14({ type: String })
], NineCardList.prototype, "smallVariant", 2);
__decorateClass([
  property14({ type: String })
], NineCardList.prototype, "gap", 2);
__decorateClass([
  property14({ type: String })
], NineCardList.prototype, "align", 2);

// src/components/card/card-list.ts
var card_list_default = NineCardList;
NineCardList.define("nine-card-list");

// src/components/card/card.component.ts
import { html as html22, unsafeCSS as unsafeCSS9 } from "lit";
import { property as property15 } from "lit/decorators.js";
import { createRef as createRef4, ref as ref4 } from "lit/directives/ref.js";

// src/constants/arrows.ts
import { html as html21 } from "lit";
var lineArrow = html21`<svg
  width="20"
  height="21"
  viewBox="0 0 20 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="m10.93 6.27-.6.59 3.51 3.5h-9.2v.83h9.04l-3.34 3.35.59.59 4.43-4.43-4.43-4.43Z"
    fill="currentColor"
  />
</svg>`;
var simpleArrowUp = html21`<svg
  width="16"
  height="16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="m4 10 4-4 4 4" stroke="currentColor" />
</svg>`;

// src/components/card/card.global.scss?inline
import { css as css21 } from "lit-element/lit-element.js";
var card_global_default = css21`nine-card[variant=investor] nine-person {
  --person-position-color: var(--color-charcoal-80);
}

nine-card [slot=icon],
nine-card [slot=icon] svg {
  display: block;
  width: 100%;
  height: auto;
}`;

// src/components/card/card.scss?inline
import { css as css22 } from "lit-element/lit-element.js";
var card_default = css22`:host {
  display: flex;
  flex: 1;
  direction: ltr;
  opacity: var(--item-opacity, 1);
}

.card-container,
.card-inner {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
}

.card {
  max-width: 230px;
  border-radius: var(--border-radius);
  background: var(--color-white);
  box-shadow: var(--light-shadow);
  position: relative;
  padding: 0;
  flex: 1;
  --outline-size: 2px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 0;
  transition: margin-bottom var(--ease-time) var(--ease-type);
}
.card.active.growMore {
  margin-bottom: var(--moreHeight, 0);
  transition: margin-bottom calc(var(--ease-time) * 0.5) var(--ease-type);
}
.card[noCardPaddingMobile=true] {
  padding: 0;
}
.card *[hide-element] {
  display: none;
}

.moreToggle {
  margin-left: auto;
  transform: rotateX(180deg);
  transition: transform var(--ease-time) var(--ease-type);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5em;
}

.more {
  position: absolute;
  flex: 1;
  padding: 1em 1.6em;
  background: inherit;
  left: 0;
  right: 0;
  top: calc(100% - var(--border-radius));
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  border-top: 1px solid var(--color-cream-dark);
  box-shadow: var(--light-shadow);
  pointer-events: none;
  opacity: 0;
  transform: translateY(-0.2em);
  transition: opacity var(--ease-time) var(--ease-type);
  transition-property: opacity, transform;
  z-index: 99;
}

.card[asm=true] {
  flex-direction: column;
  align-items: flex-start;
}

.card[asm=true] .more {
  position: relative;
  opacity: 1;
  transform: none;
  pointer-events: all;
  box-shadow: none;
  margin-top: 1em;
  padding-bottom: 0.5em;
  top: 0;
  margin: 0.4em 0 0;
  left: -1em;
  width: calc(100% + 2em);
  box-sizing: border-box;
}

.card[asm=true] .moreToggle {
  display: none;
}

.card.active .more {
  opacity: 1;
  pointer-events: all;
  transform: translateY(0);
}

.card.active .moreToggle {
  transform: rotateX(0);
}

.card[gradient=true]::after {
  content: "";
  display: block;
  height: var(--border-radius);
  background: var(--gradient-sunrise);
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
}

.card::before {
  counter-increment: cardList;
}

.card ::slotted([slot=title]) {
  font-weight: 500;
  display: block;
  font-size: var(--font-size);
  line-height: 140%;
  letter-spacing: -0.02em;
  margin: 0.1em 0 0;
}

.meta {
  display: flex;
  flex-direction: column;
  align-items: var(--align-items);
  padding: var(--py) var(--px);
}

.icon {
  width: calc(var(--scale) * 3);
  min-width: calc(var(--scale) * 3);
}

.icon[outline=true] {
  border-radius: 200px;
  padding: 0.5em;
  position: relative;
  z-index: 2;
  margin-left: -0.5em;
}

.icon[outline=true]::before,
.icon[outline=true]::after {
  content: "";
  display: block;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 200px;
  position: absolute;
  z-index: -1;
}

.icon[outline=true]::before {
  width: 100%;
  height: 100%;
  --gradient-dir: 180deg;
  background-image: var(--wcl-bg-gradient-sunrise, linear-gradient(var(--gradient-dir), var(--color-sunrise-blue) 13.49%, var(--color-sunrise-pink) 51.22%, var(--color-sunrise-orange) 85.11%));
}

.icon[outline=true]::after {
  width: calc(100% - 3px);
  height: calc(100% - 3px);
  background: var(--color-white);
}

.icon .card[outline=true] {
  box-sizing: border-box;
  padding: var(--outline-size);
  --gradient-dir: 180deg;
  background-image: var(--wcl-bg-gradient-sunrise, linear-gradient(var(--gradient-dir), var(--color-sunrise-blue) 13.49%, var(--color-sunrise-pink) 51.22%, var(--color-sunrise-orange) 85.11%));
}

.card[outline=true] {
  background-image: var(--wcl-bg-gradient-sunrise, linear-gradient(var(--gradient-dir), var(--color-sunrise-blue) 13.49%, var(--color-sunrise-pink) 51.22%, var(--color-sunrise-orange) 85.11%));
}

.card[outline=true] .meta {
  background: var(--bg-inner, var(--color-white));
  border-radius: calc(var(--border-radius) * 0.7);
}

.card[grow=true] {
  max-width: 100%;
  overflow: visible;
}

.starsList {
  font-weight: 500;
  font-size: 1.2rem;
  --gap: 0.1rem;
  --c1: #e1ded4;
  --c2: var(--color-sunrise-orange);
  color: var(--c2);
  background: linear-gradient(90deg, var(--c1) 0%, var(--c1) 50%, var(--c2) 50.01%, var(--c2) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  --fill: calc(100% / -5 * var(--stars));
  background-position: var(--fill) 0;
  background-size: 200% 100%;
  margin-left: calc(var(--gap) * -1);
}

.star {
  margin: var(--gap);
}

.stars {
  display: flex;
  align-items: center;
  grid-gap: 0.8em;
  margin-bottom: var(--space-md);
  color: var(--color-trout);
  /* font-size: 14px; */
  font-size: calc(var(--sm-scale) * 0.88);
}

.card[no-title] .meta {
  display: none;
}
.card[no-title] .more {
  margin: 0;
  border: none;
}

.card[large-radius] {
  --border-radius: 0.5rem;
}`;

// src/components/card/card.variant.bubble.ts
import { css as css23 } from "lit";
var cardVariantBubble = css23`
  :host([variant="bubble"]) {
    display: flex;
    --img-size: calc(8.5rem + 2em);
  }

  .card[variant="bubble"] {
    padding: var(--outline-size, 0);
    max-width: none;
    display: flex;
    height: 100%;
    flex: 1;
    box-shadow: var(--light-shadow);
    border-radius: var(--border-radius);
    margin-top: var(--img-size);
    overflow: visible;
  }

  .card[variant="bubble"]::after {
    border-radius: 0 0 var(--border-radius) var(--border-radius);
  }

  .card[variant="bubble"]::before {
    content: "";
    position: absolute;
    left: calc(50% - 12px);
    top: -12px;
    width: 25px;
    height: 25px;
    background: white;
    display: block;
    border-radius: 2px;
    transform: rotate(45deg);
  }

  .card[variant="bubble"] .meta {
    flex: 1;
    padding: var(--space-lg);
    padding-left: var(--space-md);
    align-items: flex-start;
  }

  .card[variant="bubble"] .extra {
    margin-top: auto;
    font-size: calc(var(--sm-scale) * 0.88);
    line-height: 140%;
    letter-spacing: -0.02em;
    opacity: 0.8;
  }

  .card[variant="bubble"] .image {
    position: absolute;
    right: 50%;
    bottom: 100%;
    width: calc(var(--img-size) - 2em);
    transform: translate(50%, -2em);
  }

  .card[variant="bubble"] ::slotted([slot="image"]) {
    width: 100%;
    height: auto;
    border-radius: 50%;
    overflow: hidden;
    aspect-ratio: 1;
    object-fit: cover;
  }

  .card[variant="bubble"] ::slotted([slot="title"]) {
    margin: 0 0 var(--space-sm) !important;
  }

  .card[variant="bubble"] ::slotted([slot="content"]) {
    margin: 0.3em 0 var(--space-md) !important;
  }

  @media (min-width: 740px) {
    .card[variant="bubble"] {
      margin-left: var(--img-size);
      margin-top: 0;
    }

    .card[variant="bubble"] .image {
      right: calc(100% + 2em);
      top: 0;
      bottom: auto;
      transform: none;
    }

    .card[variant="bubble"]::before {
      top: calc(var(--img-size) * 0.5);
      left: 0;
      transform: rotate(45deg) translate(-25px, -50%);
    }
  }
`;
var card_variant_bubble_default = cardVariantBubble;

// src/components/card/card.variant.card.ts
import { css as css24 } from "lit";
var cardVariantCard = css24`
  .card[variant="card"] {
    align-items: center;
  }
  .card[variant="card"] .meta {
    padding: var(--space-lg) 0;
  }
  .card[variant="card"] ::slotted([slot="title"]) {
    text-align: center;
    margin-top: var(--space-sm);
  }
  .card[variant="card"] .title-space {
    width: 55%;
    min-width: 118px;
  }
`;
var card_variant_card_default = cardVariantCard;

// src/components/card/card.variant.columns.scss?inline
import { css as css25 } from "lit-element/lit-element.js";
var card_variant_columns_default = css25`.card[variant=columns] {
  align-items: flex-start;
  width: 100%;
  --border-radius: 0.5rem;
}
.card[variant=columns]::after {
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}
.card[variant=columns] .title-space {
  padding-bottom: 0.6em;
}
.card[variant=columns] .meta {
  flex-direction: column-reverse;
  gap: 1.5rem;
}
.card[variant=columns] .card[outline=true][variant=columns] .meta {
  border-radius: var(--border-radius);
}
.card[variant=columns] .meta,
.card[variant=columns] .content {
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
}
.card[variant=columns] .icon {
  display: none;
}
.card[variant=columns] .moreToggle {
  display: none;
}

::slotted([slot=right]) {
  width: 100%;
  aspect-ratio: 295/170;
  border-radius: var(--border-radius);
  overflow: hidden;
  display: block;
}

@media screen and (min-width: 960px) {
  .card[variant=columns] .meta {
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
    padding: var(--space-lg) calc(var(--space-sm) * 1.5);
  }
  ::slotted([slot=left]) {
    width: calc(100% + var(--space-xl));
  }
  ::slotted([slot=right]) {
    aspect-ratio: 298/269;
  }
}`;

// src/components/card/card.variant.image-left.ts
import { css as css26 } from "lit";
var cardVariantImageLeft = css26`
  .card[variant="image-left"] {
    --border-radius: 8px;
    max-width: 100%;
  }
  .card[variant="image-left"] .title-space {
    padding: calc(var(--space-sm) * 0.5) calc(var(--space-sm) * 1.5);
  }
  .card[variant="image-left"] .meta {
    padding: 0;
    width: 100%;
    display: grid;
    grid-template-columns: 87px 1fr;
  }
  .card[variant="image-left"] .icon {
    display: none;
  }
  .card[variant="image-left"] .image {
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    min-height: 4.5em;
  }
  .card[variant="image-left"] ::slotted([slot="image"]) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .card[variant="image-left"] ::slotted([slot="title"]) {
    margin: 0;
  }
  .card[variant="image-left"] .extra {
    background: var(--color-cream-dark);
    width: calc(var(--space-sm) * 1.5);
    height: calc(var(--space-sm) * 1.5);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 75px;
    border: 2px solid #fff;
  }
  .card[variant="image-left"] ::slotted([slot="extra"]) {
    font-weight: 400;
    /* font-size: 14px; */
    font-size: calc(var(--sm-scale) * 0.88);
    line-height: 140%;
    letter-spacing: -0.02em;
    width: var(--space-sm);
    height: var(--space-sm);
  }

  @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
    .card[variant="image-left"].growMore {
      min-height: 78px;
    }
  }
`;
var card_variant_image_left_default = cardVariantImageLeft;

// src/components/card/card.variant.image-top.ts
import { css as css27 } from "lit";
var cardVariantImageTop = css27`
  :host([variant="image-top"]) {
    --border-radius: 8px;
    overflow: hidden;
    width: min(204px, calc(90vw - var(--space-md)));
    margin: 0;
    box-shadow: var(--light-shadow);
    display: block;
    border-radius: var(--border-radius);
  }

  .card[variant="image-top"] {
    padding: 0;
    width: 100%;
    max-width: none;
    height: 100%;
  }

  .card[variant="image-top"] .meta {
    padding: 0;
  }

  .card[variant="image-top"] .image {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 112px;
  }

  .card[variant="image-top"] .title-space {
    padding: calc(var(--space-sm) * 1.5) calc(var(--space-sm) * 0.75);
  }

  .card[variant="image-top"] ::slotted([slot="title"]) {
    margin: 0;
    text-align: center;
  }

  .card[variant="image-top"] ::slotted([slot="image"]) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .card[variant="image-top"] .extra {
    background: var(--color-cream-dark);
    width: calc(var(--space-sm) * 1.5);
    height: calc(var(--space-sm) * 1.5);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    border: 2px solid #fff;
  }

  .card[variant="image-top"] ::slotted([slot="extra"]) {
    font-weight: 400;
    /* font-size: 14px; */
    font-size: calc(var(--sm-scale) * 0.88);
    line-height: 140%;
    letter-spacing: -0.02em;
  }
`;
var card_variant_image_top_default = cardVariantImageTop;

// src/components/card/card.variant.investor.ts
import { css as css28 } from "lit";
var cardVariantInvestor = css28`
  :host([variant="investor"]) {
    width: min(327px, calc(90vw - var(--space-md)));
    min-height: 440px;
    margin: 0;
    display: block;
  }

  :host([variant="investor"]) .card-container {
    perspective: 2000px;
  }

  :host([variant="investor"]) .card-inner {
    border-radius: var(--border-radius);
    box-shadow: var(--light-shadow);
    transition: transform 0.6s ease-in-out;
    transform-style: preserve-3d;
  }

  :host([variant="investor"]) .card-container:hover .card-inner {
    transform: rotateY(-180deg);
  }

  .card[variant="investor"] {
    padding: 0;
    width: 100%;
    max-width: none;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  .card[variant="investor"].card-back {
    position: absolute;
    top: 0;
    left: 0;
    transform: rotateY(-180deg);
  }

  .card[variant="investor"].card-front .meta {
    padding: 0;
  }
  .card[variant="investor"].card-back .meta {
    align-items: flex-start;
  }

  .card[variant="investor"].card-front .image {
    display: block;
    aspect-ratio: 1;
    overflow: hidden;
    width: 100%;
    border-radius: 0 0 50% 50%;
    margin-top: -20%;
    margin-bottom: var(--space-sm);
  }

  .card[variant="investor"] .content {
    margin: 0.3em 0 var(--space-lg);
    padding: 0 var(--space-lg);
    text-align: center;
  }
  .card[variant="investor"][larger-extra-image="true"] .content {
    margin-bottom: 0;
  }

  .card[variant="investor"] ::slotted([slot="title"]) {
    margin: var(--space-md) 0 0 !important;
  }

  .card[variant="investor"] ::slotted([slot="content"]) {
    color: var(--color-charcoal-60);
  }

  .card[variant="investor"].card-front .extra {
    margin: auto 0 calc(var(--space-lg) - 0.2rem);
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card[variant="investor"][larger-extra-image="true"].card-front .extra {
    height: 4rem;
    margin-bottom: var(--space-md);
  }

  .card[variant="investor"].card-back .extra {
    margin-top: auto;
  }

  .card[variant="investor"] ::slotted([slot="extra"]) {
    margin-top: auto;
    max-width: 9rem;
    max-height: 2rem;
  }
  .card[variant="investor"][larger-extra-image="true"]
    ::slotted([slot="extra"]) {
    max-height: 4rem;
    margin: 0;
  }

  .card[variant="investor"] ::slotted([slot="image"]) {
    width: 100%;
    height: 90%;
    margin-top: 20%;
    object-fit: cover;
  }

  .card[variant="investor"] .pill {
    position: absolute;
    top: 50%;
  }
`;
var card_variant_investor_default = cardVariantInvestor;

// src/components/card/card.variant.pricing.ts
import { css as css29 } from "lit";
var cardVariantPricing = css29`
  :host([variant="pricing"]) {
    width: auto;
    box-shadow: var(--light-shadow);
    border-radius: var(--border-radius);
    display: block;
  }

  .card[variant="pricing"] {
    padding: var(--outline-size, 0);
    width: 100%;
    max-width: none;
    display: block;
    height: 100%;
  }

  .card[variant="pricing"] .meta {
    display: flex;
    padding: 0;
    height: 100%;
  }

  .card[variant="pricing"] .title-space {
    width: 100%;
    margin: 0 0 var(--space-sm);
    padding: var(--space-lg);
    border-bottom: 1px solid var(--color-cream-dark);
    box-sizing: border-box;
  }

  .card[variant="pricing"] .subtitle {
    color: var(--color-charcoal-80);
  }

  .card[variant="pricing"] .content {
    margin: 0;
    padding: 0 var(--space-lg);
    width: 100%;
    box-sizing: border-box;
  }

  .card[variant="pricing"] .extra {
    padding: var(--space-xs) var(--space-lg) var(--space-lg);
    text-align: center;
    margin-top: auto;
    box-sizing: border-box;
  }

  .card[variant="pricing"] ::slotted([slot="content"]) {
    margin-bottom: var(--space-lg) !important;
  }
`;
var card_variant_pricing_default = cardVariantPricing;

// src/components/card/card.variant.quote.ts
import { css as css30 } from "lit";
var cardVariantQuote = css30`
  :host([variant="quote"]) {
    width: min(327px, calc(90vw - var(--space-md)));
    box-shadow: var(--light-shadow);
    border-radius: var(--border-radius);
    display: flex;
  }

  .card[variant="quote"] {
    padding: var(--outline-size, 0);
    width: 100%;
    max-width: none;
    display: flex;
    height: 100%;
    flex: 1;
    min-height: 23.5rem;
  }

  .card[variant="quote"] .meta {
    flex: 1;
    padding: var(--space-lg) var(--space-md);
    align-items: flex-start;
  }

  .card[variant="quote"] .extra {
    margin-top: auto;
  }

  .card[variant="quote"] .image {
    display: none;
  }
`;
var card_variant_quote_default = cardVariantQuote;

// src/components/card/card.variant.row.ts
import { css as css31 } from "lit";
var cardVariantRow = css31`
  .card[variant="row"] {
    max-width: 327px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--card-padding, 0.6em 1.2em 0.6em 1em);
  }
  .card[variant="row"][custom-padding],
  .card[variant="row"][custom-padding-large] {
    padding: 0;
  }
  .card[variant="row"][custom-padding] .meta {
    padding: var(--space-sm) var(--space-sm) var(--space-md);
  }
  .card[variant="row"][custom-padding-large] .meta {
    padding: calc(var(--space-sm) * 1.5) calc(var(--space-sm) * 1.5)
      var(--space-lg);
  }
  .card[variant="row"][custom-padding] .more,
  .card[variant="row"][custom-padding-large] .more {
    width: 100%;
    left: 0;
    margin: 0;
    padding: var(--space-md) var(--space-sm);
    z-index: 0;
  }
  .card[variant="row"][custom-padding-large] .more {
    padding: calc(var(--space-sm) * 1.5) var(--space-sm)
      calc(var(--space-sm) * 0.25);
  }
  .card[variant="row"][custom-padding-large] {
    overflow: hidden;
  }
  .card[variant="row"] .title-space {
    margin-left: calc(var(--space-sm) * 0.75);
  }
  .card[variant="row"] .meta {
    flex-direction: row;
  }
  .card[variant="row"][icon-background] .icon {
    background-color: var(--color-gray-fog);
    border-radius: 8px;
  }
  .card[variant="row"][icon-padding] .icon {
    padding: var(--space-xs);
  }
  .card[variant="row"] .icon {
    box-sizing: border-box;
    width: calc(var(--scale) * 2);
    min-width: calc(var(--scale) * 2);
  }
  .card[variant="row"][largerMobileIcon="true"] .icon {
    width: calc(var(--scale) * 2.25);
    min-width: calc(var(--scale) * 2.25);
  }
  .card[variant="row"][largeIcon="true"] .icon {
    width: calc(var(--scale) * 2.5);
    min-width: calc(var(--scale) * 2.5);
  }
  .card[variant="row"][extra-large-icon] .icon {
    width: calc(var(--scale) * 2.75);
    min-width: calc(var(--scale) * 2.75);
  }

  @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
    .card[variant="row"] .title-space {
      margin-left: var(--space-sm);
    }

    .card[variant="row"].growMore {
      min-height: 78px;
    }

    .card[variant="row"][icon-padding] .icon {
      padding: var(--space-sm);
    }

    .card[variant="row"][extra-large-icon] .icon {
      width: calc(var(--scale) * 4.5);
      min-width: calc(var(--scale) * 4.5);
    }

    .card[variant="row"][custom-padding] .meta {
      padding: var(--py) var(--px);
      margin-bottom: var(--space-xs);
    }

    .card[variant="row"][custom-padding] .more {
      padding: calc(var(--py) + var(--space-xs)) var(--px);
    }

    .card[variant="row"][custom-padding-large] .more {
      padding: var(--space-lg) var(--space-lg) var(--space-xs);
    }
  }
`;
var card_variant_row_default = cardVariantRow;

// src/components/card/card.variant.subtle.ts
import { css as css32 } from "lit";
var cardVariantSubtle = css32`
  .card[variant="subtle"] {
    align-items: flex-start;
    width: 100%;
  }
  .card[variant="subtle"]::after {
    border-radius: 0 0 8px 8px;
    overflow: hidden;
  }
  .card[variant="subtle"] .title-space {
    padding-bottom: 0.6em;
  }
  .card[variant="subtle"] .meta,
  .card[variant="subtle"] .content {
    align-items: flex-start;
    width: 100%;
    overflow: hidden;
  }
  .card[variant="subtle"] .icon {
    display: none;
  }
  .card[variant="subtle"] .moreToggle {
    display: none;
  }
`;
var card_variant_subtle_default = cardVariantSubtle;

// src/components/card/card.variant.team.ts
import { css as css33 } from "lit";
var cardVariantTeam = css33`
  :host([variant="team"]) {
    overflow: hidden;
    width: min(324px, calc(90vw - var(--space-md)));
    margin: 0;
    box-shadow: var(--light-shadow);
    display: block;
    border-radius: var(--border-radius);
  }

  @media screen and (max-width: 959px) {
    :host([variant="team"][responsive]) {
      width: min(250px, calc(90vw - var(--space-md)));
    }
  }

  .card[variant="team"] {
    padding: 0;
    width: 100%;
    max-width: none;
    height: 100%;
  }

  .card[variant="team"] .meta {
    padding: 0;
  }

  .card[variant="team"] .image {
    display: block;
    aspect-ratio: 1;
    overflow: hidden;
    width: 100%;
    border-radius: 0 0 50% 50%;
    margin-top: -20%;
    margin-bottom: var(--space-sm);
  }

  .card[variant="team"] ::slotted([slot="title"]) {
    margin: var(--space-md) 0 0 !important;
  }

  .card[variant="team"] .content {
    width: calc(100% - (var(--space-sm) * 4.5));
    text-align: center;
  }

  .card[variant="team"] ::slotted([slot="content"]) {
    margin: 0.3em 0 var(--space-lg) !important;
    color: var(--color-charcoal-60);
    /* font-size: 14px; */
    font-size: calc(var(--sm-scale) * 0.88);
    word-break: break-word;
  }

  .card[variant="team"] ::slotted([slot="extra"]) {
    margin: 0 0 calc(var(--space-lg) + 0.2rem) !important;
  }

  .card[variant="team"] ::slotted([slot="image"]) {
    width: 100%;
    height: 90%;
    margin-top: 20%;
    object-fit: cover;
  }
`;
var card_variant_team_default = cardVariantTeam;

// src/components/card/card.variant.testimonial.ts
import { css as css34 } from "lit";
var cardVariantTestimonial = css34`
  :host([variant="testimonial"]) {
    width: min(324px, calc(90vw - var(--space-md)));
    box-shadow: var(--light-shadow);
    border-radius: var(--border-radius);
    display: flex;
  }

  .card[variant="testimonial"] {
    padding: var(--outline-size, 0);
    width: 100%;
    max-width: none;
    display: flex;
    height: 100%;
    flex: 1;
  }

  .card[variant="testimonial"] .meta {
    flex: 1;
    padding: var(--space-lg);
    padding-left: var(--space-md);
    align-items: flex-start;
  }

  .card[variant="testimonial"] .extra {
    margin-top: auto;
    color: var(--color-charcoal-60);
  }

  .card[variant="testimonial"] .image {
    display: none;
  }

  .card[variant="testimonial"] ::slotted([slot="title"]) {
    margin: 0 0 var(--space-sm) !important;
  }

  .card[variant="testimonial"] ::slotted([slot="content"]) {
    margin: 0.3em 0 var(--space-md) !important;
  }
`;
var card_variant_testimonial_default = cardVariantTestimonial;

// src/components/card/card.component.ts
styleInject_default(card_global_default);
var NineCard = class extends NineElement {
  constructor() {
    super(...arguments);
    this.variant = "card";
    this.grow = "false";
    this.gradient = "false";
    this.outline = "false";
    this.outlineIcon = "false";
    this.moreContent = "false";
    this.alwaysShowMore = "false";
    this.py = "sm";
    this.px = "sm";
    this.stars = 5;
    this.active = false;
    this.growMore = "true";
    this.showBackSide = "false";
    this.largerMobileIcon = "false";
    this.largeIcon = "false";
    this.extraLargeIcon = false;
    this.iconBackground = false;
    this.iconPadding = false;
    this.customPadding = false;
    this.customPaddingLarge = false;
    this.noCardPaddingMobile = "false";
    this.largerExtraImage = "false";
    this.alignItems = "center";
    this.initialVariant = this.variant;
    this.uniqueId = `nine-card-${Math.random()}`;
    this.usedSlots = [];
    this.noTitle = false;
    this.largeRadius = false;
    this.responsive = false;
    this.moreRef = createRef4();
    this.cardRef = createRef4();
    this.handleDomChanges = () => {
      const nodesFromQuery = Array.from(this.querySelectorAll("[slot]"));
      this.usedSlots = nodesFromQuery.map((node) => node.getAttribute("slot"));
    };
    this.updateSize = () => {
      const more = this.moreRef.value;
      const card = this.cardRef.value;
      if (more && card) {
        const height = more.getBoundingClientRect().height;
        if (this.alwaysShowMore === "false") {
          card.style.setProperty("--moreHeight", `${height}px`);
        }
      }
    };
    this.handleClick = () => {
      this.active = !this.active;
    };
  }
  shouldRenderSlot(slotName) {
    return Boolean(this.usedSlots.includes(slotName));
  }
  get starsNumber() {
    return parseFloat(`${this.stars}`);
  }
  get starsMarkup() {
    const starsList = Array.from(
      { length: 5 },
      () => html22`<span class="star">&#9733;</span>`
    );
    return html22`
            <div class="stars" style="--stars: ${this.starsNumber}">
                <div class="starsList">${starsList}</div>
                ${this.stars} stars
            </div>`;
  }
  get variantStyles() {
    switch (this.variant) {
      case "card":
        return card_variant_card_default;
      case "row":
        return card_variant_row_default;
      case "details":
        return card_variant_row_default;
      case "team":
        return card_variant_team_default;
      case "investor":
        return card_variant_investor_default;
      case "testimonial":
        return card_variant_testimonial_default;
      case "quote":
        return card_variant_quote_default;
      case "pricing":
        return card_variant_pricing_default;
      case "bubble":
        return card_variant_bubble_default;
      case "subtle":
        return card_variant_subtle_default;
      case "columns":
        return card_variant_columns_default;
      case "image-top":
        return card_variant_image_top_default;
      case "image-left":
        return card_variant_image_left_default;
      default:
        return "";
    }
  }
  firstUpdated() {
    this.addEventListeners();
    this.updateSize();
    this.handleDomChanges();
    setTimeout(() => this.handleDomChanges, 200);
  }
  addEventListeners() {
    globalThis.addEventListener("resize", this.updateSize, { passive: true });
    addScrollListener(this.updateSize, {
      passive: true
    });
    const observer = new MutationObserver(this.handleDomChanges);
    observer.observe(this, {
      childList: true,
      subtree: true
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    globalThis.removeEventListener("resize", this.updateSize);
    removeScrollListener(this.updateSize);
  }
  render() {
    return html22`
            <style>
                ${this.variantStyles}
            </style>

            <div class="card-container">
                <div class="card-inner">
                    <div
                            class="card card-front ${this.active ? "active" : ""} ${this.growMore === "true" ? "growMore" : ""}"
                            variant=${this.variant}
                            larger-extra-image=${this.largerExtraImage}
                            largerMobileIcon=${this.largerMobileIcon}
                            largeIcon=${this.largeIcon}
                            ?extra-large-icon=${this.extraLargeIcon}
                            ?icon-background=${this.iconBackground}
                            ?icon-padding=${this.iconPadding}
                            ?custom-padding=${this.customPadding}
                            ?custom-padding-large=${this.customPaddingLarge}
                            ?no-title=${this.noTitle}
                            ?large-radius=${this.largeRadius}
                            ?responsive=${this.responsive}
                            noCardPaddingMobile=${this.noCardPaddingMobile}
                            grow=${this.grow}
                            gradient=${this.gradient}
                            outline=${this.outline}
                            asm="${this.alwaysShowMore}"
                            style="--py: var(--space-${this.py}); --px: var(--space-${this.px});"
                            @click=${this.handleClick}
                            tabindex="0"
                            aria-labelledby="${this.uniqueId}"
                            ${ref4(this.cardRef)}
                    >
                        <div class="meta" style="--align-items: ${this.alignItems};">
                            ${this.variant === "columns" ? html22`
                                        <slot name="left"></slot>
                                        <slot name="right"></slot>
                                    ` : html22`
                                        <div class="icon" outline="${this.outlineIcon}">
                                            <slot name="icon"></slot>
                                        </div>
                                        <div class="image">
                                            <slot name="image"></slot>
                                        </div>
                                        ${this.variant === "testimonial" ? html22` ${this.starsMarkup} ` : ""}
                                        <div class="title-space">
                                            <div class="title" id="${this.uniqueId}">
                                                <slot name="title"></slot>
                                            </div>
                                            <div class="subtitle">
                                                <slot name="subtitle"></slot>
                                            </div>
                                        </div>
                                        <div
                                                class="content"
                                                ?hide-element=${!this.shouldRenderSlot("content")}
                                        >
                                            <slot name="content"></slot>
                                        </div>
                                        <div class="extra">
                                            <slot name="extra"></slot>
                                        </div>
                                        <div
                                                class="pill"
                                                ?hide-element=${!this.shouldRenderSlot("pill")}
                                        >
                                            <slot name="pill"></slot>
                                        </div>
                                    `}
                        </div>
                        ${this.moreContent === "true" ? html22`
                                    <div class="moreToggle">${simpleArrowUp}</div>
                                    <div class="more" ${ref4(this.moreRef)}>
                                        <slot name="more"></slot>
                                    </div>
                                ` : ""}
                    </div>

                    ${this.showBackSide === "true" ? html22`
                                <div
                                        class="card card-back ${this.active ? "active" : ""}"
                                        variant=${this.variant}
                                        largerMobileIcon=${this.largerMobileIcon}
                                        largeIcon=${this.largeIcon}
                                        ?extra-large-icon=${this.extraLargeIcon}
                                        ?icon-background=${this.iconBackground}
                                        ?icon-padding=${this.iconPadding}
                                        ?custom-padding=${this.customPadding}
                                        ?custom-padding-large=${this.customPaddingLarge}
                                        ?large-radius=${this.largeRadius}
                                        noCardPaddingMobile=${this.noCardPaddingMobile}
                                        grow=${this.grow}
                                        gradient=${this.gradient}
                                        outline=${this.outline}
                                        style="--py: var(--space-${this.py}); --px: var(--space-${this.px});"
                                        @click=${this.handleClick}
                                        tabindex="0"
                                        aria-labelledby="${this.uniqueId}"
                                >
                                    <div class="meta" style="--align-items: ${this.alignItems};">
                                        <div class="icon" outline="${this.outlineIcon}">
                                            <slot name="icon-back"></slot>
                                        </div>
                                        <div class="image">
                                            <slot name="image-back"></slot>
                                        </div>
                                        ${this.variant === "testimonial" ? html22` ${this.starsMarkup} ` : ""}
                                        <div class="title-space">
                                            <div class="title" id="${this.uniqueId}">
                                                <slot name="title-back"></slot>
                                            </div>
                                            <div class="subtitle">
                                                <slot name="subtitle-back"></slot>
                                            </div>
                                        </div>
                                        <div class="content">
                                            <slot name="content-back"></slot>
                                        </div>
                                        <div class="extra">
                                            <slot name="extra-back"></slot>
                                        </div>
                                    </div>
                                </div>
                            ` : ""}
                </div>
            </div>
        `;
  }
};
NineCard.styles = unsafeCSS9(card_default);
__decorateClass([
  property15({ type: String, reflect: true })
], NineCard.prototype, "variant", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "grow", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "gradient", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "outline", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "outlineIcon", 2);
__decorateClass([
  property15({ type: String, reflect: true })
], NineCard.prototype, "moreContent", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "alwaysShowMore", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "py", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "px", 2);
__decorateClass([
  property15({ type: Number })
], NineCard.prototype, "stars", 2);
__decorateClass([
  property15({ type: Boolean, reflect: true })
], NineCard.prototype, "active", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "growMore", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "showBackSide", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "largerMobileIcon", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "largeIcon", 2);
__decorateClass([
  property15({ type: Boolean, attribute: "extra-large-icon" })
], NineCard.prototype, "extraLargeIcon", 2);
__decorateClass([
  property15({ type: Boolean, attribute: "icon-background" })
], NineCard.prototype, "iconBackground", 2);
__decorateClass([
  property15({ type: Boolean, attribute: "icon-padding" })
], NineCard.prototype, "iconPadding", 2);
__decorateClass([
  property15({ type: Boolean, attribute: "custom-padding" })
], NineCard.prototype, "customPadding", 2);
__decorateClass([
  property15({ type: Boolean, attribute: "custom-padding-large" })
], NineCard.prototype, "customPaddingLarge", 2);
__decorateClass([
  property15({ type: String })
], NineCard.prototype, "noCardPaddingMobile", 2);
__decorateClass([
  property15({ type: String, attribute: "larger-extra-image" })
], NineCard.prototype, "largerExtraImage", 2);
__decorateClass([
  property15({ type: String, attribute: "align-items", reflect: true })
], NineCard.prototype, "alignItems", 2);
__decorateClass([
  property15({ type: Array, reflect: false })
], NineCard.prototype, "usedSlots", 2);
__decorateClass([
  property15({ type: Boolean, attribute: "no-title" })
], NineCard.prototype, "noTitle", 2);
__decorateClass([
  property15({ type: Boolean, attribute: "large-radius" })
], NineCard.prototype, "largeRadius", 2);
__decorateClass([
  property15({ type: Boolean })
], NineCard.prototype, "responsive", 2);

// src/components/card/card.ts
var card_default2 = NineCard;
NineCard.define("nine-card");

// src/components/card-grid/card-grid.component.ts
import { css as css36, html as html23 } from "lit";
import { property as property16 } from "lit/decorators.js";

// src/components/card-grid/card-grid.global.scss?inline
import { css as css35 } from "lit-element/lit-element.js";
var card_grid_global_default = css35`nine-card-grid nine-card {
  --border-radius: 8px;
  --card-padding: 0.6em 1em;
  z-index: 1;
  width: 100%;
}`;

// src/components/card-grid/card-grid.component.ts
styleInject_default(card_grid_global_default);
var NineCardGrid = class extends NineElement {
  constructor() {
    super(...arguments);
    this.columns = 4;
    this.gap = "md";
    this.responsive = "true";
    this.textAlign = "left";
  }
  render() {
    return html23`
      <div
        class="grid"
        responsive="${this.responsive}"
        text-align="${this.textAlign}"
        style="--cols: ${this.columns}; --gap: var(--space-${this.gap});"
      >
        <slot></slot>
      </div>
    `;
  }
};
NineCardGrid.styles = css36`
    :host {
      display: block;
    }

    .grid {
      display: grid;
      gap: var(--space-sm);
    }

    .grid[responsive="false"] {
      grid-template-columns: repeat(var(--cols), 1fr);
    }

    .grid[text-align="left"] {
      text-align: left;
    }

    .grid[text-align="right"] {
      text-align: right;
    }

    .grid[text-align="center"] {
      text-align: center;
    }

    .grid[text-align="justify"] {
      text-align: justify;
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      .grid {
        grid-template-columns: repeat(var(--cols), 1fr);
        gap: var(--gap);
      }
    }
  `;
__decorateClass([
  property16({ type: Number })
], NineCardGrid.prototype, "columns", 2);
__decorateClass([
  property16({ type: String })
], NineCardGrid.prototype, "gap", 2);
__decorateClass([
  property16({ type: String })
], NineCardGrid.prototype, "responsive", 2);
__decorateClass([
  property16({ type: String, attribute: "text-align" })
], NineCardGrid.prototype, "textAlign", 2);

// src/components/card-grid/card-grid.ts
var card_grid_default = NineCardGrid;
NineCardGrid.define("nine-card-grid");

// src/components/cell/cell.component.ts
import { css as css37, html as html24 } from "lit";
import { property as property17 } from "lit/decorators.js";
var icon = html24`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.3 12 8.64 6.35l.7-.7L15.71 12l-6.36 6.35-.7-.7L14.29 12Z"
      fill="currentColor"
    />
  </svg>
`;
var NineCell = class extends NineElement {
  constructor() {
    super(...arguments);
    this.variant = "ghost";
  }
  render() {
    var _a2;
    return html24`<div
      class="cell ${((_a2 = this.href) == null ? void 0 : _a2.length) ? "cell-link" : ""}"
      v=${this.variant}
    >
      ${this.img ? html24`<img src=${this.img} />` : ""}
      <slot></slot>
      ${this.href ? html24`${icon} <a href=${this.href} target=${this.target}></a>` : ""}
    </div>`;
  }
};
NineCell.styles = css37`
    :host {
      display: block;
      max-width: 100%;
    }

    .cell {
      display: flex;
      align-items: center;
      max-width: 100%;
      grid-gap: 1rem;
      padding: var(--cell-gap, 1rem);
      position: relative;
    }

    .cell[v="fill"] {
      border-radius: 0.6em;
      background: var(--color-cream);
      margin-bottom: 0.7em;
    }

    .cell[v="ghost"] {
      border-bottom: 0.1em solid var(--color-cream-dark);
      padding: var(--cell-gap, 1rem) 0;
    }

    :host(:first-of-type) .cell:not(.cell-link) {
      padding-top: 0;
    }

    :host(:last-of-type) .cell:not(.cell-link) {
      padding-bottom: 0;
    }

    :host(:last-of-type) .cell[v="ghost"] {
      border-bottom: none;
    }

    .cell-link:hover {
      background: var(--color-cream-darker);
      border-radius: 8px;
    }

    .cell img {
      width: calc(min(3em, 56px) * var(--cell-img-scale, 1));
      aspect-ratio: 1;
      border-radius: 50%;
      object-fit: cover;
    }

    a {
      position: absolute;
      display: block;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }

    svg {
      margin-left: auto;
      width: 1.4em;
      height: auto;
    }
  `;
__decorateClass([
  property17({ type: String })
], NineCell.prototype, "img", 2);
__decorateClass([
  property17({ type: String })
], NineCell.prototype, "href", 2);
__decorateClass([
  property17({ type: String })
], NineCell.prototype, "target", 2);
__decorateClass([
  property17({ type: String })
], NineCell.prototype, "variant", 2);

// src/components/cell/cell.ts
var cell_default = NineCell;
NineCell.define("nine-cell");

// src/components/center/center.component.ts
import { css as css38, html as html25 } from "lit";
import { property as property18 } from "lit/decorators.js";
var NineCenter = class extends NineElement {
  constructor() {
    super(...arguments);
    this.pageModule = false;
    this.text = false;
    this.maxWidth = "100vw";
  }
  render() {
    return html25`<div style="--max-width: ${this.maxWidth};">
      <slot></slot>
    </div>`;
  }
};
NineCenter.styles = css38`
    :host {
      flex: 1;
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      min-height: 100%;
      box-sizing: border-box;
    }

    :host > div {
      max-width: var(--max-width);
    }

    :host([page-module]) {
      width: min(100%, var(--page-max-width));
      margin: 0 auto;
      padding: 0 var(--space-md);
      height: auto;
      min-height: 0;
      position: relative;
      z-index: 2;
    }
    :host([page-module]) > div {
      width: 100%;
    }

    :host([text]) {
      text-align: center;
    }
  `;
__decorateClass([
  property18({ type: Boolean, attribute: "page-module" })
], NineCenter.prototype, "pageModule", 2);
__decorateClass([
  property18({ type: Boolean, attribute: "text" })
], NineCenter.prototype, "text", 2);
__decorateClass([
  property18({ type: String, attribute: "max-width" })
], NineCenter.prototype, "maxWidth", 2);

// src/components/center/center.ts
var center_default = NineCenter;
NineCenter.define("nine-center");

// src/components/checkbox/checkbox.component.ts
import { html as html26, unsafeCSS as unsafeCSS10 } from "lit";
import { property as property19 } from "lit/decorators.js";
import { createRef as createRef5, ref as ref5 } from "lit/directives/ref.js";

// src/components/checkbox/checkbox.scss?inline
import { css as css39 } from "lit-element/lit-element.js";
var checkbox_default = css39`:host {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

label {
  cursor: pointer;
}

.wrap {
  padding: calc(var(--space-sm) * 0.125);
}

input {
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  margin: 0;
  width: calc(var(--space-sm) * 1.5);
  height: calc(var(--space-sm) * 1.5);
  border: 1px solid var(--color-charcoal-60);
  transform: translateY(0);
  display: grid;
  /* aligning ::before horizontally and vertically */
  place-content: center;
  position: relative;
}
input::before {
  content: "";
  transform: scale(0);
  transition: transform 0.12s ease-in-out;
}
input::after {
  content: "";
  position: absolute;
  z-index: -1;
}
input:checked {
  border: none;
  background: linear-gradient(89.59deg, #80aeff 0.36%, #f7bde6 52.67%, #ffbd70 99.65%);
}
input:checked::after {
  top: 1px;
  bottom: 1px;
  left: 1px;
  right: 1px;
  background: linear-gradient(270.11deg, #ffdfb4 16.73%, #fddee9 50.08%, #c1d7fb 81.42%);
}
input:checked::before {
  transform: scale(1);
}

/* Radio */
.wrap[variant=radio] input {
  border-radius: 50%;
}
.wrap[variant=radio] input::before {
  width: calc(var(--space-sm) * 0.875);
  height: calc(var(--space-sm) * 0.875);
  border-radius: 50%;
  --gradient-dir: 90deg;
  background: var(--gradient-dusk);
}
.wrap[variant=radio] input:checked::after {
  border-radius: 50%;
}
.wrap[variant=radio] input:checked::before {
  transform: scale(1);
}

.wrap[variant=checkbox] input {
  border-radius: 4px;
}
.wrap[variant=checkbox] input::before {
  content: url('data:image/svg+xml;utf8, <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.1883 1.76986L15.669 0.298096L6.22459 9.76751L1.78081 5.32373L0.287109 6.76924L6.22463 12.7068L17.1883 1.76986Z" fill="url(%23paint0_linear_959_607)"/><defs><linearGradient id="paint0_linear_959_607" x1="0.287109" y1="6.50243" x2="17.1883" y2="6.50243" gradientUnits="userSpaceOnUse"><stop stop-color="%230E3763"/><stop offset="0.526042" stop-color="%235B4855"/><stop offset="1" stop-color="%238A6947"/></linearGradient></defs></svg>');
  position: absolute;
  top: 25%;
  left: 15%;
}
@media screen and (max-width: 374px) {
  .wrap[variant=checkbox] input::before {
    top: 20%;
    left: 12%;
  }
}
.wrap[variant=checkbox] input:checked::after {
  border-radius: 3px;
}`;

// src/components/checkbox/checkbox.component.ts
var NineCheckbox = class extends NineElement {
  constructor() {
    super(...arguments);
    this.inputRef = createRef5();
    this.name = "";
    this.variant = "checkbox";
    this.checked = false;
    this.controlled = false;
    this.label = null;
    this.handleLabelClick = () => {
      const nextChecked = !this.checked;
      if (!this.controlled) {
        const inputEl = this.inputRef.value;
        if (!inputEl) return;
        if (nextChecked === inputEl.checked) {
          this.checked = nextChecked;
          return;
        }
        inputEl.checked = nextChecked;
        this.checked = nextChecked;
      }
      this.dispatchEvent(
        new CustomEvent("change", {
          detail: { checked: nextChecked },
          bubbles: true
        })
      );
    };
    this.handleChange = () => {
      if (this.controlled && this.inputRef.value) {
        this.inputRef.value.checked = this.checked;
      }
      this.dispatchEvent(
        new CustomEvent("change", {
          detail: { checked: !this.checked },
          bubbles: true
        })
      );
    };
  }
  static get formAssociated() {
    return true;
  }
  firstUpdated() {
    this.addEventListener("click", this.handleLabelClick);
  }
  disconnectedCallback() {
    var _a2;
    super.disconnectedCallback();
    (_a2 = this.label) == null ? void 0 : _a2.removeEventListener(
      "click",
      this.handleLabelClick
    );
  }
  render() {
    return html26`
      <div class="wrap" variant="${this.variant}">
        <input
          type="checkbox"
          name="${this.name}"
          ?checked="${this.checked}"
          @change="${this.handleChange}"
          ${ref5(this.inputRef)}
        />
      </div>
    `;
  }
};
NineCheckbox.styles = unsafeCSS10(checkbox_default);
__decorateClass([
  property19({ type: String })
], NineCheckbox.prototype, "name", 2);
__decorateClass([
  property19({ type: String })
], NineCheckbox.prototype, "variant", 2);
__decorateClass([
  property19({ type: Boolean })
], NineCheckbox.prototype, "checked", 2);
__decorateClass([
  property19({ type: Boolean })
], NineCheckbox.prototype, "controlled", 2);

// src/components/checkbox/checkbox.ts
var checkbox_default2 = NineCheckbox;
NineCheckbox.define("nine-checkbox");

// src/components/checklist/checklist.component.ts
import { css as css40, html as html27 } from "lit";
var NineChecklist = class extends NineElement {
  render() {
    return html27`
      <section>
        <div class="title"><slot name="title"></slot></div>
        <slot></slot>
      </section>
    `;
  }
};
NineChecklist.styles = css40`
    :host {
      display: block;
      padding: 0 var(--space-md);
      position: relative;
      z-index: 2;
    }

    section {
      max-width: var(--page-max-width);
      margin: var(--section-gap) auto;
    }

    .title {
      text-align: center;
      margin: 0 0 var(--space-xl);
    }
  `;

// src/components/checklist/checklist.ts
var checklist_default = NineChecklist;
NineChecklist.define("nine-checklist");

// src/components/circle/circle.component.ts
import { css as css42, html as html28 } from "lit";

// src/constants/gradient.ts
import { css as css41 } from "lit";
var bgGradientSunrise = css41`
  background-image: var(
    --wcl-bg-gradient-sunrise,
    linear-gradient(
      var(--gradient-dir),
      var(--color-sunrise-blue) 13.49%,
      var(--color-sunrise-pink) 51.22%,
      var(--color-sunrise-orange) 85.11%
    )
  );
`;
var bgGradientSunriseLight = css41`
  background-image: var(
    --wcl-bg-gradient-sunrise-light,
    linear-gradient(var(--gradient-dir), #a6c6ff 5.3%, #fad0e8 48.44%, #ffd199 90.45%)
  );
`;
var bgGradientSunriseLightest = css41`
  background-image: var(
    --wcl-bg-gradient-sunrise-lightest,
    linear-gradient(var(--gradient-dir), #c1d7fb 13.49%, #fddee9 50.42%, #ffdfb4 85.11%)
  );
`;
var bgGradientSunriseLightRepeating = css41`
  background-image: var(
    --wcl-bg-gradient-sunrise-repeating,
    linear-gradient(
      var(--gradient-dir),
      rgba(128, 174, 255, 0.6) 0.36%,
      rgba(247, 189, 230, 0.6) 49.61%,
      rgba(255, 189, 112, 0.6) 99.86%,
      rgba(247, 189, 230, 0.6) 148.1%,
      rgba(128, 174, 255, 0.6) 193.33%
    )
  );
`;
var bgGradientAfternoonLight = css41`
  background-image: var(
    --wcl-bg-gradient-afternoon,
    linear-gradient(var(--gradient-dir), #fffcf3 12.24%, #b0f2ce 54.34%, #ffefc7 87.78%)
  );
`;
var bgGradientDusk = css41`
  background-image: var(
    --wcl-bg-gradient-dusk,
    linear-gradient(var(--gradient-dir), #0e3763 0%, #5b4855 52.6%, #8a6947 100%)
  );
`;

// src/components/circle/circle.component.ts
var styles = css42`
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    border-radius: 50%;
    width: 200%;
    aspect-ratio: 1;
    position: relative;
    left: -50%;
    --gradient-dir: 24.44deg;
    ${bgGradientAfternoonLight};
  }

  .text {
    text-align: center;
    max-width: 50%;
  }

  @media screen and (min-width: 700px) {
    :host {
      width: 110%;
      left: -5%;
    }

    .text {
      max-width: 75%;
    }
  }

  @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
    :host {
      width: 100%;
      left: 0;
    }

    .text {
      max-width: 100%;
      padding: 0 calc(2 * var(--space-xxl));
    }
  }
`;
var NineCircle = class extends NineElement {
  render() {
    return html28`
      <div class="text">
        <slot></slot>
      </div>
    `;
  }
};
NineCircle.styles = styles;

// src/components/circle/circle.ts
var circle_default = NineCircle;
NineCircle.define("nine-circle");

// src/components/content/content.component.ts
import { css as css44, html as html29 } from "lit";
import { property as property20, queryAssignedNodes as queryAssignedNodes3 } from "lit/decorators.js";
import { createRef as createRef6, ref as ref6 } from "lit/directives/ref.js";
import { styleMap } from "lit/directives/style-map.js";

// src/components/content/content.global.scss?inline
import { css as css43 } from "lit-element/lit-element.js";
var content_global_default = css43`nine-content img:not([slot=absolute], [slot=absolute-mobile], nine-image-list img) {
  max-width: 100%;
}

nine-content *[slot=scroll] > img {
  box-shadow: var(--light-shadow);
  border-radius: 8px;
}

nine-content *[slot=extra] > img {
  max-width: var(--extra-img-max-width);
}

@media screen and (max-width: 960px) {
  nine-content[align-title-center-mobile] .text-center-mobile {
    text-align: center;
  }
}`;

// src/components/content/content.component.ts
styleInject_default(content_global_default);
var NineContent = class extends NineElement {
  constructor() {
    super(...arguments);
    this.halfCircleRef = createRef6();
    this.addMargin = "false";
    this.addMarginTop = "false";
    this.addMarginBottom = "false";
    this.paddingTop = "true";
    this.alignCenter = "false";
    this.textCenter = "false";
    this.padding = "true";
    this.primarySide = "";
    this.slimSide = "";
    this.sticky = "";
    this.size = "";
    this.centerNarrow = "false";
    this.reverseOrder = "false";
    this.largeGapDesktop = "true";
    this.halfCircle = "";
    this.gradientBackground = "false";
    this.fadeTop = "false";
    this.fadeBottom = "false";
    this.primaryChildWidth = "";
    this.image = "";
    this.scrollMobile = "true";
    this.breakpoint = 740;
    this.imageBelowContentMobile = false;
    this.ctaClone = null;
    this.alignTitleCenterMobile = false;
    this.hideCtaBelowBreakpoint = () => {
      if (this.ctaClone) {
        if (window.innerWidth < this.breakpoint) {
          this.ctaClone.style.display = "none";
        } else {
          this.ctaClone.style.display = "inline-block";
        }
      }
    };
  }
  get inlineStyles() {
    return css44`
      @media screen and (max-width: ${this.breakpoint}px) {
        .list[image-below-content-mobile] .flex {
          flex-direction: column-reverse;
        }

        ::slotted([slot='cta']) {
          align-self: flex-start;
        }

        .list[image-below-content-mobile] ::slotted([slot='cta']) {
          order: -1;
        }

        .list[align-title-center-mobile] ::slotted([slot='cta']) {
          align-self: center;
        }
      }

      @media screen and (min-width: ${this.breakpoint}px) {
        :host .flex {
          flex-direction: row;
          grid-gap: min(var(--gap, var(--grid-gap, 10vw)));
        }

        :host .flex:is(.list[large-gap-desktop='true'] .flex) {
          grid-gap: min(var(--grid-gap-desktop, 10vw));
        }

        :host .list[margin='true'].mobile-margin {
          margin: var(--section-gap) auto;
        }

        .list[reverseOrder='true'] .flex {
          flex-direction: row-reverse;
        }

        .list[centerNarrow='true'] .flex {
          grid-gap: var(--gap, calc(var(--scale) * 2));
        }

        .list[slim='left'] ::slotted(*:nth-child(2)) {
          padding-right: var(--padding-right);
        }

        .list[slim='left'] ::slotted(*:first-child) {
          max-width: var(--slim-size, 237px);
        }

        .list[slim='right'] ::slotted(*:nth-child(2)) {
          max-width: var(--slim-size, 237px);
        }

        .list ::slotted([slot='absolute']) {
          display: block;
        }

        .list ::slotted([slot='absolute-mobile']) {
          display: none;
        }

        .list ::slotted([slot='cta']) {
          display: none;
        }
      }
    `;
  }
  get renderStyles() {
    return this.primaryChildWidth ? { "--primary-child-width": this.primaryChildWidth } : {};
  }
  firstUpdated() {
    setTimeout(() => {
      var _a2, _b, _c, _d, _e;
      if (this._absoluteMobileNodes.length) {
        (_b = (_a2 = this.shadowRoot) == null ? void 0 : _a2.querySelector(".list[margin='true']")) == null ? void 0 : _b.classList.add("mobile-margin");
      }
      if (this.image.trim().length) {
        (_c = this.halfCircleRef.value) == null ? void 0 : _c.style.setProperty("background-image", `url('${this.image}')`);
      }
      const items = (_d = this._scrollNodes[0]) == null ? void 0 : _d.children;
      if (!items) {
        ((_e = this.shadowRoot) == null ? void 0 : _e.querySelector(".scroller")).style.display = "none";
      } else {
        [...items].forEach((item) => {
          var _a3, _b2;
          item.classList.add("scroll-mobile");
          (_b2 = (_a3 = this.shadowRoot) == null ? void 0 : _a3.querySelector("div[slot='items']")) == null ? void 0 : _b2.appendChild(item.cloneNode(true));
        });
      }
      const cta = this._ctaNodes[0];
      if (cta && cta instanceof HTMLElement) {
        this.ctaClone = cta.cloneNode(true);
        const secondChild = this._slotNodes.filter((node) => node instanceof HTMLElement)[1];
        secondChild.appendChild(this.ctaClone);
        this.hideCtaBelowBreakpoint();
        window.addEventListener("resize", this.hideCtaBelowBreakpoint);
      }
    }, 10);
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this.hideCtaBelowBreakpoint);
  }
  render() {
    return html29`
      <style>
        ${this.inlineStyles}
      </style>
      <div
        class="list"
        margin=${this.addMargin}
        margin-top=${this.addMarginTop}
        margin-bottom=${this.addMarginBottom}
        acenter=${this.alignCenter}
        prim=${this.primarySide}
        slim=${this.slimSide}
        tcenter=${this.textCenter}
        size=${this.size}
        sticky=${this.sticky}
        p=${this.padding}
        centerNarrow=${this.centerNarrow}
        reverseOrder=${this.reverseOrder}
        large-gap-desktop=${this.largeGapDesktop}
        half-circle=${this.halfCircle}
        image=${this.image}
        padding-top=${this.paddingTop}
        scroll-mobile="${this.scrollMobile}"
        ?image-below-content-mobile=${this.imageBelowContentMobile}
        ?align-title-center-mobile=${this.alignTitleCenterMobile}
        style=${styleMap(this.renderStyles)}
      >
        ${this.fadeTop === "true" ? html29`<div class="fade-top"></div>` : html29``}
        ${this.fadeBottom === "true" ? html29`<div class="fade-bottom"></div>` : html29``}

        <div class="flex">
          <slot></slot>
          <slot name="cta"></slot>
          <slot name="scroll"></slot>
          <slot name="absolute"></slot>
          <slot name="absolute-mobile"></slot>
        </div>

        <slot name="extra"></slot>

        <nine-scrolling class="scroller" fade="false" item-fit-width="true" item-shadow="true" item-radius="true">
          <div slot="items"></div>
        </nine-scrolling>

        ${this.halfCircle !== "" ? html29`<div class="half-circle" ${ref6(this.halfCircleRef)}></div>` : html29``}
      </div>
    `;
  }
};
NineContent.styles = css44`
    :host {
      display: block;
      width: 100%;
      position: relative;
      z-index: 2;
      padding: 0 var(--pad-x, var(--space-md));
      box-sizing: border-box;
      --grid-gap: var(--gap, calc(var(--scale) * 5));
      --grid-gap-desktop: var(--gap-desktop, calc(var(--scale) * 5));
      --padding-right: 0;

      --size: min(230vw, 970px);
      --half-size: calc(var(--size) / 2);
    }

    :host([padding='false']) {
      padding: 0;
    }

    :host([gradient-background='true']) {
      background: linear-gradient(180.56deg, #ffdfb4 13.49%, #fddee9 50.42%, #c1d7fb 85.11%);
    }

    .fade-top {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 50%;
      z-index: -1;
      background: linear-gradient(180.56deg, #fffcf3 7.72%, rgba(255, 252, 243, 0) 98.53%);
    }

    .fade-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40%;
      z-index: -1;
      background: linear-gradient(180.56deg, rgba(255, 252, 243, 0) 7.72%, #fffcf3 98.53%);
    }

    .list {
      /* max-width: var(--section-max-width, calc(var(--page-max-width) * 1.1)); */
      margin: 0 auto;
      max-width: var(--section-max-width, var(--page-max-width));
      width: 100%;
    }

    .list[centerNarrow='true'] {
      max-width: calc(var(--page-max-width-narrow) + (var(--space-md) * 2));
    }

    .list[p='false'] {
      padding: 0;
    }

    .flex {
      max-width: inherit;
      margin: 0 auto;
      flex-direction: column;
      display: flex;
      grid-gap: var(--gap, var(--grid-gap));
    }

    .flex:not(.list[centerNarrow='true'] .flex) {
      grid-gap: var(--gap, calc(var(--scale) * 2));
    }

    ::slotted(*) {
      flex: 1;
      box-sizing: border-box;
      position: relative;
    }

    ::slotted([slot='absolute']) {
      position: absolute;
      max-width: var(--absolute-element-max-width, 215px);
      max-height: var(--absolute-element-max-height, 215px);
      top: var(--absolute-element-top, var(--space-xl));
      left: var(--absolute-element-left, 50%);
      transform: translateX(var(--absolute-element-translate-x, calc(-1 * var(--absolute-element-max-width, 215px))));
      border-radius: 8px;
      box-shadow: var(--light-shadow);
      display: none;
    }

    ::slotted([slot='absolute-mobile']) {
      position: absolute;
      max-width: var(--absolute-mobile-element-max-width, 200px);
      max-height: var(--absolute-mobile-element-max-height, 180px);
      top: var(--absolute-mobile-element-top, calc(var(--absolute-mobile-element-max-height, 180px) / 2 * (-1)));
      left: var(--absolute-mobile-element-left, 50%);
      transform: translateX(var(--absolute-mobile-element-translate-x, -50%));
      border-radius: 8px;
      box-shadow: var(--light-shadow);
    }

    .list[prim='left'] {
      --absolute-element-left: 53%;
    }

    .list[prim='left'] ::slotted(*:first-child) {
      min-width: var(--primary-child-width, 50%);
    }

    .list[prim='right'] ::slotted(*:nth-child(2)) {
      min-width: var(--primary-child-width, 50%);
    }

    .list[margin='true'] {
      margin: var(--section-gap) auto;
    }

    .list[margin-top='true'] {
      margin: var(--section-gap) auto 0;
    }

    .list[margin-bottom='true'] {
      margin: 0 auto var(--section-gap);
    }

    .list[margin='true'].mobile-margin {
      margin-top: calc(var(--section-gap) + var(--absolute-mobile-element-max-height, 180px) / 2);
    }

    .list[size='slim'] {
      max-width: var(--slim-size, 35rem);
      margin-left: auto;
      margin-right: auto;
    }

    .list[size='medium'] {
      max-width: var(--medium-size, 50rem);
      margin-left: auto;
      margin-right: auto;
    }

    .list[size='content'] {
      max-width: var(--content-size, var(--page-max-width));
      margin-left: auto;
      margin-right: auto;
    }

    .list[acenter='true'] .flex {
      align-items: center;
    }

    .list[tcenter='true'] {
      text-align: center;
    }

    .half-circle {
      position: absolute;
      width: var(--size);
      height: var(--half-size);
      z-index: -1;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(179.73deg, #ffd199 45.23%, #fad0e8 86.89%, #fffcf3 141.97%);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .list[half-circle='top'] .half-circle {
      top: 0;
      border-radius: 0 0 var(--half-size) var(--half-size);
    }

    .list[half-circle='bottom'] .half-circle {
      bottom: 0;
      border-radius: var(--half-size) var(--half-size) 0 0;
    }

    .list[half-circle='top'][padding-top='true'] {
      padding-top: calc(var(--half-size) - var(--space-xxxl));
    }

    .list[scroll-mobile='true'] ::slotted([slot='scroll']) {
      display: none;
    }

    .scroller {
      margin-top: calc(-1 * var(--space-sm));
      margin-bottom: -77px;
      margin-left: calc(-1 * var(--space-md));
      margin-right: calc(-1 * var(--space-md));
    }

    .list[scroll-mobile='false'] .scroller {
      display: none;
    }

    .scroll-mobile {
      max-width: min(80vw, 100%);
      max-height: 40vh;
      border-radius: 8px;
      box-shadow: var(--light-shadow);
    }

    ::slotted([slot='extra']) {
      margin: 0 auto;
      max-width: var(--extra-max-width, 206px);
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      :host {
        --size: 1154px;
      }

      .list[half-circle='top'][padding-top='true'] {
        padding-top: calc(var(--half-size) - var(--space-xxxxl) * 1.2);
      }

      .scroller {
        display: none;
      }

      .list[scroll-mobile='true'] ::slotted([slot='scroll']) {
        display: initial;
      }
    }
  `;
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "addMargin", 2);
__decorateClass([
  property20({ type: String, attribute: "add-margin-top" })
], NineContent.prototype, "addMarginTop", 2);
__decorateClass([
  property20({ type: String, attribute: "add-margin-bottom" })
], NineContent.prototype, "addMarginBottom", 2);
__decorateClass([
  property20({ type: String, attribute: "padding-top" })
], NineContent.prototype, "paddingTop", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "alignCenter", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "textCenter", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "padding", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "primarySide", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "slimSide", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "sticky", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "size", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "centerNarrow", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "reverseOrder", 2);
__decorateClass([
  property20({ type: String, attribute: "large-gap-desktop" })
], NineContent.prototype, "largeGapDesktop", 2);
__decorateClass([
  property20({ type: String, attribute: "half-circle" })
], NineContent.prototype, "halfCircle", 2);
__decorateClass([
  property20({ type: String, attribute: "gradient-background" })
], NineContent.prototype, "gradientBackground", 2);
__decorateClass([
  property20({ type: String, attribute: "fade-top" })
], NineContent.prototype, "fadeTop", 2);
__decorateClass([
  property20({ type: String, attribute: "fade-bottom" })
], NineContent.prototype, "fadeBottom", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "primaryChildWidth", 2);
__decorateClass([
  property20({ type: String })
], NineContent.prototype, "image", 2);
__decorateClass([
  property20({ type: String, attribute: "scroll-mobile" })
], NineContent.prototype, "scrollMobile", 2);
__decorateClass([
  property20({ type: Number })
], NineContent.prototype, "breakpoint", 2);
__decorateClass([
  property20({ type: Boolean, attribute: "image-below-content-mobile" })
], NineContent.prototype, "imageBelowContentMobile", 2);
__decorateClass([
  property20()
], NineContent.prototype, "ctaClone", 2);
__decorateClass([
  property20({ type: Boolean, attribute: "align-title-center-mobile" })
], NineContent.prototype, "alignTitleCenterMobile", 2);
__decorateClass([
  queryAssignedNodes3({ slot: "absolute-mobile", flatten: true })
], NineContent.prototype, "_absoluteMobileNodes", 2);
__decorateClass([
  queryAssignedNodes3({ slot: "scroll", flatten: true })
], NineContent.prototype, "_scrollNodes", 2);
__decorateClass([
  queryAssignedNodes3({ slot: "cta", flatten: true })
], NineContent.prototype, "_ctaNodes", 2);
__decorateClass([
  queryAssignedNodes3({ flatten: true })
], NineContent.prototype, "_slotNodes", 2);

// src/components/content/content.ts
var content_default = NineContent;
NineContent.define("nine-content");

// src/components/datepicker/datepicker.component.ts
import { css as css45, html as html30 } from "lit";
import { property as property21 } from "lit/decorators.js";
import { createRef as createRef7, ref as ref7 } from "lit/directives/ref.js";
var NineDatepicker = class extends NineElement {
  constructor() {
    super(...arguments);
    this.pickerInputRef = createRef7();
    this.inputRef = createRef7();
    this.datePropRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
    this.errorMessages = defaultErrorMessages_default;
    this.help = "";
    this.value = "";
    this.min = "0000-01-01";
    this.max = "9999-12-31";
    this.required = "false";
    this.format = "MM/DD/YYYY";
    this.mask = this.format;
    this.error = "";
    this.forceError = "";
    this.disableValidation = false;
    this.name = "";
    this.label = "";
    this.placeholder = "";
    this.size = "full";
    this.initialValidation = "true";
    this.scrollIntoViewOnFocus = false;
    this.checkIfStringIsDate = (date) => {
      const match = this.datePropRegex.test(date);
      if (date && !match) {
        console.warn(`The date ${date} is not in the correct format. Please use YYYY-MM-DD`, this);
      }
      return match;
    };
    this.setupPicker = async () => {
      var _a2;
      try {
        const conf = window.easypickConfig || {};
        this.picker = new window.easypick.create(__spreadProps(__spreadValues({}, conf), {
          element: this.pickerInputRef.value,
          LockPlugin: __spreadValues({
            minDate: this.minDate,
            maxDate: this.maxDate
          }, conf.LockPlugin)
        }));
        (_a2 = this.picker) == null ? void 0 : _a2.on("select", this.handleSelect);
      } catch (error) {
        console.error(error);
      }
    };
    this.dateMaskOptions = () => {
      const IMask = window.IMask;
      if (!IMask) {
        console.error("IMask is not installed. Please install it to use the mask feature.");
        return {
          blocks: {
            DD: { mask: "00" },
            MM: { mask: "00" },
            YYYY: { mask: "0000" }
          }
        };
      }
      return {
        blocks: {
          DD: {
            mask: IMask.MaskedRange,
            autofix: "pad",
            from: 1,
            to: 31,
            maxLength: 2
          },
          MM: {
            mask: IMask.MaskedRange,
            autofix: "pad",
            from: 1,
            to: 12,
            maxLength: 2
          },
          YYYY: {
            mask: IMask.MaskedRange,
            autofix: true,
            from: 1900,
            to: 2999
          }
        },
        lazy: false
      };
    };
    this.handleSelect = (event) => {
      var _a2;
      const date = event.detail.date;
      let day = date.getDate();
      day = day < 10 ? "0" + day : day;
      let month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      const year = date.getFullYear();
      this.value = `${month}/${day}/${year}`;
      if ((_a2 = this.inputRef) == null ? void 0 : _a2.value) {
        this.inputRef.value.setValue(this.value);
      }
      this.gatherDetailsAndDispatch(this.value);
    };
    this.handleChange = (event, resetError = true) => {
      var _a2;
      event.stopPropagation();
      if (resetError && !this.disableValidation) this.error = "";
      const value = (_a2 = event.detail.maskedValue) != null ? _a2 : this.value;
      const date = this.getDateValue(value);
      if (date.valid) {
        this.setDateValue(date.month, date.day, date.year);
        this.value = value;
        this.validate();
      }
      const details = __spreadProps(__spreadValues({}, event.detail), {
        value: date.valid ? this.value : "",
        validDate: date.valid,
        date: date.valid ? date.date : null,
        name: this.name,
        required: this.isRequired
      });
      this.dispatchEvent(
        new CustomEvent(input_default2.customEvents.change, {
          detail: details,
          bubbles: true
        })
      );
    };
    this.setDateValue = (month, day, year) => {
      var _a2, _b;
      if (month && day && year && year > 1e3) {
        const date = /* @__PURE__ */ new Date();
        date.setFullYear(year);
        date.setMonth(month - 1);
        date.setDate(day);
        if (date) {
          (_a2 = this.picker) == null ? void 0 : _a2.gotoDate(date);
          (_b = this.picker) == null ? void 0 : _b.setDate(date);
        }
      }
    };
    this.validate = (setError = false) => {
      const input = this.inputRef.value;
      let error = "";
      if (this.forceError) {
        return this.forceError;
      }
      if (this.disableValidation) {
        return this.error;
      }
      const valueDate = this.getDateValue();
      const asDate = valueDate.date;
      if (this.value && (!valueDate.valid || !asDate)) {
        error = "invalid";
      }
      if (!error && this.required === "true" && !input.unmaskedValue) {
        error = "required";
      }
      if (!error && this.required === "true" && input.unmaskedValue && this.mask && input.maskFilled === false) {
        error = "incomplete";
      }
      const minDate = this.minDate ? new Date(this.minDate) : null;
      const maxDate = this.maxDate ? new Date(this.maxDate) : null;
      if (minDate) minDate == null ? void 0 : minDate.setHours(0, 0, 0, 0);
      if (maxDate) maxDate == null ? void 0 : maxDate.setHours(23, 59, 59, 999);
      const validMin = minDate && asDate ? asDate >= minDate : true;
      const validMax = maxDate && asDate ? asDate <= maxDate : true;
      const dateInRange = validMin && validMax;
      if (valueDate.valid && !dateInRange) {
        error = "out_of_range";
      }
      if (setError && !this.disableValidation) this.error = error;
      return error;
    };
  }
  static get formAssociated() {
    return true;
  }
  get isRequired() {
    return this.required === "true";
  }
  get minDate() {
    let minDate = void 0;
    if (this.checkIfStringIsDate(this.min)) {
      minDate = new Date(this.min);
    }
    if (!minDate) {
      minDate = /* @__PURE__ */ new Date("0000-01-01");
    }
    minDate.setHours(0, 0, 0, 0);
    return minDate;
  }
  get maxDate() {
    let maxDate = void 0;
    if (this.checkIfStringIsDate(this.max)) {
      maxDate = new Date(this.max);
    }
    if (!maxDate) {
      maxDate = /* @__PURE__ */ new Date("9999-12-31");
    }
    maxDate.setHours(23, 59, 59, 999);
    return maxDate;
  }
  setupMask() {
    const input = this.inputRef.value;
    input.setMask(this.dateMaskOptions());
  }
  gatherDetailsAndDispatch(initialValue) {
    var _a2;
    const dateValue = this.getDateValue(initialValue);
    const details = {
      value: this.value,
      date: dateValue.valid ? dateValue.date : null,
      validDate: dateValue.valid,
      name: this.name,
      required: this.isRequired,
      error: (_a2 = this.inputRef.value) == null ? void 0 : _a2.error
    };
    this.handleChange(
      new CustomEvent(input_default2.customEvents.change, {
        detail: details
      })
    );
  }
  addListeners() {
    var _a2;
    ((_a2 = this.inputRef) == null ? void 0 : _a2.value).addEventListener(
      input_default2.customEvents.change,
      this.handleChange
    );
  }
  getDateValue(value) {
    const date = /* @__PURE__ */ new Date();
    const [month, day, year] = (value != null ? value : this.value).replace(/_/g, "").split("/");
    const parsed = {
      month: parseInt(month),
      day: parseInt(day),
      year: parseInt(year == null ? void 0 : year.slice(0, 4))
    };
    const computed = {
      month: parsed.month < 1 ? NaN : parsed.month,
      day: parsed.day < 1 ? NaN : parsed.day,
      year: parsed.year < 1e3 ? NaN : parsed.year
    };
    date.setMonth(computed.month - 1);
    date.setDate(computed.day);
    date.setFullYear(computed.year);
    const valid = !isNaN(computed.month) && !isNaN(computed.day) && !isNaN(computed.year);
    const dateString = valid ? `${computed.month}/${computed.day}/${computed.year}` : "";
    return __spreadProps(__spreadValues({}, computed), {
      valid,
      string: dateString,
      date
    });
  }
  registerInForm() {
    this.dispatchEvent(
      new CustomEvent(input_default2.customEvents.register, {
        detail: {
          name: this.name,
          value: this.value,
          required: this.required,
          root: this
        },
        bubbles: true
      })
    );
    setTimeout(() => {
      this.inputRef.value.errorMessages = this.errorMessages;
    }, 0);
  }
  disconnectedCallback() {
    this.dispatchEvent(
      new CustomEvent(input_default2.customEvents.unregister, {
        detail: {
          name: this.name,
          value: this.value,
          required: this.required,
          root: this
        },
        bubbles: true
      })
    );
  }
  firstUpdated() {
    this.setupPicker();
    this.setupMask();
    this.addListeners();
    this.registerInForm();
    if (this.initialValidation === "true") this.validate();
  }
  openPicker() {
    var _a2;
    (_a2 = this.picker) == null ? void 0 : _a2.show();
  }
  connectedCallback() {
    super.connectedCallback();
  }
  render() {
    var _a2;
    return html30`
      <nine-input
        ${ref7(this.inputRef)}
        mask="${(_a2 = this.mask) != null ? _a2 : this.format}"
        value="${this.value}"
        label="${this.label}"
        name="${this.name}"
        placeholder="${this.placeholder}"
        required="${this.required}"
        hideWarningIcon="true"
        .error=${this.error}
        force-error="${this.forceError}"
        help="${this.help}"
        disable-validation
        type="tel"
        ?scroll-into-view-on-focus="${this.scrollIntoViewOnFocus}"
      >
        <label slot="decoration-end" tabindex="-1" aria-hidden="true">
          <nine-button
            track="false"
            variant="ghost"
            arrow=""
            round="true"
            @click="${this.openPicker}"
            tabindex="-1"
            aria-hidden="true"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.32 6.178h-2.142a1.05 1.05 0 0 0 .014-.167V4.68a1.167 1.167 0 0 0-1.16-1.164h-.672a1.166 1.166 0 0 0-1.164 1.164v1.332c0 .055.005.11.013.166H9.86c.01-.055.014-.11.014-.167V4.68a1.166 1.166 0 0 0-1.165-1.164h-.665A1.166 1.166 0 0 0 6.879 4.68v1.332c0 .055.005.11.013.166H4.684a1.167 1.167 0 0 0-1.168 1.164V19.32a1.166 1.166 0 0 0 1.164 1.165h14.64a1.166 1.166 0 0 0 1.165-1.165V7.342a1.167 1.167 0 0 0-1.165-1.164Zm-4.128-.167V4.68a.167.167 0 0 1 .168-.168h.672a.167.167 0 0 1 .167.166v1.333a.167.167 0 0 1-.167.167h-.672a.167.167 0 0 1-.164-.167h-.004Zm-7.319 0V4.68a.167.167 0 0 1 .17-.168h.665a.166.166 0 0 1 .166.166v1.333a.166.166 0 0 1-.166.167h-.665a.167.167 0 0 1-.166-.167h-.004ZM4.68 7.176h14.64a.166.166 0 0 1 .168.166v2.828H4.512V7.342a.166.166 0 0 1 .168-.166Zm14.64 12.312H4.68a.168.168 0 0 1-.168-.168v-8.151h14.976v8.151a.167.167 0 0 1-.168.168Z"
                fill="#212121"
              />
            </svg>
          </nine-button>
        </label>
        <div slot="root">
          <input class="easepick-input" tabindex="-1" aria-hidden ${ref7(this.pickerInputRef)} aria-hidden="true" />
        </div>
      </nine-input>
    `;
  }
};
NineDatepicker.styles = css45`
    :host {
      display: block;
      position: relative;
      width: 100%;
      z-index: 70;
      --padding: 1em;
      --color-fg-primary: var(--color-fg-primary);
    }

    .easepick-input {
      position: absolute;
      width: min(306px, 100%);
      height: 10px;
      opacity: 0.0001;
      right: 0;
      bottom: -0.2em;
    }

    .easepick-wrapper {
      z-index: 900;
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      :host([size='half']) {
        width: calc(50% - (1em / 2));
      }

      :host([size='half'][colGap2='true']),
      :host([size='half'][colgap2='true']) {
        width: calc(50% - (2em / 2));
      }
    }
  `;
__decorateClass([
  property21({})
], NineDatepicker.prototype, "errorMessages", 2);
__decorateClass([
  property21({ type: String, reflect: true })
], NineDatepicker.prototype, "help", 2);
__decorateClass([
  property21({ type: String })
], NineDatepicker.prototype, "value", 2);
__decorateClass([
  property21({ type: String })
], NineDatepicker.prototype, "min", 2);
__decorateClass([
  property21({ type: String })
], NineDatepicker.prototype, "max", 2);
__decorateClass([
  property21({ type: String })
], NineDatepicker.prototype, "required", 2);
__decorateClass([
  property21({ type: String })
], NineDatepicker.prototype, "format", 2);
__decorateClass([
  property21({ type: String })
], NineDatepicker.prototype, "mask", 2);
__decorateClass([
  property21({ type: String, reflect: true })
], NineDatepicker.prototype, "error", 2);
__decorateClass([
  property21({ type: String, attribute: "force-error", reflect: true })
], NineDatepicker.prototype, "forceError", 2);
__decorateClass([
  property21({ type: Boolean, attribute: "disable-validation" })
], NineDatepicker.prototype, "disableValidation", 2);
__decorateClass([
  property21({ type: String })
], NineDatepicker.prototype, "name", 2);
__decorateClass([
  property21({ type: String })
], NineDatepicker.prototype, "label", 2);
__decorateClass([
  property21({ type: String })
], NineDatepicker.prototype, "placeholder", 2);
__decorateClass([
  property21({ type: String, reflect: true })
], NineDatepicker.prototype, "size", 2);
__decorateClass([
  property21({ type: String, attribute: "initial-validation" })
], NineDatepicker.prototype, "initialValidation", 2);
__decorateClass([
  property21({ type: Boolean, attribute: "scroll-into-view-on-focus" })
], NineDatepicker.prototype, "scrollIntoViewOnFocus", 2);

// src/components/datepicker/datepicker.ts
var datepicker_default = NineDatepicker;
NineDatepicker.define("nine-datepicker");

// src/components/dropdown/dropdown.component.ts
import { css as css46, html as html31 } from "lit";
import { property as property22 } from "lit/decorators.js";
import { createRef as createRef8, ref as ref8 } from "lit/directives/ref.js";

// src/internal/watch.ts
function watch(propertyName, options) {
  const resolvedOptions = __spreadValues({
    waitUntilFirstUpdate: false
  }, options);
  return (proto, decoratedFnName) => {
    const { update } = proto;
    const watchedProperties = Array.isArray(propertyName) ? propertyName : [propertyName];
    proto.update = function(changedProps) {
      watchedProperties.forEach((property77) => {
        const key = property77;
        if (changedProps.has(key)) {
          const oldValue = changedProps.get(key);
          const newValue = this[key];
          if (oldValue !== newValue) {
            if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) {
              this[decoratedFnName](oldValue, newValue);
            }
          }
        }
      });
      update.call(this, changedProps);
    };
  };
}

// src/components/dropdown/dropdown.component.ts
var NineDropdown = class extends NineElement {
  constructor() {
    super();
    this.contentRef = createRef8();
    this.ddRef = createRef8();
    this.handleToggle = (e) => {
      const checked = e.target.checked;
      this.open = Boolean(checked);
      this.emit("nine-dropdown:toggle", { detail: { ref: this.ddRef } });
    };
    this.updateHeight = () => {
      var _a2, _b, _c;
      const contentHeight = (_a2 = this.contentRef.value) == null ? void 0 : _a2.getBoundingClientRect().height;
      const setToHeight = this.open ? contentHeight : 0;
      (_b = this.ddRef.value) == null ? void 0 : _b.style.setProperty("--dd-height", `${setToHeight}px`);
      (_c = this.ddRef.value) == null ? void 0 : _c.classList.toggle("open", this.open);
    };
    this.open = false;
    this.listenForResize();
  }
  listenForResize() {
    window.addEventListener("resize", this.updateHeight);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("resize", this.updateHeight);
  }
  firstUpdated() {
    setTimeout(() => {
      if (this.open) {
        this.updateHeight();
      }
    }, 100);
  }
  handleOpenChange(oldValue, newValue) {
    var _a2;
    const input = (_a2 = this.shadowRoot) == null ? void 0 : _a2.querySelector("input");
    if (input) {
      input.checked = newValue;
    }
    if (oldValue !== newValue) {
      this.updateHeight();
    }
  }
  render() {
    return html31`
      <div ${ref8(this.ddRef)}>
        <div class="header">
          <input type="checkbox" id="toggle" @change=${this.handleToggle} .checked=${this.open} />
          <label for="toggle">
            <div><slot name="header"></slot></div>
            <nine-button
              variant="outline"
              color="sunrise"
              round="true"
              direction="down"
              arrow=">"
              style="--scale: 0.7em"
            ></nine-button>
          </label>
        </div>

        <div class="animated-height">
          <div class="animated-content" ${ref8(this.contentRef)}>
            <div class="dropdown">
              <div class="content">
                <slot name="content"></slot>
              </div>
            </div>
            <div class="absolute">
              <slot name="absolute"></slot>
            </div>
          </div>
        </div>
        <div class="border"></div>
      </div>
    `;
  }
};
NineDropdown.styles = css46`
    :host {
      display: block;
      margin-bottom: 1.5rem;
      position: relative;
    }

    :host(:last-of-type) {
      margin-bottom: 0;
    }

    .border {
      border-bottom: 1px solid var(--color-gray-lighter);
    }

    .content {
      padding-bottom: 1.5rem;
    }

    .header label {
      font-weight: 500;
      font-size: calc(var(--sm-scale) * 1.25);
      line-height: 140%;
      letter-spacing: -0.02em;
      display: flex;
      position: relative;
      padding-bottom: 1rem;
      cursor: pointer;
      align-items: center;
      justify-content: space-between;
    }

    .header input {
      position: absolute;
      opacity: 0.0001;
      pointer-events: none;
    }

    .header nine-button {
      transform: rotate(0deg);
      pointer-events: none;
      margin-left: 1rem;
      transition: transform calc(var(--ease-time) * 2) var(--ease-type);
    }

    .open .header nine-button {
      transform: rotate(180deg);
    }

    .animated-height {
      height: calc(var(--dd-height, 0px) + 100px);
      padding-top: 100px;
      margin-top: -100px;
      margin-bottom: -100px;
      transition: height calc(var(--ease-time) * 2) cubic-bezier(0.34, 1.56, 0.64, 1);
      pointer-events: none;
    }

    .animated-content {
      width: 100%;
      overflow: hidden;
      opacity: 0;
      transition: all 0.6s ease;
      position: absolute;
      pointer-events: none;
    }

    .open .animated-content {
      height: auto;
      overflow: visible;
      opacity: 1;
      pointer-events: all;
    }

    .absolute {
      padding-bottom: var(--space-md);
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      .absolute {
        position: absolute;
        right: -70%;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  `;
__decorateClass([
  property22({ type: Boolean, reflect: true })
], NineDropdown.prototype, "open", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], NineDropdown.prototype, "handleOpenChange", 1);

// src/components/dropdown/dropdown.ts
var dropdown_default = NineDropdown;
NineDropdown.define("nine-dropdown");

// src/components/embed/embed.component.ts
import { css as css47, html as html32 } from "lit";
import { property as property23 } from "lit/decorators.js";
import { createRef as createRef9, ref as ref9 } from "lit/directives/ref.js";
var NineEmbed = class extends NineElement {
  constructor() {
    super(...arguments);
    this.iframeRef = createRef9();
    this.url = "";
    this.title = "";
    this.allow = "autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    this.frameborder = "0";
    this.fullscreen = "true";
    this.width = "100%";
  }
  get videoUrl() {
    var _a2, _b;
    const videoType = this.url.includes("youtube.com") ? "youtube" : this.url.includes("vimeo.com") ? "vimeo" : "";
    switch (videoType) {
      case "youtube": {
        const videoId = (_a2 = this.url.split("?v=")[1]) != null ? _a2 : "";
        return `https://www.youtube.com/embed/${videoId}`;
      }
      case "vimeo": {
        const videoId = (_b = this.url.split("vimeo.com/")[1]) != null ? _b : "";
        return `https://player.vimeo.com/video/${videoId}`;
      }
      default:
        return "";
    }
  }
  firstUpdated() {
    var _a2;
    if (this.fullscreen === "true") {
      (_a2 = this.iframeRef.value) == null ? void 0 : _a2.setAttribute("allowfullscreen", "");
    }
  }
  render() {
    return html32`
      <iframe
        ${ref9(this.iframeRef)}
        src="${this.videoUrl}"
        title="${this.title}"
        frameborder="${this.frameborder}"
        allow="${this.allow}"
        style="--width: ${this.width};"
      >
      </iframe>
    `;
  }
};
NineEmbed.styles = css47`
    :host {
      display: block;
    }

    iframe {
      width: var(--width);
      aspect-ratio: 16/9;
    }
  `;
__decorateClass([
  property23({ type: String })
], NineEmbed.prototype, "url", 2);
__decorateClass([
  property23({ type: String })
], NineEmbed.prototype, "title", 2);
__decorateClass([
  property23({ type: String })
], NineEmbed.prototype, "allow", 2);
__decorateClass([
  property23({ type: String })
], NineEmbed.prototype, "frameborder", 2);
__decorateClass([
  property23({ type: String })
], NineEmbed.prototype, "fullscreen", 2);
__decorateClass([
  property23({ type: String })
], NineEmbed.prototype, "width", 2);

// src/components/embed/embed.ts
var embed_default = NineEmbed;
NineEmbed.define("nine-embed");

// src/components/emoji-to-bullet/emoji-to-bullet.component.ts
import { css as css49, html as html33 } from "lit";

// src/components/emoji-to-bullet/emoji-to-bullet.global.scss?inline
import { css as css48 } from "lit-element/lit-element.js";
var emoji_to_bullet_global_default = css48`@charset "UTF-8";
nine-emoji-to-bullet ul li:not([data-emoji=""]),
nine-emoji-to-bullet ul li[data-img] {
  position: relative;
  padding-left: 2.25em;
}
nine-emoji-to-bullet ul li:not([data-emoji=""])[data-img]::before,
nine-emoji-to-bullet ul li[data-img][data-img]::before {
  display: none;
}
nine-emoji-to-bullet ul li:not([data-emoji=""])[data-img] .img-bullet,
nine-emoji-to-bullet ul li[data-img][data-img] .img-bullet {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-0.15em);
  width: 24px !important;
  height: 24px !important;
}
nine-emoji-to-bullet ul li:not([data-emoji=""])::before,
nine-emoji-to-bullet ul li[data-img]::before {
  content: attr(data-emoji);
  width: 24px;
  height: 24px;
  background: none;
  transform: translate(-1.75em, 0em);
  font-size: 1.25em;
  line-height: 24px;
  text-align: center;
}
nine-emoji-to-bullet ul li:not([data-emoji=""])[data-emoji=🏆]::before, nine-emoji-to-bullet ul li:not([data-emoji=""])[data-emoji=🫴]::before, nine-emoji-to-bullet ul li:not([data-emoji=""])[data-emoji=🫶]::before, nine-emoji-to-bullet ul li:not([data-emoji=""])[data-emoji=🔁]::before,
nine-emoji-to-bullet ul li[data-img][data-emoji=🏆]::before,
nine-emoji-to-bullet ul li[data-img][data-emoji=🫴]::before,
nine-emoji-to-bullet ul li[data-img][data-emoji=🫶]::before,
nine-emoji-to-bullet ul li[data-img][data-emoji=🔁]::before {
  transform: translate(-2.25em, -0.15em);
  font-size: initial;
  line-height: initial;
}
nine-emoji-to-bullet ul li:not([data-emoji=""])[data-emoji=🏆]::before,
nine-emoji-to-bullet ul li[data-img][data-emoji=🏆]::before {
  content: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="%23212121" fill-rule="evenodd" d="M15.75 10.718c0 .857-.355 1.69-1.039 2.303-.714.64-1.68.992-2.711.992-2.073 0-3.75-1.473-3.75-3.295V4.045h7.5v6.673ZM7.057 9.58l.406.073V6.259H4.102l.023.313C4.232 8.04 5.441 9.29 7.058 9.58Zm12.84-3.321-.023.313c-.107 1.467-1.316 2.718-2.933 3.008l-.406.073V6.259h3.361Zm-3.362-2.356c0-.34-.312-.608-.67-.608H8.134c-.358 0-.67.268-.67.608v1.634H4.007c-.39 0-.67.24-.67.609v.233c0 2.01 1.666 3.663 3.842 3.961l.285.039v.34c0 1.786 1.315 3.31 3.13 3.839-.007.06-.022.162-.052.31-.06.296-.18.78-.421 1.505-.238.712-.476 1.186-.649 1.475a3.503 3.503 0 0 1-.164.252H7.6v3.3h8.8v-3.3h-1.667c-.07-.124-.165-.298-.27-.495-.212-.4-.452-.88-.588-1.245a9.8 9.8 0 0 1-.344-1.239 17.942 17.942 0 0 1-.12-.59 4.435 4.435 0 0 0 1.851-1.014l.005-.004c.847-.76 1.3-1.76 1.27-2.816l-.001-.008v-.34l.285-.038c2.176-.298 3.841-1.952 3.841-3.961v-.233c0-.334-.272-.58-.67-.58h-3.456V3.903ZM13.82 18.1h-3.57c.188-.34.412-.82.63-1.474a13.777 13.777 0 0 0 .47-1.726h1.318c.022.112.05.246.082.393.089.407.219.93.376 1.347.156.417.416.936.63 1.34l.064.12ZM8.4 20.6v-1.7h7.2v1.7H8.4Z" clip-rule="evenodd"/></svg>');
}
nine-emoji-to-bullet ul li:not([data-emoji=""])[data-emoji=🫴]::before,
nine-emoji-to-bullet ul li[data-img][data-emoji=🫴]::before {
  content: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="%23212121" fill-rule="evenodd" d="M17.984 18.938a.069.069 0 0 1-.03.016h-.037l-.043.008.086.472-.086-.472-.054.01-.157.028a339.305 339.305 0 0 1-2.424.426c-1.433.246-3.07.513-3.933.611-.13.015-.332-.032-.638-.212-.3-.176-.632-.44-1.01-.758-.119-.1-.241-.206-.368-.314-.651-.56-1.402-1.204-2.184-1.622-1.13-.603-2.519-.322-3.281-.023a.48.48 0 1 0 .35.893c.667-.261 1.72-.429 2.479-.023.68.363 1.333.922 1.985 1.482l.4.34c.38.321.767.631 1.141.852.367.216.793.39 1.234.34.896-.102 2.56-.375 3.987-.62a310.749 310.749 0 0 0 2.433-.427l.157-.028.02-.004a1.02 1.02 0 0 0 .625-.27c.23-.213.364-.529.364-.929 0-.846-.581-1.219-.972-1.275l-.034-.005h-2.853c.014-.095.019-.19.019-.28a.811.811 0 0 0-.172-.483 1.543 1.543 0 0 0-.307-.298 4.41 4.41 0 0 0-.79-.451 12.95 12.95 0 0 0-1.707-.626c-.807-.277-1.196-.713-1.547-1.13l-.061-.075c-.33-.395-.747-.897-1.536-.897H4.28a.48.48 0 0 0 0 .96h4.76c.321 0 .462.152.863.63.387.46.917 1.062 1.982 1.425l.011.003.011.004c.426.122 1.061.336 1.582.577.262.122.474.24.612.345a.822.822 0 0 1 .097.084.59.59 0 0 1-.019.131.162.162 0 0 1-.014.035l-.002.001-.005.003a.184.184 0 0 1-.04.016.85.85 0 0 1-.238.026h-.008c-.681 0-1.882 0-3.44-1.075a.48.48 0 1 0-.545.79c1.797 1.241 3.233 1.245 3.993 1.245h4.022a.188.188 0 0 1 .057.042c.028.03.081.103.081.278a.478.478 0 0 1-.027.177.125.125 0 0 1-.03.047ZM14.22 17.25v-.002.002Z" clip-rule="evenodd"/><path fill="%23212121" fill-rule="evenodd" stroke="%23212121" stroke-width=".5" d="M11.377 4.91v3.008c0 3.55 2.7 5.285 4.123 5.698 1.424-.413 4.123-2.147 4.123-5.698V4.91L15.5 3.395 11.377 4.91Zm4.468-1.783a1 1 0 0 0-.69 0L11 4.653v3.265c0 3.854 3 5.694 4.5 6.082 1.5-.388 4.5-2.228 4.5-6.082V4.653l-4.155-1.526Z" clip-rule="evenodd"/></svg>');
}
nine-emoji-to-bullet ul li:not([data-emoji=""])[data-emoji=🫶]::before,
nine-emoji-to-bullet ul li[data-img][data-emoji=🫶]::before {
  content: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="%23212121" fill-rule="evenodd" d="M11.98 2.57c-.897-.92-2.316-1.143-3.51-.89-1.389.296-2.75 1.303-2.75 2.96 0 .846.164 1.548.478 2.177.312.623.76 1.15 1.29 1.66.426.41.925.825 1.465 1.275l.381.318a34.236 34.236 0 0 1 2.287 2.07c.098.098.23.145.359.14.13.005.26-.042.36-.14a34.256 34.256 0 0 1 2.286-2.07l.38-.318c.541-.45 1.04-.866 1.466-1.276.53-.51.978-1.036 1.29-1.659.314-.629.478-1.33.478-2.177 0-1.657-1.361-2.664-2.75-2.96-1.194-.253-2.613-.03-3.51.89Zm0 1.23a.48.48 0 0 1-.428-.228c-.535-.865-1.728-1.198-2.882-.953-1.152.245-1.99.998-1.99 2.021 0 .714.136 1.267.377 1.748.243.487.606.925 1.096 1.396.4.384.865.772 1.403 1.22l.395.33a36.997 36.997 0 0 1 2.029 1.812 36.953 36.953 0 0 1 2.029-1.811l.395-.33c.538-.449 1.004-.837 1.403-1.221.49-.47.853-.91 1.096-1.396.24-.481.377-1.034.377-1.748 0-1.023-.838-1.776-1.99-2.02-1.154-.246-2.347.087-2.882.952a.48.48 0 0 1-.428.228ZM4.496 8.376a.07.07 0 0 0-.016.03v.037l-.008.043L4 8.4l.472.086-.01.054a186.046 186.046 0 0 0-.13.728c-.086.48-.202 1.14-.324 1.853-.245 1.433-.513 3.07-.611 3.933-.015.13.032.332.213.638.176.299.439.632.757 1.01.1.119.206.241.315.368.559.651 1.204 1.402 1.621 2.184.604 1.13.323 2.519.024 3.281a.48.48 0 0 1-.894-.35c.262-.667.429-1.72.024-2.479-.363-.68-.923-1.333-1.483-1.985l-.34-.4c-.321-.38-.63-.767-.852-1.141-.216-.367-.39-.793-.339-1.234.102-.896.374-2.56.619-3.987a300.646 300.646 0 0 1 .456-2.59l.004-.02a1.02 1.02 0 0 1 .27-.625c.213-.23.528-.364.928-.364.846 0 1.22.581 1.275.972L6 8.366v2.853c.095-.014.19-.019.28-.019.204 0 .369.087.484.173.116.086.215.196.298.306.166.219.318.502.45.79.266.574.495 1.252.626 1.707.277.807.714 1.196 1.13 1.547l.075.061c.395.33.897.747.897 1.536v4.76a.48.48 0 0 1-.96 0v-4.76c0-.321-.152-.462-.629-.863-.46-.387-1.063-.917-1.425-1.982l-.004-.011-.003-.011a12.012 12.012 0 0 0-.578-1.582 3.499 3.499 0 0 0-.344-.612.817.817 0 0 0-.084-.097.584.584 0 0 0-.132.019.157.157 0 0 0-.035.014v.002c-.001 0-.003.002-.004.005a.188.188 0 0 0-.016.04.852.852 0 0 0-.026.238v.008c0 .681 0 1.882 1.075 3.44a.48.48 0 1 1-.79.545C5.045 14.676 5.04 13.24 5.04 12.48V8.458a.186.186 0 0 0-.042-.058c-.03-.027-.102-.08-.278-.08a.478.478 0 0 0-.177.027.124.124 0 0 0-.047.03Zm1.689 3.763h.001-.001ZM19.504 8.376a.07.07 0 0 1 .016.03v.037l.008.043L20 8.4l-.472.086.01.054a108.453 108.453 0 0 1 .13.728c.086.48.202 1.14.324 1.853.245 1.433.513 3.07.611 3.933.015.13-.032.332-.213.638-.176.299-.439.632-.757 1.01-.1.119-.206.241-.314.368-.56.651-1.205 1.402-1.622 2.184-.604 1.13-.323 2.519-.024 3.281a.48.48 0 1 0 .894-.35c-.262-.667-.429-1.72-.023-2.479.362-.68.922-1.333 1.482-1.985l.34-.4c.321-.38.63-.767.852-1.141.216-.367.39-.793.339-1.234-.102-.896-.374-2.56-.619-3.987a294.714 294.714 0 0 0-.427-2.433l-.029-.157-.004-.02a1.02 1.02 0 0 0-.27-.625c-.212-.23-.528-.364-.928-.364-.846 0-1.22.581-1.275.972L18 8.366v2.853a1.924 1.924 0 0 0-.28-.019.811.811 0 0 0-.484.173 1.54 1.54 0 0 0-.298.306 4.41 4.41 0 0 0-.45.79 12.935 12.935 0 0 0-.626 1.707c-.277.807-.714 1.196-1.13 1.547l-.075.061c-.395.33-.897.747-.897 1.536v4.76a.48.48 0 1 0 .96 0v-4.76c0-.321.152-.462.629-.863.46-.387 1.063-.917 1.425-1.982l.004-.011.003-.011c.123-.426.337-1.061.578-1.582.121-.262.24-.474.344-.612a.81.81 0 0 1 .085-.097.583.583 0 0 1 .13.019.156.156 0 0 1 .036.014v.002l.004.005c.004.006.01.018.016.04.013.043.026.118.026.238v.008c0 .681 0 1.882-1.075 3.44a.48.48 0 1 0 .79.545c1.24-1.797 1.245-3.233 1.245-3.993V8.458a.185.185 0 0 1 .042-.058c.03-.027.102-.08.278-.08.092 0 .147.015.177.027a.124.124 0 0 1 .047.03Zm-1.689 3.763h-.001.001Z" clip-rule="evenodd"/></svg>');
}
nine-emoji-to-bullet ul li:not([data-emoji=""])[data-emoji=🔁]::before,
nine-emoji-to-bullet ul li[data-img][data-emoji=🔁]::before {
  content: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="%23212121" d="m7.25 20.95-3.225-3.225 3.225-3.25.675.675-2.125 2.1h11.5V13.3h.925v4.875H5.8L7.925 20.3l-.675.65ZM5.8 10.65V5.775h12.425l-2.125-2.1.65-.675L20 6.25l-3.25 3.225-.65-.675 2.125-2.1h-11.5v3.95H5.8Z"/></svg>');
}`;

// src/components/emoji-to-bullet/emoji-to-bullet.component.ts
styleInject_default(emoji_to_bullet_global_default);
var NineEmojiToBullet = class extends NineElement {
  constructor() {
    super(...arguments);
    this.convertEmojisToBullets = () => {
      var _a2, _b, _c, _d;
      const emojiRegex = new RegExp("^(\\p{Extended_Pictographic})", "u");
      const listElements = this.querySelectorAll("li");
      for (const li of listElements) {
        if (li.dataset.emoji) {
          continue;
        }
        const liContent = (_b = (_a2 = li.textContent) == null ? void 0 : _a2.trim()) != null ? _b : "";
        const emoji = (_d = (_c = emojiRegex.exec(liContent)) == null ? void 0 : _c[1]) != null ? _d : "";
        li.dataset.emoji = emoji;
        if (emoji) {
          li.innerHTML = li.innerHTML.replace(emoji, "").trim();
        } else {
          const firstElement = li.firstElementChild;
          if (firstElement && ["img", "svg"].includes(firstElement.tagName.toLowerCase())) {
            li.dataset.img = "";
            firstElement.classList.add("img-bullet");
          }
          if (!li.dataset.img) {
            const img = firstElement == null ? void 0 : firstElement.querySelector("img, svg");
            if (img) {
              li.dataset.img = "";
              img.classList.add("img-bullet");
            }
          }
        }
      }
    };
  }
  firstUpdated() {
    this.convertEmojisToBullets();
    const observer = new MutationObserver(this.convertEmojisToBullets);
    observer.observe(this, {
      childList: true,
      subtree: true
    });
  }
  render() {
    return html33`<slot></slot>`;
  }
};
NineEmojiToBullet.styles = css49`
    :host {
      display: block;
    }
  `;

// src/components/emoji-to-bullet/emoji-to-bullet.ts
var emoji_to_bullet_default = NineEmojiToBullet;
NineEmojiToBullet.define("nine-emoji-to-bullet");

// src/components/feature-card/feature-card-list.component.ts
import { css as css50, html as html34 } from "lit";
var NineFeatureCardList = class extends NineElement {
  constructor() {
    super(...arguments);
    this.checkLayout = () => {
      const allFeatureCards = this.querySelectorAll("nine-feature-card");
      if (allFeatureCards.length === 0) return;
      this.style.setProperty("--ideal-fit", "");
      allFeatureCards.forEach((card) => {
        const cardEl = card;
        cardEl.style.gridColumn = "";
      });
      const firstCard = allFeatureCards[0];
      const firstCardRect = firstCard.getBoundingClientRect();
      const firstCardWidth = firstCardRect.width;
      const firstCardMargin = parseInt(
        window.getComputedStyle(firstCard).marginRight
      );
      const cardsPerRow = Math.floor(
        (this.getBoundingClientRect().width + firstCardMargin) / (firstCardWidth + firstCardMargin)
      );
      const lastRowCards = allFeatureCards.length % cardsPerRow;
      const totalIsOdd = allFeatureCards.length % 2 === 1;
      if (lastRowCards === 1 && !totalIsOdd) {
        this.style.setProperty("--ideal-fit", "450px");
      }
      allFeatureCards.forEach((card, index) => {
        const cardEl = card;
        const cardIndex = allFeatureCards.length - index;
        cardEl.style.zIndex = `${cardIndex}`;
      });
    };
  }
  firstUpdated() {
    super.connectedCallback();
    this.checkLayout();
    window.addEventListener("resize", this.checkLayout);
    const interval = setInterval(() => {
      const allFeatureCards = this.querySelectorAll("nine-feature-card");
      if (allFeatureCards.length > 0) {
        this.checkLayout();
        clearInterval(interval);
      }
    }, 100);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("resize", this.checkLayout);
  }
  render() {
    return html34`
      <div class="grid">
        <slot></slot>
      </div>
    `;
  }
};
NineFeatureCardList.styles = css50`
    :host {
      display: block;
      --ideal-fit: 280px;
      position: relative;
      z-index: 2;
    }

    .grid {
      display: grid;
      gap: var(--space-md);
      grid-template-columns: repeat(
        auto-fit,
        minmax(min(70vw, var(--ideal-fit)), 1fr)
      );
    }
  `;

// src/components/feature-card/feature-card-list.ts
var feature_card_list_default = NineFeatureCardList;
NineFeatureCardList.define("nine-feature-card-list");

// src/components/feature-card/feature-card.component.ts
import { css as css51, html as html35 } from "lit";
import { property as property24 } from "lit/decorators.js";
import { when } from "lit/directives/when.js";
var NineFeatureCard = class extends NineElement {
  constructor() {
    super(...arguments);
    this.image = "";
    this.showExtra = false;
  }
  render() {
    return html35`
      <div class="card">
        <div class="all">
          ${when(
      this.image,
      () => html35` <div class="image">
              <img src="${this.image}" alt="card image" />
            </div>`
    )}
          <div class="content">
            <div class="title">
              <slot name="title"></slot>
            </div>
            <div class="body">
              <slot name="content"></slot>
            </div>
            ${when(
      this.showExtra,
      () => html35` <div class="extra">
                <slot name="extra"></slot>
              </div>`
    )}
          </div>
        </div>
      </div>
    `;
  }
};
NineFeatureCard.styles = css51`
    :host {
      /* use css vars when possible */
      display: grid;
      max-width: 100%;
    }

    .card {
      container: card / inline-size;
      display: grid;
    }

    .all {
      --obj-pos: 50% 50%;
      --img-aspect-ratio: 315 / 255;
      --img-margin-bottom: var(--space-lg);
      --extra-margin-top: var(--space-lg);
      --title-margin-bottom: var(--space-md);
      --card-padding: var(--space-md);
      padding: var(--card-padding);
      box-shadow: var(--light-shadow);
      border-radius: var(--border-radius);
      background: var(--color-white);
      display: flex;
      flex-direction: column;
    }

    .image img {
      display: block;
      margin-bottom: var(--img-margin-bottom);
      width: 100%;
      aspect-ratio: var(--img-aspect-ratio);
      object-fit: cover;
      border-radius: var(--border-radius);
      object-position: var(--obj-pos);
      transition: all 0.2s ease-in-out;
      max-width: 100%;
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .body {
      flex: 1;
    }

    .extra {
      margin-top: var(--extra-margin-top);
    }

    .title {
      margin-bottom: var(--title-margin-bottom);
    }

    @container card(width > 400 px) {
      .all {
        --obj-pos: 50% 30%;
        --img-aspect-ratio: 1.95 / 1;
        --img-margin-bottom: var(--space-md);
        --extra-margin-top: var(--space-md);
        --title-margin-bottom: var(--space-xs);
      }
    }

    @media (max-width: 664px) {
      .all {
        --obj-pos: 50% 30%;
        --img-aspect-ratio: 1.95 / 1;
        --img-margin-bottom: var(--space-md);
        --extra-margin-top: var(--space-md);
        --title-margin-bottom: var(--space-xs);
        --card-padding: var(--space-sm);
      }
    }
  `;
__decorateClass([
  property24({ type: String })
], NineFeatureCard.prototype, "image", 2);
__decorateClass([
  property24({ type: Boolean, attribute: "show-extra" })
], NineFeatureCard.prototype, "showExtra", 2);

// src/components/feature-card/feature-card.ts
var feature_card_default = NineFeatureCard;
NineFeatureCard.define("nine-feature-card");

// src/components/form/form.component.ts
import { css as css53, html as html37 } from "lit";
import { property as property26 } from "lit/decorators.js";

// src/components/select/select.component.ts
import { html as html36, unsafeCSS as unsafeCSS11 } from "lit";
import { property as property25 } from "lit/decorators.js";
import { createRef as createRef10, ref as ref10 } from "lit/directives/ref.js";

// src/components/select/select.scss?inline
import { css as css52 } from "lit-element/lit-element.js";
var select_default = css52`:host {
  display: block;
  position: relative;
  width: 100%;
}

nine-select-menu[native-select] {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 40;
  width: 100%;
  height: 100%;
}

@media screen and (min-width: 960px) {
  :host([size=half]) {
    width: calc(50% - 0.5em);
  }
  :host([size=half][col-gap]) {
    width: calc(50% - 1em);
  }
}`;

// src/components/select/select.component.ts
var NineSelect = class extends NineElement {
  constructor() {
    super(...arguments);
    this.inputRef = createRef10();
    this.menuRef = createRef10();
    this.cachedValue = "";
    this.setValueOnBlur = false;
    this.selectedOptions = [];
    this.scrollPosBeforeOpen = 0;
    this.name = "";
    this.value = "";
    this.label = "";
    this.error = "";
    this.forceError = "";
    this.disableValidation = false;
    this.nativeSelect = false;
    this.disableProblematicDeviceCheck = false;
    this.required = false;
    this.filter = "";
    this.open = false;
    this.loading = false;
    this.noFilter = false;
    this.noResultsText = "";
    this.preventScroll = false;
    this.disabled = false;
    this.disableVirtual = false;
    this.colGap = false;
    this.size = "full";
    this.handleTouchMove = (e) => {
      var _a2;
      const target = e.target;
      const isInPopover = (_a2 = document.querySelector(".nine-select-popup")) == null ? void 0 : _a2.contains(target);
      if (!isInPopover) {
        e.preventDefault();
      }
    };
    this.handleInputFocus = (e) => {
      e.stopPropagation();
      this.cachedValue = e.detail.value;
      this.setValueOnBlur = true;
      this.setInputValue("");
      this.open = true;
    };
    this.handleInputBlur = (e) => {
      e.stopPropagation();
      this.open = false;
      setTimeout(() => {
        if (this.setValueOnBlur) {
          this.setValueOnBlur = false;
          this.setInputValue(this.cachedValue);
        }
      }, 500);
    };
    this.setInputValue = (value) => {
      var _a2;
      (_a2 = this.inputRef.value) == null ? void 0 : _a2.setValue(value, Boolean(value));
    };
    this.observer = null;
    this.addOptionChangeMutationObserver = () => {
      this.observer = new MutationObserver(
        (mutations) => {
          var _a2;
          return (_a2 = this.menuRef.value) == null ? void 0 : _a2.handleMutationChange(mutations);
        }
      );
      this.observer.observe(this, {
        childList: true,
        subtree: true
      });
    };
    this.handleInputChange = (e) => {
      var _a2;
      e.stopPropagation();
      if (!this.noFilter) {
        (_a2 = this.menuRef.value) == null ? void 0 : _a2.setFilter({
          label: e.detail.value
        });
      }
      const detail = {
        value: e.detail.value,
        selected: this.selectedOptions,
        name: this.name,
        required: this.required,
        root: this
      };
      this.dispatchEvent(
        new CustomEvent("select:filter", {
          detail,
          bubbles: true,
          composed: true
        })
      );
    };
    this.handleSelectChange = (e) => {
      if (!this.name) return;
      if (this.value === e.detail.value) return;
      this.selectedOptions = e.detail.selectedOptions;
      const stringValue = this.selectedOptions.map(({ value }) => value).join(", ");
      const stringLabel = this.selectedOptions.map(({ label }) => label).join(", ");
      const detail = {
        value: stringValue,
        selected: this.selectedOptions,
        name: this.name,
        required: this.required,
        root: this
      };
      this.dispatchEvent(
        new CustomEvent("nineInputChange", {
          detail,
          bubbles: true,
          composed: true
        })
      );
      this.setValueOnBlur = false;
      this.setInputValue(stringLabel);
    };
    this.registerInForm = () => {
      if (!this.name) return;
      const details = {
        value: this.value,
        name: this.name,
        required: this.required,
        root: this
      };
      this.dispatchEvent(
        new CustomEvent(input_default2.customEvents.register, {
          detail: details,
          bubbles: true,
          composed: true
        })
      );
    };
    this.validate = (setError = true) => {
      let error = void 0;
      const selected = this.selectedOptions;
      const { required } = this;
      if (this.forceError) {
        return this.forceError;
      }
      if (required && selected.length === 0) {
        error = "required";
      }
      if (setError && !this.disableValidation) this.error = error;
      return error;
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListeners();
    this.registerInForm();
  }
  disconnectedCallback() {
    var _a2;
    super.disconnectedCallback();
    (_a2 = this.observer) == null ? void 0 : _a2.disconnect();
    const details = {
      value: this.value,
      name: this.name,
      required: this.required,
      root: this
    };
    this.dispatchEvent(
      new CustomEvent(input_default2.customEvents.unregister, {
        detail: details,
        bubbles: true,
        composed: true
      })
    );
  }
  firstUpdated() {
    var _a2;
    (_a2 = this.menuRef.value) == null ? void 0 : _a2.setAnchorElement(this.inputRef.value);
    this.addOptionChangeMutationObserver();
    if (this.open) {
      console.warn(
        "nine-select: The open property should not be set to true on init."
      );
    }
  }
  updated(changedProperties) {
    if (changedProperties.has("open")) {
      this.handleOpenChanged();
    }
  }
  get usePopover() {
    const isTouchDevice = "ontouchstart" in document.documentElement;
    const isMobile = window.innerWidth < 768;
    return isTouchDevice && isMobile;
  }
  addEventListeners() {
    this.addEventListenerInputChange();
  }
  addEventListenerInputChange() {
    var _a2, _b, _c, _d;
    (_a2 = this.shadowRoot) == null ? void 0 : _a2.addEventListener(
      "nineInputChange",
      this.handleInputChange
    );
    (_b = this.shadowRoot) == null ? void 0 : _b.addEventListener(
      "select:change",
      this.handleSelectChange
    );
    (_c = this.shadowRoot) == null ? void 0 : _c.addEventListener(
      "nineInputFocus",
      this.handleInputFocus
    );
    (_d = this.shadowRoot) == null ? void 0 : _d.addEventListener(
      "nineInputBlur",
      this.handleInputBlur
    );
  }
  handleOpenChanged() {
    var _a2;
    if (this.usePopover) {
      this.classList.toggle("has-popover", this.open);
      document.body.classList.toggle("nine-select-open", this.open);
      if (this.open) {
        this.scrollPosBeforeOpen = getMainScrollPosition().y;
        getConfig().mainScrollTarget.scrollTo(0, 0);
        window.scrollTo(0, 0);
        scrollMainTo(0, 0);
        this.createPlaceholder();
        const scrollTopInterval = setInterval(() => {
          var _a3;
          if (this.open) {
            (_a3 = document.scrollingElement) == null ? void 0 : _a3.scrollTo(0, 0);
            scrollMainTo(0, 0);
            window.scrollTo(0, 0);
          } else {
            clearInterval(scrollTopInterval);
          }
        }, 500);
        document.addEventListener("touchmove", this.handleTouchMove, {
          passive: false
        });
      } else {
        this.removePlaceholder();
        (_a2 = document.scrollingElement) == null ? void 0 : _a2.scrollTo(0, this.scrollPosBeforeOpen);
        scrollMainTo(0, this.scrollPosBeforeOpen);
        setTimeout(() => {
          var _a3;
          if (!this.open) {
            (_a3 = document.scrollingElement) == null ? void 0 : _a3.scrollTo(0, this.scrollPosBeforeOpen);
            scrollMainTo(0, this.scrollPosBeforeOpen);
          }
        }, 100);
        setTimeout(() => {
          var _a3;
          if (!this.open) {
            (_a3 = document.scrollingElement) == null ? void 0 : _a3.scrollTo(0, this.scrollPosBeforeOpen);
            scrollMainTo(0, this.scrollPosBeforeOpen);
          }
        }, 500);
        document.removeEventListener("touchmove", this.handleTouchMove);
      }
    }
  }
  createPlaceholder() {
    const placeholder = document.createElement("div");
    placeholder.classList.add("nine-select-popover-placeholder");
    this.after(placeholder);
  }
  removePlaceholder() {
    const placeholder = this.nextElementSibling;
    if (placeholder == null ? void 0 : placeholder.classList.contains("nine-select-popover-placeholder")) {
      placeholder.remove();
    }
  }
  render() {
    return html36`
            <nine-input
                    ${ref10(this.inputRef)}
                    label=${this.label}
                    error=${this.error}
                    disabled="${this.disabled}"
                    required="${this.required}"
            >
                <div slot="decoration-end" style="pointer-events:none">
                    <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                    >
                        <path
                                fill="#212121"
                                d="M11.992 13.718 6.71 9.024l-.662.746 5.944 5.285 5.945-5.285-.664-.746-5.28 4.694Z"
                        />
                    </svg>
                </div>
            </nine-input>
            <nine-select-menu
                    ?loading=${this.loading}
                    ?open=${this.open}
                    ?native-select=${this.nativeSelect}
                    ?disable-virtual=${this.disableVirtual}
                    ?use-popover=${this.usePopover}
                    ?disable-problematic-device-check=${this.disableProblematicDeviceCheck}
                    no-results-text=${this.noResultsText}
                    initial-value=${this.value}
                    ${ref10(this.menuRef)}
            >
                <slot></slot>
            </nine-select-menu>
        `;
  }
};
NineSelect.styles = unsafeCSS11(select_default);
__decorateClass([
  property25({ type: String })
], NineSelect.prototype, "name", 2);
__decorateClass([
  property25({ type: String })
], NineSelect.prototype, "value", 2);
__decorateClass([
  property25({ type: String })
], NineSelect.prototype, "label", 2);
__decorateClass([
  property25({ type: String })
], NineSelect.prototype, "error", 2);
__decorateClass([
  property25({ type: String, attribute: "force-error" })
], NineSelect.prototype, "forceError", 2);
__decorateClass([
  property25({ type: Boolean, attribute: "disable-validation" })
], NineSelect.prototype, "disableValidation", 2);
__decorateClass([
  property25({ type: Boolean, attribute: "native-select" })
], NineSelect.prototype, "nativeSelect", 2);
__decorateClass([
  property25({ type: Boolean, attribute: "disable-problematic-device-check" })
], NineSelect.prototype, "disableProblematicDeviceCheck", 2);
__decorateClass([
  property25({ type: Boolean })
], NineSelect.prototype, "required", 2);
__decorateClass([
  property25({ type: String })
], NineSelect.prototype, "filter", 2);
__decorateClass([
  property25({ type: Boolean })
], NineSelect.prototype, "open", 2);
__decorateClass([
  property25({ type: Boolean })
], NineSelect.prototype, "loading", 2);
__decorateClass([
  property25({ type: Boolean, attribute: "no-filter" })
], NineSelect.prototype, "noFilter", 2);
__decorateClass([
  property25({ type: String, attribute: "no-results-text" })
], NineSelect.prototype, "noResultsText", 2);
__decorateClass([
  property25({ type: Boolean })
], NineSelect.prototype, "preventScroll", 2);
__decorateClass([
  property25({ type: Boolean })
], NineSelect.prototype, "disabled", 2);
__decorateClass([
  property25({ type: Boolean, attribute: "disable-virtual" })
], NineSelect.prototype, "disableVirtual", 2);
__decorateClass([
  property25({ type: Boolean, attribute: "col-gap" })
], NineSelect.prototype, "colGap", 2);
__decorateClass([
  property25({ type: String, reflect: true })
], NineSelect.prototype, "size", 2);

// src/components/form/form.component.ts
var NineForm = class extends NineElement {
  constructor() {
    super(...arguments);
    this.values = {};
    this.fields = [];
    this.errorMessages = defaultErrorMessages_default;
    this.formEventListeners = [];
    this.addMutationObservers = () => {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            let nodeWasRemoved = false;
            if (mutation.removedNodes.length > 0) {
              nodeWasRemoved = true;
            }
            if (!nodeWasRemoved) return;
            const removedFields = this.fields.filter((field) => {
              return !this.contains(field);
            });
            removedFields.forEach((field) => {
              this.handleUnregisterInput(field);
            });
          }
        });
      });
      this.observer.observe(this, {
        childList: true
      });
    };
    this.submitting = false;
    this.handleSubmit = async (e) => {
      e == null ? void 0 : e.preventDefault();
      if (this.submitting) return;
      this.submitting = true;
      this.status = "loading";
      const errors = await this.validateForm();
      const ok = Object.values(errors).every((e2) => !e2);
      this.status = ok ? "success" : "error";
      if (ok) {
        this.dispatchEvent(
          new CustomEvent("submit", {
            detail: this.values,
            bubbles: true,
            composed: true
          })
        );
        this.emit("nine-submit", {
          detail: this.values
        });
        this.onSubmit(this.values);
      }
      this.submitting = false;
    };
    this.validating = false;
    this.validateForm = async (setError = true) => {
      if (this.validating) return {};
      this.validating = true;
      const errors = {};
      this.fields.forEach(
        ({ name, validate }) => errors[name] = validate(setError)
      );
      const formIsValid = Object.values(errors).every((e) => !e);
      if (!formIsValid) {
        this.status = "error";
      }
      if (this.debug === "true") {
        console.log("form validation", {
          errors,
          formIsValid
        });
      }
      this.dispatchEvent(
        new CustomEvent("nine-form:validated", {
          detail: {
            errors,
            formIsValid
          },
          bubbles: true,
          composed: true
        })
      );
      setTimeout(() => {
        this.validating = false;
      });
      return errors;
    };
    this.handleNineInput = (e) => {
      this.status = "dirty";
      const setValue = e.detail.checked !== false;
      if (this.values[e.detail.name] === e.detail.value) return;
      this.values[e.detail.name] = setValue ? e.detail.value : void 0;
      if (this.debug === "true") {
        console.log(
          "values changed",
          {
            name: e.detail.name,
            value: e.detail.value,
            event: e
          },
          this.values
        );
      }
      this.dispatchEvent(new CustomEvent("change", { detail: this.values }));
      if (this.validateOnChange) {
        this.validateForm(false);
      }
    };
    this.handleRegisterInput = (e) => {
      if (this.debug === "true") {
        console.log("register input", e.detail);
      }
      if (e.detail.name in this.values) {
        const oldInput = this.fields.find((f) => f.name === e.detail.name);
        if (oldInput) {
          this.handleUnregisterInput(oldInput);
          if (this.debug === "true") {
            console.warn("unregistering old input", oldInput);
          }
        } else {
          throw new Error("Name already taken!");
        }
      }
      if (this.fields.includes(e.detail.root)) {
        const oldInput = this.fields[e.detail.root];
        if (oldInput) {
          this.handleUnregisterInput(oldInput);
          if (this.debug === "true") {
            console.warn("unregistering old input", oldInput);
          }
        } else {
          throw new Error("Input already registered!");
        }
      }
      this.values[e.detail.name] = e.detail.value;
      this.fields.push(e.detail.root);
      e.detail.root.errorMessages = this.errorMessages;
    };
    this.handleUnregisterInput = (e) => {
      if (this.debug === "true") {
        console.log("unregister input", e);
      }
      if (e instanceof NineInput || e instanceof NineDatepicker || e instanceof NineSelect) {
        this.fields = this.fields.filter((f) => f.name !== e.name);
        delete this.values[e.name];
      }
      if (e instanceof CustomEvent) {
        this.fields = this.fields.filter((f) => f.name !== e.detail.name);
        delete this.values[e.detail.name];
      }
      this.validateForm(false);
    };
    this.scanForInputs = () => {
      const inputs = this.querySelectorAll(
        "nine-input, nine-datepicker, nine-select"
      );
      inputs.forEach((input) => {
        if (input instanceof NineInput || input instanceof NineDatepicker || input instanceof NineSelect) {
          this.handleRegisterInput(
            new CustomEvent(NineInput.customEvents.register, {
              detail: {
                name: input.name,
                value: input.value,
                root: input
              },
              bubbles: true,
              composed: true
            })
          );
        }
      });
    };
    this.rowGap2 = "false";
    this.colGap2 = "false";
    this.debug = "false";
    this.lightDomInputs = [];
    this.status = "pristine";
    this.validateOnChange = false;
    this.onSubmit = async () => {
      return false;
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.formEventListeners.push([
      NineInput.customEvents.change,
      this.handleNineInput
    ]);
    this.formEventListeners.push([
      NineInput.customEvents.register,
      this.handleRegisterInput
    ]);
    this.formEventListeners.push([
      NineInput.customEvents.unregister,
      this.handleUnregisterInput
    ]);
    this.formEventListeners.push([
      NineInput.customEvents.submit,
      this.handleSubmit
    ]);
    this.addMutationObservers();
    this.formEventListeners.forEach(([eventName, listener]) => {
      this.addEventListener(eventName, listener);
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.formEventListeners.forEach(([eventName, listener]) => {
      var _a2;
      this.removeEventListener(eventName, listener);
      (_a2 = this.shadowRoot) == null ? void 0 : _a2.removeEventListener(eventName, listener);
    });
  }
  firstUpdated() {
    this.scanForInputs();
    if (this.validateOnChange) {
      this.validateForm(false);
    }
  }
  renderSlot() {
    return html37`
            <slot></slot>`;
  }
  render() {
    return html37`
            <form
                    @submit="${this.handleSubmit}"
                    status="${this.status}"
                    rowGap2="${this.rowGap2}"
                    colGap2="${this.colGap2}"
            >
                ${this.renderSlot()}
            </form>`;
  }
};
NineForm.styles = css53`
      :host {
        display: block;
        width: 100%;
        position: relative;
      }

      form {
        display: flex;
        flex-wrap: wrap;
        grid-gap: 1em;
        max-width: var(--section-max-width, 100%);
        margin: 0 auto;
        padding: 0 var(--form-padding-x, 0);
        box-sizing: border-box;
      }

      form[rowGap2="true"] {
        row-gap: 2em;
      }

      form[colGap2="true"] {
        column-gap: 2em;
      }
    `;
NineForm.customEvents = {
  validated: "nine-form:validated"
};
__decorateClass([
  property26({ type: String })
], NineForm.prototype, "rowGap2", 2);
__decorateClass([
  property26({ type: String })
], NineForm.prototype, "colGap2", 2);
__decorateClass([
  property26({ type: String })
], NineForm.prototype, "debug", 2);
__decorateClass([
  property26()
], NineForm.prototype, "lightDomInputs", 2);
__decorateClass([
  property26()
], NineForm.prototype, "status", 2);
__decorateClass([
  property26({ type: Boolean, attribute: "validate-on-change" })
], NineForm.prototype, "validateOnChange", 2);
__decorateClass([
  property26()
], NineForm.prototype, "onSubmit", 2);

// src/components/form/form.ts
var form_default = NineForm;
NineForm.define("nine-form");

// src/components/grid/grid-item.component.ts
import { css as css54, html as html38 } from "lit";
import { property as property27 } from "lit/decorators.js";
var NineGridItem = class extends NineElement {
  constructor() {
    super(...arguments);
    this.keepAspectRatio = false;
  }
  render() {
    return html38`
      <div ?keep-aspect-ratio=${this.keepAspectRatio}>
        <slot></slot>
      </div>
    `;
  }
};
NineGridItem.styles = css54`
    :host {
      display: block;
    }

    ::slotted(img) {
      width: 100%;
      border-radius: 0.5rem;
    }

    [keep-aspect-ratio] ::slotted(img) {
      aspect-ratio: 561/440;
      object-fit: cover;
    }

    ::slotted(p) {
      padding: 0 0 0.25rem;
    }
  `;
__decorateClass([
  property27({ type: Boolean, attribute: "keep-aspect-ratio" })
], NineGridItem.prototype, "keepAspectRatio", 2);

// src/components/grid/grid-item.ts
var grid_item_default = NineGridItem;
NineGridItem.define("nine-grid-item");

// src/components/grid/grid.component.ts
import { css as css55, html as html39 } from "lit";
import { property as property28 } from "lit/decorators.js";
var NineGrid = class extends NineElement {
  constructor() {
    super(...arguments);
    this.cols = 4;
    this.shadow = false;
  }
  render() {
    return html39`
      <div
        ?shadow=${this.shadow}
        class="grid"
        style="--cols: ${this.cols}; --cols-mid: ${Math.floor(this.cols / 2)}"
      >
        <slot></slot>
      </div>
    `;
  }
};
NineGrid.styles = css55`
    :host {
      display: block;
    }

    .grid {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      grid-column-gap: var(--space-lg);
      grid-row-gap: var(--space-md);
    }

    .grid[shadow] {
      filter: var(--light-drop-shadow);
    }

    @media screen and (min-width: 640px) {
      .grid {
        grid-template-columns: repeat(var(--cols-mid), 1fr);
        grid-row-gap: calc(var(--space-sm) * 2.5);
      }
    }
    @media screen and (min-width: 1100px) {
      .grid {
        grid-template-columns: repeat(var(--cols), 1fr);
      }
    }
  `;
__decorateClass([
  property28({ type: Number })
], NineGrid.prototype, "cols", 2);
__decorateClass([
  property28({ type: Boolean })
], NineGrid.prototype, "shadow", 2);

// src/components/grid/grid.ts
var grid_default = NineGrid;
NineGrid.define("nine-grid");

// src/components/heading/heading.component.ts
import { css as css56, html as html40 } from "lit";
var NineHeading = class extends NineElement {
  render() {
    return html40`
      <section>
        <div class="center">
          <div class="text">
            <slot></slot>
          </div>
        </div>
      </section>
    `;
  }
};
NineHeading.styles = css56`
    :host {
      display: block;
    }

    .center {
      max-width: var(--section-max-width, var(--page-max-width-narrow));
      margin: 0 auto;
      padding: 0 var(--space-md);
    }

    .text {
      text-align: center;
    }
  `;

// src/components/heading/heading.ts
var heading_default = NineHeading;
NineHeading.define("nine-heading");

// src/components/helper/helper.component.ts
import { html as html41 } from "lit";
var NineHelper = class extends NineElement {
  constructor() {
    super(...arguments);
    this.operatingSystem = "unknown";
    this.deviceType = "unknown";
  }
  connectedCallback() {
    super.connectedCallback();
    this.detectDeviceType();
    this.detectOperatingSystem();
  }
  detectDeviceType() {
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.deviceType = "touch";
    } else if (window.matchMedia("(pointer: fine)").matches) {
      this.deviceType = "mouse";
    }
    document.body.classList.add(`device-${this.deviceType}`);
  }
  detectOperatingSystem() {
    const userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
      this.operatingSystem = "android";
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      this.operatingSystem = "ios";
    } else {
      this.operatingSystem = "desktop";
    }
    document.body.classList.add(`os-${this.operatingSystem}`);
  }
  render() {
    return html41``;
  }
};

// src/components/helper/helper.ts
var helper_default = NineHelper;
NineHelper.define("nine-helper");

// src/components/highlights/highlights.component.ts
import { css as css57, html as html42 } from "lit";
import { repeat } from "lit-html/directives/repeat.js";
import { property as property29 } from "lit/decorators.js";
var NineHighlights = class extends NineElement {
  constructor() {
    super(...arguments);
    this.highlights = [];
    this.poll = false;
  }
  parseContent() {
    const ul = this.querySelector("ul");
    if (!ul) return;
    const lis = ul.querySelectorAll("li");
    if (!lis) return;
    if (lis.length === this.highlights.length) return;
    const newHighlights = [];
    Array.from(lis).forEach((li) => {
      const icon2 = li.getAttribute("data-icon");
      const title = li.innerHTML;
      if (icon2 && title) {
        newHighlights.push({ icon: icon2, title });
      }
    });
    this.highlights = newHighlights;
  }
  connectedCallback() {
    super.connectedCallback();
    this.parseContent();
    if (this.poll) {
      setInterval(() => {
        this.parseContent();
      }, 1e3);
    }
  }
  render() {
    return html42`<div class="hl">
      ${repeat(
      this.highlights,
      (h) => h.title,
      (h) => html42`<div class="item">
          <img src=${h.icon} class="icon" />
          <div class="title">${h.title}</div>
        </div>`
    )}
    </div>`;
  }
};
NineHighlights.styles = css57`
    :host {
      display: block;
      width: 100%;
      container: highlights / inline-size;
    }

    .hl {
      border-radius: 0.5rem;
      border: 1px solid var(--color-gray-light);
      padding: var(--space-sm) calc(var(--space-sm) * 1.2);
      margin: 0;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));

      grid-gap: 0.8em;
    }

    .item {
      display: flex;
      align-items: center;
    }

    .icon {
      width: 20px;
      height: 20px;
      margin-right: var(--space-xs);
      display: block;
      transform: translateY(-1px);
    }

    .title {
      font-weight: 400;
      font-size: calc(var(--sm-scale) * 0.88);
      line-height: 140%;
      letter-spacing: -0.02em;
      color: var(--color-charcoal-80);
    }

    @container highlights (width > 500px) {
      .hl {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  `;
__decorateClass([
  property29({ type: Array })
], NineHighlights.prototype, "highlights", 2);
__decorateClass([
  property29({ type: Boolean })
], NineHighlights.prototype, "poll", 2);

// src/components/highlights/highlights.ts
var highlights_default = NineHighlights;
NineHighlights.define("nine-highlights");

// src/components/icon/icon.component.ts
import { css as css59, html as html43 } from "lit";

// src/components/icon/icon.global.scss?inline
import { css as css58 } from "lit-element/lit-element.js";
var icon_global_default = css58`nine-icon > * {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
}`;

// src/components/icon/icon.component.ts
styleInject_default(icon_global_default);
var NineIcon = class extends NineElement {
  render() {
    return html43`
      <div class="wrap">
        <slot></slot>
      </div>
    `;
  }
};
NineIcon.styles = css59`
    :host {
      display: inline-block;
      max-width: calc(var(--sm-scale) * 3);
    }
  `;

// src/components/icon/icon.ts
var icon_default = NineIcon;
NineIcon.define("nine-icon");

// src/components/icon-link/icon-link.component.ts
import { css as css60, html as html44 } from "lit";
import { property as property30 } from "lit/decorators.js";
var NineIconLink = class extends NineElement {
  constructor() {
    super(...arguments);
    this.resting = "";
    this.active = "";
  }
  render() {
    return html44`
      <img src="${this.resting}" class="resting" />
      <img src="${this.active}" class="active" />
      <slot></slot>
    `;
  }
};
NineIconLink.styles = css60`
    :host {
      position: relative;
      display: inline-block;
      width: var(--width, 1.8em);
      height: var(--width, 1.8em);
      padding: var(--padding, 0.5em);
      margin: var(--margin, 0.5em);
      box-sizing: border-box;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      transition: opacity 0.2s ease-in-out;
    }

    .active {
      opacity: 0;
    }

    :host(:hover) .active {
      opacity: 1;
    }

    :host(:hover) .resting {
      opacity: 0;
    }

    :host(:first-of-type) {
      margin-left: 0;
    }

    :host(:last-of-type) {
      margin-right: 0;
    }

    ::slotted(a) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: block;
    }
  `;
__decorateClass([
  property30({ type: String })
], NineIconLink.prototype, "resting", 2);
__decorateClass([
  property30({ type: String })
], NineIconLink.prototype, "active", 2);

// src/components/icon-link/icon-link.ts
var icon_link_default = NineIconLink;
NineIconLink.define("nine-icon-link");

// src/components/icon-list/icon-list.component.ts
import { css as css61, html as html45 } from "lit";
import { property as property31 } from "lit/decorators.js";
var NineIconList = class extends NineElement {
  constructor() {
    super(...arguments);
    this.maxWidth = "80px";
    this.maxHeight = "80px";
  }
  render() {
    return html45`
      <div
        style="--max-width: ${this.maxWidth}; --max-height: ${this.maxHeight};"
      >
        <slot></slot>
      </div>
    `;
  }
};
NineIconList.styles = css61`
    :host {
      display: block;
    }

    ::slotted(*) {
      max-width: calc(var(--max-width) - var(--space-sm));
      max-height: calc(var(--max-height) - var(--space-sm));
    }

    ::slotted(*:not(:first-child)) {
      margin-left: calc(-1 * var(--space-sm));
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      ::slotted(*) {
        max-width: var(--max-width);
        max-height: var(--max-height);
      }
    }
  `;
__decorateClass([
  property31({ type: String, attribute: "max-width" })
], NineIconList.prototype, "maxWidth", 2);
__decorateClass([
  property31({ type: String, attribute: "max-height" })
], NineIconList.prototype, "maxHeight", 2);

// src/components/icon-list/icon-list.ts
var icon_list_default = NineIconList;
NineIconList.define("nine-icon-list");

// src/components/identify/identify.component.ts
import { css as css62, html as html46 } from "lit";
import { property as property32 } from "lit/decorators.js";
import { createRef as createRef11, ref as ref11 } from "lit/directives/ref.js";
var NineIdentify = class extends NineElement {
  constructor() {
    super(...arguments);
    this.iframeRef = createRef11();
    this.debug = "false";
    this.analyticsToken = "";
    this.src = "";
    this.delay = 0;
    this.renderIframe = false;
  }
  connectedCallback() {
    super.connectedCallback();
    setTimeout(() => {
      this.renderIframe = true;
    }, this.delay * 1e3);
  }
  get isDebug() {
    return this.debug === "true";
  }
  render() {
    if (this.renderIframe) {
      return html46`
        <div class="identify">
          ${this.isDebug ? html46`<div>Token: ${this.analyticsToken}</div>` : ""}
          <iframe ${ref11(this.iframeRef)} src="${this.src}"></iframe>
        </div>
      `;
    }
    return ``;
  }
};
NineIdentify.styles = css62`
    :host {
      position: absolute;
      left: 0;
      top: 0;
      width: 100px;
      height: 100px;
      overflow: hidden;
      pointer-events: none;
      z-index: 999999;
      display: block;
      opacity: 0.001;
    }

    iframe {
      pointer-events: none;
    }

    :host([debug='true']) {
      opacity: 1;
    }
  `;
__decorateClass([
  property32({ type: String })
], NineIdentify.prototype, "debug", 2);
__decorateClass([
  property32({ type: String })
], NineIdentify.prototype, "analyticsToken", 2);
__decorateClass([
  property32({ type: String })
], NineIdentify.prototype, "src", 2);
__decorateClass([
  property32({ type: Number })
], NineIdentify.prototype, "delay", 2);
__decorateClass([
  property32({ type: Boolean })
], NineIdentify.prototype, "renderIframe", 2);

// src/components/identify/identify.ts
var identify_default = NineIdentify;
NineIdentify.define("nine-identify");

// src/components/iframe/iframe.component.ts
import { css as css63, html as html47 } from "lit";
import { property as property33 } from "lit/decorators.js";
import { createRef as createRef12, ref as ref12 } from "lit/directives/ref.js";
var NineIframe = class extends NineElement {
  constructor() {
    super(...arguments);
    this.src = "";
    this.aspect = null;
    this.autoResize = false;
    this.rounded = false;
    this.scrolling = "no";
    this.iframeRef = createRef12();
  }
  initAutoResize() {
    var _a2;
    if (!this.autoResize) return;
    const frame = (_a2 = this.iframeRef) == null ? void 0 : _a2.value;
    const iFrameResize = window.iFrameResize;
    if (frame && iFrameResize) {
      iFrameResize({ log: true, checkOrigin: false }, frame);
    } else {
      console.error(`Can't find iframe or iFrameResize`, {
        frame,
        iFrameResize
      });
    }
  }
  firstUpdated() {
    this.initAutoResize();
  }
  render() {
    var _a2;
    return html47`<section
      style="--aspect: ${(_a2 = this.aspect) != null ? _a2 : "auto"};"
      ?rounded=${this.rounded}
    >
      <iframe
        src="${this.src}"
        frameborder="0"
        scrolling=${this.scrolling}
        ${ref12(this.iframeRef)}
      ></iframe>
    </section>`;
  }
};
// Styles
NineIframe.styles = css63`
    /* Host object as block */
    :host {
      display: block;
      width: 100%;
    }

    /* Reset iframe styles */
    iframe {
      border: none;
      width: 100%;
      height: 100%;
    }

    section {
      position: relative;
      width: 100%;
      aspect-ratio: var(--aspect);
      height: var(--iframe-height, "auto");
    }

    section[rounded] {
      border-radius: 8px;
      overflow: hidden;
    }
  `;
__decorateClass([
  property33({ type: String })
], NineIframe.prototype, "src", 2);
__decorateClass([
  property33({ type: Number })
], NineIframe.prototype, "aspect", 2);
__decorateClass([
  property33({ type: Boolean, attribute: "auto-resize" })
], NineIframe.prototype, "autoResize", 2);
__decorateClass([
  property33({ type: Boolean })
], NineIframe.prototype, "rounded", 2);
__decorateClass([
  property33({ type: String })
], NineIframe.prototype, "scrolling", 2);

// src/components/iframe/iframe.ts
var iframe_default = NineIframe;
NineIframe.define("nine-iframe");

// src/components/image-list/image-list.component.ts
import { css as css64, html as html48 } from "lit";
import { property as property34, queryAssignedNodes as queryAssignedNodes4 } from "lit/decorators.js";
var NineImageList = class extends NineElement {
  constructor() {
    super(...arguments);
    this.maxWidth = "200px";
    this.maxHeight = "100px";
  }
  firstUpdated() {
    const images = this._nodes.filter((node) => node.nodeName === "IMG");
    const percentage = 100 / images.length;
    images.forEach((img) => {
      img.style.width = `calc(${percentage}% - 1.25em)`;
    });
  }
  render() {
    return html48`
      <div
        class="wrapper"
        style="--max-width: ${this.maxWidth}; --max-height: ${this.maxHeight};"
      >
        <slot></slot>
      </div>
    `;
  }
};
NineImageList.styles = css64`
    :host {
      display: block;
    }

    ::slotted(img) {
      max-width: var(--max-width);
      max-height: var(--max-height);
      box-shadow: var(--light-shadow);
      border-radius: 8px;
    }

    ::slotted(img:not(:first-child)) {
      margin-left: var(--space-sm);
    }

    @media screen and (min-width: 740px) {
      ::slotted(img:not(:first-child)) {
        margin-left: var(--space-lg);
      }
    }
  `;
__decorateClass([
  property34({ type: String, attribute: "max-width" })
], NineImageList.prototype, "maxWidth", 2);
__decorateClass([
  property34({ type: String, attribute: "max-height" })
], NineImageList.prototype, "maxHeight", 2);
__decorateClass([
  queryAssignedNodes4({ flatten: true })
], NineImageList.prototype, "_nodes", 2);

// src/components/image-list/image-list.ts
var image_list_default = NineImageList;
NineImageList.define("nine-image-list");

// src/components/info-container/info-container.component.ts
import { css as css65, html as html49 } from "lit";
import { property as property35 } from "lit/decorators.js";
var NineInfoContainer = class extends NineElement {
  constructor() {
    super(...arguments);
    this.variant = "";
  }
  render() {
    return html49`
      <div class="container" variant="${this.variant}">
        <slot></slot>
      </div>
    `;
  }
};
NineInfoContainer.styles = css65`
    :host {
      display: block;
      --padding: 2px;
    }

    .container {
      padding: 0 var(--space-md);
      background-color: var(--color-white);
      border-radius: 0.5rem;
      box-shadow: var(--light-shadow);
    }

    .container[active="true"] {
      background: var(--gradient-sunrise);
      padding: var(--padding);
    }

    .container[active="true"] ::slotted(nine-info-row) {
      border-radius: 0.4rem;
      padding: 0 var(--space-sm);
      background-color: var(--color-white);
    }

    .container[variant="medicationEmpty"] {
      background-color: var(--color-gray-light);
      filter: none;
    }

    ::slotted(nine-info-row:not(:last-child)) {
      border-bottom: 1px solid var(--color-gray-light);
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      .container {
        padding: 0 calc(var(--space-sm) * 1.5);
      }

      .container[active="true"] ::slotted(nine-info-row) {
        padding: 0 calc(var(--space-md) - var(--padding));
      }
    }
  `;
__decorateClass([
  property35({ type: String })
], NineInfoContainer.prototype, "variant", 2);

// src/components/info-container/info-container.ts
var info_container_default = NineInfoContainer;
NineInfoContainer.define("nine-info-container");

// src/components/info-row/info-row.component.ts
import { css as css70, html as html50 } from "lit";
import { property as property36, queryAssignedNodes as queryAssignedNodes5 } from "lit/decorators.js";

// src/components/info-row/info-row.variant.default.ts
import { css as css66 } from "lit";
var infoRowVariantDefault = css66``;
var info_row_variant_default_default = infoRowVariantDefault;

// src/components/info-row/info-row.variant.medication.ts
import { css as css67 } from "lit";
var infoRowVariantMedication = css67``;
var info_row_variant_medication_default = infoRowVariantMedication;

// src/components/info-row/info-row.variant.medication-empty.ts
import { css as css68 } from "lit";
var infoRowVariantMedicationEmpty = css68`
  [variant="medicationEmpty"] {
    background: var(--color-gray-light);
  }

  .image-wrapper {
    border: 1px solid var(--color-gray);
  }
`;
var info_row_variant_medication_empty_default = infoRowVariantMedicationEmpty;

// src/components/info-row/info-row.variant.test-strips.ts
import { css as css69 } from "lit";
var infoRowVariantTestStrips = css69`
  :host([variant="testStrips"][standalone="true"]) .row {
    padding: var(--space-sm);
  }

  [variant="testStrips"] {
    --grid-gap: calc(var(--space-sm) * 1.5);
  }

  [variant="testStrips"] .image-wrapper {
    width: calc(var(--space-sm) * 15.875);
    height: calc(var(--space-sm) * 15.875);
  }

  [variant="testStrips"] .image-wrapper.hide-desktop {
    width: 100%;
    height: calc(var(--space-sm) * 11.25);
  }

  [variant="testStrips"] .image-wrapper {
    width: calc(var(--space-sm) * 15.875);
    height: calc(var(--space-sm) * 15.875);
  }

  [variant="testStrips"] .subtitle-wrapper {
    padding: calc(var(--space-sm) * 0.5) 0 0;
  }

  [variant="testStrips"] .buttons-wrapper {
    margin: calc(var(--space-sm) * 0.75) 0;
  }

  [variant="testStrips"] .hide-mobile ::slotted([slot="price"]) {
    margin: 0 0 calc(var(--space-sm) * 1.5) !important;
  }

  [variant="testStrips"] ::slotted([slot="pill"]),
  [variant="testStrips"] .price-mobile,
  [variant="testStrips"] .image-wrapper.hide-desktop,
  [variant="testStrips"] ::slotted([slot="title"]) {
    margin: 0 0 calc(var(--space-sm) * 0.875) !important;
  }

  @media screen and (min-width: 660px) {
    :host([variant="testStrips"][standalone="true"]) .row {
      padding: calc(var(--space-sm) * 2) calc(var(--space-sm) * 1.5);
    }

    [variant="testStrips"] .hide-mobile {
      display: initial;
    }

    [variant="testStrips"] .hide-desktop {
      display: none;
    }

    [variant="testStrips"] .image-wrapper.hide-desktop {
      margin: 0 !important;
    }

    [variant="testStrips"] ::slotted([slot="pill"]),
    [variant="testStrips"] ::slotted([slot="title"]) {
      margin: 0 0 var(--space-sm) !important;
    }

    [variant="testStrips"] .buttons-wrapper {
      margin: calc(var(--space-sm) * 0.5) 0;
    }

    [variant="testStrips"] ::slotted([slot="extra"]) {
      padding: calc(var(--space-sm) * 0.125) 0 0;
    }
  }
`;
var info_row_variant_test_strips_default = infoRowVariantTestStrips;

// src/components/info-row/info-row.component.ts
var NineInfoRow = class extends NineElement {
  constructor() {
    super(...arguments);
    this.variant = "default";
    this.imageSrc = "";
    this.standalone = "false";
    this.active = "false";
    this.imageAlt = "";
    this.inputName = "";
    this.inputChecked = "false";
    this.padding = "";
    this.alignItems = "";
    this.error = "";
    this.onClick = () => {
    };
  }
  firstUpdated() {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    (_a2 = this.shadowRoot) == null ? void 0 : _a2.addEventListener("change", (e) => {
      this.dispatchEvent(
        new CustomEvent("change", {
          detail: {
            name: this.inputName,
            checked: e.detail.checked
          },
          bubbles: true
        })
      );
    });
    const pill = this._pillNodes[0];
    if (pill) {
      const pillMobile = document.createElement("nine-pill");
      const attributes = pill.getAttributeNames();
      attributes.map((attr) => {
        var _a3;
        (_a3 = pillMobile.setAttribute) == null ? void 0 : _a3.call(pillMobile, attr, String(pill.getAttribute(attr)));
      });
      pillMobile.innerHTML = pill.innerHTML;
      (_c = (_b = this.shadowRoot) == null ? void 0 : _b.querySelector(".pill-mobile")) == null ? void 0 : _c.append(pillMobile);
      (_f = (_e = (_d = this.shadowRoot) == null ? void 0 : _d.querySelector(".pill-mobile")) == null ? void 0 : _e.closest(".flex")) == null ? void 0 : _f.classList.remove("justify-end");
      (_i = (_h = (_g = this.shadowRoot) == null ? void 0 : _g.querySelector(".pill-mobile")) == null ? void 0 : _h.closest(".flex")) == null ? void 0 : _i.classList.add("justify-between");
    }
    const price = this._priceNodes[0];
    if (price) {
      const priceMobile = document.createElement("p");
      const attributes = price.getAttributeNames();
      attributes.map((attr) => {
        var _a3;
        (_a3 = priceMobile.setAttribute) == null ? void 0 : _a3.call(priceMobile, attr, String(price.getAttribute(attr)));
      });
      priceMobile.innerHTML = price.innerHTML;
      (_k = (_j = this.shadowRoot) == null ? void 0 : _j.querySelector(".price-mobile")) == null ? void 0 : _k.append(priceMobile);
    }
    const descriptionWrappers = (_l = this.shadowRoot) == null ? void 0 : _l.querySelectorAll(
      ".description-wrapper"
    );
    descriptionWrappers == null ? void 0 : descriptionWrappers.forEach((descriptionWrapper) => {
      if (!this._descriptionNodes.length) {
        descriptionWrapper == null ? void 0 : descriptionWrapper.classList.remove("description-wrapper");
      }
    });
  }
  renderMarkup() {
    return html50`
      ${this.imageSrc ? html50`
            <div>
              <div class="image-wrapper">
                <img src="${this.imageSrc}" alt="${this.imageAlt}" />
              </div>
            </div>
          ` : ""}
      ${this.variant === "checkbox" || this.variant === "radio" ? html50`
            <div class="input-wrapper">
              <nine-checkbox
                controlled
                variant="${this.variant}"
                name="${this.inputName}"
                ?checked=${this.inputChecked === "true"}
                tabindex="-1"
              ></nine-checkbox>
            </div>
          ` : ""}

      <slot name="icon"></slot>

      <div class="flex flex-alternate-direction justify-between w-100">
        <div>
          <div gap0 class="flex items-center">
            <div id="label-${this.inputName}"><slot name="title"></slot></div>
            <slot name="title-affix"></slot>
            <slot name="pill"></slot>
          </div>
          <div class="description-wrapper">
            <slot name="description"></slot>
            ${this.error ? html50`<div class="error">${this.error}</div>` : ""}
          </div>
        </div>

        <div>
          <div class="flex justify-end items-center">
            <div class="pill-mobile hide-desktop"></div>
            <slot name="price"></slot>
            <slot name="discount"></slot>
          </div>
        </div>
      </div>
    `;
  }
  renderMarkupDefault() {
    return html50`
      <div
        class="row flex"
        variant="${this.variant}"
        padding="${this.padding}"
        alignItems="${this.alignItems}"
      >
        ${this.renderMarkup()}
      </div>
    `;
  }
  renderMarkupCheckboxRadio() {
    return html50`
      <label
        class="row flex"
        variant="${this.variant}"
        padding="${this.padding}"
        alignItems="${this.alignItems}"
        @click=${this.onClick}
        tabindex="0"
        aria-labelledby="label-${this.inputName}"
      >
        ${this.renderMarkup()}
      </label>
    `;
  }
  renderMarkupMedication() {
    return html50`
      <div
        class="row flex"
        variant="${this.variant}"
        padding="${this.padding}"
        alignItems="${this.alignItems}"
      >
        ${this.imageSrc ? html50`
              <div>
                <div class="image-wrapper">
                  <img src="${this.imageSrc}" alt="${this.imageAlt}" />
                </div>
              </div>
            ` : ""}

        <div class="w-100">
          <div class="flex justify-between">
            <div gap0 class="flex items-center">
              <slot name="title"></slot>
              <slot name="title-affix"></slot>
              <slot name="pill"></slot>
            </div>
            <slot name="price"></slot>
          </div>
          <div gap0 class="flex flex-alternate-direction justify-between">
            <div class="description-wrapper">
              <slot name="description"></slot>
            </div>
            <div class="pill-mobile hide-desktop description-wrapper"></div>
            <div class="description-wrapper">
              <slot name="actions"></slot>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  renderMarkupMedicationEmpty() {
    return html50`
      <div
        variant="${this.variant}"
        class="row flex"
        padding="${this.padding}"
        alignItems="${this.alignItems}"
      >
        ${this.imageSrc ? html50`
              <div>
                <div class="image-wrapper">
                  <img src="${this.imageSrc}" alt="${this.imageAlt}" />
                </div>
              </div>
            ` : ""}

        <div class="w-100">
          <div class="flex justify-between">
            <div gap0 class="flex items-center">
              <slot name="title"></slot>
              <slot name="title-affix"></slot>
              <slot name="pill"></slot>
            </div>
            <slot name="price"></slot>
          </div>
          <div gap0 class="flex flex-alternate-direction justify-between">
            <div class="description-wrapper">
              <slot name="description"></slot>
            </div>
            <div class="description-wrapper">
              <slot name="resetModal"></slot>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  renderMarkupTestStrips() {
    return html50`
      <div
        class="row flex"
        variant="${this.variant}"
        padding="${this.padding}"
        alignItems="${this.alignItems}"
      >
        <div class="w-100">
          <div class="flex justify-between items-center pill-wrapper">
            <div class="pill">
              <slot name="pill"></slot>
            </div>
            <div class="price-mobile hide-desktop"></div>
          </div>

          <slot name="title"></slot>

          <div class="image-wrapper hide-desktop">
            <img src="${this.imageSrc}" alt="${this.imageAlt}" />
          </div>

          <div class="subtitle-wrapper">
            <slot name="subtitle"></slot>
          </div>

          <div class="buttons-wrapper">
            <slot name="button"></slot>
          </div>

          <slot name="list"></slot>
          <slot name="extra"></slot>
        </div>

        <div class="text-right hide-mobile">
          <slot name="price"></slot>
          <div class="image-wrapper">
            <img src="${this.imageSrc}" alt="${this.imageAlt}" />
          </div>
        </div>
      </div>
    `;
  }
  get variantStyles() {
    switch (this.variant) {
      case "checkbox":
      case "radio":
        return "";
      case "medication":
        return info_row_variant_medication_default;
      case "medicationEmpty":
        return info_row_variant_medication_empty_default;
      case "testStrips":
        return info_row_variant_test_strips_default;
      default:
        return info_row_variant_default_default;
    }
  }
  get variantMarkup() {
    switch (this.variant) {
      case "checkbox":
      case "radio":
        return this.renderMarkupCheckboxRadio();
      case "medication":
        return this.renderMarkupMedication();
      case "medicationEmpty":
        return this.renderMarkupMedicationEmpty();
      case "testStrips":
        return this.renderMarkupTestStrips();
      default:
        return this.renderMarkupDefault();
    }
  }
  render() {
    return html50`
      <style>
        ${this.variantStyles}
      </style>

      ${this.variantMarkup}
    `;
  }
};
NineInfoRow.styles = css70`
    :host {
      display: block;
      --grid-gap: calc(var(--space-sm) * 0.75);
      --padding: 2px;
    }

    label {
      cursor: pointer;
    }

    .m0 {
      margin: 0;
    }

    .color-c-60 {
      color: var(--color-charcoal-60);
    }

    .hide-mobile {
      display: none;
    }

    .row:not([padding="none"]) {
      padding: var(--space-sm) 0 calc(var(--space-sm) * 0.875);
    }

    .w-100 {
      width: 100%;
    }

    .flex {
      display: flex;
      grid-gap: var(--grid-gap);
    }

    .flex[gap0] {
      grid-gap: 0;
    }

    .flex-alternate-direction {
      flex-direction: column;
    }

    .items-center {
      align-items: center;
    }

    .items-baseline {
      align-items: baseline;
    }

    .justify-between {
      justify-content: space-between;
    }

    .justify-end {
      justify-content: flex-end;
    }

    .text-right {
      text-align: right;
    }

    .image-wrapper {
      width: calc(var(--space-sm) * 2.75);
      height: calc(var(--space-sm) * 2.75);
      border-radius: 0.5rem;
      overflow: hidden;
    }

    img,
    svg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    button {
      cursor: pointer;
      margin: 0;
      padding: 0;
      background-color: transparent;
      border: none;
      outline: none;
      box-shadow: none;
      font-weight: 500;
      /* font-size: 14px; */
      font-size: calc(var(--font-size) * 0.88);
      line-height: 140%;
      letter-spacing: -0.02em;
    }

    .icon-btn {
      margin: -2px 0 calc(var(--space-sm) * 0.125) 0.25rem;
      width: var(--font-size-h5);
      height: var(--font-size-h5);
    }

    ::slotted([slot="title-affix"]) {
      margin-left: calc(var(--space-sm) * 0.25);
    }

    ::slotted([slot="pill"]) {
      margin-left: calc(var(--space-sm) * 0.5);
    }

    ::slotted([slot="removeModal"]),
    ::slotted([slot="resetModal"]) {
      margin-top: calc(var(--space-sm) * 0.125);
    }

    .description-wrapper {
      margin-top: calc(var(--space-sm) * 0.25);
    }

    :host([standalone="true"]) .row {
      box-shadow: var(--light-shadow);
      padding: calc(var(--space-sm) - var(--padding))
        calc(var(--space-sm) - var(--padding))
        calc(var(--space-sm) * 0.875 - var(--padding));
      height: 100%;
      box-sizing: border-box;
      background-color: var(--color-white);
      border: var(--padding) solid transparent;
      border-radius: 6px;
    }

    :host([standalone="true"]) .row:hover {
      border-color: var(--color-gray-fog);
    }

    :host([standalone="true"][active="true"]) {
      ${bgGradientSunrise};
      padding: var(--padding);
      border-radius: 8px;
    }

    :host([standalone="true"][active="true"]) .row,
    :host([standalone="true"][active="true"]) .row:hover {
      border: none;
    }

    .error {
      color: var(--color-error);
      margin-top: calc(var(--space-sm) * 0.25);
      font-weight: 400;
      /* font-size: 14px; */
      font-size: calc(var(--sm-scale) * 0.88);
      line-height: 140%;
      letter-spacing: -0.02em;
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      :host {
        --grid-gap: calc(var(--space-sm));
      }

      .row[alignItems="center"] {
        align-items: center;
      }

      .hide-mobile {
        display: initial;
      }

      .hide-desktop {
        display: none;
      }

      .row:not([padding="none"]) {
        padding: calc(var(--space-sm) * 1.5) 0;
      }

      :host([standalone="true"]) .row {
        padding: calc(var(--space-sm) * 1.5 - var(--padding));
      }

      .flex-alternate-direction {
        flex-direction: row;
      }

      .image-wrapper {
        width: calc(var(--space-sm) * 3.625);
        height: calc(var(--space-sm) * 3.625);
      }

      .description-wrapper {
        margin-top: calc(var(--space-sm) * 0.25);
      }

      ::slotted([slot="removeModal"]),
      ::slotted([slot="resetModal"]) {
        margin-top: 0;
      }
    }
  `;
__decorateClass([
  property36({ type: String })
], NineInfoRow.prototype, "variant", 2);
__decorateClass([
  property36({ type: String })
], NineInfoRow.prototype, "imageSrc", 2);
__decorateClass([
  property36({ type: String, reflect: true })
], NineInfoRow.prototype, "standalone", 2);
__decorateClass([
  property36({ type: String, reflect: true })
], NineInfoRow.prototype, "active", 2);
__decorateClass([
  property36({ type: String })
], NineInfoRow.prototype, "imageAlt", 2);
__decorateClass([
  property36({ type: String })
], NineInfoRow.prototype, "inputName", 2);
__decorateClass([
  property36({ type: String })
], NineInfoRow.prototype, "inputChecked", 2);
__decorateClass([
  property36({ type: String })
], NineInfoRow.prototype, "padding", 2);
__decorateClass([
  property36({ type: String })
], NineInfoRow.prototype, "alignItems", 2);
__decorateClass([
  property36({ type: String })
], NineInfoRow.prototype, "error", 2);
__decorateClass([
  property36({ type: Function })
], NineInfoRow.prototype, "onClick", 2);
__decorateClass([
  queryAssignedNodes5({ slot: "pill", flatten: true })
], NineInfoRow.prototype, "_pillNodes", 2);
__decorateClass([
  queryAssignedNodes5({ slot: "price", flatten: true })
], NineInfoRow.prototype, "_priceNodes", 2);
__decorateClass([
  queryAssignedNodes5({ slot: "description", flatten: true })
], NineInfoRow.prototype, "_descriptionNodes", 2);

// src/components/info-row/info-row.ts
var info_row_default = NineInfoRow;
NineInfoRow.define("nine-info-row");

// src/components/info-section/info-section.component.ts
import { css as css71, html as html51 } from "lit";
var NineInfoSection = class extends NineElement {
  render() {
    return html51`
      <section>
        <div class="center">
          <div class="flex">
            <slot name="title"></slot>
            <slot name="infoModal"></slot>
          </div>

          <slot name="content"></slot>
          <slot name="requestChangeModal"></slot>
          <slot name="extra"></slot>
        </div>
      </section>
    `;
  }
};
NineInfoSection.styles = css71`
    :host {
      display: block;
      margin: var(--section-gap-sm) 0;
    }

    .center {
      max-width: var(--page-max-width-narrow);
      margin: 0 auto;
      padding: 0 var(--section-padding-x, var(--space-md));
    }

    .flex {
      display: flex;
      align-items: center;
    }

    ::slotted([slot="content"]) {
      margin-top: var(--space-sm);
    }

    ::slotted([slot="extra"]) {
      color: var(--color-charcoal-80);
    }

    ::slotted([slot="infoModal"]) {
      margin-left: calc(var(--space-sm) * 0.25);
    }
  `;

// src/components/info-section/info-section.ts
var info_section_default = NineInfoSection;
NineInfoSection.define("nine-info-section");

// src/components/infobar/infobar.component.ts
import { html as html52, unsafeCSS as unsafeCSS12 } from "lit";
import { property as property37 } from "lit/decorators.js";
import { createRef as createRef13, ref as ref13 } from "lit/directives/ref.js";

// src/components/infobar/infobar.scss?inline
import { css as css72 } from "lit-element/lit-element.js";
var infobar_default = css72`:host {
  display: block;
  height: 0;
}

.sticky {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: var(--color-cream);
  transform: translateY(calc(100% - var(--in) * 100%));
  box-shadow: var(--light-shadow);
}

.sticky[always=true] {
  transform: translateY(0);
}

.sticky[inline=true] {
  position: relative;
  transform: translateY(0);
}

.center {
  /* content */
  position: relative;
  margin: 0 auto;
  width: min(100%, var(--page-max-width-wide));
  padding: var(--space-sm) var(--space-md);
  display: flex;
  box-sizing: border-box;
  align-items: center;
}

.left {
  margin-right: auto;
}

.name {
  font-size: calc(var(--sm-scale) * 1.25);
  font-weight: 500;
  order: 1;
}

.show-desktop {
  display: none;
}

.info {
  font-size: calc(var(--scale) * 0.8);
}

.extra {
  display: none;
  order: 10;
}

.action {
  order: 11;
}

.sticky[promo=true] .name {
  display: none;
}

@media screen and (min-width: 1140px) {
  .extra {
    display: block;
    margin-right: auto;
    order: 8;
    padding: 0 var(--space-md);
  }
  .left {
    display: contents;
  }
  .name {
    padding-bottom: 0.22em;
  }
  .show-mobile {
    display: none;
  }
  .show-desktop {
    display: initial;
  }
  .info {
    order: 9;
    padding: 0 var(--space-md);
    font-size: calc(var(--scale) * 1);
  }
  ::slotted([slot=info-mobile]) {
    display: none;
  }
  .sticky[promo=true] .name.show-desktop {
    display: block;
  }
}`;

// src/components/infobar/infobar.component.ts
var NineInfobar = class extends NineElement {
  constructor() {
    super();
    this.triggerEl = createRef13();
    this.stickyEl = createRef13();
    this.setPosition = () => {
      if (this.checkIsPreview()) {
        return;
      }
      const trigger = this.triggerEl.value;
      const sticky = this.stickyEl.value;
      if (!trigger || !sticky) return;
      const scrollPos = getMainScrollPosition().y;
      const windowHeight = window.innerHeight;
      const percentPastCenter = (scrollPos - windowHeight / 3) / windowHeight;
      const set = Math.max(0, Math.min(1, percentPastCenter * 3));
      this.setBodyClass(set > 0.3);
      sticky.style.setProperty("--in", `${set}`);
    };
    this.name = "";
    this.nameMobile = "";
    this.always = "false";
    this.promotion = "false";
    this.inline = "false";
    this.hideNavigationCta = "";
    this.setup();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.teardown();
  }
  setup() {
    addScrollListener(this.setPosition, {
      passive: true
    });
    window.addEventListener("resize", this.setPosition, { passive: true });
    window.addEventListener("DOMContentLoaded", this.setPosition);
    this.setPosition();
  }
  firstUpdated() {
    setTimeout(() => {
      const footer = document.querySelector("nine-footer");
      if (footer) {
        footer.style.paddingBottom = "4rem";
      }
    }, 1e3);
  }
  updateInfobarHeightVariable() {
    var _a2;
    const infobarHeight = (_a2 = this.stickyEl.value) == null ? void 0 : _a2.clientHeight;
    document.body.style.setProperty("--infobar-height", `${infobarHeight}px`);
  }
  teardown() {
    removeScrollListener(this.setPosition);
    window.removeEventListener("resize", this.setPosition);
  }
  setBodyClass(set) {
    if (set) {
      document.body.classList.add("infobar-open");
      this.updateInfobarHeightVariable();
    } else {
      document.body.classList.remove("infobar-open");
    }
  }
  checkIsPreview() {
    const ddElement = document.querySelector("[data-hs-dragdrop]");
    if (ddElement) {
      this.inline = "true";
    }
    return Boolean(ddElement);
  }
  get isPromotion() {
    return this.promotion === "true";
  }
  render() {
    return html52`
            <div class="trigger" ${ref13(this.triggerEl)}></div>
            <div
                    class="sticky"
                    ${ref13(this.stickyEl)}
                    always="${this.always}"
                    promo="${this.promotion}"
                    inline="${this.inline}"
            >
                <div class="center">
                    <div class="left">
                        <div class="name show-desktop">${this.name}</div>
                        ${this.nameMobile ? html52`
                                    <div class="name show-mobile">${this.nameMobile}</div>` : html52``}
                        <div class="info">
                            ${this.isPromotion ? html52`
                                        <slot name="promotion"></slot>` : html52`
                                        <slot name="info"></slot>
                                        <slot name="info-mobile"></slot>
                                        <slot name="info-desktop"></slot>
                                    `}
                        </div>
                    </div>
                    <div class="extra">
                        <slot name="extra"></slot>
                    </div>
                    <div class="action">
                        <slot name="action"></slot>
                    </div>
                </div>
            </div>
        `;
  }
};
NineInfobar.styles = unsafeCSS12(infobar_default);
__decorateClass([
  property37()
], NineInfobar.prototype, "name", 2);
__decorateClass([
  property37({ type: String, attribute: "name-mobile" })
], NineInfobar.prototype, "nameMobile", 2);
__decorateClass([
  property37()
], NineInfobar.prototype, "always", 2);
__decorateClass([
  property37()
], NineInfobar.prototype, "promotion", 2);
__decorateClass([
  property37()
], NineInfobar.prototype, "inline", 2);
__decorateClass([
  property37()
], NineInfobar.prototype, "hideNavigationCta", 2);

// src/components/infobar/infobar.ts
var infobar_default2 = NineInfobar;
NineInfobar.define("nine-infobar");

// src/components/inline-cta/inline-cta.component.ts
import { css as css73, html as html53 } from "lit";
import { property as property38 } from "lit/decorators.js";
var NineInlineCta = class extends NineElement {
  constructor() {
    super(...arguments);
    this.image = "";
    this.dir = "v";
  }
  render() {
    return html53`
      <aside dir="${this.dir}">
        <div class="img" style="background-image: url('${this.image}')"></div>
        <div class="text"><slot></slot></div>
      </aside>
    `;
  }
};
NineInlineCta.styles = css73`
    :host {
      display: block;
    }

    aside {
      display: flex;
      background: white;
      flex-direction: column;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: var(--light-shadow);
    }

    .img {
      width: 100%;
      aspect-ratio: 1.7;
      position: relative;
      background-color: var(--color-cream);
      background-size: cover;
      background-position: 50% 25%;
    }

    .text {
      padding: var(--space-md) var(--space-sm);
    }

    aside[dir="h"] {
      flex-direction: row;
    }

    aside[dir="h"] .img {
      height: auto;
      aspect-ratio: initial;
      width: auto;
      min-width: 32%;
    }

    aside[dir="h"] .text {
      padding: var(--space-md) var(--space-md);
    }
  `;
__decorateClass([
  property38({ type: String })
], NineInlineCta.prototype, "image", 2);
__decorateClass([
  property38({ type: String })
], NineInlineCta.prototype, "dir", 2);

// src/components/inline-cta/inline-cta.ts
var inline_cta_default = NineInlineCta;
NineInlineCta.define("nine-inline-cta");

// src/components/item/item.component.ts
import { css as css74, html as html54 } from "lit";
import { property as property39 } from "lit/decorators.js";
var NineItem = class extends NineElement {
  constructor() {
    super(...arguments);
    this.icon = "check";
    this.title = "check";
    this.center = "true";
  }
  renderIcon() {
    return html54`
      <svg
        width="23"
        height="22"
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.59 6.3 8.46 16.5l-5.38-4.92.89-.8 4.49 4.1L18.7 5.5l.89.8Z"
          fill="#212121"
        />
      </svg>
    `;
  }
  renderBackground() {
    return html54`
      <div class="bg">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x=".5" y=".5" width="39" height="39" rx="19.5" stroke="url(#a)" />
          <defs>
            <linearGradient id="a" x1="20.168" y1="5.254" x2="19.883" y2="34.181" gradientUnits="userSpaceOnUse">
              <stop stop-color="#80AEFF" />
              <stop offset=".527" stop-color="#F7BDE6" />
              <stop offset="1" stop-color="#FFBD70" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    `;
  }
  render() {
    return html54`
      <div class="item" center="${this.center}">
        <div class="icon">${this.renderBackground()} ${this.renderIcon()}</div>
        <div class="text">
          <h5>${this.title}</h5>
          <slot></slot>
        </div>
      </div>
    `;
  }
};
NineItem.styles = css74`
    :host {
      display: block;
      --icon-size: 2.7rem;
      padding: 0.6em 0;
      box-sizing: border-box;
    }

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      width: min(100%, 355px);
    }

    .icon {
      background: var(--icon-bg, transparent);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: var(--icon-size);
      aspect-ratio: 1;
      position: relative;
      margin-bottom: 1.5em;
    }

    .icon svg {
      width: min(100%, auto);
      height: auto;
    }

    h5 {
      font-weight: 500;
      font-size: var(--font-size-h5);
      margin: 0 0 0.5em;
    }

    .item[center="false"] {
      align-items: flex-start;
      text-align: left;
    }

    .bg svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }
  `;
__decorateClass([
  property39({ type: String })
], NineItem.prototype, "icon", 2);
__decorateClass([
  property39({ type: String })
], NineItem.prototype, "title", 2);
__decorateClass([
  property39({ type: String })
], NineItem.prototype, "center", 2);

// src/components/item/item.ts
var item_default = NineItem;
NineItem.define("nine-item");

// src/components/lab-value/lab-value.component.ts
import { css as css75, html as html55 } from "lit";
import { property as property40 } from "lit/decorators.js";
var NineLabValue = class extends NineElement {
  constructor() {
    super(...arguments);
    this.loading = false;
  }
  render() {
    return html55`<div class="wrap">
      <nine-loading-overlay ?loading=${this.loading}> </nine-loading-overlay>
      <div class="icon">
        <slot name="icon"></slot>
      </div>
      <div class="content">
        <div class="title"><slot name="title"></slot>&nbsp;</div>
        <div class="text"><slot name="text"></slot>&nbsp;</div>
      </div>
    </div>`;
  }
};
NineLabValue.styles = css75`
    :host {
      display: block;
    }

    .wrap {
      display: flex;
      align-items: flex-start;
      padding: 1em 1em 0.8em;
      border-radius: 0.5rem;
      background-color: white;
      border: 1px solid var(--color-gray-light);
      position: relative;
    }

    .icon {
      width: 2.4rem;
      height: 2.4rem;
      border-radius: 0.5rem;
      background: var(--gradient-sunrise);
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.5em;
    }

    .icon::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0.94);
      border-radius: inherit;
      width: 100%;
      height: 100%;
      background: white;
      opacity: var(--lab-value-icon-overlay-opacity, 0.6); 
      display: block;
    }

    ::slotted([slot="icon"]) {
      position: relative;
      z-index: 1;
      width: auto;
      height: 1em;
    }

    .title {
      font-weight: 500;
      line-height: 1.4;
    }

    .text {
      font-size: calc(var(--sm-scale) * 0.875);
      font-weight: 400;
      opacity: 0.8;
    }

    .content {
      padding: 0 0.8rem 0 0.7rem;
    }
  `;
__decorateClass([
  property40({ type: Boolean })
], NineLabValue.prototype, "loading", 2);

// src/components/lab-value/lab-value.ts
var lab_value_default = NineLabValue;
NineLabValue.define("nine-lab-value");

// src/components/language-select/language-select.component.ts
import { html as html56, unsafeCSS as unsafeCSS13 } from "lit";
import { property as property41 } from "lit/decorators.js";

// src/components/language-select/language-select.scss?inline
import { css as css76 } from "lit-element/lit-element.js";
var language_select_default = css76`.language-select-nav {
  position: relative;
  display: inline-block;
  font-weight: 500;
  display: flex;
  margin-top: 1px;
}
.language-select-nav[data-top-bar=false] {
  width: 100%;
  display: initial;
  margin-top: 0;
}
@media screen and (max-width: 960px) {
  .language-select-nav[data-top-bar=true] {
    display: none;
  }
}

.select-displayed {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  --color-gray-charcoal: #212121;
}
.select-displayed[data-top-bar=false] {
  border: 1px solid var(--color-gray-charcoal);
  border-radius: 0.5rem;
  padding: 1rem 1rem;
}

.text-icon {
  display: flex;
  align-items: center;
  gap: 10px;
}

select {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}`;

// src/components/language-select/language-select.component.ts
var Languages = /* @__PURE__ */ ((Languages2) => {
  Languages2["en"] = "English (EN)";
  Languages2["es"] = "Spanish (ES)";
  return Languages2;
})(Languages || {});
var NineLanguageSelect = class extends NineElement {
  constructor() {
    super(...arguments);
    this.initialLanguageNav = "";
    this.redirectSlug = "";
    this.topBar = false;
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    if (this.initialLanguageNav === value) {
      return;
    }
    window.location.pathname = this.redirectSlug;
  }
  get initialValue() {
    return this.topBar ? this.initialLanguageNav.toUpperCase() : Languages[this.initialLanguageNav];
  }
  render() {
    return html56`
      <div class="language-select-nav" data-top-bar="${this.topBar}">
        <label class="select-displayed" data-top-bar="${this.topBar}">
          <div class="text-icon">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.83238 8.5C1.61567 9.29657 1.5 10.1348 1.5 11C1.5 11.8652 1.61567 12.7034 1.83238 13.5H6.75009C6.6019 12.6826 6.51761 11.8503 6.50011 11.0104C6.49996 11.0035 6.49996 10.9965 6.50011 10.9896C6.51761 10.1497 6.6019 9.31739 6.75009 8.5H1.83238ZM2.16551 7.5H6.96506C7.50094 5.34865 8.48598 3.325 9.86496 1.56711C6.35097 1.98548 3.42563 4.32197 2.16551 7.5ZM11 1.75702C9.57944 3.43527 8.55888 5.39915 7.99779 7.5H14.0022C13.4411 5.39915 12.4206 3.43527 11 1.75702ZM14.2325 8.5H7.76753C7.60855 9.31946 7.5183 10.1556 7.50011 11C7.5183 11.8444 7.60855 12.6805 7.76753 13.5H14.2325C14.3914 12.6805 14.4817 11.8444 14.4999 11C14.4817 10.1556 14.3914 9.31946 14.2325 8.5ZM15.2499 13.5C15.3981 12.6826 15.4824 11.8503 15.4999 11.0104C15.5 11.0035 15.5 10.9965 15.4999 10.9896C15.4824 10.1497 15.3981 9.31739 15.2499 8.5H20.1676C20.3843 9.29657 20.5 10.1348 20.5 11C20.5 11.8652 20.3843 12.7034 20.1676 13.5H15.2499ZM14.0022 14.5H7.99779C8.55888 16.6008 9.57944 18.5647 11 20.243C12.4206 18.5647 13.4411 16.6008 14.0022 14.5ZM9.86496 20.4329C8.48598 18.675 7.50094 16.6513 6.96506 14.5H2.16551C3.42563 17.678 6.35097 20.0145 9.86496 20.4329ZM12.135 20.4329C13.514 18.675 14.4991 16.6513 15.0349 14.5H19.8345C18.5744 17.678 15.649 20.0145 12.135 20.4329ZM19.8345 7.5H15.0349C14.4991 5.34865 13.514 3.325 12.135 1.56711C15.649 1.98548 18.5744 4.32197 19.8345 7.5ZM0.5 11C0.5 5.20101 5.20101 0.5 11 0.5C16.799 0.5 21.5 5.20101 21.5 11C21.5 16.799 16.799 21.5 11 21.5C5.20101 21.5 0.5 16.799 0.5 11Z"
                fill="#212121"
              />
            </svg>
            <span>${this.initialValue}</span>
          </div>
          ${!this.topBar ? html56`<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.99217 4.71833L0.710252 0.0239258L0.0478516 0.769845L5.99217 6.05465L11.9365 0.769845L11.2731 0.0239258L5.99217 4.71833Z"
                  fill="#212121"
                />
              </svg>` : html56``}
          <select
            data-navbar="true"
            class="native-select"
            id="language"
            .value="${this.initialLanguageNav}"
            @change="${this.handleInputChange}"
          >
            <option value="en">${"English (EN)" /* en */}</option>
            <option value="es">${"Spanish (ES)" /* es */}</option>
          </select>
        </label>
      </div>
    `;
  }
};
NineLanguageSelect.styles = unsafeCSS13(language_select_default);
__decorateClass([
  property41({ type: String, attribute: "initial-language" })
], NineLanguageSelect.prototype, "initialLanguageNav", 2);
__decorateClass([
  property41({ type: String, attribute: "redirect-slug" })
], NineLanguageSelect.prototype, "redirectSlug", 2);
__decorateClass([
  property41({ type: Boolean, reflect: true, attribute: "top-bar" })
], NineLanguageSelect.prototype, "topBar", 2);

// src/components/language-select/language-select.ts
var language_select_default2 = NineLanguageSelect;
NineLanguageSelect.define("nine-language-select");

// src/components/layout-grid/layout-grid.component.ts
import { css as css77, html as html57 } from "lit";
var NineLayoutGrid = class extends NineElement {
  render() {
    return html57`<slot></slot> `;
  }
};
NineLayoutGrid.styles = css77`
    :host {
      max-width: var(--page-max-width);
      display: grid;
      grid-gap: var(--space-md);
      margin: 0 0 5em;
    }

    @media (min-width: 768px) {
      :host {
        /* 2 column grid */
        grid-template-columns: repeat(2, 1fr);
      }
    }
  `;

// src/components/layout-grid/layout-grid.ts
var layout_grid_default = NineLayoutGrid;
NineLayoutGrid.define("nine-layout-grid");

// src/components/loading-overlay/loading-overlay.component.ts
import { css as css78, html as html58 } from "lit";
import { property as property42 } from "lit/decorators.js";
var NineLoadingOverlay = class extends NineElement {
  constructor() {
    super(...arguments);
    this.loading = false;
  }
  get randomLoadingAnimationDelay() {
    return Math.floor(Math.random() * 300);
  }
  render() {
    return html58`<div
      class="wrap"
      style="--animation-delay: ${this.randomLoadingAnimationDelay}ms"
    >
      <div class="shine"></div>
    </div>`;
  }
};
NineLoadingOverlay.styles = css78`
    :host {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: inherit;
      background: #ffffff;
      z-index: 30;
      overflow: hidden;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
    }

    :host([loading]) {
      opacity: 1;
      pointer-events: all;
    }

    @keyframes shine {
      0% {
        transform: translateX(-100%);
        opacity: 1;
      }
      100% {
        transform: translateX(100%);
        opacity: 1;
      }
    }

    .shine {
      position: absolute;
      top: 0;
      width: 300%;
      height: 100%;
      background-image: linear-gradient(
        var(--gradient-dir),
        #ffffff 0%,
        #a6c6ff 20%,
        #fad0e8 48.44%,
        #ffd199 81.45%,
        #ffffff 100%
      );
      opacity: 0;
      animation: shine 3s infinite linear;
      animation-delay: var(--animation-delay, 0ms);
    }
  `;
__decorateClass([
  property42({ type: Boolean })
], NineLoadingOverlay.prototype, "loading", 2);

// src/components/loading-overlay/loading-overlay.ts
var loading_overlay_default = NineLoadingOverlay;
NineLoadingOverlay.define("nine-loading-overlay");

// src/components/logo/logo.component.ts
import { css as css79, html as html59 } from "lit";
import { property as property43 } from "lit/decorators.js";
var NineLogo = class extends NineElement {
  constructor() {
    super(...arguments);
    this.src = "";
    this.alt = "";
    this.href = "";
    this.target = "";
    this.rel = "";
    this.mixBlendMode = "multiply";
    this.shadow = "false";
    this.radius = "false";
    this.imgFullWidth = "false";
  }
  renderImage() {
    return html59`<div
      class="wrapper"
      style="
    --mix-blend-mode: ${this.mixBlendMode}; 
    --img-url: url('${this.src}');
    "
    >
      <img
        img-full-width="${this.imgFullWidth}"
        src="${this.src}"
        alt="${this.alt}"
      />
    </div>`;
  }
  renderMarkup() {
    if (this.href) {
      return html59`
        <a href=${this.href} target=${this.target} rel=${this.rel}>
          ${this.renderImage()}
        </a>
      `;
    }
    return html59` ${this.renderImage()} `;
  }
  render() {
    return html59`${this.renderMarkup()}`;
  }
};
NineLogo.styles = css79`
    :host {
      display: block;
    }

    :host([shadow="true"]) {
      box-shadow: var(--light-shadow);
    }

    :host([radius="true"]) {
      border-radius: 8px;
      overflow: hidden;
    }

    .wrapper {
      max-width: var(--max-width);
      max-height: var(--max-height);
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: var(--img-url);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      /* background-blend-mode: var(--mix-blend-mode); */
      /* background-color: var(--color-cream); */
    }

    img {
      width: min(100%, 170px, 60vw);
      max-height: 100%;
      opacity: 0;
    }

    img[img-full-width="true"] {
      width: 100%;
    }
  `;
__decorateClass([
  property43({ type: String })
], NineLogo.prototype, "src", 2);
__decorateClass([
  property43({ type: String })
], NineLogo.prototype, "alt", 2);
__decorateClass([
  property43({ type: String })
], NineLogo.prototype, "href", 2);
__decorateClass([
  property43({ type: String })
], NineLogo.prototype, "target", 2);
__decorateClass([
  property43({ type: String })
], NineLogo.prototype, "rel", 2);
__decorateClass([
  property43({ type: String })
], NineLogo.prototype, "mixBlendMode", 2);
__decorateClass([
  property43({ type: String })
], NineLogo.prototype, "shadow", 2);
__decorateClass([
  property43({ type: String })
], NineLogo.prototype, "radius", 2);
__decorateClass([
  property43({ type: String, attribute: "img-full-width" })
], NineLogo.prototype, "imgFullWidth", 2);

// src/components/logo/logo.ts
var logo_default = NineLogo;
NineLogo.define("nine-logo");

// src/components/logo-list/logo-list.component.ts
import { css as css80, html as html60 } from "lit";
import { property as property44 } from "lit/decorators.js";
var NineLogoList = class extends NineElement {
  constructor() {
    super(...arguments);
    this.padding = "md";
    this.gap = "lg";
    this.justifyContent = "center";
    this.alignItems = "center";
    this.responsive = "true";
  }
  render() {
    return html60`
      <div
        class="flex"
        responsive="${this.responsive}"
        style="
        --padding: var(--space-${this.padding});
        --gap: var(--space-${this.gap});
        --justify-content: ${this.justifyContent};
        --align-items: ${this.alignItems};"
      >
        <slot></slot>
      </div>
    `;
  }
};
NineLogoList.styles = css80`
    :host {
      display: block;
      position: relative;
      z-index: 2;
      --max-width: 190px;
      --max-height: 43px;
    }

    .flex {
      display: flex;
      justify-content: var(--justify-content);
      align-items: var(--align-items);
      grid-gap: var(--gap);
      flex-wrap: wrap;
      margin: 0 auto;
      padding: 0 var(--padding);
    }

    .flex[responsive="false"] {
      flex-wrap: nowrap;
      grid-gap: calc(var(--gap) / 2);
    }

    ::slotted(*) {
      width: min(100%, var(--max-width));
      max-height: var(--max-height);
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      .flex[responsive="false"] {
        grid-gap: var(--gap);
      }
    }
  `;
__decorateClass([
  property44({ type: String })
], NineLogoList.prototype, "padding", 2);
__decorateClass([
  property44({ type: String })
], NineLogoList.prototype, "gap", 2);
__decorateClass([
  property44({ type: String, attribute: "justify-content" })
], NineLogoList.prototype, "justifyContent", 2);
__decorateClass([
  property44({ type: String, attribute: "align-items" })
], NineLogoList.prototype, "alignItems", 2);
__decorateClass([
  property44({ type: String })
], NineLogoList.prototype, "responsive", 2);

// src/components/logo-list/logo-list.ts
var logo_list_default = NineLogoList;
NineLogoList.define("nine-logo-list");

// src/components/message/message.component.ts
import { html as html61, unsafeCSS as unsafeCSS14 } from "lit";
import { property as property45 } from "lit/decorators.js";

// src/components/message/message.scss?inline
import { css as css81 } from "lit-element/lit-element.js";
var message_default = css81`:host {
  display: block;
}

.wrap {
  display: flex;
  align-items: flex-end;
  grid-gap: 1.1em;
}

.profile {
  width: 3.2em;
  min-width: 3.2em;
  height: 3.2em;
  border-radius: 50%;
  background-color: var(--color-cream);
  background-size: cover;
  background-position: center;
  background-image: var(--img);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-charcoal);
  font-size: 0.9em;
  font-weight: 500;
}

.header {
  margin-bottom: 0.5em;
  font-size: 0.9em;
  color: var(--color-charcoal-60);
  font-weight: 400;
}

.footer {
  margin-top: 0.8em;
  font-size: 0.9em;
  color: var(--color-charcoal-60);
  font-weight: 400;
}
.footer .daytime {
  display: none;
}

.name {
  font-weight: 500;
  color: var(--color-charcoal-80);
}

.msg {
  padding: 1em 1em 0.8em;
  border-radius: 0.5em;
  position: relative;
  max-width: var(--msg-max-w, 100%);
  width: var(--msg-w, auto);
  box-sizing: border-box;
}
.msg::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  border-radius: inherit;
  background: var(--bg, var(--color-white));
  box-shadow: var(--light-shadow);
  z-index: -2;
}
.msg::after {
  content: "";
  display: block;
  position: absolute;
  width: 2em;
  height: 2em;
  background-color: var(--bg, var(--color-white));
  border-radius: 10%;
  transform: rotate(45deg);
  bottom: 0.48em;
  right: calc(100% - 1.7em);
  z-index: -1;
}

.wrap[hide-avatar=true] .msg::after {
  display: none;
}

.wrap[message-type=user] {
  flex-direction: row-reverse;
}
.wrap[message-type=user] .msg::after {
  right: auto;
  left: calc(100% - 1.7em);
}
.wrap[message-type=user] .header {
  display: none;
}
.wrap[message-type=user] .footer {
  display: flex;
  justify-content: flex-end;
}
.wrap[message-type=user] .footer .name, .wrap[message-type=user] .footer .credentials {
  display: none;
}
.wrap[message-type=user] .footer .daytime {
  display: block;
}

.wrap[just-pos=true] .msg {
  padding: 0;
}
.wrap[just-pos=true] .msg::before, .wrap[just-pos=true] .msg::after {
  content: none;
}
.wrap[just-pos=true] .profile {
  opacity: 0;
}
.wrap[just-pos=true] .header, .wrap[just-pos=true] .footer {
  display: none;
}`;

// src/components/message/message.component.ts
var NineMessage = class extends NineElement {
  constructor() {
    super(...arguments);
    this.daytime = "";
    this.author = "";
    this.credentials = "";
    this.initials = "";
    this.profileImage = "";
    this.hideAvatar = false;
    this.messageType = "other";
    this.justPosition = false;
  }
  triggerDetails() {
    this.dispatchEvent(
      new CustomEvent("nine:openDetails", {
        detail: {
          root: this
        },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return html61`<div
      class="wrap"
      hide-avatar="${this.hideAvatar}"
      just-pos="${this.justPosition}"
      message-type="${this.messageType}"
      style="--bg: ${this.messageType === "user" ? "var(--color-midmorning-blue)" : "white"}"
      ;
    >
      ${this.hideAvatar ? "" : html61`
            <div
              class="profile"
              style="--img: url('${this.profileImage}')"
              @click="${this.triggerDetails}"
            >
              ${!this.profileImage ? this.initials : ""}
            </div>
          `}
      <div class="msg">
        <div class="header">${this.daytime}</div>

        <slot></slot>

        <div class="footer" @click="${this.triggerDetails}">
          <div class="name">${this.author}</div>
          <div class="credentials">${this.credentials}</div>
          <div class="daytime">${this.daytime}</div>
        </div>
      </div>
    </div>`;
  }
};
NineMessage.styles = unsafeCSS14(message_default);
__decorateClass([
  property45({ type: String })
], NineMessage.prototype, "daytime", 2);
__decorateClass([
  property45({ type: String })
], NineMessage.prototype, "author", 2);
__decorateClass([
  property45({ type: String })
], NineMessage.prototype, "credentials", 2);
__decorateClass([
  property45({ type: String })
], NineMessage.prototype, "initials", 2);
__decorateClass([
  property45({ type: String, attribute: "profile-image", reflect: true })
], NineMessage.prototype, "profileImage", 2);
__decorateClass([
  property45({ type: Boolean, reflect: true, attribute: "hide-avatar" })
], NineMessage.prototype, "hideAvatar", 2);
__decorateClass([
  property45({ type: String, reflect: true, attribute: "message-type" })
], NineMessage.prototype, "messageType", 2);
__decorateClass([
  property45({ type: Boolean, reflect: true, attribute: "just-position" })
], NineMessage.prototype, "justPosition", 2);

// src/components/message/message.ts
var message_default2 = NineMessage;
NineMessage.define("nine-message");

// src/components/messageList/messageList.component.ts
import { css as css82, html as html62 } from "lit";
import { property as property46 } from "lit/decorators.js";
var NineMessageList = class extends NineElement {
  constructor() {
    super(...arguments);
    this.num = 0;
  }
  // scroll to bottom when list loads
  updated() {
    this.scrollToBottom();
  }
  handleMutation() {
    this.scrollToBottom();
  }
  connectedCallback() {
    super.connectedCallback();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  scrollToBottom(time = 1200) {
    animate(
      time,
      (p) => {
        this.scrollTo(0, p);
      },
      {
        range: [this.scrollTop, this.scrollHeight - this.clientHeight]
      }
    );
  }
  render() {
    return html62`<div class="wrap">
      <slot></slot>
    </div>`;
  }
};
NineMessageList.styles = css82`
    :host {
      display: block;
      height: 500px;
      overflow: auto;
      padding: 50px 0 100px;
      display: flex;
      flex-direction: column-reverse;
    }

    .wrap {
      display: flex;
      flex-direction: column;
      grid-gap: 0.5rem;
      margin: 0 auto;
      width: var(--width, 100%);
    }
  `;
__decorateClass([
  property46({ type: Number, reflect: true })
], NineMessageList.prototype, "num", 2);

// src/components/messageList/messageList.ts
var messageList_default = NineMessageList;
NineMessageList.define("nine-message-list");

// src/components/navigation/nav-menu.component.ts
import { html as html63, unsafeCSS as unsafeCSS15 } from "lit";
import { property as property47 } from "lit/decorators.js";
import { repeat as repeat2 } from "lit/directives/repeat.js";

// src/components/navigation/nav-menu.scss?inline
import { css as css83 } from "lit-element/lit-element.js";
var nav_menu_default = css83`ul {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 1rem 1.5rem;
}

li {
  display: block;
  position: relative;
  font-weight: 500;
  padding-left: 0;
  margin: 0;
  text-align: center;
}
li::before {
  content: none;
}

/* toggle sub-menus */
li ul {
  display: none;
}

li.subnav-open ul {
  display: block;
}

li.has-subnav .link-parent-title::after {
  content: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"><path fill="%23212121" d="m15.99 18.291-7.043-6.259-.883.995 7.926 7.046 7.926-7.046-.885-.995-7.041 6.26Z"/></svg>');
  position: absolute;
  top: 50%;
  right: calc(var(--space-sm) * 2.25 * -1);
  transform: translateY(-35%);
}
li.has-subnav[aria-current=page] .link-parent-title::after {
  content: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"><path fill="%23FFFFFF" d="m15.99 18.291-7.043-6.259-.883.995 7.926 7.046 7.926-7.046-.885-.995-7.041 6.26Z"/></svg>');
}
li.has-subnav .subnav-menu-wrapper {
  margin-right: calc(var(--space-sm) * 2.25 * -1);
}
li.has-subnav .subnav-menu-wrapper .subnav-menu {
  padding-right: calc(var(--space-sm) * 2.25);
}
li.has-subnav .subnav-menu-wrapper .subnav-menu li .link-title {
  font-family: "STK Bureau";
  font-size: calc(var(--space-sm) * 1.125);
  color: var(--color-charcoal-80);
  font-weight: 500;
  line-height: 140%;
  margin: 0;
  padding: 9px 0;
}
li.has-subnav .subnav-menu-wrapper .subnav-menu li[aria-current=page] .link-title {
  color: white;
}
li.has-subnav .subnav-menu-wrapper .subnav-menu li .icon-wrapper,
li.has-subnav .subnav-menu-wrapper .subnav-menu li .link-description {
  display: none;
}
li.has-subnav.subnav-open .link-parent-title::after {
  content: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"><path fill="%23212121" d="m15.99 13.814-7.043 6.259-.883-.995 7.926-7.046 7.926 7.046-.885.995-7.041-6.26Z"/></svg>');
}
li.has-subnav.subnav-open[aria-current=page] .link-parent-title::after {
  content: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"><path fill="%23FFFFFF" d="m15.99 13.814-7.043 6.259-.883-.995 7.926-7.046 7.926 7.046-.885.995-7.041-6.26Z"/></svg>');
}

.link {
  display: block;
  position: relative;
  cursor: pointer;
  font-family: var(--font-family-serif);
  font-size: 2rem;
  font-weight: 300;
  text-decoration: none;
  letter-spacing: -0.015em;
  background: transparent;
  -webkit-background-clip: initial;
  background-clip: initial;
  -webkit-text-fill-color: initial;
  text-decoration: none;
  color: inherit;
}

li[aria-current=page] .link {
  color: white;
}

.link-title {
  letter-spacing: -0.02em;
}

@media screen and (min-width: 960px) {
  ul {
    flex-direction: row;
    justify-content: flex-start;
  }
  li::after {
    content: "";
    position: absolute;
    display: block;
    width: 24px;
    height: 2px;
    border-radius: 4px;
    background-color: var(--color-charcoal);
    left: 50%;
    margin-top: 0.2rem;
    transform: translateX(-50%);
    opacity: 0;
  }
  li[aria-current=page]::after {
    opacity: 1;
  }
  li.has-subnav .link-parent-title::after {
    content: none;
  }
  li.has-subnav.subnav-open .link-parent-title::after {
    content: none;
  }
  li.has-subnav .subnav-menu-wrapper {
    position: absolute;
    width: 336px;
    margin: 0;
    padding-top: var(--space-sm);
    opacity: 0;
    pointer-events: none;
    transition: all 0.1s ease-in-out;
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu {
    display: block;
    background-color: var(--color-white);
    box-shadow: var(--light-shadow);
    border-radius: 8px;
    overflow: hidden;
    padding: 0;
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li {
    text-align: left;
    margin: 0;
    padding: 0;
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li::after {
    content: none;
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li:hover {
    background-color: var(--color-gray-fog);
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li:not(:last-child) {
    border-bottom: 1px solid var(--color-gray-fog);
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li .link {
    padding: var(--space-sm);
    display: flex;
    gap: calc(var(--space-sm) * 0.75);
    background: transparent;
    -webkit-background-clip: initial;
    background-clip: initial;
    -webkit-text-fill-color: initial;
    text-decoration: none;
    color: inherit;
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li .link::after {
    content: none;
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li .link .link-title {
    margin: 0;
    padding: 0;
    color: var(--color-charcoal);
    font-size: var(--font-size);
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li .link .link-description {
    display: block;
    color: var(--color-charcoal-60);
    font-weight: 400;
    /* font-size: 14px; */
    font-size: calc(var(--sm-scale) * 0.875);
    line-height: 140%;
    letter-spacing: -0.02em;
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li .link .icon-wrapper {
    display: block;
    flex: 0 0 calc(var(--space-sm) * 2.25);
    overflow: hidden;
  }
  li.has-subnav .subnav-menu-wrapper .subnav-menu li .link .icon-wrapper * {
    width: 100%;
    height: auto;
  }
  li.has-subnav:hover .subnav-menu-wrapper {
    opacity: 1;
    pointer-events: all;
  }
  .link {
    font-family: "STK Bureau";
    font-size: var(--font-size);
    font-weight: 500;
    --color-1: var(--color-sunrise-blue);
    --color-2: var(--color-sunrise-pink);
    --color-3: var(--color-sunrise-orange);
    background: linear-gradient(90deg, var(--color-text) 0%, var(--color-text) 45%, var(--color-1) 55%, var(--color-2) 76%, var(--color-3) 96%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    /* offset background 100px */
    background-size: 250%;
    background-position: 0;
    transition: background 1s var(--ease-type);
  }
  .link:hover {
    background-position: 100% 0;
    transition: all 0.6s var(--ease-type);
    text-shadow: none;
  }
}`;

// src/components/navigation/nav-menu.component.ts
var NineNavMenu = class extends NineElement {
  constructor() {
    super(...arguments);
    this.navLinks = [];
    this.subnavLinks = {
      employers: {
        icon: "https://cdn.sanity.io/images/g38rxyoc/production/194f05f709dac403faba80552a8d9de004135111-36x36.svg",
        description: "Specialized whole-body care"
      },
      health_plans: {
        icon: "https://cdn.sanity.io/images/g38rxyoc/production/22b2066829343731587d52ac34422c1ebe59fbd7-36x36.svg",
        description: "One solution for five conditions"
      },
      pharmacy_benefit_manager: {
        icon: "https://cdn.sanity.io/images/g38rxyoc/production/b99923539d33f09f72d9fca03045340fd63c1186-36x36.svg",
        description: "Lower costs and better outcomes"
      }
    };
    this.getNavLinksInterval = null;
    this.getNavLinks = () => {
      var _a2, _b;
      if (this.navLinks.length) {
        this.removeGetNavLinksInterval();
        return;
      }
      const navLinks = [];
      const listElements = Array.from((_b = (_a2 = this.querySelector("ul")) == null ? void 0 : _a2.children) != null ? _b : []);
      listElements.forEach((listElement) => {
        var _a3, _b2, _c;
        const anchorTag = listElement.querySelector("a");
        const text = (_b2 = (_a3 = anchorTag == null ? void 0 : anchorTag.textContent) == null ? void 0 : _a3.trim()) != null ? _b2 : "";
        const link = (_c = anchorTag == null ? void 0 : anchorTag.href) != null ? _c : "";
        const active = (listElement == null ? void 0 : listElement.classList.contains("active")) || (listElement == null ? void 0 : listElement.classList.contains("active-branch"));
        const navLink = {
          text,
          link,
          active,
          children: []
        };
        const childrenListElements = listElement.querySelectorAll("li");
        childrenListElements.forEach((childListElement) => {
          var _a4, _b3, _c2, _d;
          const anchorTag2 = childListElement.querySelector("a");
          const text2 = (_b3 = (_a4 = anchorTag2 == null ? void 0 : anchorTag2.textContent) == null ? void 0 : _a4.trim()) != null ? _b3 : "";
          const link2 = (_c2 = anchorTag2 == null ? void 0 : anchorTag2.href) != null ? _c2 : "";
          const active2 = (childListElement == null ? void 0 : childListElement.classList.contains("active")) || (childListElement == null ? void 0 : childListElement.classList.contains("active-branch"));
          const childNavLink = {
            text: text2,
            link: link2,
            active: active2
          };
          (_d = navLink.children) == null ? void 0 : _d.push(childNavLink);
        });
        navLinks.push(navLink);
      });
      this.navLinks = navLinks;
    };
    this.setLinkHashListener = (link, event) => {
      var _a2;
      if (link == null ? void 0 : link.hash) {
        const el = document.querySelector(link.hash);
        if (el) {
          const navbarHeightString = document.body.style.getPropertyValue("--navbar-height");
          const navbarHeight = navbarHeightString.length > 0 ? parseInt(navbarHeightString) : 0;
          animate(
            1100,
            (progress) => {
              scrollMainTo(0, progress);
            },
            {
              range: [getMainScrollPosition().y, el.offsetTop - navbarHeight - 30]
            }
          );
          window.location.hash = link.hash;
          const nineNavigation = document.querySelector("nine-navigation");
          (_a2 = nineNavigation == null ? void 0 : nineNavigation.setAttribute) == null ? void 0 : _a2.call(nineNavigation, "open", "false");
          event.preventDefault();
        }
      }
    };
    this.handleLinkClick = (event) => {
      const link = event.target.closest("a");
      this.setLinkHashListener(link, event);
    };
    this.handleParentListElementClick = (event) => {
      var _a2;
      const li = event.target.closest("li");
      (_a2 = li == null ? void 0 : li.closest("ul")) == null ? void 0 : _a2.querySelectorAll("li.has-subnav").forEach((listElement) => {
        if (listElement !== li) {
          listElement.classList.remove("subnav-open");
        }
      });
      li == null ? void 0 : li.classList.toggle("subnav-open");
    };
  }
  addGetNavLinksInterval() {
    this.getNavLinksInterval = window.setInterval(this.getNavLinks, 100);
  }
  removeGetNavLinksInterval() {
    if (this.getNavLinksInterval) {
      window.clearInterval(this.getNavLinksInterval);
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this.addGetNavLinksInterval();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeGetNavLinksInterval();
  }
  createKey(navLink) {
    return navLink.text.toLocaleLowerCase().split(" ").join("_");
  }
  render() {
    if (!this.navLinks.length) {
      return html63``;
    }
    return html63`
      <ul role="menu">
        ${repeat2(this.navLinks, this.createKey, (navLink) => {
      var _a2, _b;
      const hasChildren = Boolean((_a2 = navLink.children) == null ? void 0 : _a2.length);
      let navLinkClasses = "";
      if (hasChildren) {
        navLinkClasses = "has-subnav";
        if (navLink.active) {
          navLinkClasses += " subnav-open";
        }
      }
      return html63`
            <li aria-current=${navLink.active ? "page" : "false"} class=${navLinkClasses}>
              ${!hasChildren ? html63`<a class="link" href="${navLink.link}" @click=${this.handleLinkClick}> ${navLink.text} </a>` : html63`
                    <span class="link link-parent-title" @click=${this.handleParentListElementClick}>
                      ${navLink.text}
                    </span>

                    <div class="subnav-menu-wrapper">
                      <ul class="subnav-menu">
                        ${repeat2((_b = navLink.children) != null ? _b : [], this.createKey, (childNavLink) => {
        var _a3, _b2, _c, _d;
        const subnavLinksKey = this.createKey(childNavLink);
        return html63`
                            <li aria-current=${childNavLink.active ? "page" : "false"}>
                              <a class="link" href="${childNavLink.link}" @click=${this.handleLinkClick}>
                                ${((_a3 = this.subnavLinks[subnavLinksKey]) == null ? void 0 : _a3.icon) ? html63`<div class="icon-wrapper">
                                      <img src="${(_b2 = this.subnavLinks[subnavLinksKey]) == null ? void 0 : _b2.icon}" />
                                    </div>` : html63``}
                                <div>
                                  <p class="link-title">${childNavLink.text}</p>
                                  ${((_c = this.subnavLinks[subnavLinksKey]) == null ? void 0 : _c.description) ? html63`<small class="link-description">
                                        ${(_d = this.subnavLinks[subnavLinksKey]) == null ? void 0 : _d.description}
                                      </small>` : html63``}
                                </div>
                              </a>
                            </li>
                          `;
      })}
                      </ul>
                    </div>
                  `}
            </li>
          `;
    })}
      </ul>
    `;
  }
};
NineNavMenu.styles = unsafeCSS15(nav_menu_default);
__decorateClass([
  property47({ type: Array, reflect: false })
], NineNavMenu.prototype, "navLinks", 2);
__decorateClass([
  property47({ type: Object, reflect: false })
], NineNavMenu.prototype, "subnavLinks", 2);

// src/components/navigation/nav-menu.ts
var nav_menu_default2 = NineNavMenu;
NineNavMenu.define("nine-nav-menu");

// src/components/navigation/navigation.component.ts
import { html as html64, unsafeCSS as unsafeCSS16 } from "lit";
import { property as property48, queryAssignedNodes as queryAssignedNodes6 } from "lit/decorators.js";

// src/components/navigation/navigation.global.scss?inline
import { css as css84 } from "lit-element/lit-element.js";
var navigation_global_default = css84`nine-navigation ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  grid-gap: 1.5rem;
}

body nine-navigation li {
  display: block;
  position: relative;
  font-weight: 500;
  padding-left: 0;
}

body nine-navigation ul li:before {
  content: none;
}

/* hide sub-menus */
body nine-navigation ul li ul {
  display: none;
}

body nine-navigation a {
  position: relative;
}

body nine-navigation a[aria-current=page]:hover {
  text-decoration: none;
}

body nine-navigation [slot=top-bar] {
  margin: 0;
}

@media screen and (max-width: 959px) {
  nine-navigation ul {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  body nine-navigation li {
    margin: 0;
  }
  body nine-navigation li a {
    font-size: 2.4rem;
    font-family: var(--font-family-serif);
    font-weight: 300 !important;
    background: transparent !important;
    -webkit-background-clip: initial !important;
    background-clip: initial !important;
    -webkit-text-fill-color: initial !important;
    text-decoration: none !important;
  }
  body nine-navigation li[aria-current=page] a,
  body nine-navigation a[aria-current=page] {
    color: white;
  }
  nine-navigation nine-button {
    margin-left: 0;
  }
  nine-navigation *[slot=actions] nine-button {
    --scale: 0.7rem;
    line-height: 0.9;
  }
  nine-navigation *[slot=actions] > a {
    display: none;
  }
  nine-navigation[open=true] *[slot=actions] > a {
    display: block;
  }
}
*[data-onlysticky] {
  opacity: 0;
  transform: translateX(4em);
  transition: all var(--ease-time) var(--ease-type);
  transition-property: transform, opacity;
}

nine-navigation[data-sticky=false] *[data-onlysticky] {
  opacity: 0;
  position: absolute;
  pointer-events: none;
}

nine-navigation[open=true] *[data-onlysticky] {
  transition: none;
}

/* display: none; */
nine-navigation[open=true] *[data-onlysticky],
nine-navigation[data-sticky=true] *[data-onlysticky] {
  position: relative;
  transform: translateX(0);
  opacity: 1;
  display: block;
  pointer-events: all;
}

@media screen and (min-width: 960px) {
  nine-navigation li::after,
  nine-navigation a::after {
    content: "";
    position: absolute;
    display: block;
    width: 24px;
    height: 2px;
    border-radius: 4px;
    background-color: var(--color-charcoal);
    left: 50%;
    margin-top: 0.2rem;
    transform: translateX(-50%);
    opacity: 0;
  }
  nine-navigation li[aria-current=page]::after,
  nine-navigation a[aria-current=page]::after {
    opacity: 1;
  }
  nine-navigation a {
    font-weight: 500;
    text-decoration: none;
  }
  nine-navigation[variant=landingpage] *[data-onlysticky] {
    display: none;
  }
}`;

// src/components/navigation/navigation.scss?inline
import { css as css85 } from "lit-element/lit-element.js";
var navigation_default = css85`:host {
  position: fixed;
  z-index: 80;
  contain: layout;
  background: linear-gradient(to bottom, var(--color-cream) 0%, var(--color-cream) 50%, rgba(255, 252, 243, 0.5333333333) 76%, rgba(255, 252, 243, 0) 100%);
  background-size: 100% 200%;
  background-position: 0 100%;
  left: 0;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  height: calc(var(--scale) * 4.8);
  box-shadow: 0 0 0 1px transparent;
  transition: box-shadow calc(var(--ease-time) * 1) var(--ease-type);
  transition-property: box-shadow, background-position;
}

:host([topBar=true]) {
  padding-top: 2.75rem;
}

:host([open=true]) {
  padding-top: 0;
}

:host([data-sticky=true]) {
  background-position: 0 0;
  box-shadow: var(--light-shadow);
  transition: box-shadow calc(var(--ease-time) * 1) var(--ease-type);
  transition-property: box-shadow, background-position;
}

.center {
  width: 100%;
  display: flex;
  align-items: center;
  max-width: var(--page-max-width-wide);
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 var(--space-md);
}

.actions {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

::slotted([slot=actions]) {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  grid-gap: 1em;
}

.logo {
  color: var(--color-charcoal);
  position: relative;
  z-index: 1;
}
.logo a {
  color: var(--color-charcoal);
}
.logo svg {
  width: calc(var(--scale) * 8.4);
  height: auto;
}
.logo .custom-logo {
  max-height: 35px;
  max-width: 300px;
}
@media screen and (min-width: 340px) {
  .logo .custom-logo {
    max-height: 43px;
  }
}
.logo[with-partner] {
  display: flex;
  align-items: center;
  min-width: 237px;
  justify-content: center;
}
@media screen and (max-width: 340px) {
  .logo[with-partner] .logo-stacked {
    width: 60px;
  }
  .logo[with-partner] .partner-logo {
    max-height: 35px;
    height: 35px;
    aspect-ratio: var(--p-logo-ratio, 110/43);
  }
}
.logo .logo-stacked {
  width: 75px;
  margin-right: 1em;
}

.partner-logo {
  max-height: var(--nav-partner-logo-h, 43px);
  height: var(--nav-partner-logo-h, 43px);
  aspect-ratio: var(--p-logo-ratio, 110/43);
  max-width: var(--nav-partner-logo-w, 120px);
  margin-left: 1.6em;
  position: relative;
  background: var(--p-logo) 0 50%/contain no-repeat;
}
.partner-logo::before {
  content: "";
  display: block;
  height: 30px;
  width: 1.2px;
  background: var(--color-charcoal);
  position: absolute;
  left: -1.4em;
  top: 50%;
  transform: translateY(-50%);
}

.domain,
.back {
  display: none;
}

.help {
  display: none;
  justify-content: flex-end;
}

.center[variant=landingpage] .mob,
.center[variant=stepper] .mob,
.center[variant=landingpage] .m-toggle,
.center[variant=stepper] .m-toggle,
.center[only-cta] .m-toggle,
.center[only-logo] .m-toggle,
.center[variant=landingpage] .nav,
.center[variant=stepper] .nav,
.center[variant=stepper] .domain {
  display: none;
}

.center[variant=landingpage] .domain,
.center[variant=stepper] .back,
.center[variant=landingpage] .help,
.center[variant=stepper] .help {
  display: flex;
  flex: 1;
  font-weight: 500;
}

.center[variant=landingpage] .actions,
.center[variant=stepper] .actions {
  display: none;
}

.progress {
  display: none;
}

.center[variant=stepper] .progress {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.sticky-top-bar {
  background: var(--color-charcoal-80);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2.75rem;
}
.sticky-top-bar a {
  margin: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  text-decoration: none;
  font-size: calc(var(--sm-scale) * 0.88);
  line-height: 140%;
  letter-spacing: -0.02em;
}
.sticky-top-bar a:hover {
  text-decoration: underline;
}

:host([open=true]) .sticky-top-bar {
  z-index: -1;
}

::slotted([slot=top-bar]) {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 959px) {
  .nav {
    position: absolute;
    left: 0;
    right: 0;
    top: 50vh;
    z-index: 100;
    transform: translateY(-30vh);
  }
  .m-toggle {
    flex: 1;
    position: relative;
    z-index: 1;
  }
  .m-toggle button {
    padding: 0.6em 1em;
    margin: -0.6em 0 -0.6em -1em;
    background: none;
    border: none;
    color: var(--color-charcoal);
    font-weight: 500;
    font-size: var(--font-size);
    line-height: 1;
    letter-spacing: -0.02em;
    font-family: "STK Bureau";
    font-style: normal;
    color: inherit;
  }
  .mob {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
  }
  .actions {
    position: absolute;
    top: 100vh;
    transform: translateY(-100%);
    padding-bottom: 15vh;
    left: 0;
    right: 0;
  }
  .center[open=true] ::slotted([slot=actions]) {
    flex-direction: column;
    justify-content: center;
    grid-gap: var(--space-sm);
    width: 100%;
    flex-direction: column-reverse;
  }
  .center .mob,
  .center .actions,
  .center .nav {
    opacity: 1;
    transition: opacity var(--ease-time) var(--ease-type);
  }
  .center[open=false] .mob,
  .center[open=false] .nav {
    display: none;
    opacity: 0;
    pointer-events: none;
  }
  .center[open=false] .actions {
    position: relative;
    top: 0;
    opacity: 1;
    transform: translateY(0);
    font-size: 0.9em;
    margin-left: var(--space-md);
    padding-bottom: 0;
  }
  .logo {
    position: absolute;
    margin: 0;
    left: 4em;
    transform: translateX(0);
    color: var(--color-charcoal);
    transition: all var(--ease-time) var(--ease-type);
  }
  .center[only-logo] .logo {
    transform: translateX(-50%);
    left: 50%;
  }
  .logo svg {
    width: calc(var(--scale) * 7);
  }
  .center:not([sticky]):not([only-cta]) .logo,
  .center[open=true]:not([only-cta]) .logo {
    transform: translateX(-50%);
    left: 50%;
  }
  .center[variant=landingpage] .domain {
    opacity: 0;
    width: 0;
    pointer-events: none;
  }
  /* Overwrites because of subnavigation */
  :host([open=true]) {
    height: 100%;
  }
  :host([open=true]) .mob {
    height: 100%;
  }
  :host([open=true]) .center {
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    padding: var(--space-md);
  }
  :host([open=true]) .center .m-toggle,
  :host([open=true]) .center .nav,
  :host([open=true]) .center .logo,
  :host([open=true]) .center .actions {
    display: block;
    flex: none;
    position: relative;
    inset: 0;
    transform: none;
    margin: 0;
    padding: 0;
    transition: none;
  }
  :host([open=true]) .center .logo {
    order: -1;
    top: 0.3rem;
  }
  :host([open=true]) .center .m-toggle {
    position: absolute;
    top: var(--space-md);
    left: var(--space-md);
    right: unset;
    bottom: unset;
  }
}
@media screen and (min-width: 510px) and (max-width: 959px) {
  .logo {
    transform: translateX(-50%);
    left: 50%;
  }
}
@media screen and (min-width: 960px) {
  .nav {
    display: block;
    flex: 1;
  }
  .mob {
    display: none;
  }
  .m-toggle {
    display: none;
  }
  .logo svg {
    width: 158px;
  }
  :host([topBar=true]) {
    padding-top: 2.875rem;
  }
  .sticky-top-bar {
    height: 2.875rem;
  }
}
.center[app] .actions {
  display: none;
}

@media screen and (max-width: 959px) {
  .center[app] .logo {
    transform: translateX(-50%);
    left: 50%;
  }
}`;

// src/components/navigation/navigation.component.ts
styleInject_default(navigation_global_default);
var NineNavigation = class extends NineElement {
  constructor() {
    super(...arguments);
    this.button = void 0;
    this.sticky = false;
    this.open = "false";
    this.variant = "default";
    this.home = "/";
    this.topBar = "false";
    this.topBarLink = "#";
    this.topBarOpenInNewTab = "true";
    this.app = false;
    this.onlyCTA = false;
    this.onlyLogo = false;
    this.partnerLogo = "";
    this.customLogo = "";
    this.customLogoAlt = "";
    this.customLogoUrl = "";
    this.customLogoUrlOpenInNewTab = false;
    this.hasLanguageSelector = false;
    this.handleScroll = () => {
      this.sticky = getMainScrollPosition().y > 0;
      this.dataset.sticky = this.sticky ? "true" : "false";
      this.updateColors();
    };
    this.svgBurger = html64`
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.48 11.5H3.52v1h16.96v-1ZM20.48 16.16H3.52v1h16.96v-1ZM20.48 6.84H3.52v1h16.96v-1Z"
        fill="currentColor"
      />
    </svg>
  `;
    this.svgClose = html64`
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m12.5 12.5 4.4 4.4.85-.85-4.4-4.4L17.9 7.1l-.85-.85-4.55 4.55-4.65-4.65L7 7l4.65 4.65-4.5 4.5L8 17l4.5-4.5Z"
        fill="currentColor"
      />
    </svg>
  `;
    this.toggleOpen = () => {
      this.open = this.open === "true" ? "false" : "true";
      this.updateColors();
    };
  }
  get hasPartnerLogo() {
    const supportedImages = ["png", "svg"];
    const isSupportedImageType = supportedImages.some((type) => this.partnerLogo.includes(`.${type}`));
    return this.partnerLogo && isSupportedImageType;
  }
  get hasCustomLogo() {
    const supportedImages = ["png", "svg"];
    const isSupportedImageType = supportedImages.some((type) => this.customLogo.includes(`.${type}`));
    return this.customLogo && isSupportedImageType;
  }
  updateNavbarHeightVariable() {
    const navbarHeight = this.clientHeight;
    document.body.style.setProperty("--navbar-height", `${navbarHeight}px`);
  }
  updateColors() {
    const windowWidth = window.innerWidth;
    this.button = this.querySelector("nine-button");
    if (this.button) {
      let color = windowWidth < LAYOUT_SWITCH_AT ? "black" : "sunrise";
      if (this.open === "false") {
        color = "sunrise";
      }
      this.button.color = color;
    }
  }
  firstUpdated() {
    var _a2;
    this.button = this.querySelector("nine-button");
    this.handleScroll();
    addScrollListener(this.handleScroll, {
      passive: true
    });
    window.addEventListener("resize", this.handleScroll, { passive: true });
    if (this.topBarActive) {
      document.body.classList.add("top-bar-padding");
    }
    (_a2 = this._actionNodes) == null ? void 0 : _a2.forEach((node) => {
      const children = [...node.children];
      children == null ? void 0 : children.forEach((element) => {
        element.addEventListener("click", this.handleActionBtnClick);
      });
    });
    this.updateNavbarHeightVariable();
  }
  disconnectedCallback() {
    var _a2;
    super.disconnectedCallback();
    removeScrollListener(this.handleScroll);
    window.removeEventListener("resize", this.handleScroll);
    (_a2 = this._actionNodes) == null ? void 0 : _a2.forEach((node) => {
      const children = [...node.children];
      children == null ? void 0 : children.forEach((element) => {
        element.removeEventListener("click", this.handleActionBtnClick);
      });
    });
  }
  handleActionBtnClick() {
    document.body.classList.add("fade-out-page");
  }
  updated(changedProperties) {
    if (changedProperties.has("open")) {
      this.updateScrollBlock();
    }
  }
  updateScrollBlock() {
    if (this.open === "true") {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100vh";
    } else {
      document.body.style.overflow = "";
      document.body.style.height = "";
    }
  }
  get topBarActive() {
    return this.topBar === "true";
  }
  render9amLogo() {
    let logoVersion = "full";
    if (this.hasPartnerLogo) {
      logoVersion = "stacked";
    }
    return html64`
      ${logoVersion === "full" ? html64` <svg width="158" height="24" viewBox="0 0 158 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.52 1.95c-4.45 0-7.88 3-7.88 7.5 0 4.14 2.9 6.83 6.49 6.83 2 0 3.67-.84 4.91-2.29-.99 4.48-4.3 8-9.39 8.93L3 24c8.62-.65 13.47-6.12 13.47-12.91 0-5.34-2.97-9.14-7.94-9.14ZM4.84 8.83c0-2.47 1.05-4.57 3.3-4.57 2.7 0 4.24 2.94 4.24 6.77 0 .52-.03 1.05-.1 1.57a5.48 5.48 0 0 1-3.54 1.36c-2.5 0-3.9-2.04-3.9-5.13ZM22.26 24c2 0 3.58-.93 4.97-2.69.22 1.55 1.27 2.69 3.06 2.69a3.9 3.9 0 0 0 3.25-1.76L33 21.07c-.37.21-.74.3-1.14.3-.8 0-1.2-.55-1.2-1.6v-7.41c0-2.82-2.48-4.85-6-4.85-3.58 0-6.4 2.22-6.4 5.28v.55h3.5l.03-.8c.03-1.73 1.14-2.81 2.75-2.81 1.63 0 2.65 1.14 2.65 2.9v1.27l-4.85 1.51c-3.12.96-4.54 2.29-4.54 4.48 0 2.47 1.86 4.11 4.45 4.11Zm-.52-4.85c0-1.3.99-2.13 2.47-2.66l3-1.05v4.54a5.52 5.52 0 0 1-3.19 1.12c-1.45 0-2.28-.74-2.28-1.95ZM35.04 21.96v1.67h7.47v-1.67c-1.17-.12-2-.28-2-1.73v-7.5a5.42 5.42 0 0 1 3.86-1.92c1.54 0 2.5.96 2.5 2.53v6.9c0 1.44-.83 1.6-2 1.72v1.67h7.47v-1.67c-1.18-.12-2.01-.28-2.01-1.73v-7.57a5.42 5.42 0 0 1 3.83-1.85c1.54 0 2.5.96 2.5 2.53v6.9c0 1.44-.8 1.6-2 1.72v1.67h7.5v-1.67c-.8-.12-2.04-.28-2.04-1.73V12.4c0-2.85-1.88-4.88-4.57-4.88-2.16 0-4.1 1.35-5.38 3.49a4.4 4.4 0 0 0-4.44-3.5c-2.1 0-4.02 1.24-5.22 3.22V7.88h-.62l-4.7 1.08v1.2l1.86.62v9.45c0 1.45-.84 1.6-2.01 1.73ZM79.5 21.96v1.67h7.69v-1.67c-1.24-.12-2.1-.28-2.1-1.73V5.71c0-1.45.86-1.6 2.1-1.73V2.32h-7.7v1.66c1.24.13 2.1.28 2.1 1.73v5.69h-10V5.7c0-1.45.86-1.6 2.1-1.73V2.32h-7.7v1.66c1.24.13 2.1.28 2.1 1.73v14.52c0 1.45-.86 1.6-2.1 1.73v1.67h7.7v-1.67c-1.24-.12-2.1-.28-2.1-1.73v-6.7h10v6.7c0 1.45-.86 1.6-2.1 1.73ZM94.82 24a7.07 7.07 0 0 0 6.98-5.47l-.78-.52a6.29 6.29 0 0 1-5.12 2.68c-2.72 0-4.8-1.85-4.8-5.59h10.67c-.22-4.54-2.63-7.6-6.68-7.6-4.26 0-7.5 3.5-7.5 8.4 0 4.67 2.93 8.1 7.23 8.1Zm-3.56-10.56c.4-2.29 1.73-3.71 3.62-3.71 1.76 0 2.96 1.39 3.18 3.7h-6.8ZM107.73 24c2.01 0 3.59-.93 4.98-2.69.21 1.55 1.26 2.69 3.06 2.69a3.9 3.9 0 0 0 3.24-1.76l-.53-1.17c-.37.21-.74.3-1.14.3-.8 0-1.2-.55-1.2-1.6v-7.41c0-2.82-2.47-4.85-6-4.85-3.58 0-6.39 2.22-6.39 5.28v.55h3.5l.02-.8c.03-1.73 1.14-2.81 2.75-2.81 1.64 0 2.66 1.14 2.66 2.9v1.27l-4.85 1.51c-3.12.96-4.54 2.29-4.54 4.48 0 2.47 1.85 4.11 4.44 4.11Zm-.52-4.85c0-1.3.99-2.13 2.47-2.66l3-1.05v4.54a5.52 5.52 0 0 1-3.19 1.12c-1.45 0-2.28-.74-2.28-1.95ZM119.62 21.96v1.67h7.47v-1.67c-1.17-.12-2-.28-2-1.73V0h-.66l-4.66 1.08v1.2l1.85.62v17.33c0 1.45-.83 1.6-2 1.73ZM133.8 24c1.5 0 3.23-.71 4.53-2.2l-.5-1.17a4.5 4.5 0 0 1-2.22.59c-1.51 0-2.34-.93-2.34-2.32v-8.5h4.63V7.89l-4.63.27v-4.2h-1.2a9.35 9.35 0 0 1-5.2 4.76v1.7h2.94v9.33c0 2.47 1.45 4.26 3.98 4.26ZM139.53 21.96v1.67H147v-1.67c-1.17-.12-2-.28-2-1.73v-7.35a5.88 5.88 0 0 1 4.07-2.07c1.58 0 2.5.99 2.5 2.63v6.8c0 1.44-.83 1.6-2.04 1.72v1.67h7.5v-1.67c-1.2-.12-2-.28-2-1.73v-7.75c0-2.87-1.8-4.97-4.5-4.97-2.14 0-4.24 1.3-5.54 3.27V0h-.62l-4.69 1.08v1.2l1.85.62v17.33c0 1.45-.83 1.6-2 1.73Z"
              fill="currentColor"
            />
          </svg>` : ""}
      ${logoVersion === "stacked" ? html64` <svg
            class="logo-stacked"
            xmlns="http://www.w3.org/2000/svg"
            width="75"
            height="40"
            fill="none"
            viewBox="0 0 75 40"
          >
            <path
              fill="currentColor"
              d="M18.264 18.595c1.632 0 2.913-.75 4.044-2.175.176 1.25 1.03 2.175 2.486 2.175 1.03 0 1.91-.45 2.638-1.425l-.427-.95c-.302.174-.603.25-.93.25-.652 0-.979-.45-.979-1.3V9.167c0-2.276-2.01-3.926-4.873-3.926-2.863 0-5.199 1.8-5.199 4.276v.45h2.838l.025-.65c.025-1.4.93-2.276 2.236-2.276s2.16.925 2.16 2.35v1.026l-3.944 1.225c-2.537.775-3.692 1.85-3.692 3.626 0 2 1.507 3.325 3.617 3.325v.001Zm-.427-3.926c0-1.05.803-1.725 2.01-2.15l2.436-.85v3.675c-.704.55-1.733.9-2.587.9-1.18 0-1.859-.6-1.859-1.575Zm10.315 2.276v1.35h6.078v-1.35c-.955-.1-1.633-.225-1.633-1.4V9.467c.88-.976 2.06-1.55 3.14-1.55 1.256 0 2.035.774 2.035 2.05v5.576c0 1.175-.678 1.3-1.633 1.4v1.351h6.078v-1.35c-.955-.1-1.633-.225-1.633-1.4V9.417c.93-1 2.11-1.5 3.115-1.5 1.256 0 2.034.775 2.034 2.05v5.577c0 1.175-.653 1.3-1.633 1.4v1.35h6.104v-1.35c-.653-.1-1.657-.225-1.657-1.4V9.193c0-2.3-1.533-3.95-3.718-3.95-1.758 0-3.34 1.1-4.37 2.825-.377-1.676-1.784-2.826-3.617-2.826-1.708 0-3.266 1-4.245 2.6v-2.3h-.502l-3.818.875v.976l1.507.5v7.652c0 1.175-.678 1.3-1.633 1.4ZM11.829 38.014v1.35h6.254v-1.35c-1.005-.1-1.708-.225-1.708-1.401V24.86c0-1.175.703-1.3 1.708-1.4v-1.35h-6.254v1.35c1.004.1 1.708.225 1.708 1.4v4.601H5.398v-4.6c0-1.176.704-1.3 1.708-1.4V22.11H.852v1.35c1.005.1 1.708.225 1.708 1.4v11.753c0 1.175-.703 1.3-1.708 1.4v1.35h6.254v-1.35c-1.004-.1-1.708-.224-1.708-1.4v-5.426h8.139v5.426c0 1.175-.704 1.3-1.708 1.4Zm12.457 1.65c2.938 0 5.023-1.926 5.676-4.426l-.628-.425c-.88 1.3-2.487 2.175-4.17 2.175-2.21 0-3.893-1.5-3.893-4.526h8.666c-.176-3.676-2.135-6.151-5.425-6.151-3.466 0-6.104 2.825-6.104 6.801s2.386 6.551 5.878 6.551Zm-2.889-8.552c.327-1.85 1.406-3 2.939-3 1.432 0 2.411 1.125 2.587 3h-5.526Zm13.394 8.552c1.633 0 2.914-.75 4.044-2.175.176 1.25 1.03 2.175 2.487 2.175 1.03 0 1.909-.45 2.637-1.425l-.427-.95a1.79 1.79 0 0 1-.929.25c-.653 0-.98-.45-.98-1.3v-6.002c0-2.275-2.008-3.926-4.872-3.926s-5.2 1.8-5.2 4.276v.45h2.839l.025-.65c.025-1.4.929-2.276 2.235-2.276 1.306 0 2.16.926 2.16 2.351v1.025l-3.943 1.225c-2.537.776-3.692 1.85-3.692 3.626 0 2 1.507 3.326 3.617 3.326Zm-.427-3.926c0-1.05.804-1.725 2.01-2.15l2.436-.85v3.675c-.703.55-1.733.9-2.587.9-1.18 0-1.858-.6-1.858-1.575Zm10.089 2.276v1.35h6.078v-1.35c-.954-.1-1.633-.225-1.633-1.401V20.235h-.527l-3.793.875v.975l1.507.5v14.028c0 1.175-.678 1.3-1.633 1.4h.001Zm11.526 1.65c1.23 0 2.638-.575 3.692-1.776l-.402-.95c-.477.3-1.205.476-1.808.476-1.231 0-1.909-.75-1.909-1.876v-6.876h3.767v-2.05l-3.767.224v-3.4h-.98c-1.03 1.95-2.134 2.95-4.22 3.85v1.376h2.387v7.551c0 2 1.18 3.45 3.24 3.45Zm4.663-1.65v1.35h6.078v-1.35c-.954-.1-1.632-.225-1.632-1.401v-5.951c.954-1.05 2.235-1.675 3.315-1.675 1.281 0 2.034.8 2.034 2.125v5.502c0 1.175-.677 1.3-1.657 1.4v1.35h6.103v-1.35c-.98-.1-1.632-.225-1.632-1.4v-6.277c0-2.325-1.457-4.025-3.668-4.025-1.732 0-3.44 1.05-4.495 2.65v-8.727h-.503l-3.818.875v.976l1.507.5v14.028c0 1.175-.678 1.3-1.632 1.4ZM6.877.336C3.136.336.252 2.846.252 6.621c0 3.466 2.442 5.716 5.456 5.716 1.689 0 3.091-.698 4.13-1.913-.831 3.75-3.61 6.698-7.898 7.474l.286.905c7.249-.543 11.328-5.12 11.328-10.81 0-4.475-2.494-7.657-6.677-7.657ZM3.785 6.104c0-2.069.884-3.828 2.78-3.828 2.26 0 3.56 2.457 3.56 5.665 0 .44-.026.879-.078 1.319-.858.724-1.897 1.138-2.988 1.138-2.104 0-3.273-1.707-3.273-4.294Z"
            />
          </svg>` : ""}
    `;
  }
  renderPartnerLogo() {
    if (!this.hasPartnerLogo) {
      return "";
    }
    return html64`
      <div class="partner-logo" style="--p-logo: url('${this.partnerLogo}'); --p-logo-ratio: 100/43"></div>
    `;
  }
  renderLogo() {
    if (this.hasCustomLogo) {
      return this.customLogoUrl.length ? html64`
            <a href="${this.customLogoUrl}" target="${this.customLogoUrlOpenInNewTab ? "_blank" : "_self"}">
              <img class="custom-logo" src="${this.customLogo}" alt="${this.customLogoAlt}" />
            </a>
          ` : html64`<img class="custom-logo" src="${this.customLogo}" alt="${this.customLogoAlt}" />`;
    }
    return html64`
      <a href="${this.home}" class="as-link">${this.render9amLogo()}</a>
      ${this.renderPartnerLogo()}
    `;
  }
  render() {
    return html64` <div
      class="center"
      open="${this.open}"
      ?sticky=${this.sticky}
      variant="${this.variant}"
      ?app=${this.app}
      ?only-cta=${this.onlyCTA}
      ?only-logo=${this.onlyLogo}
    >
      <nine-bg variant="sunrise" fade="false" curve="sunrise" class="mob"> </nine-bg>
      <div class="m-toggle">
        <button aria-label="Toggle Navigation" @click="${this.toggleOpen}">
          ${this.open === "true" ? this.svgClose : this.svgBurger}
        </button>
      </div>
      <div class="domain">join9am.com</div>
      <div class="back">
        <slot name="back"></slot>
      </div>
      <div class="nav">
        <slot name="main-menu"></slot>
      </div>
      <div class="logo" ?with-partner=${this.hasPartnerLogo}>${this.renderLogo()}</div>
      <div class="actions">
        <slot name="actions"></slot>
      </div>
      <div class="language">
        <slot name="language"></slot>
      </div>
      <div class="help">
        <slot name="help"></slot>
      </div>
      <div class="progress">
        <slot name="progress"></slot>
      </div>
      ${this.topBarActive ? html64`
            <div class="sticky-top-bar">
              <a href="${this.topBarLink}" target="${this.topBarOpenInNewTab === "true" ? "_blank" : "_self"}">
                <slot name="top-bar"></slot>
              </a>
            </div>
          ` : ""}
    </div>`;
  }
};
NineNavigation.styles = unsafeCSS16(navigation_default);
__decorateClass([
  property48({ type: Boolean, reflect: true })
], NineNavigation.prototype, "sticky", 2);
__decorateClass([
  property48({ type: String, reflect: true })
], NineNavigation.prototype, "open", 2);
__decorateClass([
  property48({ type: String })
], NineNavigation.prototype, "variant", 2);
__decorateClass([
  property48({ type: String })
], NineNavigation.prototype, "home", 2);
__decorateClass([
  property48({ type: String })
], NineNavigation.prototype, "topBar", 2);
__decorateClass([
  property48({ type: String })
], NineNavigation.prototype, "topBarLink", 2);
__decorateClass([
  property48({ type: String })
], NineNavigation.prototype, "topBarOpenInNewTab", 2);
__decorateClass([
  property48({ type: Boolean, reflect: true })
], NineNavigation.prototype, "app", 2);
__decorateClass([
  property48({ type: Boolean, reflect: true, attribute: "only-cta" })
], NineNavigation.prototype, "onlyCTA", 2);
__decorateClass([
  property48({ type: Boolean, reflect: true, attribute: "only-logo" })
], NineNavigation.prototype, "onlyLogo", 2);
__decorateClass([
  property48({ type: String, attribute: "partner-logo" })
], NineNavigation.prototype, "partnerLogo", 2);
__decorateClass([
  property48({ type: String, attribute: "custom-logo" })
], NineNavigation.prototype, "customLogo", 2);
__decorateClass([
  property48({ type: String, attribute: "custom-logo-alt" })
], NineNavigation.prototype, "customLogoAlt", 2);
__decorateClass([
  property48({ type: String, attribute: "custom-logo-url" })
], NineNavigation.prototype, "customLogoUrl", 2);
__decorateClass([
  property48({ type: Boolean, attribute: "custom-logo-url-open-in-new-tab" })
], NineNavigation.prototype, "customLogoUrlOpenInNewTab", 2);
__decorateClass([
  property48({ type: Boolean, attribute: "has-language-selector" })
], NineNavigation.prototype, "hasLanguageSelector", 2);
__decorateClass([
  queryAssignedNodes6({ slot: "actions", flatten: true })
], NineNavigation.prototype, "_actionNodes", 2);

// src/components/navigation/navigation.ts
var navigation_default2 = NineNavigation;
NineNavigation.define("nine-navigation");

// src/components/overlay/overlay-trigger.component.ts
import { css as css86, html as html65 } from "lit";
import { property as property49 } from "lit/decorators.js";
var NineOverlayTrigger = class extends NineElement {
  constructor() {
    super(...arguments);
    this.target = "";
  }
  openTarget() {
    if (!this.target) {
      console.warn("No target set for overlay trigger");
      return;
    }
    const target = globalThis.nineOverlays[this.target];
    if (!target) {
      console.warn(`No overlay with id ${this.target} found`);
      return;
    }
    target.open();
  }
  render() {
    return html65`<button @click="${this.openTarget}" aria-label="Open modal">
      <slot></slot>
    </button>`;
  }
};
NineOverlayTrigger.styles = css86`
    :host {
      display: inline-block;
    }

    button {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
      margin: 0;
      font: inherit;
      color: inherit;
      text-align: inherit;
      font-family: inherit;
      font-size: inherit;
    }
  `;
__decorateClass([
  property49({ type: String })
], NineOverlayTrigger.prototype, "target", 2);

// src/components/overlay/overlay-trigger.ts
var overlay_trigger_default = NineOverlayTrigger;
NineOverlayTrigger.define("nine-overlay-trigger");

// src/components/overlay/overlay.component.ts
import { html as html66, unsafeCSS as unsafeCSS17 } from "lit";
import { property as property50 } from "lit/decorators.js";
import { createRef as createRef14, ref as ref14 } from "lit/directives/ref.js";

// src/lib/slugify.ts
function slugify(str) {
  const from = "\xE0\xE1\xE4\xE2\xE8\xE9\xEB\xEA\xEC\xED\xEF\xEE\xF2\xF3\xF6\xF4\xF9\xFA\xFC\xFB\xF1\xE7\xB7/_,:;";
  const to = "aaaaeeeeiiiioooouuuunc------";
  const regex = new RegExp(from.split("").join("|"), "g");
  return str.toString().toLowerCase().trim().replace(regex, (c) => to.charAt(from.indexOf(c))).replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
}

// src/components/overlay/overlay.global.scss?inline
import { css as css87 } from "lit-element/lit-element.js";
var overlay_global_default = css87`nine-overlay > [slot=content] > h5 {
  font-weight: 500;
  margin: 0 0 calc(var(--space-sm) * 0.25);
}

nine-overlay > [slot=content] > p:not(:last-child) {
  margin: 0 0 calc(var(--space-sm) * 1.25);
}

nine-overlay > [slot=content] > h6 {
  font-weight: 500;
  font-size: var(--sm-scale);
  margin: calc(var(--space-sm) * 1.5) 0 calc(var(--space-sm) * 1.25);
}

nine-overlay > [slot=content] > h6 ~ *:not(h6) {
  color: var(--color-charcoal-80);
}

nine-overlay > [slot=content] > img {
  display: block;
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px;
}

nine-overlay > [slot=content] > h6 ~ img {
  width: initial;
  height: initial;
  max-width: 100%;
  max-height: 250px;
  margin: calc(var(--space-sm) * 1.5) 0 calc(var(--space-sm) * 1.25);
}

nine-overlay > [slot=content] > h6 ~ img:last-child {
  margin-bottom: 0;
}

@keyframes addPopupOpen {
  0% {
    transform: scale(1) translateY(0);
  }
  100% {
    transform: scale(var(--popup-scale)) translateY(var(--popup-mt));
    border-radius: var(--popup-frame-br);
  }
}
@keyframes addPopupClosed {
  0% {
    transform: scale(var(--popup-scale)) translateY(var(--popup-mt));
    border-radius: var(--popup-frame-br);
  }
  100% {
    transform: scale(1) translateY(0);
  }
}
.nine-overlay-content-center {
  padding: 0.5rem 1rem 2.5rem;
  width: min(520px, 100dvw);
  margin: 0 auto;
  box-sizing: border-box;
}

body {
  transform-origin: top center;
  position: relative;
}
body:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100dvh;
  z-index: -1;
  border-radius: inherit;
  background: var(--overlay-bg, var(--color-cream));
  pointer-events: none;
}

body.n-popup-closed, body.n-popup-open {
  --popup-scale: 0.90;
  --popup-frame-br: 0.6rem;
  --popup-mt: calc(var(--safe-area-top, 0px) + 0.5rem);
}

body.n-popup-open nine-overlay {
  --overlay-content-scale: calc(1 / 0.9);
}

body.n-popup-open nine-overlay > [slot=content] {
  opacity: 1;
}

@keyframes setDarkBg {
  0% {
    background: var(--color-cream);
  }
  100% {
    background: #000;
  }
}
html:has(body.n-popup-open) {
  overflow: hidden;
  animation: setDarkBg 0s linear forwards;
}

@keyframes setLightBg {
  0%, 60% {
    background: #000;
  }
  100% {
    background: var(--color-cream);
  }
}
html:has(body.n-popup-closed) {
  animation: setLightBg 0s linear forwards;
}`;

// src/components/overlay/overlay.scss?inline
import { css as css88 } from "lit-element/lit-element.js";
var overlay_default = css88`@keyframes showDialog {
  0% {
    opacity: 0;
    transform: translateY(2em);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes showOuterDialog {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
dialog {
  background: none;
  border: none;
  padding: 0;
  position: fixed;
  top: 0;
  z-index: 90001;
  overflow-scrolling: contain;
  display: none;
  left: 0;
  --show-animation: showDialog var(--overlay-show-time, 0.4s) var(--ease-type) forwards;
}
dialog[open] {
  display: block;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  font-family: inherit;
  cursor: pointer;
  font-size: var(--font-size);
}

.in-dialog {
  opacity: 0;
}

dialog[open] .in-dialog {
  opacity: 1;
  animation: var(--show-animation);
}

.close {
  background: var(--color-cream);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  width: 44px;
  height: 44px;
  position: absolute;
  top: 6px;
  right: calc(var(--space-md) + 6px);
  display: grid;
  place-items: center;
  opacity: 0;
  pointer-events: all;
}

dialog[open] .close {
  opacity: 1;
  animation: var(--show-animation);
}

.title {
  opacity: 0;
}

dialog[open] .title {
  opacity: 1;
  animation: var(--show-animation);
}

.close-wrapper {
  position: fixed;
  right: 0;
  z-index: 1;
}

.trigger {
  display: flex;
}

.trigger[inline=true] {
  display: inline;
}

.content[v=toast] .in-dialog {
  padding: var(--space-lg);
  background: var(--color-cream-dark);
  box-shadow: var(--light-shadow);
  border-radius: 9px;
}
.content[v=toast] dialog {
  right: 0;
  top: 4em;
  left: auto;
  margin: var(--space-md);
}

.content[v=overlay] .in-dialog-wrapper {
  position: relative;
  box-sizing: border-box;
  --overlay-width: calc(min(var(--page-max-width-narrow), calc(100% - (var(--space-sm) * 2))));
  width: var(--overlay-max-w, var(--overlay-width));
  margin-top: var(--overlay-offset-top, 0);
  margin-bottom: var(--overlay-offset-bottom, 0);
}
.content[v=overlay] .in-dialog {
  padding: calc(var(--space-sm) * 1.5) var(--space-sm);
  background: var(--color-cream);
  box-shadow: var(--light-shadow);
  border-radius: 8px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  height: var(--overlay-height, unset);
  max-height: var(--overlay--max-h, calc(100dvh - 4em));
}
.content[v=overlay] dialog[open] {
  display: grid;
  place-items: center;
  padding: 1em 0;
  width: 100%;
  height: 100%;
  background: var(--color-charcoal-60);
  margin: 0;
  pointer-events: all;
  overflow: hidden;
  animation: showOuterDialog var(--overlay-show-time, 0.4s) var(--ease-type) forwards;
}
.content[v=overlay] .in-dialog-wrapper[open] .close {
  background: var(--color-cream-65);
  border: 1px solid var(--color-cream);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  transition-delay: 0.08s;
}
.content[v=overlay] .close-wrapper {
  position: relative;
  box-sizing: border-box;
}
@media screen and (min-width: 960px) {
  .content[v=overlay] .in-dialog {
    padding: calc(var(--space-sm) * 1.5);
  }
}

.content[v=fullpage] dialog {
  width: 100dvw;
  height: 100dvh;
  background: var(--color-cream);
  padding: var(--space-md);
  margin: 0;
  pointer-events: all;
  overflow: auto;
  z-index: 1;
  box-sizing: border-box;
  padding-top: var(--safe-area-top, 0);
  padding-bottom: var(--ion-safe-area-bottom, 0);
}
.content[v=fullpage] dialog[open][center=true] {
  display: flex;
  flex-direction: column;
}
.content[v=fullpage] dialog .in-dialog-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: min(100%, var(--content-width));
  margin: 0 auto;
}
.content[v=fullpage] .close {
  position: fixed;
  top: var(--overlay-close-top, calc(var(--safe-area-top, 0px) + 0.8em));
  right: var(--overlay-close-right, 1em);
}
.content[v=fullpage] .title {
  font-size: 1.1rem;
  margin: var(--overlay-title-pt, 1.25em) 0 var(--overlay-title-pb, 2em);
  padding: 0 50px 0;
  font-weight: 500;
  text-align: center;
}

.content[v=fullpage-content] dialog {
  width: 100dvw;
  height: 100dvh;
  background: var(--color-cream);
  margin: 0;
  pointer-events: all;
  overflow: auto;
  z-index: 90001;
  box-sizing: border-box;
}
.content[v=fullpage-content] dialog[open][center=true] {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}
.content[v=fullpage-content] dialog .in-dialog-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;
  margin: 0 auto;
  height: 100%;
}
.content[v=fullpage-content] .in-dialog {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  max-height: 100dvh;
}
.content[v=fullpage-content] ::slotted([slot=content]) {
  height: 100%;
}
.content[v=fullpage-content] .close {
  position: fixed;
  top: 1em;
  right: 1em;
}
.content[v=fullpage-content] .title {
  display: none;
}

@keyframes showPopupDialog {
  0% {
    transform: translateY(100dvh);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes showPopupBackground {
  0% {
    transform: scale(1.2);
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes hidePopupBackground {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}
.content[v=popup]:after {
  content: "";
  position: fixed;
  top: calc(var(--safe-area-top, 0px) + 0.2rem);
  left: 1rem;
  right: 1rem;
  border-radius: var(--popup-frame-br);
  height: 100dvh;
  background: var(--color-cream);
  z-index: 90000;
  box-shadow: 0 0 0 10rem #000000;
  transform-origin: top center;
  opacity: 0;
  pointer-events: none;
  animation: hidePopupBackground 0.2s ease-out forwards;
}
.content[v=popup]:has(dialog[open]):after {
  animation: showPopupBackground 0.4s ease-out forwards;
}
.content[v=popup] dialog {
  transform-origin: top center;
  margin: 0;
  --top: calc(var(--safe-area-top, 0px) + 0.8rem);
  top: var(--top);
  left: 0;
  right: 0;
  background: var(--overlay-bg, var(--color-cream));
  width: 100dvw;
  height: calc(100dvh - var(--top));
  border-radius: var(--popup-frame-br) var(--popup-frame-br) 0 0;
  overflow: auto;
  animation: showPopupDialog 0.5s cubic-bezier(0.25, 1, 0.5, 1) forwards;
  box-shadow: 0 0 3rem 3rem rgba(0, 0, 0, 0.5333333333);
}
.content[v=popup] dialog .title {
  position: sticky;
  top: 0;
  margin: 0 0 1rem;
  padding: 1rem 4rem;
  z-index: 10;
  text-align: center;
  font-size: 1.1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 1.4rem */
  letter-spacing: -0.02rem;
  background-color: var(--color-cream);
  border-bottom: 1px solid var(--greys-light-gray, #E6E3DB);
}
.content[v=popup] dialog .title .close {
  margin: 0;
  right: 1.2rem;
}

@media screen and (min-width: 900px) {
  .content[v=popup]:after {
    left: 2rem;
    right: 2rem;
  }
  .content[v=popup] dialog {
    left: 1rem;
    right: 1rem;
    width: calc(100vw - 2rem);
  }
}`;

// src/components/overlay/overlay.component.ts
styleInject_default(overlay_global_default);
var animationTimeClose = 200;
var _NineOverlay = class _NineOverlay extends NineElement {
  constructor() {
    super();
    this.dialogRef = createRef14();
    this.inDialogRef = createRef14();
    this.closeDialogRef = createRef14();
    this.hasInnerFocus = false;
    this.isOpen = false;
    this.clickOutClose = "true";
    this.variant = "overlay";
    this.triggerInline = "false";
    this.overlayOpen = "false";
    this.name = "";
    this.title = "";
    this.history = false;
    this.centerContent = false;
    this.hideClose = false;
    this.onOpen = () => {
    };
    this.onClose = () => {
    };
    // make the slugify function available publicly
    this.slugify = (name) => {
      return slugify(name);
    };
    this.handleResize = () => {
      this.alignDialog();
    };
    this.allowClickOutClose = false;
    this.handleDocumentClick = () => {
      if (this.isOpen && this.hasInnerFocus === false && this.allowClickOutClose) {
        this.close();
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this.handleAnimationEnd = () => {
    };
    this.setOpenProps = () => {
      const inDialog = this.inDialogRef.value;
      if (!inDialog) return;
      this.onOpen();
      this.dispatchEvent(
        new CustomEvent(_NineOverlay.customEvents.open, {
          detail: {
            name: this.name
          },
          bubbles: true,
          composed: true
        })
      );
      if (this.history) {
        if (!this.name) {
          throw new Error("Overlay name is required for history");
        }
        window.location.hash = this.slugify(this.name);
      }
      inDialog.setAttribute("open", "");
      this.isOpen = true;
    };
    this.openPopup = () => {
      this.allowClickOutClose = false;
      this.setOpenProps();
      setTimeout(() => {
        this.allowClickOutClose = true;
      }, 200);
    };
    this.open = (e) => {
      this.addPopupClasses();
      if (this.isOpen) return;
      if (e) e.preventDefault();
      this.overlayOpen = "true";
      this.emit("nine-open");
      this.openPopup();
    };
    this.close = () => {
      this.removePopupClasses();
      if (!this.isOpen) return;
      const inDialog = this.inDialogRef.value;
      if (!inDialog) return;
      inDialog.removeAttribute("open");
      this.overlayOpen = "false";
      setTimeout(() => {
        var _a2;
        (_a2 = this.dialogRef.value) == null ? void 0 : _a2.removeAttribute("open");
        this.emit("nine-close");
        this.onClose();
        this.dispatchEvent(
          new CustomEvent(_NineOverlay.customEvents.close, {
            detail: {
              name: this.name
            },
            bubbles: true,
            composed: true
          })
        );
        this.isOpen = false;
      }, animationTimeClose);
      this.isOpen = false;
      if (this.history) {
        if (window.location.hash === `#${this.slugify(this.name)}`) {
          window.history.pushState("", document.title, window.location.pathname);
        }
      }
    };
    this.handleOverlayScroll = () => {
      this.emit("nine-scroll");
      this.emit("resize");
    };
    this.listenForResize();
  }
  get hasTitle() {
    return this.title !== "";
  }
  firstUpdated() {
    this.setup();
  }
  updated(_changedProperties) {
    super.updated(_changedProperties);
    if (_changedProperties.has("overlayOpen")) {
      if (this.overlayOpen === "true") {
        this.open();
      } else {
        this.close();
      }
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.teardown();
  }
  alignDialog() {
    var _a2, _b;
    if (this.variant !== "toast") return;
    const windowWidth = window.innerWidth;
    const dialogRightPosition = Math.max((windowWidth - 1440) / 2, 0);
    (_a2 = this.dialogRef.value) == null ? void 0 : _a2.style.setProperty(
      "right",
      `${dialogRightPosition}px`
    );
    (_b = this.closeDialogRef.value) == null ? void 0 : _b.style.setProperty(
      "right",
      `${dialogRightPosition}px`
    );
  }
  listenForResize() {
    window.addEventListener("resize", this.handleResize);
  }
  setup() {
    var _a2, _b;
    this.alignDialog();
    if (!globalThis.nineOverlays) {
      globalThis.nineOverlays = {};
    }
    globalThis.nineOverlays[this.name] = this;
    if (this.overlayOpen === "true") {
      this.openPopup();
    }
    if (this.clickOutClose === "true") {
      window.document.addEventListener("click", this.handleDocumentClick);
      const ref21 = this.variant === "overlay" ? this.inDialogRef : this.dialogRef;
      (_a2 = ref21.value) == null ? void 0 : _a2.addEventListener("mouseover", () => {
        this.hasInnerFocus = true;
      });
      (_b = ref21.value) == null ? void 0 : _b.addEventListener("mouseout", () => {
        this.hasInnerFocus = false;
      });
    }
    if (this.history) {
      window.addEventListener("hashchange", (event) => {
        const oldHash = event.oldURL.split("#")[1];
        const newHash = event.newURL.split("#")[1];
        if (oldHash === this.slugify(this.name) && newHash !== this.slugify(this.name)) {
          this.close();
        }
        if (newHash === this.slugify(this.name) && oldHash !== this.slugify(this.name)) {
          this.open();
        }
      });
    }
  }
  teardown() {
    window.removeEventListener("resize", this.handleResize);
    if (this.clickOutClose === "true") {
      window.document.removeEventListener("click", this.handleDocumentClick);
    }
  }
  addPopupClasses() {
    this.setPopupClasses(true);
  }
  removePopupClasses() {
    this.setPopupClasses(false);
  }
  setPopupClasses(add) {
    if (this.variant !== "popup") return;
    const body = document.body;
    if (!body) return;
    if (add) {
      body.classList.add("n-popup-open");
      body.classList.remove("n-popup-closed");
    } else {
      body.classList.remove("n-popup-open");
      body.classList.add("n-popup-closed");
    }
  }
  get trigger() {
    return html66`
      <button @click="${this.open}">
        <slot name="trigger"></slot>
      </button>
    `;
  }
  get closeButton() {
    return html66` <button
      class="close"
      @click="${this.close}"
      aria-label="Close modal"
    >
      <svg
        width="11"
        height="11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="m5.5 6.5 4.4 4.4.85-.85-4.4-4.4L10.9 1.1l-.85-.85L5.5 4.8.85.15 0 1l4.65 4.65-4.5 4.5L1 11l4.5-4.5Z"
          fill="#212121"
        />
      </svg>
    </button>`;
  }
  get content() {
    return html66`
      <dialog
        ${ref14(this.dialogRef)}
        center="${this.centerContent}"
        ?open=${this.isOpen}
      >
        ${this.hasTitle && this.isOpen ? html66`
              <h2 class="title">
                ${this.title}
                ${this.variant === "popup" && !this.hideClose ? this.closeButton : ""}
              </h2>
            ` : ""}
        <div class="in-dialog-wrapper" ${ref14(this.inDialogRef)}>
          <div class="close-wrapper" ${ref14(this.closeDialogRef)}>
            ${this.variant !== "popup" && !this.hideClose ? this.closeButton : ""}
          </div>
          <div class="in-dialog" @scroll=${this.handleOverlayScroll}>
            ${this.isOpen ? html66` <slot name="content"></slot>` : ""}
          </div>
        </div>
      </dialog>
    `;
  }
  render() {
    return html66`
      <div class="trigger" inline="${this.triggerInline}">${this.trigger}</div>
      <div class="content" v="${this.variant}">${this.content}</div>
    `;
  }
};
_NineOverlay.customEvents = {
  open: "nine-overlay:open",
  close: "nine-overlay:close"
};
_NineOverlay.styles = unsafeCSS17(overlay_default);
__decorateClass([
  property50({ type: Boolean, reflect: true, attribute: "open" })
], _NineOverlay.prototype, "isOpen", 2);
__decorateClass([
  property50()
], _NineOverlay.prototype, "clickOutClose", 2);
__decorateClass([
  property50({ type: String })
], _NineOverlay.prototype, "variant", 2);
__decorateClass([
  property50({ type: String })
], _NineOverlay.prototype, "triggerInline", 2);
__decorateClass([
  property50({ type: String, reflect: true })
], _NineOverlay.prototype, "overlayOpen", 2);
__decorateClass([
  property50({ type: String })
], _NineOverlay.prototype, "name", 2);
__decorateClass([
  property50({ type: String })
], _NineOverlay.prototype, "title", 2);
__decorateClass([
  property50({ type: Boolean })
], _NineOverlay.prototype, "history", 2);
__decorateClass([
  property50({ type: Boolean, attribute: "center-content" })
], _NineOverlay.prototype, "centerContent", 2);
__decorateClass([
  property50({ type: Boolean, attribute: "hide-close" })
], _NineOverlay.prototype, "hideClose", 2);
__decorateClass([
  property50({ type: Function })
], _NineOverlay.prototype, "onOpen", 2);
__decorateClass([
  property50({ type: Function })
], _NineOverlay.prototype, "onClose", 2);
var NineOverlay = _NineOverlay;

// src/components/overlay/overlay.ts
var overlay_default2 = NineOverlay;
NineOverlay.define("nine-overlay");

// src/components/parse-text/parse-text.component.ts
import { html as html67 } from "lit";
var ParseTextElements = {
  Pill: {
    matcher: /\[\[(.*?)\]\]/g,
    replace: `<nine-pill style="--background-color: #F2EFE8; margin: 0.5em 0">$1</nine-pill>`
  },
  "Mobile Break": {
    // [% mobile-break %] or [%mobile-break%]
    matcher: /\[%\s?mobile-break\s?%\]/g,
    replace: `<span class="mobile-break"></span>`
  },
  "Desktop Break": {
    // [% desktop-break %] or [%desktop-break%]
    matcher: /\[%\s?desktop-break\s?%\]/g,
    replace: `<span class="desktop-break"></span>`
  }
};
var NineParseText = class extends NineElement {
  constructor() {
    super(...arguments);
    this.slotContent = null;
    this.parseInterval = null;
    this.observer = null;
    this.contentLastChanged = null;
    this.contentLastParsed = null;
  }
  parseContent(skipTimeCheck = false) {
    if (!skipTimeCheck && this.contentLastChanged && this.contentLastParsed) {
      if (this.contentLastChanged < this.contentLastParsed) {
        return;
      }
    }
    this.querySelectorAll('div[slot="parsed"]').forEach((el) => {
      el.remove();
    });
    this.slotContent = document.createElement("div");
    this.slotContent.slot = "parsed";
    this.appendChild(this.slotContent);
    const input = this.innerHTML;
    let parsed = input;
    const slotRegex = /<div slot="parsed">(.*)<\/div>/g;
    const slotReplace = `$1`;
    parsed = parsed.replace(slotRegex, slotReplace);
    Object.values(ParseTextElements).forEach((element) => {
      parsed = parsed.replace(element.matcher, element.replace);
    });
    if (this.slotContent && parsed) {
      this.contentLastParsed = Date.now() + 50;
      this.slotContent.innerHTML = parsed;
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this.parseContent();
    this.observer = new MutationObserver(() => {
      this.contentLastChanged = Date.now();
    });
    this.observer.observe(this, {
      childList: true,
      subtree: true,
      characterData: true
    });
    this.parseInterval = window.setInterval(() => {
      this.parseContent();
    }, 500);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.parseInterval) window.clearInterval(this.parseInterval);
  }
  firstUpdated() {
    this.parseContent();
  }
  render() {
    return html67`<slot name="parsed"></slot>`;
  }
};

// src/components/parse-text/parse-text.ts
var parse_text_default = NineParseText;
NineParseText.define("nine-parse-text");

// src/components/person/person.component.ts
import { css as css89, html as html68 } from "lit";
import { property as property51 } from "lit/decorators.js";
var styles2 = css89`
  :host {
    display: block;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  a {
    text-decoration: none;
    color: var(--color-charcoal);
  }

  a:hover {
    text-decoration: underline;
  }

  img {
    width: var(--space-xl);
    height: var(--space-xl);
    border-radius: 50%;
    margin-right: calc(0.75 * var(--space-sm));
    object-fit: cover;
  }

  p {
    font-weight: 500;
    font-size: var(--font-size);
    line-height: 140%;
    letter-spacing: -0.02em;
    margin: 0;
  }

  small {
    font-weight: 400;
    /* font-size: 14px; */
    font-size: calc(var(--sm-scale) * 0.88);
    line-height: 140%;
    letter-spacing: -0.02em;
    color: var(--person-position-color, --color-charcoal);
  }
`;
var NinePerson = class extends NineElement {
  constructor() {
    super(...arguments);
    this.imageSrc = "";
    this.imageAlt = "";
    this.name = "";
    this.pronouns = "";
    this.position = "";
    this.href = "";
    this.target = "";
    this.rel = "";
  }
  renderPersonInfo() {
    return html68`
      <div class="flex">
        <img src="${this.imageSrc}" alt="${this.imageAlt}" />
        <div>
          <p>${this.name} <small>${this.pronouns}</small></p>
          <small>${this.position}</small>
        </div>
      </div>
    `;
  }
  renderMarkup() {
    if (this.href) {
      return html68`
        <a href=${this.href} target=${this.target} rel=${this.rel}>
          ${this.renderPersonInfo()}
        </a>
      `;
    }
    return html68`${this.renderPersonInfo()}`;
  }
  render() {
    return html68`${this.renderMarkup()}`;
  }
};
NinePerson.styles = styles2;
__decorateClass([
  property51({ type: String })
], NinePerson.prototype, "imageSrc", 2);
__decorateClass([
  property51({ type: String })
], NinePerson.prototype, "imageAlt", 2);
__decorateClass([
  property51({ type: String })
], NinePerson.prototype, "name", 2);
__decorateClass([
  property51({ type: String })
], NinePerson.prototype, "pronouns", 2);
__decorateClass([
  property51({ type: String })
], NinePerson.prototype, "position", 2);
__decorateClass([
  property51({ type: String })
], NinePerson.prototype, "href", 2);
__decorateClass([
  property51({ type: String })
], NinePerson.prototype, "target", 2);
__decorateClass([
  property51({ type: String })
], NinePerson.prototype, "rel", 2);

// src/components/person/person.ts
var person_default = NinePerson;
NinePerson.define("nine-person");

// src/components/pill/pill.component.ts
import { css as css90, html as html69 } from "lit";
import { property as property52 } from "lit/decorators.js";
var NinePill = class extends NineElement {
  constructor() {
    super(...arguments);
    this.type = "";
    this.background = "--color-cream-dark";
    this.action = "false";
    this.checked = "false";
  }
  renderCheck() {
    return html69`
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="check"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 4.585 5.907 12 2 8.42l.64-.585 3.267 2.993L13.36 4l.64.585Z"
          fill="#fff"
        />
      </svg>
    `;
  }
  render() {
    return html69`
      <style>
        :host {
          --background-color: var(${this.background});
        }
      </style>

      <div class="wrap" aria-checked="${this.checked}">
        ${this.renderCheck()}
        <slot></slot>
      </div>
    `;
  }
};
NinePill.styles = css90`
    :host {
      display: inline-block;
      border-radius: 500px;
      background: var(--background-color, var(--color-cream-darker));
      box-shadow: 0 0 0 1px transparent;
      transition: box-shadow 0.2s ease-in-out;
      white-space: nowrap;
      padding: calc(var(--space-sm) * 0.2) calc(var(--space-sm) * 0.5)
        calc(var(--space-sm) * 0.135);
      font-weight: 500;
      /* font-size: 14px; */
      font-size: calc(var(--font-size) * 0.88);
      line-height: 140%;
      letter-spacing: -0.02em;
    }

    :host([type="outline"]) {
      background: transparent;
      border: 1px solid #000000;
    }

    :host([action="true"]:hover) {
      background: white;
      cursor: pointer;
      box-shadow: var(--large-shadow);
    }

    :host([checked="true"]) {
      color: white;
      background: #000;
    }

    :host([checked="true"]:hover) {
      background: #000;
    }

    .wrap {
      display: flex;
      align-items: center;
      position: relative;
      transition: all 0.2s ease-in-out;
    }

    .check {
      width: 16px;
      margin-right: 0.3em;
      position: absolute;
      left: 0;
      opacity: 0;
      transform: translateX(-1em) translateY(-0.07em);
      transition: all 0.2s ease-in-out;
    }

    :host([checked="true"]) .wrap {
      padding-left: 1.4em;
    }
    :host([checked="true"]) .check {
      opacity: 1;
      transform: translateX(-0.2em) translateY(-0.07em);
    }
  `;
__decorateClass([
  property52({ type: String })
], NinePill.prototype, "type", 2);
__decorateClass([
  property52({ type: String })
], NinePill.prototype, "background", 2);
__decorateClass([
  property52({ type: String })
], NinePill.prototype, "action", 2);
__decorateClass([
  property52({ type: String })
], NinePill.prototype, "checked", 2);

// src/components/pill/pill.ts
var pill_default = NinePill;
NinePill.define("nine-pill");

// src/components/progress/progress.component.ts
import { css as css91, html as html70 } from "lit";
import { property as property53 } from "lit/decorators.js";
var NineProgress = class extends NineElement {
  constructor() {
    super(...arguments);
    this.img = "";
    this.loaded = false;
    this.percent = 0;
    this.loadTime = 2e3;
    this.done = false;
    this.controlled = false;
  }
  firstUpdated() {
    this.fadeInImageOnLoad();
    if (!this.controlled) {
      setTimeout(() => {
        this.done = true;
      }, this.loadTime);
    }
  }
  updated(_changedProperties) {
    if (_changedProperties.has("percent")) {
      this.done = this.percent >= 1;
    }
  }
  fadeInImageOnLoad() {
    if (!this.img) return;
    const img = new Image();
    img.src = this.img;
    img.onload = () => {
      this.loaded = true;
    };
  }
  render() {
    return html70`<div
      class="progress"
      style="
      --img-url: url('${this.img}'); 
      --bar-percent: ${this.percent};
      --bar-time: ${this.loadTime}ms;
      "
      ?controlled=${this.controlled}
      ?done=${this.done}
    >
      ${this.img ? html70`<div class="img" ?loaded=${this.loaded}></div>` : ""}
      <div class="info">
        <slot name="info"></slot>
      </div>
      <div class="bar"></div>
    </div>`;
  }
};
NineProgress.styles = css91`
    :host {
      display: block;
      width: min(327px, 100%);
      --img-url: url("");
      --bar-height: 4px;
      --bar-color: var(--gradient-sunrise);
      --bar-background: var(--color-cream-dark);
      --bar-radius: 2em;
      --bar-transition: width 0.3s ease-in-out;
    }

    .progress {
      position: relative;
      width: 100%;
    }

    .img {
      width: 100%;
      height: var(--img-height);
      margin: 0 auto;
      aspect-ratio: 327/274;
      background-image: var(--img-url);
      background-size: cover;
      background-position: center;
      display: block;
      opacity: 0;
      transform: translateY(-1em);
      transition: opacity 0.3s ease-in-out, transform 0.5s ease-out;
    }

    .img[loaded] {
      opacity: 1;
      transform: translateY(0);
    }

    .info {
      margin: var(--space-xs) auto var(--space-md);
      text-align: center;
    }

    .bar {
      width: min(100%, 150px);
      border-radius: var(--bar-radius);
      height: var(--bar-height);
      background: var(--bar-background);
      margin: 0 auto;
      position: relative;
    }

    @keyframes bar {
      0% {
        width: 0;
      }
      100% {
        width: 100%;
      }
    }

    .bar::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: var(--bar-height);
      background: var(--bar-color);
      border-radius: var(--bar-radius);
      background-size: 150px;
      animation: bar var(--bar-time) ease-in-out forwards;
    }

    :host([controlled]) .bar::before {
      animation: none;
      width: calc(var(--bar-percent) * 100%);
      transition: var(--bar-transition);
    }
  `;
__decorateClass([
  property53({ type: String })
], NineProgress.prototype, "img", 2);
__decorateClass([
  property53({ type: Boolean, reflect: true })
], NineProgress.prototype, "loaded", 2);
__decorateClass([
  property53({ type: Number })
], NineProgress.prototype, "percent", 2);
__decorateClass([
  property53({ type: Number })
], NineProgress.prototype, "loadTime", 2);
__decorateClass([
  property53({ type: Boolean })
], NineProgress.prototype, "done", 2);
__decorateClass([
  property53({ type: Boolean })
], NineProgress.prototype, "controlled", 2);

// src/components/progress/progress.ts
var progress_default = NineProgress;
NineProgress.define("nine-progress");

// src/components/progress-bar/progress-bar.component.ts
import { css as css92, html as html71 } from "lit";
import { property as property54 } from "lit/decorators.js";
var styles3 = css92`
  :host {
    display: block;
    width: 100%;
    height: calc(var(--space-sm) * 0.25);
    position: relative;
    background-color: var(--color-cream-dark);
  }

  .progress {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: var(--progress, 0);
    ${bgGradientSunrise};
    background-size: 100vw;
    border-top-right-radius: calc(var(--space-sm) * 1.25);
    border-bottom-right-radius: calc(var(--space-sm) * 1.25);
  }
`;
var NineProgressBar = class extends NineElement {
  constructor() {
    super(...arguments);
    this.progress = "0%";
  }
  render() {
    return html71`<div>
      <div class="progress" style="--progress: ${this.progress};"></div>
    </div>`;
  }
};
NineProgressBar.styles = styles3;
__decorateClass([
  property54({ type: String })
], NineProgressBar.prototype, "progress", 2);

// src/components/progress-bar/progress-bar.ts
var progress_bar_default = NineProgressBar;
NineProgressBar.define("nine-progress-bar");

// src/components/promotion/promotion.component.ts
import { css as css94, html as html72 } from "lit";
import { property as property55 } from "lit/decorators.js";

// src/components/promotion/promotion.global.scss?inline
import { css as css93 } from "lit-element/lit-element.js";
var promotion_global_default = css93`nine-promotion h5,
nine-promotion h6 {
  font-weight: 500;
  font-size: var(--font-size);
  line-height: 140%;
  letter-spacing: -0.02em;
  margin: 0;
  white-space: nowrap;
}

nine-promotion h6 {
  font-weight: 400;
  font-size: calc(var(--scale) * 0.8);
  line-height: 140%;
}`;

// src/components/promotion/promotion.component.ts
styleInject_default(promotion_global_default);
var NinePromotion = class extends NineElement {
  constructor() {
    super(...arguments);
    this.icon = "";
  }
  render() {
    return html72`
      <div class="promotion">
        <div class="icon">
          <img src="${this.icon}" alt="" />
        </div>
        <div class="text"><slot></slot></div>
      </div>
    `;
  }
};
NinePromotion.styles = css94`
    :host {
      display: block;
    }

    .promotion {
      display: flex;
      align-items: center;
    }

    .icon {
      width: 3.1em;
      aspect-ratio: 1;
      background: var(--color-cream-dark);
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: var(--border-radius);
    }

    .icon img {
      width: 80%;
    }

    .text {
      padding-left: 0.5em;
    }
  `;
__decorateClass([
  property55({ type: String })
], NinePromotion.prototype, "icon", 2);

// src/components/promotion/promotion.ts
var promotion_default = NinePromotion;
NinePromotion.define("nine-promotion");

// src/components/roi-calculator-result/roi-calculator-result.component.ts
import { css as css95, html as html73 } from "lit";
import { property as property56 } from "lit/decorators.js";

// src/lib/roiCalculator.ts
var chronicDiseasePrevalencePercentage = 0.08;
var obesityPrevalancePercentage = 0.4;
var enrollmentRateDiabetesPercentage = 0.18;
var enrollmentRateWeightMgmtPercentageWithGlp1 = 0.2;
var enrollmentRateWeightMgmtPercentageWithoutGlp1 = 0.1;
var getMemberCount = (numberOfMembers, coverMedication) => {
  const nineAmHealthDiabetesMembers = numberOfMembers * chronicDiseasePrevalencePercentage * enrollmentRateDiabetesPercentage;
  const nineAmHealthObesityMembersGlp1 = coverMedication ? numberOfMembers * obesityPrevalancePercentage * enrollmentRateWeightMgmtPercentageWithGlp1 : 0;
  const nineAmHealthObesityMembersNoGlp1 = coverMedication ? 0 : numberOfMembers * obesityPrevalancePercentage * enrollmentRateWeightMgmtPercentageWithoutGlp1;
  return {
    nineAmHealthDiabetesMembers: parseFloat(nineAmHealthDiabetesMembers.toFixed(2)),
    nineAmHealthObesityMembersGlp1: parseFloat(nineAmHealthObesityMembersGlp1.toFixed(2)),
    nineAmHealthObesityMembersNoGlp1: parseFloat(nineAmHealthObesityMembersNoGlp1.toFixed(2))
  };
};
var getDiabetesDrugSavings = (nineAmHealthDiabetesMembers) => {
  return Math.round(23e4 * 0.6 * (nineAmHealthDiabetesMembers / 112) * -1);
};
var getCardiometabolicProgramFeeTotal = (totalProgramMembers, cardiometabolicProgramFee) => {
  return totalProgramMembers * cardiometabolicProgramFee * 12;
};
var getMedicalSavings = (totalProgramMembers) => {
  return 128 * 12 * -1 * totalProgramMembers;
};
var roiCalculator = (numberOfMembers, coverMedication) => {
  const cardiometabolicProgramFee = 70;
  const { nineAmHealthDiabetesMembers, nineAmHealthObesityMembersGlp1, nineAmHealthObesityMembersNoGlp1 } = getMemberCount(numberOfMembers, coverMedication);
  const totalProgramMembers = nineAmHealthDiabetesMembers + nineAmHealthObesityMembersGlp1 + nineAmHealthObesityMembersNoGlp1;
  const cardiometabolicProgramFeeTotal = getCardiometabolicProgramFeeTotal(
    totalProgramMembers,
    cardiometabolicProgramFee
  );
  const diabetesDrugSavings = getDiabetesDrugSavings(nineAmHealthDiabetesMembers);
  const medicalSavings = getMedicalSavings(totalProgramMembers);
  const weightManagementDrugSavings = coverMedication ? -476e3 / 156 * nineAmHealthObesityMembersGlp1 : 0;
  const productivitySavings = totalProgramMembers * 2 * 2 * 45 * -1;
  const programSavings = diabetesDrugSavings + medicalSavings + weightManagementDrugSavings + productivitySavings;
  const roiValue = parseFloat((programSavings / cardiometabolicProgramFeeTotal * -1).toFixed(1));
  const grossSavingsPerMemberPerYear = Math.round(programSavings / totalProgramMembers * -1);
  const totalSavingsPerYear = Math.round(grossSavingsPerMemberPerYear * totalProgramMembers);
  return {
    roiValue,
    grossSavingsPerMemberPerYear,
    totalSavingsPerYear
  };
};

// src/components/roi-calculator-result/roi-calculator-result.component.ts
var styles4 = css95`
  :host {
    display: block;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .roi {
    border-radius: 200px;
    border: 1px solid var(--greys-charcoal, #212121);
    padding: 4px 20px;
    font-weight: 500;
    margin-bottom: var(--space-lg);
  }

  h2 {
    margin-top: 0;
    margin-bottom: 16px;
    text-align: center;
    font-size: calc(var(--scale) * 3);
    font-weight: 300;
    line-height: 120%;
    font-family: 'STK Bureau Serif';
    font-weight: 300;
    background: var(--sunrise-vertical-dusk, linear-gradient(0deg, #0e3763 0%, #5b4855 52.6%, #8a6947 100%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  h2:last-child {
    margin-bottom: 56px;
  }

  .smText {
    font-size: calc(var(--font-size) * 1.75);
  }

  p {
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 0;
  }
`;
var NineRoiCalculatorResult = class extends NineElement {
  constructor() {
    super(...arguments);
    this.coveredLives = 1500;
    this.medicationCovered = false;
    this.roiCalculatorResult = roiCalculator(this.coveredLives, this.medicationCovered);
    this.formatter = Intl.NumberFormat("en-US");
  }
  updated(changedProperties) {
    if (changedProperties.has("coveredLives") || changedProperties.has("medicationCovered")) {
      this.roiCalculatorResult = roiCalculator(this.coveredLives, this.medicationCovered);
    }
  }
  get savingsPerMemberPerYear() {
    return this.formatter.format(this.roiCalculatorResult.grossSavingsPerMemberPerYear);
  }
  get totalSavingsPerYear() {
    return this.formatter.format(this.roiCalculatorResult.totalSavingsPerYear);
  }
  render() {
    return html73`<div>
      <div class="wrapper">
        <p class="roi">ROI: ${this.roiCalculatorResult.roiValue}x</p>
        <p><slot name="textSavingPerMember"> </slot></p>
        <h2 class="roiResultValue">
          <span class="smText">$ </span>${this.savingsPerMemberPerYear}<span class="smText">/year</span>
        </h2>
        <p><slot name="textSavingTotal"> </slot></p>
        <h2 class="roiResultValue">
          <span class="smText">$ </span>${this.totalSavingsPerYear}<span class="smText">/year</span>
        </h2>
      </div>
    </div>`;
  }
};
NineRoiCalculatorResult.styles = styles4;
__decorateClass([
  property56({ type: Number, attribute: "covered-lives" })
], NineRoiCalculatorResult.prototype, "coveredLives", 2);
__decorateClass([
  property56({ type: Boolean, attribute: "medication-covered" })
], NineRoiCalculatorResult.prototype, "medicationCovered", 2);
__decorateClass([
  property56({ type: Object, reflect: false })
], NineRoiCalculatorResult.prototype, "roiCalculatorResult", 2);

// src/components/roi-calculator-result/roi-calculator-result.ts
var roi_calculator_result_default = NineRoiCalculatorResult;
NineRoiCalculatorResult.define("nine-roi-calculator-result");

// src/components/scrolling/scrolling.component.ts
import { css as css96, html as html74 } from "lit";
import { property as property57 } from "lit/decorators.js";
import { createRef as createRef15, ref as ref15 } from "lit/directives/ref.js";
var NineScrolling = class extends NineElement {
  constructor() {
    super(...arguments);
    this.itemsEl = null;
    this.itemsElements = [];
    this.itemsRef = createRef15();
    this.handleScroll = () => {
      var _a2;
      const itemsElOffsetLeft = (_a2 = this.getBoundingClientRect().left) != null ? _a2 : 0;
      for (const el of this.itemsElements) {
        if (!el) continue;
        if (itemsElOffsetLeft === 0 || this.fade === "false") {
          el.style.setProperty("--item-opacity", `1`);
          continue;
        }
        const pos = el.getBoundingClientRect().left - itemsElOffsetLeft;
        const min = this.fadeOutPos;
        const max = this.fadeInPos;
        const percentPos = (pos - min) / (max - min);
        el.style.setProperty("--item-opacity", `${percentPos}`);
      }
    };
    this.fadeInPos = 450;
    this.fadeOutPos = 230;
    this.fade = "true";
    this.scrollDir = (event) => {
      var _a2, _b, _c, _d, _e, _f, _g;
      const dir = parseInt(`${(_a2 = event.detail) != null ? _a2 : 1}`);
      const scrollLeft = (_c = (_b = this.itemsEl) == null ? void 0 : _b.scrollLeft) != null ? _c : 0;
      const offsetLeftFirst = (_e = (_d = this.itemsElements[0]) == null ? void 0 : _d.offsetLeft) != null ? _e : 0;
      const offsetLeftSecond = (_g = (_f = this.itemsElements[1]) == null ? void 0 : _f.offsetLeft) != null ? _g : 0;
      if (!offsetLeftFirst || !offsetLeftSecond) {
        return;
      }
      const scrollStep = offsetLeftSecond - offsetLeftFirst;
      const newScrollLeft = scrollLeft + dir * scrollStep;
      animate(
        600,
        (i2) => {
          if (this.itemsEl) this.itemsEl.scrollLeft = i2;
        },
        {
          range: [scrollLeft, newScrollLeft]
        }
      );
    };
  }
  firstUpdated() {
    setTimeout(() => {
      var _a2, _b, _c;
      try {
        this.itemsEl = (_a2 = this.renderRoot) == null ? void 0 : _a2.querySelector(".items");
        const slot = this.itemsRef.value;
        if (!slot) {
          console.error("scrolling could not find slot");
          return;
        }
        const itemsSlot = slot.assignedNodes().find(
          (slot2) => slot2.name === "items"
        );
        const itemSlotNode = itemsSlot == null ? void 0 : itemsSlot.assignedNodes()[0];
        const items = (_b = itemSlotNode == null ? void 0 : itemSlotNode.querySelectorAll("nine-card")) != null ? _b : [];
        this.itemsElements = Array.from(items);
        (_c = this.itemsEl) == null ? void 0 : _c.addEventListener("scroll", this.handleScroll);
        window == null ? void 0 : window.addEventListener("resize", this.handleScroll, {
          passive: true
        });
        this.handleScroll();
        this.addEventListener("scrollDir", this.scrollDir);
        setInterval(() => {
          this.updateItems();
        }, 5e3);
      } catch (error) {
        console.error(error);
      }
    }, 0);
  }
  updateItems() {
    var _a2, _b;
    const slot = this.itemsRef.value;
    if (!slot) return;
    const itemsSlot = slot.assignedNodes().find(
      (slot2) => slot2.name === "items"
    );
    const itemSlotNode = itemsSlot == null ? void 0 : itemsSlot.assignedNodes()[0];
    const items = (_a2 = itemSlotNode == null ? void 0 : itemSlotNode.querySelectorAll("nine-card")) != null ? _a2 : [];
    this.itemsEl = (_b = this.renderRoot) == null ? void 0 : _b.querySelector(".items");
    this.itemsElements = Array.from(items);
    this.handleScroll();
  }
  disconnectedCallback() {
    var _a2;
    super.disconnectedCallback();
    (_a2 = this.itemsEl) == null ? void 0 : _a2.removeEventListener("scroll", this.handleScroll);
    window == null ? void 0 : window.removeEventListener("resize", this.handleScroll);
    this.removeEventListener("scrollDir", this.scrollDir);
  }
  render() {
    return html74`<div class="items" fade="${this.fade}">
      <slot name="items" ${ref15(this.itemsRef)}></slot>
    </div>`;
  }
};
NineScrolling.styles = css96`
    :host {
      display: block;
      position: relative;
    }

    ::slotted([slot="items"]) {
      display: flex;
      grid-gap: var(--space-sm);
    }

    .items {
      overflow: hidden;
      overflow-x: scroll;
      padding: var(--space-sm) var(--space-md) 77px;
      display: flex;
      padding-left: var(--scroller-pad-left, var(--space-md));
      padding-right: var(--scroller-pad-right, var(--space-md));
    }

    /* hide scrollbar */
    .items::-webkit-scrollbar {
      display: none;
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      ::slotted([slot="items"]) {
        grid-gap: var(--space-lg);
      }

      .items[fade="true"] {
        padding-bottom: 120px;
        margin-bottom: -50px;
      }
    }

    @media screen and (min-width: 1200px) {
      .items[fade="false"] {
        overflow: visible;
        padding: 0 0 56px;
      }

      .items[fade="false"] ::slotted([slot="items"]) {
        max-width: 100%;
      }
    }
  `;
__decorateClass([
  property57({ type: Number })
], NineScrolling.prototype, "fadeInPos", 2);
__decorateClass([
  property57({ type: Number })
], NineScrolling.prototype, "fadeOutPos", 2);
__decorateClass([
  property57({ type: String })
], NineScrolling.prototype, "fade", 2);

// src/components/scrolling/scrolling.ts
var scrolling_default = NineScrolling;
NineScrolling.define("nine-scrolling");

// src/components/select/select.ts
var select_default2 = NineSelect;
NineSelect.define("nine-select");

// src/components/select-menu/select-menu.component.ts
import { html as html76, unsafeCSS as unsafeCSS19 } from "lit";
import { property as property59 } from "lit/decorators.js";
import { createRef as createRef17, ref as ref17 } from "lit/directives/ref.js";

// src/components/select-menu/popup.global.scss?inline
import { css as css97 } from "lit-element/lit-element.js";
var popup_global_default = css97`@keyframes showPopover {
  0% {
    opacity: 0;
    transform: translateY(2em);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
html body .nine-select-popup {
  position: fixed;
  z-index: 122000;
  background: transparent;
  border-radius: var(--border-radius);
  background: white;
  box-shadow: var(--light-shadow);
  overflow-y: auto;
  overflow-x: hidden;
  transform: translateY(2px) translateZ(1px);
  transition: all var(--ease-time) var(--ease-type);
  margin: 0;
  padding: 0;
}
html body .nine-select-popup ul,
html body .nine-select-popup li {
  list-style: none;
  margin: 0;
  padding: 0;
}
html body .nine-select-popup .label {
  padding: var(--space-sm) var(--space-md) 0.3em;
  color: var(--color-gray);
  border-bottom: 1px solid var(--color-gray-fog);
}
html body .nine-select-popup .option {
  padding: var(--padding);
  cursor: pointer;
  color: var(--color-text);
  font-size: var(--font-size);
  line-height: var(--line-height);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  padding: var(--space-sm) var(--space-md);
  filter: blur(0);
  transition: all 0.1s ease-in-out;
}
html body .nine-select-popup .option[aria-selected] {
  background: var(--color-gray-fog);
}
html body .nine-select-popup .option:hover, html body .nine-select-popup .option:focus, html body .nine-select-popup .option:active, html body .nine-select-popup .option.focused {
  background: var(--color-mid-blue);
}
html body .nine-select-popup .option::before {
  content: none;
}
html body .nine-select-popup::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--color-white);
  opacity: 0;
  pointer-events: none;
  z-index: 0;
  transition: opacity 0.1s;
}
html body .nine-select-popup.is-loading::after {
  opacity: 0.65;
  pointer-events: all;
}
html body .nine-select-popup.is-loading .option,
html body .nine-select-popup.is-loading nine-virtual-list {
  pointer-events: none;
  filter: blur(2px);
}
html body .nine-select-popup nine-virtual-list {
  border-radius: var(--border-radius);
  background: white;
}
html body .nine-select-popup .no-results {
  padding: var(--space-md);
  text-align: center;
  color: var(--color-text);
  font-size: var(--font-size);
  line-height: var(--line-height);
}
html body .nine-select-popup.is-popover {
  position: fixed;
  left: 1em;
  right: 1em;
  padding: 0 0 1em;
  top: calc(1.2em + 64px);
  animation: showPopover 0.2s ease-in-out;
  max-height: min(60vh, 400px);
  bottom: var(--bottom, auto);
}
html body .nine-select-popup.is-popover::-webkit-scrollbar {
  display: none;
}
html body .nine-select-popup.is-popover .option {
  background: white;
}
html body .nine-select-popup.is-popover nine-virtual-list {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  height: auto !important;
  background: white;
  --virtual-item-bg: white;
}

html body.os-ios .nine-select-popup.is-popover {
  --bottom: 38.7vh;
  --height: calc(100vh - var(--bottom) - 7em - 64px);
}
@media screen and (min-height: 630px) and (max-height: 640px) {
  html body.os-ios .nine-select-popup.is-popover {
    --bottom: 40vh;
  }
}
@media screen and (min-height: 840px) and (max-height: 850px) {
  html body.os-ios .nine-select-popup.is-popover {
    --bottom: 39vh;
  }
}
@media screen and (min-height: 580px) and (max-height: 590px) {
  html body.os-ios .nine-select-popup.is-popover {
    --bottom: 45.7vh;
  }
}
@media screen and (min-height: 810px) and (max-height: 815px) {
  html body.os-ios .nine-select-popup.is-popover {
    --bottom: 41.3vh;
  }
}
@media screen and (min-height: 735px) and (max-height: 745px) {
  html body.os-ios .nine-select-popup.is-popover {
    --bottom: 36vh;
  }
}

html body.os-android .nine-select-popup.is-popover {
  --height: calc(100vh - 64px - 2em);
}

html body nine-select.has-popover {
  position: fixed;
  left: 1em;
  right: 1em;
  width: calc(100vw - 2em);
  top: 1em;
  z-index: 121000;
}

html body .nine-select-popover-placeholder {
  height: 64px;
}`;

// src/components/select-menu/select-menu.scss?inline
import { css as css98 } from "lit-element/lit-element.js";
var select_menu_default = css98`:host {
  display: block;
  position: relative;
  width: 100%;
}

.proxy {
  display: none;
}

.native-select {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline-color: transparent;
  opacity: 0.0001;
}`;

// src/components/virtual-list/virtual-list.component.ts
import { html as html75, unsafeCSS as unsafeCSS18 } from "lit";
import { repeat as repeat3 } from "lit-html/directives/repeat.js";
import { property as property58 } from "lit/decorators.js";
import { createRef as createRef16, ref as ref16 } from "lit/directives/ref.js";

// src/components/virtual-list/virtual-list.scss?inline
import { css as css99 } from "lit-element/lit-element.js";
var virtual_list_default = css99`:host {
  display: block;
  width: 100%;
  overflow-y: scroll;
  min-height: 50px;
  height: min(500px, 100%);
  position: relative;
  overscroll-behavior: contain;
  contain: paint;
  transform: translate3d(0, 0, 1px) scale(1.01);
}

.list {
  position: absolute;
  width: 100%;
  height: calc(var(--virtual-item-count, 0) * var(--virtual-item-height));
}

.no-results {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 50px;
  display: grid;
  place-items: center;
  opacity: 0.6;
  font-weight: 500;
}

.list-item {
  height: var(--virtual-item-height);
  min-height: var(--virtual-item-height);
  line-height: var(--virtual-item-height);
  cursor: pointer;
  color: var(--color-text);
  font-size: var(--font-size);
  padding: 0 var(--space-sm);
  background: var(--virtual-item-bg, transparent);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  filter: blur(0);
  transition: all 0.1s ease-in-out;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
}
.list-item[aria-selected] {
  background: var(--color-gray-fog);
}
.list-item:hover, .list-item:focus, .list-item:active, .list-item.focused {
  background: var(--color-mid-blue);
}
.list-item::before {
  content: none;
}`;

// src/components/virtual-list/virtual-list.component.ts
var _NineVirtualList = class _NineVirtualList extends NineElement {
  constructor() {
    super(...arguments);
    this.activeIndex = -1;
    this.items = [];
    this.setItemsFromOptions = false;
    this.itemHeight = 50;
    this.visibleItems = 0;
    this.startIndex = 0;
    this.height = 400;
    this.listRef = createRef16();
    this.setHeight = () => {
      const elHeight = this.height;
      const maxHeight = elHeight - 30;
      this.visibleItems = Math.ceil(maxHeight / this.itemHeight);
      const heightToSet = `${this.itemHeight * Math.min(this.visibleItems, this.itemCount)}px`;
      this.style.height = heightToSet;
    };
  }
  get itemCount() {
    return this.items.length;
  }
  updated(_changedProperties) {
    super.updated(_changedProperties);
    this.setHeight();
  }
  firstUpdated() {
    var _a2;
    if (this.setItemsFromOptions) {
      this.items = Array.from(this.querySelectorAll("option")).map(
        (option) => option.textContent || ""
      );
    }
    (_a2 = this.listRef.value) == null ? void 0 : _a2.addEventListener(
      "click",
      (e) => this.handleListClick(e)
    );
  }
  connectedCallback() {
    super.connectedCallback();
    this.setHeight();
    this.addEventListener("scroll", () => this.handleScroll());
  }
  handleListClick(e) {
    const target = e.target;
    const index = target.dataset.index;
    const indexNumber = Number(index);
    this.dispatchEvent(
      new CustomEvent(_NineVirtualList.customEvents.listItemClick, {
        detail: { index: indexNumber },
        bubbles: true,
        composed: true
      })
    );
  }
  handleScroll() {
    const scrollTop = this.scrollTop;
    this.startIndex = Math.floor(scrollTop / this.itemHeight);
    this.requestUpdate();
  }
  createItem(index) {
    const content = this.items[index];
    if (!content) {
      return html75``;
    }
    return html75`
            <div
                    class="list-item"
                    style="position: absolute; top: ${index * this.itemHeight}px;"
                    title="${content}"
                    data-index="${index}"
            >
                ${content}
            </div>`;
  }
  render() {
    return html75`
            ${this.itemCount === 0 ? html75`
                        <div class="no-results">No results</div>` : ""}
            <div
                    class="list"
                    style="
        --virtual-item-count: ${this.itemCount};
        --virtual-item-height: ${this.itemHeight}px;
        "
                    ${ref16(this.listRef)}
            >
                ${repeat3(
      Array.from(
        { length: this.visibleItems + 1 },
        (_, i2) => i2 + this.startIndex
      ),
      (index) => index,
      (index) => this.createItem(index)
    )}
            </div>
        `;
  }
};
_NineVirtualList.styles = unsafeCSS18(virtual_list_default);
_NineVirtualList.customEvents = {
  listItemClick: "list-item-click"
};
__decorateClass([
  property58({ type: Object, attribute: "items" })
], _NineVirtualList.prototype, "items", 2);
__decorateClass([
  property58({ type: Boolean, attribute: "set-items-from-options" })
], _NineVirtualList.prototype, "setItemsFromOptions", 2);
__decorateClass([
  property58({ type: Number, attribute: "itemheight" })
], _NineVirtualList.prototype, "itemHeight", 2);
__decorateClass([
  property58({ type: Number })
], _NineVirtualList.prototype, "height", 2);
var NineVirtualList = _NineVirtualList;

// src/components/select-menu/select-menu.component.ts
styleInject_default(popup_global_default);
var NineSelectMenu = class extends NineElement {
  constructor() {
    super(...arguments);
    this.popupElement = null;
    this.customSelectRef = createRef17();
    this.filter = null;
    this.anchorElement = this;
    this.delayClose = false;
    this.virtualMaxHeight = 400;
    this.nativeSelect = false;
    this.noResultsText = "No results";
    this.initialValue = "";
    this.usePopover = false;
    this.open = false;
    this.loading = false;
    this.disableProblematicDeviceCheck = false;
    this.disableVirtual = false;
    this.options = [];
    this.filteredOptions = [];
    this.selectedOptions = [];
    // check if the browser/device might cause issues with the select menu
    this.isProblematicEnvironment = () => {
      if (this.disableProblematicDeviceCheck || getConfig().disableProblematicDeviceCheck) {
        return false;
      }
      let problematic = false;
      const deviceType = getDeviceType();
      const platform = getPlatform();
      const browser = getBrowser();
      const isMobileSafari = platform === "ios" && deviceType === "mobile";
      if (isMobileSafari) {
        problematic = true;
      }
      const isEdge = browser === "edge" || browser === "ie";
      if (isEdge) {
        problematic = true;
      }
      return problematic;
    };
    this.positionUpdateInterval = null;
    this.handleValuePropChange = () => {
      if (this.initialValue) {
        const match = this.options.find((option2) => {
          if ("options" in option2) {
            return option2.options.find((o) => o.value === this.initialValue);
          } else {
            return option2.value === this.initialValue;
          }
        });
        const option = match && "options" in match ? match.options.find((o) => o.value === this.initialValue) : match;
        this.selectedOptions = option ? [option] : [];
      }
    };
    this.handleNativeSelectChange = (e) => {
      const target = e.target;
      const value = target.value;
      if (value) {
        const option = this.getOptionByValue(value);
        if (option) this.selectedOptions = [option];
      }
    };
    this.updateLoadingState = () => {
      if (!this.popupElement) return;
      if (this.loading) {
        this.popupElement.classList.add("is-loading");
      } else {
        this.popupElement.classList.remove("is-loading");
      }
    };
    this.dispatchSelectedOptionsChangeEvent = () => {
      const event = new CustomEvent("select:change", {
        detail: { selectedOptions: this.selectedOptions },
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(event);
    };
    this.createPopup = () => {
      if (this.popupElement) return;
      this.popupElement = document.createElement("div");
      this.popupElement.classList.add("nine-select-popup");
      document.body.appendChild(this.popupElement);
      this.updateLoadingState();
      this.addVirtualListEvents();
    };
    this.addVirtualListEvents = () => {
      var _a2;
      if (this.virtual) {
        (_a2 = this.popupElement) == null ? void 0 : _a2.addEventListener(
          NineVirtualList.customEvents.listItemClick,
          this.handleVirtualListItemClick
        );
      }
    };
    this.handleVirtualListItemClick = (e) => {
      const index = e.detail.index;
      const option = this.getOptionByIndex(index);
      if (option) this.selectedOptions = [option];
      setTimeout(() => {
        this.delayClose = false;
        this.destroyPopup();
      }, 50);
    };
    this.updatePopupContent = () => {
      var _a2;
      if (!this.open) return;
      if (this.popupElement) {
        this.popupElement.innerHTML = "";
        const content = (_a2 = this.customSelectRef.value) == null ? void 0 : _a2.children;
        for (const node of content != null ? content : []) {
          const clone = node.cloneNode(true);
          clone.addEventListener(
            "click",
            this.handleCloneOptionClick
          );
          clone.addEventListener(
            "mousedown",
            this.handleMouseDown
          );
          this.popupElement.appendChild(clone);
        }
        this.updateVirtualItems();
      }
    };
    this.handleCloneOptionClick = (e) => {
      const target = e.target;
      const value = target.dataset.value;
      if (value) {
        const option = this.getOptionByValue(value);
        if (option) this.selectedOptions = [option];
        this.delayClose = false;
        this.destroyPopup();
      }
    };
    this.getOptionByValue = (value) => {
      if (value) {
        const match = this.options.find((option2) => {
          if ("options" in option2) {
            return option2.options.find((o) => o.value === value);
          } else {
            return option2.value === value;
          }
        });
        const option = match && "options" in match ? match.options.find((o) => o.value === value) : match;
        return option;
      }
      return void 0;
    };
    this.getOptionByIndex = (index) => {
      const option = this.filteredOptions[index];
      if (option && "options" in option) {
        return option.options[0];
      }
      return option;
    };
    this.updatePopupPosition = () => {
      var _a2, _b, _c;
      if (!this.open) return;
      if (!this.popupElement) return;
      const anchor = this.anchorElement;
      const rect = anchor.getBoundingClientRect();
      const bodyOffset = document.body.getBoundingClientRect().bottom;
      const maxHeight = window.innerHeight - rect.bottom - 10;
      (_a2 = document.querySelector("html")) == null ? void 0 : _a2.style.setProperty("--nine-body-offset", `${bodyOffset}px`);
      (_b = document.querySelector("html")) == null ? void 0 : _b.style.setProperty("--nine-window-height", `${window.innerHeight}px`);
      (_c = this.popupElement) == null ? void 0 : _c.classList.toggle("is-popover", this.usePopover);
      this.popupElement.style.left = `${rect.left}px`;
      this.popupElement.style.width = `${rect.width}px`;
      if (!this.usePopover) {
        this.popupElement.style.top = `${rect.bottom}px`;
        this.popupElement.style.maxHeight = `min(${maxHeight}px, 400px)`;
        const virtualMaxHeight = Math.min(maxHeight, 400);
        if (virtualMaxHeight !== this.virtualMaxHeight) {
          this.virtualMaxHeight = Math.min(maxHeight, 400);
          this.updateVirtualItems();
        }
      }
    };
    this.destroyPopup = () => {
      if (this.delayClose) return;
      const to = 0;
      this.delayClose = false;
      setTimeout(() => {
        var _a2;
        (_a2 = this.popupElement) == null ? void 0 : _a2.remove();
        this.popupElement = null;
      }, to);
    };
    this.queryOptions = () => {
      let children = Array.from(this.children);
      if (this.children[0] instanceof HTMLSlotElement) {
        children = this.children[0].assignedElements();
      }
      const optionsFound = [];
      for (const el of children) {
        if (el instanceof HTMLOptGroupElement) {
          const options = Array.from(el.children).filter(
            (el2) => el2 instanceof HTMLOptionElement
          );
          optionsFound.push({
            label: el.label,
            options: Array.from(options).map((option) => {
              return {
                value: option.value,
                label: option.label,
                group: el.label
              };
            })
          });
        } else if (el instanceof HTMLOptionElement) {
          optionsFound.push({
            value: el.value,
            label: el.label
          });
        }
      }
      return optionsFound;
    };
    this.handleMutationChange = (mutations) => {
      mutations.forEach((mutation) => {
        const addedOrRemovedNodes = [
          ...mutation.addedNodes,
          ...mutation.removedNodes
        ];
        const shouldUpdate = addedOrRemovedNodes.some((node) => {
          return node instanceof HTMLOptionElement || node instanceof HTMLOptGroupElement;
        });
        if (shouldUpdate) {
          this.updateOptionList();
          this.updatePopupContent();
        }
      });
    };
    this.updateOptionList = () => {
      const options = this.queryOptions();
      this.options = options;
      this.debounceFilterOptions();
    };
    this.filterTimeout = 0;
    this.debounceFilterOptions = async (filter = this.filter) => {
      return new Promise((resolve) => {
        if (this.filterTimeout) clearTimeout(this.filterTimeout);
        this.filterTimeout = setTimeout(() => {
          this.filteredOptions = this.filterOptions(filter);
          resolve();
        }, 40);
      });
    };
    this.filterOptions = (filter = this.filter) => {
      if (filter === null) return this.options;
      const { label = "" } = filter;
      if (label === "") return this.options;
      const filteredOptions = [];
      for (const option of this.options) {
        if ("options" in option) {
          const filteredGroupOptions = option.options.filter((opt) => {
            return opt.label.toLowerCase().includes(label.toLowerCase());
          });
          if (filteredGroupOptions.length > 0) {
            filteredOptions.push({
              label: option.label,
              options: filteredGroupOptions
            });
          }
        } else {
          if (option.label.toLowerCase().includes(label.toLowerCase())) {
            filteredOptions.push(option);
          }
        }
      }
      return filteredOptions;
    };
    this.handleMouseDown = () => {
      this.delayClose = true;
      setTimeout(() => {
        if (this.delayClose) {
          this.delayClose = false;
          this.destroyPopup();
        }
      }, 1e3);
    };
    this.setFilter = (filter) => {
      this.filter = filter;
      this.debounceFilterOptions().then(this.updatePopupContent);
    };
    this.setAnchorElement = (anchorElement) => {
      this.anchorElement = anchorElement != null ? anchorElement : this;
      this.updatePopupPosition();
    };
    this.updateVirtualItems = (options) => {
      var _a2;
      if (!this.virtual) return;
      const optionList = options != null ? options : this.filteredOptions.map((option) => {
        return option.label;
      });
      const selectedIndex = this.options.findIndex((option) => {
        var _a3, _b;
        if ("options" in option) {
          return option.options[0].value === ((_a3 = this.selectedOptions[0]) == null ? void 0 : _a3.value);
        }
        return option.value === ((_b = this.selectedOptions[0]) == null ? void 0 : _b.value);
      });
      const virtualListInPopup = (_a2 = this.popupElement) == null ? void 0 : _a2.querySelector(
        "nine-virtual-list"
      );
      if (virtualListInPopup) {
        virtualListInPopup.activeIndex = selectedIndex;
        virtualListInPopup.items = optionList;
        virtualListInPopup.height = this.virtualMaxHeight;
      }
    };
    this.renderNoResults = () => {
      if (this.filteredOptions.length !== 0) return "";
      return html76`
            <div class="no-results">${this.noResultsText}</div>`;
    };
    this.renderCustomOption = (option) => {
      const isSelected = this.selectedOptions.some(
        (selected) => selected.value === option.value
      );
      return html76`
            <li
                    role="option"
                    class="option"
                    data-value=${option.value}
                    ?aria-selected=${isSelected}
                    title=${option.label}
            >
                ${option.label}
            </li>`;
    };
    this.renderCustomSelect = () => {
      if (!this.open) return "";
      if (this.virtual) {
        return html76`
                <nine-virtual-list></nine-virtual-list>`;
      }
      if (!this.nativeSelect) {
        return html76`
                <div class="select">
                    <ul role="listbox" tabindex="-1" class="options">
                        ${this.filteredOptions.map((option) => {
          if ("options" in option) {
            return html76`
                                    <li role="group" class="group">
                                        <div class="label">${option.label}</div>
                                        <ul role="group" class="group">
                                            ${option.options.map((opt) => {
              return this.renderCustomOption(opt);
            })}
                                        </ul>
                                    </li>`;
          } else {
            return this.renderCustomOption(option);
          }
        })}
                    </ul>
                </div>
            `;
      }
      return "";
    };
  }
  get virtual() {
    return !this.disableVirtual;
  }
  connectedCallback() {
    super.connectedCallback();
    this.updateOptionList();
    this.addEventListeners();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListeners();
    this.destroyPopup();
  }
  addEventListeners() {
    window.addEventListener("resize", this.updatePopupPosition);
    this.addPositionUpdateInterval();
    getConfig().mainScrollTarget.addEventListener(
      "scroll",
      this.updatePopupPosition
    );
  }
  removeEventListeners() {
    window.removeEventListener("resize", this.updatePopupPosition);
    this.removePositionUpdateInterval();
    getConfig().mainScrollTarget.removeEventListener(
      "scroll",
      this.updatePopupPosition
    );
  }
  platformSpecificAdaptations() {
    let useNativeSelect = false;
    if (this.isProblematicEnvironment()) {
      useNativeSelect = true;
    }
    if (useNativeSelect) {
      this.nativeSelect = true;
    }
  }
  addPositionUpdateInterval() {
    this.positionUpdateInterval = window.setInterval(
      this.updatePopupPosition,
      300
    );
  }
  removePositionUpdateInterval() {
    if (this.positionUpdateInterval) {
      window.clearInterval(this.positionUpdateInterval);
    }
  }
  updated(_changedProperties) {
    if (_changedProperties.has("nativeSelect") || _changedProperties.has("open")) {
      if (!this.nativeSelect && this.open) {
        this.createPopup();
        this.updatePopupContent();
        this.updatePopupPosition();
      } else {
        this.destroyPopup();
      }
    }
    if (_changedProperties.has("filteredOptions") || _changedProperties.has("selectedOptions")) {
      this.updatePopupContent();
    }
    if (_changedProperties.has("selectedOptions")) {
      this.dispatchSelectedOptionsChangeEvent();
    }
    if (_changedProperties.has("loading")) {
      this.updateLoadingState();
    }
    if (_changedProperties.has("initialValue")) {
      this.handleValuePropChange();
    }
  }
  firstUpdated() {
    this.handleValuePropChange();
    this.platformSpecificAdaptations();
  }
  renderNativeSelect() {
    var _a2, _b;
    if (this.nativeSelect) {
      const selectedValue = (_b = (_a2 = this.selectedOptions[0]) == null ? void 0 : _a2.value) != null ? _b : "";
      return html76`<select
                    class="native-select"
                    @change=${this.handleNativeSelectChange}
            >
                ${// add empty option if no value is selected
      // this will prevent the first option from being selected by default
      !selectedValue ? html76`<option value=""></option>` : html76``}
                ${this.options.map((option) => {
        if ("options" in option) {
          return html76`
                            <optgroup label=${option.label}>
                                ${option.options.map((opt) => {
            return html76`
                                        <option
                                                value=${opt.value}
                                                ?selected=${opt.value === selectedValue}
                                        >
                                            ${opt.label}
                                        </option>`;
          })}
                            </optgroup>`;
        } else {
          return html76`
                            <option
                                    value=${option.value}
                                    ?selected=${option.value === selectedValue}
                            >
                                ${option.label}
                            </option>`;
        }
      })}
            </select>`;
    }
    return "";
  }
  render() {
    return html76`
            <div>
                ${this.renderNativeSelect()}
                <div ${ref17(this.customSelectRef)} style="display: none">
                    ${this.renderNoResults()} ${this.renderCustomSelect()}
                </div>
            </div>
        `;
  }
};
NineSelectMenu.styles = unsafeCSS19(select_menu_default);
__decorateClass([
  property59({ type: Boolean, attribute: "native-select", reflect: true })
], NineSelectMenu.prototype, "nativeSelect", 2);
__decorateClass([
  property59({ type: String, attribute: "no-results-text" })
], NineSelectMenu.prototype, "noResultsText", 2);
__decorateClass([
  property59({ type: String, attribute: "initial-value" })
], NineSelectMenu.prototype, "initialValue", 2);
__decorateClass([
  property59({ type: Boolean, attribute: "use-popover" })
], NineSelectMenu.prototype, "usePopover", 2);
__decorateClass([
  property59({ type: Boolean, attribute: "open" })
], NineSelectMenu.prototype, "open", 2);
__decorateClass([
  property59({ type: Boolean })
], NineSelectMenu.prototype, "loading", 2);
__decorateClass([
  property59({ type: Boolean, attribute: "disable-problematic-device-check" })
], NineSelectMenu.prototype, "disableProblematicDeviceCheck", 2);
__decorateClass([
  property59({ type: Boolean, attribute: "disable-virtual" })
], NineSelectMenu.prototype, "disableVirtual", 2);
__decorateClass([
  property59({ type: Array })
], NineSelectMenu.prototype, "filteredOptions", 2);
__decorateClass([
  property59({ type: Array })
], NineSelectMenu.prototype, "selectedOptions", 2);

// src/components/select-menu/select-menu.ts
var select_menu_default2 = NineSelectMenu;
NineSelectMenu.define("nine-select-menu");

// src/components/side-step-row/side-step-row.component.ts
import { css as css100, html as html77 } from "lit";
import { property as property60, queryAssignedNodes as queryAssignedNodes7 } from "lit/decorators.js";
var NineSideStepRow = class extends NineElement {
  constructor() {
    super(...arguments);
    this.scrollMobile = "true";
    this.imageCenter = "false";
    this.imageHeight = "100%";
    this.gap = "lg";
  }
  firstUpdated() {
    setTimeout(() => {
      var _a2;
      const items = (_a2 = this._rightNodes[0]) == null ? void 0 : _a2.children;
      if (items) {
        [...items].forEach((item) => {
          var _a3, _b;
          (_b = (_a3 = this.shadowRoot) == null ? void 0 : _a3.querySelector("div[slot='items']")) == null ? void 0 : _b.appendChild(item.cloneNode(true));
        });
      }
    }, 10);
  }
  render() {
    return html77`
      <div
        class="step"
        scroll-mobile="${this.scrollMobile}"
        image-center="${this.imageCenter}"
        style="
          --gap: var(--space-${this.gap});
          --image-height: ${this.imageHeight};
        "
      >
        <div class="flex">
          <slot name="left"></slot>
          <slot name="image"></slot>
          <slot name="right"></slot>

          <nine-scrolling class="scroller" fade="false">
            <div slot="items"></div>
          </nine-scrolling>
        </div>
      </div>
    `;
  }
};
NineSideStepRow.styles = css100`
    :host {
      display: block;
    }

    :host(:not(:last-child)) .step {
      padding-bottom: var(--space-xl);
    }

    .flex {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: var(--gap);
    }

    [scroll-mobile="true"] ::slotted([slot="right"]) {
      display: none;
    }

    .scroller {
      margin-top: calc(-1 * var(--space-sm));
      margin-bottom: -77px;
      margin-left: calc(-2 * var(--space-sm) * 1.5);
      margin-right: calc(-1 * var(--space-sm) * 1.5);
      --scroller-pad-left: calc(var(--space-sm) * 3);
    }

    [scroll-mobile="false"] .scroller {
      display: none;
    }

    ::slotted([slot="image"]) {
      display: none;
      max-width: 204px;
      height: var(--image-height);
      border-radius: 8px;
    }

    [image-center="true"] ::slotted([slot="image"]) {
      align-self: center;
    }

    .step {
      padding-left: calc(var(--space-sm) * 1.5);
      position: relative;
      height: 100%;
    }

    .step::before {
      content: "";
      position: absolute;
      top: 8px;
      left: 0;
      width: 8px;
      height: 100%;
      border-radius: 4px;
      background: var(--color-gray-lighter);
    }

    :host(:last-of-type) .step::before {
      background: linear-gradient(
        180deg,
        #e6e3db 79.17%,
        rgba(230, 227, 219, 0) 100%
      );
    }

    .step::after {
      content: "";
      position: absolute;
      top: 4px;
      left: -4px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      border: 4px solid var(--color-cream);
      background: var(--color-gray-lighter);
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      :host(:not(:last-child)) .step {
        padding-bottom: calc(var(--space-sm) * 5);
      }

      .flex {
        flex-direction: row;
      }

      .scroller {
        display: none;
      }

      ::slotted([slot="left"]) {
        width: 100%;
        max-width: calc(204px - var(--space-sm) * 1.875);
      }

      [scroll-mobile="true"] ::slotted([slot="right"]) {
        display: block;
      }

      ::slotted([slot="image"]) {
        display: block;
      }

      .step {
        padding-left: calc(var(--space-sm) * 1.875);
      }
    }
  `;
__decorateClass([
  property60({ type: String, attribute: "scroll-mobile" })
], NineSideStepRow.prototype, "scrollMobile", 2);
__decorateClass([
  property60({ type: String, attribute: "image-center" })
], NineSideStepRow.prototype, "imageCenter", 2);
__decorateClass([
  property60({ type: String, attribute: "image-height" })
], NineSideStepRow.prototype, "imageHeight", 2);
__decorateClass([
  property60({ type: String })
], NineSideStepRow.prototype, "gap", 2);
__decorateClass([
  queryAssignedNodes7({ slot: "right", flatten: true })
], NineSideStepRow.prototype, "_rightNodes", 2);

// src/components/side-step-row/side-step-row.ts
var side_step_row_default = NineSideStepRow;
NineSideStepRow.define("nine-side-step-row");

// src/components/slider/slider.component.ts
import { html as html78, unsafeCSS as unsafeCSS20 } from "lit";
import { property as property61 } from "lit/decorators.js";

// src/components/slider/slider.scss?inline
import { css as css101 } from "lit-element/lit-element.js";
var slider_default = css101`:host {
  width: 100%;
}

input[type=range] {
  -webkit-appearance: none;
  margin: 20px 0 0 0;
  width: 100%;
  border-radius: 8px;
  outline: none;
  width: 100%;
  height: 10px;
  cursor: pointer;
  box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  background: var(--sunrise-horizontal-regular, linear-gradient(90deg, #80aeff 10%, #f7bde6 33%, #ffbd70 60%, var(--color-cream-dark) 50%, var(--color-cream-dark) 100%));
  border-radius: 25px;
  border: 0px solid #000101;
}

input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-thumb {
  box-shadow: 0px 0px 0px 0px rgba(69, 49, 22, 0.08), -5px 5px 16px 0px rgba(69, 49, 22, 0.08), -20px 20px 29px 0px rgba(69, 49, 22, 0.07), -46px 45px 39px 0px rgba(69, 49, 22, 0.03), -82px 81px 46px 0px rgba(69, 49, 22, 0.01);
  height: 24px;
  width: 24px;
  border-radius: 99%;
  background: white;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -3px;
}

input[type=range]::-moz-range-thumb {
  box-shadow: 0px 0px 0px 0px rgba(69, 49, 22, 0.08), -5px 5px 16px 0px rgba(69, 49, 22, 0.08), -20px 20px 29px 0px rgba(69, 49, 22, 0.07), -46px 45px 39px 0px rgba(69, 49, 22, 0.03), -82px 81px 46px 0px rgba(69, 49, 22, 0.01);
  height: 24px;
  width: 24px;
  border-color: white;
  border-radius: 99%;
  background: white;
  cursor: pointer;
  margin-top: -3px;
}

input[type=range]::-webkit-slider-thumb:hover {
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), -3px 3px 9px 0px rgba(0, 0, 0, 0.2), -13px 11px 17px 0px rgba(0, 0, 0, 0.17), -28px 24px 22px 0px rgba(0, 0, 0, 0.1), -50px 43px 26px 0px rgba(0, 0, 0, 0.03), -79px 67px 29px 0px rgba(0, 0, 0, 0);
}

input[type=range]::-moz-range-thumb:hover {
  border-color: white;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), -3px 3px 9px 0px rgba(0, 0, 0, 0.2), -13px 11px 17px 0px rgba(0, 0, 0, 0.17), -28px 24px 22px 0px rgba(0, 0, 0, 0.1), -50px 43px 26px 0px rgba(0, 0, 0, 0.03), -79px 67px 29px 0px rgba(0, 0, 0, 0);
}`;

// src/components/slider/slider.component.ts
var NineSlider = class extends NineElement {
  constructor() {
    super(...arguments);
    this.label = "";
    this.value = "";
    this.min = "";
    this.max = "";
    this.gradient = "";
  }
  updated(changedProperties) {
    if (changedProperties.has("value")) {
      this.dispatchEvent(new CustomEvent(NineInput.customEvents.change, { detail: this.value }));
      this.updateGradient();
    }
  }
  firstUpdated() {
    var _a2;
    this.updateGradient();
    const inputElement = (_a2 = this.shadowRoot) == null ? void 0 : _a2.getElementById("myinput");
    inputElement == null ? void 0 : inputElement.addEventListener("input", () => {
      this.value = inputElement.value;
      this.updateGradient();
    });
  }
  updateGradient() {
    const gradientValue = (parseInt(this.value) - parseInt(this.min)) / (parseInt(this.max) - parseInt(this.min)) * 100;
    this.gradient = `
      linear-gradient(to right,
        #80aeff 0%, 
        #80aeff ${Math.min(gradientValue, 20)}%, 
        #f7bde6 ${Math.min(gradientValue, 65)}%, 
        #ffbd70 ${Math.min(gradientValue, 95)}%, 
        var(--color-cream-dark) ${Math.min(gradientValue, 100)}%
      )`;
  }
  handleInput(event) {
    const inputElement = event.target;
    this.value = inputElement.value;
  }
  render() {
    return html78`<div>
      <div class="container">
        <label>${this.label}</label>
        <input
          id="myinput"
          type="range"
          min="${this.min}"
          max="${this.max}"
          .value="${this.value}"
          @input="${this.handleInput}"
          class="slider"
          style="background: ${this.gradient}"
        />
      </div>
    </div>`;
  }
};
NineSlider.styles = unsafeCSS20(slider_default);
__decorateClass([
  property61({ type: String })
], NineSlider.prototype, "label", 2);
__decorateClass([
  property61({ type: Number })
], NineSlider.prototype, "value", 2);
__decorateClass([
  property61({ type: Number })
], NineSlider.prototype, "min", 2);
__decorateClass([
  property61({ type: Number })
], NineSlider.prototype, "max", 2);
__decorateClass([
  property61({ type: String })
], NineSlider.prototype, "gradient", 2);

// src/components/slider/slider.ts
var slider_default2 = NineSlider;
NineSlider.define("nine-slider");

// src/components/slider-with-input/slider-with-input.component.ts
import { html as html79, unsafeCSS as unsafeCSS21 } from "lit";
import { property as property62 } from "lit/decorators.js";

// src/components/slider-with-input/slider-with-input.scss?inline
import { css as css102 } from "lit-element/lit-element.js";
var slider_with_input_default = css102`:host {
  display: block;
}

label {
  font-weight: 500;
}

.slider {
  margin-top: 100px;
}

.text {
  margin-top: 200px;
}

.numericInputWrapper {
  margin-top: calc(var(--space-md) * 1.075);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.numericInput {
  width: 105px;
}`;

// src/components/slider-with-input/slider-with-input.component.ts
var NineSliderWithInput = class extends NineElement {
  constructor() {
    super(...arguments);
    this.value = 0;
    this.min = "";
    this.max = "";
    this.label = "";
    this.changeHandler = () => {
    };
    this.checked = false;
  }
  handleInputChange(event) {
    var _a2;
    const inputElement = (_a2 = this.shadowRoot) == null ? void 0 : _a2.getElementById("input");
    const numericValue = parseInt(event.target.value.replace(/,/g, ""));
    if (!isNaN(numericValue) && numericValue > 0) {
      const limitedValue = Math.min(numericValue, 25e4);
      inputElement.setValue(limitedValue.toLocaleString("en-US"));
      this.value = limitedValue;
      this.changeHandler(this.value);
    } else {
      inputElement.setValue("");
      this.value = 1;
      this.changeHandler(this.value);
    }
  }
  handleCheckboxCheckedChanged(event) {
    this.checked = event.detail.checked;
    this.dispatchEvent(new CustomEvent("change", { detail: event.detail.checked }));
  }
  render() {
    return html79`
      <div class="numericInputWrapper">
        <label for="input">${this.label}</label>
        <nine-input
          id="input"
          class="numericInput"
          type="tel"
          .value="${this.value.toLocaleString("en-US")}"
          @input="${this.handleInputChange}"
        ></nine-input>
      </div>
      <nine-slider
        class="slider"
        min="${this.min}"
        max="${this.max}"
        .value="${this.value}"
        @input="${this.handleInputChange}"
      ></nine-slider>
      <nine-answer-item
        @change=${this.handleCheckboxCheckedChanged}
        value="medication"
        name="medication"
        type="checkbox"
        center="false"
        styling="false"
      >
        <slot name="medicationCheckbox"></slot>
      </nine-answer-item>
    `;
  }
};
NineSliderWithInput.styles = unsafeCSS21(slider_with_input_default);
__decorateClass([
  property62({ type: Number })
], NineSliderWithInput.prototype, "value", 2);
__decorateClass([
  property62({ type: Number })
], NineSliderWithInput.prototype, "min", 2);
__decorateClass([
  property62({ type: Number })
], NineSliderWithInput.prototype, "max", 2);
__decorateClass([
  property62({ type: String })
], NineSliderWithInput.prototype, "label", 2);
__decorateClass([
  property62({ type: Function })
], NineSliderWithInput.prototype, "changeHandler", 2);
__decorateClass([
  property62({ type: Boolean })
], NineSliderWithInput.prototype, "checked", 2);

// src/components/slider-with-input/slider-with-input.ts
var slider_with_input_default2 = NineSliderWithInput;
NineSliderWithInput.define("nine-slider-with-input");

// src/components/spacer/spacer.component.ts
import { css as css103, html as html80 } from "lit";
import { property as property63 } from "lit/decorators.js";
var NineSpacer = class extends NineElement {
  constructor() {
    super(...arguments);
    this.s = "lg";
    this.dir = "y";
  }
  render() {
    return html80`
      <div
        class="spacer"
        style="--size: var(--space-${this.s})"
        s="${this.s}"
        dir="${this.dir}"
      ></div>
    `;
  }
};
NineSpacer.styles = css103`
    :host {
      display: block;
    }

    :host([dir="x"]) {
      display: inline-block;
    }

    .spacer[dir="y"] {
      height: var(--size);
    }
    .spacer[dir="x"] {
      width: var(--size);
    }
  `;
__decorateClass([
  property63({ type: String })
], NineSpacer.prototype, "s", 2);
__decorateClass([
  property63({ type: String })
], NineSpacer.prototype, "dir", 2);

// src/components/spacer/spacer.ts
var spacer_default = NineSpacer;
NineSpacer.define("nine-spacer");

// src/components/stat-item/stat-item.component.ts
import { html as html81, nothing as nothing2, unsafeCSS as unsafeCSS22 } from "lit";
import { property as property64 } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/components/stat-item/stat-item.global.scss?inline
import { css as css104 } from "lit-element/lit-element.js";
var stat_item_global_default = css104`nine-stat-item [slot=title] * {
  margin: calc(var(--space-sm) * 0.625) 0 calc(var(--space-sm) * 0.75);
}
nine-stat-item [slot=text] * {
  margin: 0;
  color: var(--color-charcoal-80);
}

nine-stat-item[variant=card] [slot=title] * {
  margin: 0;
}
@media screen and (max-width: 960px) {
  nine-stat-item[variant=card] [slot=title] * {
    font-size: calc(var(--space-sm) * 1.125);
  }
}
nine-stat-item[variant=card] [slot=text] * {
  font-size: calc(var(--sm-scale) * 0.88);
}`;

// src/components/stat-item/stat-item.scss?inline
import { css as css105 } from "lit-element/lit-element.js";
var stat_item_default = css105`:host {
  display: block;
  text-align: center;
  width: 100%;
  max-width: 450px;
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: var(--space-lg) var(--space-sm);
}

.value-wrapper {
  display: flex;
  align-items: baseline;
  font-weight: 300;
  line-height: 120%;
  letter-spacing: -0.02em;
  font-family: "STK Bureau Serif", serif;
}

::slotted([slot=value]) {
  font-size: calc(var(--space-sm) * 3.125);
}

::slotted([slot=unit]) {
  font-size: calc(var(--space-sm) * 1.5);
}

::slotted([slot=title]),
::slotted([slot=text]) {
  text-wrap: balance;
  max-width: 100%;
}

.icon-left .icon {
  margin-right: 0.25rem;
}

.icon-right .icon {
  margin-left: 0.25rem;
}

.arrow-down {
  transform: translateY(0.25rem);
}

.arrow-down-right {
  transform: rotate(-45deg) translateY(0.625rem) scale(0.75);
}

.icon-right .arrow-down-right {
  margin-left: -0.25rem;
}

.arrow-down-left {
  transform: rotate(45deg) translateY(0.625rem) scale(0.75);
}

.icon-left .arrow-down-left {
  margin-right: -0.25rem;
}

.arrow-up {
  transform: rotate(180deg) translateY(0.25rem);
}

/* Card variant */
:host([variant=card]) {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: var(--light-shadow);
  width: 215px;
  overflow: hidden;
}
:host([variant=card]) ::slotted([slot=title]) {
  font-size: var(--font-size-h5);
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.02em;
}
:host([variant=card]) ::slotted([slot=text]) {
  font-size: calc(var(--sm-scale) * 0.88);
  line-height: 140%;
  letter-spacing: -0.02em;
}
:host([variant=card]) .flex {
  padding: 0;
}
:host([variant=card]) .title {
  order: -1;
  padding: var(--space-sm) var(--space-sm) calc(var(--space-sm) * 0.75);
  width: 100%;
  box-sizing: border-box;
}
:host([variant=card]) .title[background=sunrise] {
  background: linear-gradient(223deg, #ffdfb4 0%, #fddee9 51.56%, #c1d7fb 100%);
}
:host([variant=card]) .title[background=midmorning] {
  background: linear-gradient(74deg, #ffeff9 -12%, #cfe0fc 14.51%, #abd4ff 51.9%, #d2e7fa 76.37%, #fffcf3 103.75%);
}
:host([variant=card]) .title[background=afternoon] {
  background: linear-gradient(255deg, #fffcf3 -3.78%, #b0f2ce 49.72%, #ffefc7 116.61%);
}
:host([variant=card]) .title[background=goldenhour] {
  background: linear-gradient(255deg, #fffdf4 -11.17%, #fbdef3 60.28%, #ffdeb8 106.8%);
}
:host([variant=card]) .value-wrapper {
  padding: var(--space-lg) var(--space-xs) var(--space-xs);
  gap: calc(var(--space-sm) * 0.125);
}
:host([variant=card]) .text {
  padding: calc(var(--space-sm) * 0.25) var(--space-xs) calc(var(--space-sm) * 1.25);
}
@media screen and (max-width: 960px) {
  :host([variant=card]) {
    width: 100%;
    max-width: 450px;
  }
  :host([variant=card]) .flex {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  :host([variant=card]) .title {
    grid-row: span 2;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  :host([variant=card]) .value-wrapper {
    padding-top: var(--space-md);
    padding-bottom: calc(var(--space-sm) * 0.25);
  }
  :host([variant=card]) .text {
    padding-bottom: var(--space-sm);
  }
  :host([variant=card]) .value-wrapper,
  :host([variant=card]) .text {
    display: flex;
    justify-content: center;
  }
  :host([variant=card]) ::slotted([slot=value]) {
    font-size: calc(var(--space-sm) * 1.75);
  }
  :host([variant=card]) ::slotted([slot=unit]) {
    font-size: calc(var(--space-sm) * 0.88);
  }
  :host([variant=card]) .icon-left .icon {
    margin-right: 0;
  }
  :host([variant=card]) .icon-right .icon {
    margin-left: 0;
  }
  :host([variant=card]) .arrow-down {
    transform: translateY(0.5rem) scale(0.75);
  }
  :host([variant=card]) .arrow-down-right {
    transform: rotate(-45deg) translateY(0.875rem) scale(0.5);
  }
  :host([variant=card]) .icon-right .arrow-down-right {
    margin-left: -1rem;
  }
  :host([variant=card]) .arrow-down-left {
    transform: rotate(45deg) translateY(0.875rem) scale(0.5);
  }
  :host([variant=card]) .icon-left .arrow-down-left {
    margin-right: -1rem;
  }
  :host([variant=card]) .arrow-up {
    transform: rotate(180deg) translateY(-0.25rem) scale(0.75);
  }
}`;

// src/components/stat-item/stat-item.component.ts
styleInject_default(stat_item_global_default);
var NineStatItem = class extends NineElement {
  constructor() {
    super(...arguments);
    this.icon = "no-icon";
    this.iconPosition = "right";
    this.variant = "default";
    this.background = "none";
    this.arrowDown = html81`
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="31" fill="none" class="icon arrow-down">
      <path
        fill="var(--icon-gradient, #212121)"
        d="M12 .902c.365 0 .664.117.896.349.244.232.366.531.366.896v21.118l-.15 4.515-.78-.282 5.33-5.794 4.033-3.968c.122-.121.26-.21.415-.265.155-.056.316-.083.482-.083.354 0 .647.116.88.348.232.233.348.526.348.88 0 .343-.133.653-.398.93L12.946 30.022a1.228 1.228 0 0 1-.448.315c-.155.077-.32.116-.498.116-.177 0-.343-.039-.498-.116a1.445 1.445 0 0 1-.448-.316L.562 19.547c-.255-.277-.382-.587-.382-.93 0-.354.116-.647.348-.88.233-.232.526-.348.88-.348.166 0 .327.027.482.083a.973.973 0 0 1 .398.265l4.05 3.968 5.313 5.794-.763.282-.15-4.515V2.147c0-.365.117-.664.349-.896.232-.232.537-.349.913-.349Z"
      />
      <defs>
        <linearGradient
          id="dusk_vertical_gradient"
          x1="11.9927"
          y1="-15.991211"
          x2="11.9927"
          y2="33.0051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8A6947" />
          <stop offset="0.526042" stop-color="#5B4855" />
          <stop offset="1" stop-color="#0E3763" />
        </linearGradient>
      </defs>
    </svg>
  `;
    this.arrowDownRight = html81`
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="31" fill="none" class="icon arrow-down-right">
      <path
        fill="var(--icon-gradient, #212121)"
        d="M12 .902c.365 0 .664.117.896.349.244.232.366.531.366.896v21.118l-.15 4.515-.78-.282 5.33-5.794 4.033-3.968c.122-.121.26-.21.415-.265.155-.056.316-.083.482-.083.354 0 .647.116.88.348.232.233.348.526.348.88 0 .343-.133.653-.398.93L12.946 30.022a1.228 1.228 0 0 1-.448.315c-.155.077-.32.116-.498.116-.177 0-.343-.039-.498-.116a1.445 1.445 0 0 1-.448-.316L.562 19.547c-.255-.277-.382-.587-.382-.93 0-.354.116-.647.348-.88.233-.232.526-.348.88-.348.166 0 .327.027.482.083a.973.973 0 0 1 .398.265l4.05 3.968 5.313 5.794-.763.282-.15-4.515V2.147c0-.365.117-.664.349-.896.232-.232.537-.349.913-.349Z"
      />
      <defs>
        <linearGradient
          id="dusk_vertical_gradient"
          x1="11.9927"
          y1="-15.991211"
          x2="11.9927"
          y2="33.0051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8A6947" />
          <stop offset="0.526042" stop-color="#5B4855" />
          <stop offset="1" stop-color="#0E3763" />
        </linearGradient>
      </defs>
    </svg>
  `;
    this.arrowDownLeft = html81`
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="31" fill="none" class="icon arrow-down-left">
      <path
        fill="var(--icon-gradient, #212121)"
        d="M12 .902c.365 0 .664.117.896.349.244.232.366.531.366.896v21.118l-.15 4.515-.78-.282 5.33-5.794 4.033-3.968c.122-.121.26-.21.415-.265.155-.056.316-.083.482-.083.354 0 .647.116.88.348.232.233.348.526.348.88 0 .343-.133.653-.398.93L12.946 30.022a1.228 1.228 0 0 1-.448.315c-.155.077-.32.116-.498.116-.177 0-.343-.039-.498-.116a1.445 1.445 0 0 1-.448-.316L.562 19.547c-.255-.277-.382-.587-.382-.93 0-.354.116-.647.348-.88.233-.232.526-.348.88-.348.166 0 .327.027.482.083a.973.973 0 0 1 .398.265l4.05 3.968 5.313 5.794-.763.282-.15-4.515V2.147c0-.365.117-.664.349-.896.232-.232.537-.349.913-.349Z"
      />
      <defs>
        <linearGradient
          id="dusk_vertical_gradient"
          x1="11.9927"
          y1="-15.991211"
          x2="11.9927"
          y2="33.0051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8A6947" />
          <stop offset="0.526042" stop-color="#5B4855" />
          <stop offset="1" stop-color="#0E3763" />
        </linearGradient>
      </defs>
    </svg>
  `;
    this.arrowUp = html81`
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="31" fill="none" class="icon arrow-up">
      <path
        fill="var(--icon-gradient, #212121)"
        d="M12 .902c.365 0 .664.117.896.349.244.232.366.531.366.896v21.118l-.15 4.515-.78-.282 5.33-5.794 4.033-3.968c.122-.121.26-.21.415-.265.155-.056.316-.083.482-.083.354 0 .647.116.88.348.232.233.348.526.348.88 0 .343-.133.653-.398.93L12.946 30.022a1.228 1.228 0 0 1-.448.315c-.155.077-.32.116-.498.116-.177 0-.343-.039-.498-.116a1.445 1.445 0 0 1-.448-.316L.562 19.547c-.255-.277-.382-.587-.382-.93 0-.354.116-.647.348-.88.233-.232.526-.348.88-.348.166 0 .327.027.482.083a.973.973 0 0 1 .398.265l4.05 3.968 5.313 5.794-.763.282-.15-4.515V2.147c0-.365.117-.664.349-.896.232-.232.537-.349.913-.349Z"
      />
      <defs>
        <linearGradient
          id="dusk_vertical_gradient"
          x1="11.9927"
          y1="-15.991211"
          x2="11.9927"
          y2="33.0051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8A6947" />
          <stop offset="0.526042" stop-color="#5B4855" />
          <stop offset="1" stop-color="#0E3763" />
        </linearGradient>
      </defs>
    </svg>
  `;
  }
  renderIcon() {
    if (this.icon === "arrow-down") {
      return html81`${this.arrowDown}`;
    }
    if (this.icon === "arrow-down-right") {
      return html81`${this.arrowDownRight}`;
    }
    if (this.icon === "arrow-down-left") {
      return html81`${this.arrowDownLeft}`;
    }
    if (this.icon === "arrow-up") {
      return html81`${this.arrowUp}`;
    }
    return null;
  }
  render() {
    return html81`
      <div class="flex">
        <div
          class="value-wrapper ${classMap({
      "icon-left": this.iconPosition === "left",
      "icon-right": this.iconPosition === "right"
    })}"
        >
          ${this.iconPosition === "left" ? this.renderIcon() : nothing2}
          <slot name="custom-text"></slot>
          <slot name="value"></slot>
          <slot name="unit"></slot>
          ${this.iconPosition === "right" ? this.renderIcon() : nothing2}
        </div>

        <div class="title" background=${this.background}>
          <slot name="title"></slot>
        </div>

        <div class="text">
          <slot name="text"></slot>
        </div>
      </div>
    `;
  }
};
NineStatItem.styles = unsafeCSS22(stat_item_default);
__decorateClass([
  property64({ type: String })
], NineStatItem.prototype, "icon", 2);
__decorateClass([
  property64({ type: String, attribute: "icon-position" })
], NineStatItem.prototype, "iconPosition", 2);
__decorateClass([
  property64({ type: String })
], NineStatItem.prototype, "variant", 2);
__decorateClass([
  property64({ type: String })
], NineStatItem.prototype, "background", 2);

// src/components/stat-item/stat-item.ts
var stat_item_default2 = NineStatItem;
NineStatItem.define("nine-stat-item");

// src/components/statistics/statistics.component.ts
import { css as css106, html as html82 } from "lit";
import { property as property65 } from "lit/decorators.js";
var NineStatistics = class extends NineElement {
  constructor() {
    super(...arguments);
    this.hideBottom = false;
  }
  render() {
    return html82`
      <div class="flex">
        <div class="left">
          <div class="item">
            <slot name="left-large"></slot>
            <slot name="left-small"></slot>
          </div>
          <slot name="left-description"></slot>
        </div>

        <div class="line left-line"></div>
        <slot name="center" class="center"></slot>
        <div class="line right-line"></div>

        <div class="right">
          <div class="item">
            <slot name="right-large"></slot>
            <slot name="right-small"></slot>
          </div>
          <slot name="right-description"></slot>
        </div>
      </div>

      ${this.hideBottom ? "" : html82`<div class="vertical-line"></div>
            <div class="item bottom">
              <slot name="bottom-large"></slot>
              <slot name="bottom-small"></slot>
            </div>
            <slot name="bottom-description"></slot>`}
    `;
  }
};
NineStatistics.styles = css106`
    :host {
      display: block;
      text-align: center;
      width: 100%;
    }

    .flex {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: calc(var(--space-sm) * 0.75);
      margin: 0 auto;
      max-width: var(--section-max-width, var(--page-max-width));
      padding: 0 var(--space-md);
    }

    .item {
      display: flex;
      justify-content: center;
      align-items: baseline;
      gap: var(--space-xs);
    }

    .line {
      position: relative;
      height: 32px;
    }

    .line::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 1px;
      background: var(--color-charcoal);
    }

    .vertical-line {
      position: relative;
      height: 32px;
      margin: calc(var(--space-sm) * 0.75) 0;
    }

    .vertical-line::after {
      content: "";
      position: absolute;
      top: 0;
      height: 100%;
      width: 1px;
      background: var(--color-charcoal);
    }

    .center {
      order: 1;
    }

    .left-line {
      order: 2;
    }

    .left {
      order: 3;
    }

    .right-line {
      order: 4;
    }

    .right {
      order: 5;
    }

    @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
      .flex {
        flex-direction: row;
        justify-content: space-between;
        gap: calc(var(--space-sm) * 1.5);
      }

      .flex * {
        order: 0;
      }

      .line {
        width: 100%;
        max-width: 124px;
        height: unset;
      }

      .line::after {
        width: 100%;
        height: 1px;
      }

      .vertical-line {
        height: 80px;
        margin: calc(var(--space-sm) * 0.5) 0;
      }

      .left {
        text-align: right;
      }
      .left .item {
        justify-content: flex-end;
      }

      .right {
        text-align: left;
      }
      .right .item {
        justify-content: flex-start;
      }
    }
  `;
__decorateClass([
  property65({ type: Boolean, attribute: "hide-bottom" })
], NineStatistics.prototype, "hideBottom", 2);

// src/components/statistics/statistics.ts
var statistics_default = NineStatistics;
NineStatistics.define("nine-statistics");

// src/components/stepper/stepper.component.ts
import { css as css107, html as html83 } from "lit";
import { property as property66 } from "lit/decorators.js";
var NineStepper = class extends NineElement {
  constructor() {
    super(...arguments);
    this.label = "";
    this.name = "";
    this.unit = "";
    this.plural = "";
    this.value = 0;
    this.step = 1;
    this.min = 0;
    this.max = 99;
    this.validate = () => {
      const error = void 0;
      return error;
    };
  }
  dispatchChange() {
    if (this.name) {
      this.dispatchEvent(
        new CustomEvent("nineInputChange", {
          detail: {
            name: this.name,
            value: this.value,
            root: this
          },
          bubbles: true
        })
      );
    }
    this.dispatchEvent(new CustomEvent("change", { detail: this.value }));
  }
  handleClickSubtract(e) {
    e.preventDefault();
    this.value = Math.max(this.value - this.step, this.min);
    this.dispatchChange();
  }
  handleClickAdd(e) {
    e.preventDefault();
    this.value = Math.min(this.value + this.step, this.max);
    this.dispatchChange();
  }
  get disableMin() {
    return this.value <= this.min;
  }
  get disableMax() {
    return this.value >= this.max;
  }
  firstUpdated() {
    if (this.name) {
      this.dispatchEvent(
        new CustomEvent(input_default2.customEvents.register, {
          detail: {
            name: this.name,
            value: this.value,
            root: this
          },
          bubbles: true
        })
      );
    }
  }
  disconnectedCallback() {
    this.dispatchEvent(
      new CustomEvent(input_default2.customEvents.unregister, {
        detail: {
          name: this.name,
          value: this.value,
          root: this
        },
        bubbles: true
      })
    );
  }
  render() {
    return html83`
      <div class="step">
        <div class="label">${this.label}</div>
        <div class="stepper">
          <nine-button
            variant="outline"
            round="true"
            rounded="false"
            arrow=""
            @click="${this.handleClickSubtract}"
            aria-label="${this.label} - subtract"
            disabled="${this.disableMin}"
          >
            <svg
              viewBox="0 0 14 2"
              width="14"
              height="2"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M13.13.52H.95v1h12.18v-1Z" fill="currentColor" />
            </svg>
          </nine-button>

          <div class="info">
            ${this.value}
            <div class="unit">
              ${this.value === 1 ? this.unit : this.plural}
            </div>
          </div>

          <nine-button
            variant="outline"
            round="true"
            rounded="false"
            arrow=""
            @click="${this.handleClickAdd}"
            aria-label="${this.label} - add"
            disabled="${this.disableMax}"
          >
            <svg
              viewBox="0 0 14 14"
              width="14"
              height="14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.13 6.54H7.54V.95h-1v5.6H.95v.99h5.6v5.59h1v-5.6h5.58v-.99Z"
                fill="currentColor"
              />
            </svg>
          </nine-button>
        </div>
      </div>
    `;
  }
};
NineStepper.styles = css107`
    :host {
      display: block;
      width: 100%;
      position: relative;
    }

    .step {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .stepper {
      display: flex;
      align-items: center;
    }

    .label {
      font-weight: 500;
      font-size: 1em;
    }

    .info {
      display: flex;
      width: 5em;
      justify-content: center;
      align-items: center;
      opacity: 0.8;
    }

    .unit {
      margin-left: 0.3em;
    }

    nine-button {
      user-select: none;
    }
  `;
__decorateClass([
  property66({ type: String })
], NineStepper.prototype, "label", 2);
__decorateClass([
  property66({ type: String })
], NineStepper.prototype, "name", 2);
__decorateClass([
  property66({ type: String })
], NineStepper.prototype, "unit", 2);
__decorateClass([
  property66({ type: String })
], NineStepper.prototype, "plural", 2);
__decorateClass([
  property66({ type: Number })
], NineStepper.prototype, "value", 2);
__decorateClass([
  property66({ type: Number })
], NineStepper.prototype, "step", 2);
__decorateClass([
  property66({ type: Number })
], NineStepper.prototype, "min", 2);
__decorateClass([
  property66({ type: Number })
], NineStepper.prototype, "max", 2);

// src/components/stepper/stepper.ts
var stepper_default = NineStepper;
NineStepper.define("nine-stepper");

// src/components/sticky/sticky.component.ts
import { css as css108, html as html84 } from "lit";
import { property as property67 } from "lit/decorators.js";
import { createRef as createRef18, ref as ref18 } from "lit/directives/ref.js";
var NineSticky = class extends NineElement {
  constructor() {
    super();
    this.stickyRef = createRef18();
    this.railRef = createRef18();
    this.text = "";
    this.fromTop = window.innerHeight * 0.2;
    this.breakpoint = 1e3;
    this.setPosition = () => {
      const sticky = this.stickyRef.value;
      const rail = this.railRef.value;
      if (!sticky || !rail) {
        return;
      }
      if (window.innerWidth <= this.breakpoint) {
        sticky.classList.add("relative");
        sticky.style.top = "auto";
        sticky.classList.remove("stuck");
        sticky.classList.remove("bottom");
        return;
      } else {
        sticky.classList.remove("relative");
      }
      const stickyRect = sticky.getBoundingClientRect();
      const railRect = rail.getBoundingClientRect();
      const stickyAtBottomOfRail = railRect.bottom - this.fromTop <= stickyRect.height;
      const scrolledPastRail = railRect.top < this.fromTop;
      if (!stickyAtBottomOfRail && scrolledPastRail) {
        sticky.classList.add("stuck");
        sticky.classList.remove("bottom");
        sticky.style.top = `${this.fromTop}px`;
      } else {
        sticky.classList.remove("stuck");
        sticky.style.top = "auto";
        if (stickyAtBottomOfRail) {
          sticky.classList.add("bottom");
        }
      }
    };
    addScrollListener(this.setPosition);
    window.addEventListener("resize", this.setPosition, { passive: true });
    window.addEventListener("DOMContentLoaded", this.setPosition);
    this.setPosition();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    removeScrollListener(this.setPosition);
    window.removeEventListener("resize", this.setPosition);
  }
  render() {
    return html84`<div class="rail" ${ref18(this.railRef)}>
      <div class="sticky" ${ref18(this.stickyRef)}>
        <slot></slot>
      </div>
    </div> `;
  }
};
NineSticky.styles = css108`
    :host {
      display: block;
      height: 100%;
    }

    .rail {
      display: block;
      height: 100%;
      position: relative;
    }

    .sticky {
      position: absolute;
    }

    .stuck {
      position: fixed;
      top: 0;
    }

    .bottom {
      bottom: 0;
    }

    .relative {
      position: relative;
    }
  `;
__decorateClass([
  property67({ type: String })
], NineSticky.prototype, "text", 2);
__decorateClass([
  property67({ type: Number })
], NineSticky.prototype, "fromTop", 2);
__decorateClass([
  property67({ type: Number })
], NineSticky.prototype, "breakpoint", 2);

// src/components/sticky/sticky.ts
var sticky_default = NineSticky;
NineSticky.define("nine-sticky");

// src/components/switch/switch.component.ts
import { property as property68, query, state } from "lit/decorators.js";
import { html as html85, unsafeCSS as unsafeCSS23 } from "lit";
import { classMap as classMap2 } from "lit/directives/class-map.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { live } from "lit/directives/live.js";

// src/internal/form.ts
var formCollections = /* @__PURE__ */ new WeakMap();
var reportValidityOverloads = /* @__PURE__ */ new WeakMap();
var userInteractedControls = /* @__PURE__ */ new WeakSet();
var interactions = /* @__PURE__ */ new WeakMap();
var FormControlController = class {
  constructor(host, options) {
    this.handleFormData = (event) => {
      const disabled = this.options.disabled(this.host);
      const name = this.options.name(this.host);
      const value = this.options.value(this.host);
      const isButton = this.host.tagName.toLowerCase() === "sl-button";
      if (!disabled && !isButton && typeof name === "string" && name.length > 0 && typeof value !== "undefined") {
        if (Array.isArray(value)) {
          value.forEach((val) => {
            event.formData.append(name, val.toString());
          });
        } else {
          event.formData.append(name, value.toString());
        }
      }
    };
    this.handleFormSubmit = (event) => {
      var _a2;
      const disabled = this.options.disabled(this.host);
      const reportValidity = this.options.reportValidity;
      if (this.form && !this.form.noValidate) {
        (_a2 = formCollections.get(this.form)) == null ? void 0 : _a2.forEach((control) => {
          this.setUserInteracted(control, true);
        });
      }
      if (this.form && !this.form.noValidate && !disabled && !reportValidity(this.host)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    this.handleFormReset = () => {
      this.options.setValue(this.host, this.options.defaultValue(this.host));
      this.setUserInteracted(this.host, false);
      interactions.set(this.host, []);
    };
    this.handleInteraction = (event) => {
      const emittedEvents = interactions.get(this.host);
      if (!emittedEvents.includes(event.type)) {
        emittedEvents.push(event.type);
      }
      if (emittedEvents.length === this.options.assumeInteractionOn.length) {
        this.setUserInteracted(this.host, true);
      }
    };
    this.reportFormValidity = () => {
      if (this.form && !this.form.noValidate) {
        const elements = this.form.querySelectorAll("*");
        for (const element of elements) {
          if (typeof element.reportValidity === "function") {
            if (!element.reportValidity()) {
              return false;
            }
          }
        }
      }
      return true;
    };
    (this.host = host).addController(this);
    this.options = __spreadValues({
      form: (input) => {
        if (input.hasAttribute("form") && input.getAttribute("form") !== "") {
          const root = input.getRootNode();
          const formId = input.getAttribute("form");
          if (formId) {
            return root.getElementById(formId);
          }
        }
        return input.closest("form");
      },
      name: (input) => input.name,
      value: (input) => input.value,
      defaultValue: (input) => input.defaultValue,
      disabled: (input) => {
        var _a2;
        return (_a2 = input.disabled) != null ? _a2 : false;
      },
      reportValidity: (input) => typeof input.reportValidity === "function" ? input.reportValidity() : true,
      setValue: (input, value) => input.value = value,
      assumeInteractionOn: ["sl-input"]
    }, options);
  }
  hostConnected() {
    const form = this.options.form(this.host);
    if (form) {
      this.attachForm(form);
    }
    interactions.set(this.host, []);
    this.options.assumeInteractionOn.forEach((event) => {
      this.host.addEventListener(event, this.handleInteraction);
    });
  }
  hostDisconnected() {
    this.detachForm();
    interactions.delete(this.host);
    this.options.assumeInteractionOn.forEach((event) => {
      this.host.removeEventListener(event, this.handleInteraction);
    });
  }
  hostUpdated() {
    const form = this.options.form(this.host);
    if (!form) {
      this.detachForm();
    }
    if (form && this.form !== form) {
      this.detachForm();
      this.attachForm(form);
    }
    if (this.host.hasUpdated) {
      this.setValidity(this.host.validity.valid);
    }
  }
  /** Returns the associated `<form>` element, if one exists. */
  getForm() {
    var _a2;
    return (_a2 = this.form) != null ? _a2 : null;
  }
  /** Resets the form, restoring all the control to their default value */
  reset(submitter) {
    this.doAction("reset", submitter);
  }
  /** Submits the form, triggering validation and form data injection. */
  submit(submitter) {
    this.doAction("submit", submitter);
  }
  /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */
  setValidity(isValid) {
    const host = this.host;
    const hasInteracted = Boolean(userInteractedControls.has(host));
    const required = Boolean(host.required);
    host.toggleAttribute("data-required", required);
    host.toggleAttribute("data-optional", !required);
    host.toggleAttribute("data-invalid", !isValid);
    host.toggleAttribute("data-valid", isValid);
    host.toggleAttribute("data-user-invalid", !isValid && hasInteracted);
    host.toggleAttribute("data-user-valid", isValid && hasInteracted);
  }
  /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */
  updateValidity() {
    const host = this.host;
    this.setValidity(host.validity.valid);
  }
  /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */
  emitInvalidEvent(originalInvalidEvent) {
    const slInvalidEvent = new CustomEvent("sl-invalid", {
      bubbles: false,
      composed: false,
      cancelable: true,
      detail: {}
    });
    if (!originalInvalidEvent) {
      slInvalidEvent.preventDefault();
    }
    if (!this.host.dispatchEvent(slInvalidEvent)) {
      originalInvalidEvent == null ? void 0 : originalInvalidEvent.preventDefault();
    }
  }
  attachForm(form) {
    if (form) {
      this.form = form;
      if (formCollections.has(this.form)) {
        formCollections.get(this.form).add(this.host);
      } else {
        formCollections.set(this.form, /* @__PURE__ */ new Set([this.host]));
      }
      this.form.addEventListener("formdata", this.handleFormData);
      this.form.addEventListener("submit", this.handleFormSubmit);
      this.form.addEventListener("reset", this.handleFormReset);
      if (!reportValidityOverloads.has(this.form)) {
        reportValidityOverloads.set(this.form, this.form.reportValidity);
        this.form.reportValidity = () => this.reportFormValidity();
      }
    } else {
      this.form = void 0;
    }
  }
  detachForm() {
    var _a2;
    if (this.form) {
      (_a2 = formCollections.get(this.form)) == null ? void 0 : _a2.delete(this.host);
      this.form.removeEventListener("formdata", this.handleFormData);
      this.form.removeEventListener("submit", this.handleFormSubmit);
      this.form.removeEventListener("reset", this.handleFormReset);
      if (reportValidityOverloads.has(this.form)) {
        this.form.reportValidity = reportValidityOverloads.get(this.form);
        reportValidityOverloads.delete(this.form);
      }
    }
    this.form = void 0;
  }
  setUserInteracted(el, hasInteracted) {
    if (hasInteracted) {
      userInteractedControls.add(el);
    } else {
      userInteractedControls.delete(el);
    }
    el.requestUpdate();
  }
  doAction(type, submitter) {
    if (this.form) {
      const button = document.createElement("button");
      button.type = type;
      button.style.position = "absolute";
      button.style.width = "0";
      button.style.height = "0";
      button.style.clipPath = "inset(50%)";
      button.style.overflow = "hidden";
      button.style.whiteSpace = "nowrap";
      if (submitter) {
        button.name = submitter.name;
        button.value = submitter.value;
        ["formaction", "formenctype", "formmethod", "formnovalidate", "formtarget"].forEach((attr) => {
          if (submitter.hasAttribute(attr)) {
            button.setAttribute(attr, submitter.getAttribute(attr));
          }
        });
      }
      this.form.append(button);
      button.click();
      button.remove();
    }
  }
};
var validValidityState = Object.freeze({
  badInput: false,
  customError: false,
  patternMismatch: false,
  rangeOverflow: false,
  rangeUnderflow: false,
  stepMismatch: false,
  tooLong: false,
  tooShort: false,
  typeMismatch: false,
  valid: true,
  valueMissing: false
});
var valueMissingValidityState = Object.freeze(__spreadProps(__spreadValues({}, validValidityState), {
  valid: false,
  valueMissing: true
}));
var customErrorValidityState = Object.freeze(__spreadProps(__spreadValues({}, validValidityState), {
  valid: false,
  customError: true
}));

// src/internal/default-value.ts
import { defaultConverter } from "lit";
var defaultValue = (propertyName = "value") => (proto, key) => {
  const ctor = proto.constructor;
  const attributeChangedCallback = ctor.prototype.attributeChangedCallback;
  ctor.prototype.attributeChangedCallback = function(name, old, value) {
    var _a2;
    const options = ctor.getPropertyOptions(propertyName);
    const attributeName = typeof options.attribute === "string" ? options.attribute : propertyName;
    if (name === attributeName) {
      const converter = options.converter || defaultConverter;
      const fromAttribute = typeof converter === "function" ? converter : (_a2 = converter == null ? void 0 : converter.fromAttribute) != null ? _a2 : defaultConverter.fromAttribute;
      const newValue = fromAttribute(value, options.type);
      if (this[propertyName] !== newValue) {
        this[key] = newValue;
      }
    }
    attributeChangedCallback.call(this, name, old, value);
  };
};

// src/components/switch/switch.scss?inline
import { css as css109 } from "lit-element/lit-element.js";
var switch_default = css109`:host {
  box-sizing: border-box;
  display: inline-block;
  --height: 1.3rem;
  --thumb-size: calc(var(--height) + 4px);
  --width: calc(var(--height) * 2);
  --main-color: #fff;
  --hl-color: #746E74;
  --line-color: #9e9e9e;
  --border-color: #9e9e9e;
  --focus-ring: 0 0 0 2px #2196f3;
  --focus-ring-offset: 2px;
  --input-required-content: "*";
  --input-required-content-offset: 0.25em;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
:host[hidden] {
  display: none !important;
}

.switch {
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.02em;
  margin: 0.8em 0;
  position: relative;
  display: inline-flex;
  align-items: center;
  font-size: inherit;
  color: var(--label-color, #000);
  vertical-align: middle;
  cursor: pointer;
}

.control {
  flex: 0 0 auto;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--width);
  height: var(--height);
  background-color: var(--hl-color);
  border: solid var(--border-color) var(--hl-color);
  border-radius: var(--height);
  transition: 0.2s border-color, 0.3s background;
}

.control .thumb {
  width: var(--thumb-size);
  height: var(--thumb-size);
  background-color: var(--main-color);
  border-radius: 50%;
  border: solid var(--border-color) var(--hl-color);
  translate: calc((var(--width) - var(--height)) / -2);
  transition: 0.2s translate ease, 0.2s background-color, 0.2s border-color, 0.2s box-shadow;
  position: relative;
}
.control .thumb::after, .control .thumb::before {
  position: absolute;
  content: "";
  inset: 0;
  border-radius: 50%;
  background: white;
}
.control .thumb::before {
  box-shadow: -0.2rem 0.2rem 0.2rem rgba(51, 51, 51, 0.25);
  transform: scale(1);
  transition: 0.1s background-color, 0.1s transform, 0.1s box-shadow;
}

.input {
  position: absolute;
  opacity: 0;
  padding: 0;
  margin: 0;
  pointer-events: none;
}

/* Focus */
.switch:not(.is-checked):not(.is-disabled).has-focus .control {
  background-color: var(--hl-color);
  border-color: var(--hl-color);
}
.switch:not(.is-checked):not(.is-disabled).has-focus .control .thumb {
  background-color: var(--main-color);
  border-color: var(--hl-color);
}
.switch:not(.is-checked):not(.is-disabled).has-focus .control .thumb::before {
  background-color: rgba(0, 0, 0, 0.1333333333);
  box-shadow: -0.1rem 0.1rem 0.1rem rgba(51, 51, 51, 0.2);
  transform: scale(1.8);
}

.switch:not(.is-checked):not(.is-disabled) .input:focus ~ .control .thumb {
  background-color: var(--main-color);
  border-color: var(--line-color);
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

/* Checked */
.is-checked .control {
  background-color: var(--line-color);
  background-image: var(--gradient-sunrise);
  border-color: var(--line-color);
}

.is-checked .control .thumb {
  background-color: var(--main-color);
  border-color: var(--line-color);
  translate: calc((var(--width) - var(--height)) / 2);
}

/* Checked + focus */
.switch.is-checked:not(.is-disabled).has-focus .control {
  background-color: var(--line-color);
  border-color: var(--line-color);
}
.switch.is-checked:not(.is-disabled).has-focus .control .thumb::before {
  background-color: rgba(171, 212, 255, 0.4);
  box-shadow: -0.1rem 0.1rem 0.1rem rgba(51, 51, 51, 0.2);
  transform: scale(1.8);
}

.switch.is-checked:not(.is-disabled) .input:focus ~ .control .thumb {
  background-color: var(--main-color);
  border-color: var(--line-color);
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

/* Disabled */
.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.switch__label {
  display: inline-block;
  line-height: var(--height);
  margin-inline-start: 0.5em;
  user-select: none;
}

:host([required]) .switch__label::after {
  content: var(--input-required-content);
  margin-inline-start: var(--input-required-content-offset);
}

@media (forced-colors: active) {
  .switch.is-checked:not(.is-disabled) .control:hover .thumb,
  .is-checked .control .thumb {
    background-color: ButtonText;
  }
}
@media (hover: hover) {
  .switch:not(.is-checked):not(.is-disabled) .control:hover {
    background-color: var(--hl-color);
    border-color: var(--hl-color);
  }
  .switch:not(.is-checked):not(.is-disabled) .control:hover .thumb {
    background-color: var(--main-color);
    border-color: var(--hl-color);
  }
  .switch:not(.is-checked):not(.is-disabled) .control:hover .thumb::before {
    background-color: rgba(0, 0, 0, 0.1333333333);
    box-shadow: -0.1rem 0.1rem 0.1rem rgba(51, 51, 51, 0.2);
    transform: scale(1.8);
  }
  .switch.is-checked:not(.is-disabled) .control:hover {
    background-color: var(--line-color);
    border-color: var(--line-color);
  }
  .switch.is-checked:not(.is-disabled) .control:hover .thumb::before {
    background-color: rgba(171, 212, 255, 0.4);
    box-shadow: -0.1rem 0.1rem 0.1rem rgba(51, 51, 51, 0.2);
    transform: scale(1.8);
  }
}`;

// src/components/switch/switch.component.ts
var NineSwitch = class extends NineElement {
  constructor() {
    super(...arguments);
    this.formControlController = new FormControlController(this, {
      value: (control) => control.checked ? control.value || "on" : void 0,
      defaultValue: (control) => control.defaultChecked,
      setValue: (control, value) => control.checked = Boolean(value)
    });
    this.input = null;
    this.title = "";
    this.name = "";
    this.disabled = false;
    this.checkedInternal = false;
    this.form = "";
    this.required = false;
    this.defaultChecked = false;
    this.hasFocus = false;
    this.handleCheckedInternalChange = (_was, is) => {
      if (is !== this.checked) {
        this.emit("nine-change");
      }
    };
    this.handleCheckedChange = (_was, is) => {
      this.checkedInternal = is;
    };
    this.handleFocusChange = (was) => {
      if (!was) {
        this.emit("nine-focus");
      } else {
        this.emit("nine-blur");
      }
    };
  }
  get validity() {
    return this.input.validity;
  }
  get validationMessage() {
    return this.input.validationMessage;
  }
  /** Simulates a click on the switch. */
  click() {
    if (!this.input) return;
    this.input.click();
  }
  /** Sets focus on the switch. */
  focus(options) {
    if (!this.input) return;
    this.input.focus(options);
  }
  /** Removes focus from the switch. */
  blur() {
    this.input.blur();
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    if (!this.input) return false;
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    if (!this.input) return false;
    return this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(message) {
    if (!this.input) return;
    this.input.setCustomValidity(message);
    this.formControlController.updateValidity();
  }
  firstUpdated() {
    this.formControlController.updateValidity();
    if (typeof this.checked === "boolean") {
      this.checkedInternal = this.checked;
    }
  }
  setChecked(set) {
    if (this.isReactElement && typeof this.checked === "boolean") {
      this.emit("nine-change");
      return;
    }
    this.checkedInternal = set;
  }
  handleBlur() {
    this.hasFocus = false;
  }
  handleInput() {
    this.emit("nine-input");
  }
  handleInvalid(event) {
    this.formControlController.setValidity(false);
    this.formControlController.emitInvalidEvent(event);
  }
  handleClick() {
    this.setChecked(!this.checkedInternal);
  }
  handleFocus() {
    this.hasFocus = true;
  }
  handleKeyDown(event) {
    const currentChecked = this.checkedInternal;
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      this.setChecked(false);
    }
    if (event.key === "ArrowRight") {
      event.preventDefault();
      this.setChecked(true);
    }
    const changed = currentChecked !== this.checkedInternal;
    if (changed) {
      this.handleInput();
    }
  }
  render() {
    return html85`
      <label
        part="base"
        class=${classMap2({
      switch: true,
      "is-checked": this.checkedInternal,
      "is-disabled": this.disabled,
      "has-focus": this.hasFocus
    })}
      >
        <input
          class="input"
          type="checkbox"
          title=${this.title}
          name=${this.name}
          value=${ifDefined(this.value)}
          .checked=${live(this.checkedInternal)}
          .disabled=${this.disabled}
          .required=${this.required}
          role="switch"
          aria-checked=${this.checkedInternal ? "true" : "false"}
          @click=${this.handleClick}
          @input=${this.handleInput}
          @invalid=${this.handleInvalid}
          @blur=${this.handleBlur}
          @focus=${this.handleFocus}
          @keydown=${this.handleKeyDown}
        />
        <span part="control" class="control"><span part="thumb" class="thumb"></span></span>
        <slot part="label" class="switch__label"></slot>
      </label>
    `;
  }
};
NineSwitch.styles = unsafeCSS23(switch_default);
__decorateClass([
  query('input[type="checkbox"]')
], NineSwitch.prototype, "input", 2);
__decorateClass([
  property68()
], NineSwitch.prototype, "title", 2);
__decorateClass([
  property68()
], NineSwitch.prototype, "name", 2);
__decorateClass([
  property68()
], NineSwitch.prototype, "value", 2);
__decorateClass([
  property68({ type: Boolean, reflect: true })
], NineSwitch.prototype, "disabled", 2);
__decorateClass([
  property68({ type: Boolean, reflect: true })
], NineSwitch.prototype, "checked", 2);
__decorateClass([
  property68({ type: Boolean, reflect: false })
], NineSwitch.prototype, "checkedInternal", 2);
__decorateClass([
  property68({ reflect: true })
], NineSwitch.prototype, "form", 2);
__decorateClass([
  property68({ type: Boolean, reflect: true })
], NineSwitch.prototype, "required", 2);
__decorateClass([
  defaultValue("checked")
], NineSwitch.prototype, "defaultChecked", 2);
__decorateClass([
  state()
], NineSwitch.prototype, "hasFocus", 2);
__decorateClass([
  watch("checkedInternal", { waitUntilFirstUpdate: true })
], NineSwitch.prototype, "handleCheckedInternalChange", 2);
__decorateClass([
  watch("checked", { waitUntilFirstUpdate: true })
], NineSwitch.prototype, "handleCheckedChange", 2);
__decorateClass([
  watch("hasFocus", { waitUntilFirstUpdate: true })
], NineSwitch.prototype, "handleFocusChange", 2);

// src/components/switch/switch.ts
var switch_default2 = NineSwitch;
NineSwitch.define("nine-switch");

// src/components/table/row.component.ts
import { html as html86, unsafeCSS as unsafeCSS24 } from "lit";
import { property as property69 } from "lit/decorators.js";

// src/components/table/row.scss?inline
import { css as css110 } from "lit-element/lit-element.js";
var row_default = css110`:host {
  display: block;
}

:host(:not([border]):last-of-type) .row::after {
  display: none;
}

.title {
  font-weight: 500;
  margin-right: auto;
}

.label {
  font-weight: 300;
  color: var(--color-trout);
}

.row {
  display: flex;
  padding: var(--space-sm);
  position: relative;
}
.row[alignCenter=true] {
  align-items: center;
}
.row[px0=true] {
  padding-left: 0;
  padding-right: 0;
}
.row[py0=true] {
  padding-top: 0;
  padding-bottom: 0;
}
.row::after {
  content: "";
  display: block;
  height: 1px;
  background: var(--color-cream-dark);
  position: absolute;
  bottom: 1px;
  left: var(--space-sm);
  right: 0;
}
.row[px0=true]::after {
  left: 0;
}
.row[borderGrayLight=true]::after {
  background: var(--color-gray-light);
}
.row[ball=true]::before {
  content: "";
  display: block;
  width: 1em;
  min-width: 1em;
  height: 1em;
  background-color: var(--ball, #eee);
  border-radius: 50%;
  margin-right: 0.8em;
  transform: scale(1.2) translate(6%, 6%);
}
.row[clickable] {
  cursor: pointer;
}

@media screen and (min-width: 960px) {
  .row[pyLarge=true] {
    padding-top: var(--space-lg);
    padding-bottom: var(--space-lg);
  }
}`;

// src/components/table/row.component.ts
var NineRow = class extends NineElement {
  constructor() {
    super(...arguments);
    this.ball = "";
    this.border = false;
    this.px0 = false;
    this.py0 = false;
    this.pyLarge = false;
    this.borderGrayLight = false;
    this.alignCenter = false;
    this.clickable = false;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    this.onClick = () => {
    };
  }
  render() {
    return html86`
      <div
        class="row"
        px0="${this.px0}"
        py0="${this.py0}"
        pyLarge="${this.pyLarge}"
        borderGrayLight="${this.borderGrayLight}"
        alignCenter="${this.alignCenter}"
        ball="${this.ball !== ""}"
        @click=${this.onClick}
        ?clickable=${this.clickable}
        style="--ball: ${this.ball}"
      >
        <div class="title"><slot name="title"></slot></div>
        <div class="label"><slot name="label"></slot></div>
      </div>
    `;
  }
};
NineRow.styles = unsafeCSS24(row_default);
__decorateClass([
  property69({ type: String })
], NineRow.prototype, "ball", 2);
__decorateClass([
  property69({ type: Boolean })
], NineRow.prototype, "border", 2);
__decorateClass([
  property69({ type: Boolean })
], NineRow.prototype, "px0", 2);
__decorateClass([
  property69({ type: Boolean })
], NineRow.prototype, "py0", 2);
__decorateClass([
  property69({ type: Boolean })
], NineRow.prototype, "pyLarge", 2);
__decorateClass([
  property69({ type: Boolean })
], NineRow.prototype, "borderGrayLight", 2);
__decorateClass([
  property69({ type: Boolean })
], NineRow.prototype, "alignCenter", 2);
__decorateClass([
  property69({ type: Boolean })
], NineRow.prototype, "clickable", 2);
__decorateClass([
  property69({ type: Function })
], NineRow.prototype, "onClick", 2);

// src/components/table/row.ts
var row_default2 = NineRow;
NineRow.define("nine-row");

// src/components/table/table.component.ts
import { css as css111, html as html87 } from "lit";
import { property as property70 } from "lit/decorators.js";
var NineTable = class extends NineElement {
  constructor() {
    super();
    this.shadow = "false";
    this.showTitle = "true";
    this.gradient = "false";
  }
  render() {
    return html87`<div class="table">
      <div class="rows">
        ${this.showTitle === "true" ? html87`<nine-row border>
              <div slot="title"><slot name="title"></slot></div>
            </nine-row>` : html87``}
        <slot></slot>
      </div>
    </div>`;
  }
};
NineTable.styles = css111`
    :host {
      display: block;
      border-radius: var(--border-radius);
      background: var(--color-white);
      overflow: hidden;
    }

    :host([shadow="true"]) {
      box-shadow: var(--light-shadow);
    }

    .rows {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .table::after {
      content: "";
      display: block;
      height: var(--border-radius);
      background: var(--gradient-sunrise);
    }

    :host([gradient="false"]) .table::after {
      content: none;
    }

    ::slotted(h5) {
      font-weight: 500;
      margin: 0em 0 !important;
      font-size: var(--font-size);
    }
  `;
__decorateClass([
  property70({ type: String, reflect: true })
], NineTable.prototype, "shadow", 2);
__decorateClass([
  property70({ type: String })
], NineTable.prototype, "showTitle", 2);
__decorateClass([
  property70({ type: String, reflect: true })
], NineTable.prototype, "gradient", 2);

// src/components/table/table.ts
var table_default = NineTable;
NineTable.define("nine-table");

// src/components/tabs/tabs-item.component.ts
import { css as css112, html as html88 } from "lit";
import { property as property71 } from "lit/decorators.js";
var NineTabsItem = class extends NineElement {
  constructor() {
    super();
    this.header = "";
  }
  firstUpdated() {
    if (!this.header) return;
    this.dispatchEvent(
      new CustomEvent("nine-add-item", {
        detail: {
          name: this.header,
          item: this
        },
        bubbles: true
      })
    );
  }
  render() {
    return html88`<slot></slot>`;
  }
};
NineTabsItem.styles = css112`
    :host {
      width: 0;
      height: 0;
      overflow: hidden;
      opacity: 0;
      pointer-events: none;
      flex: 1;
      transition: opacity var(--time);
      transition-delay: 0;
    }

    :host(.active) {
      width: 100%;
      height: auto;
      opacity: 1;
      pointer-events: all;
      transition-delay: calc(var(--time) * 2);
    }
  `;
__decorateClass([
  property71({ type: String })
], NineTabsItem.prototype, "header", 2);

// src/components/tabs/tabs-item.ts
var tabs_item_default = NineTabsItem;
NineTabsItem.define("nine-tabs-item");

// src/components/tabs/tabs.component.ts
import { css as css113, html as html89 } from "lit";
import { property as property72 } from "lit/decorators.js";
import { createRef as createRef19, ref as ref19 } from "lit/directives/ref.js";
var NineTabs = class extends NineElement {
  constructor() {
    super();
    this.tabsRef = createRef19();
    this.listenForItems = () => {
      this.addEventListener("nine-add-item", this.handleAddItem);
    };
    this.handleAddItem = (event) => {
      var _a2, _b, _c;
      if (!((_a2 = event == null ? void 0 : event.detail) == null ? void 0 : _a2.name)) return;
      this.items = [...this.items, event.detail];
      if (this.selected === void 0) {
        this.selected = event.detail;
        event.detail.item.classList.add("active");
        event.detail.item.setAttribute("aria-hidden", "false");
        (_b = this.tabsRef.value) == null ? void 0 : _b.style.setProperty("--tabs-index", "0");
      } else {
        event.detail.item.setAttribute("aria-hidden", "true");
      }
      (_c = this.tabsRef.value) == null ? void 0 : _c.style.setProperty(
        "--tabs-count",
        this.items.length.toString()
      );
    };
    this.handleChange = (selected) => () => {
      var _a2;
      this.selected = selected;
      for (const item of this.items) {
        if (item === selected) {
          item.item.classList.add("active");
          item.item.setAttribute("aria-hidden", "false");
          item.item.focus();
          const activeIndex = this.items.indexOf(item);
          (_a2 = this.tabsRef.value) == null ? void 0 : _a2.style.setProperty("--tabs-index", `${activeIndex}`);
        } else {
          item.item.classList.remove("active");
          item.item.setAttribute("aria-hidden", "true");
        }
      }
    };
    this.items = [];
    this.name = `id_${Math.random()}`;
    this.listenForItems();
  }
  render() {
    return html89`
      <div class="tabs" ${ref19(this.tabsRef)}>
        <div class="header">
          ${this.items.map(
      (item) => html89`<label>
                ${this.selected === item ? html89`
                      <input
                        type="radio"
                        name="${this.name}"
                        value="${item}"
                        checked="checked"
                        @change="${this.handleChange(item)}"
                      />
                    ` : html89`
                      <input
                        type="radio"
                        name="${this.name}"
                        value="${item}"
                        @change="${this.handleChange(item)}"
                      />
                    `}
                <div>${item.name}</div>
              </label>`
    )}
        </div>
        <div class="content">
          <slot></slot>
        </div>
      </div>
    `;
  }
};
NineTabs.styles = css113`
    :host {
      display: block;
      margin: 1.5em 0 0;
    }

    label {
      display: block;
    }

    .header {
      display: flex;
      padding: 0.5rem 0;
      grid-gap: 1em;
      margin: 0 0 0.9em;
    }

    input {
      opacity: 0;
      position: absolute;
      pointer-events: none;
    }

    input + div {
      display: block;
      padding: 0;
      cursor: pointer;
      position: relative;
      color: var(--color-charcoal-80);
      font-weight: 500;
    }

    input + div:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 0.16em;
      transform: translateY(30%);
      background: var(--gradient-sunrise);
      opacity: 0;
      transition: opacity calc(var(--ease-time) * 4) var(--ease-type);
    }

    input:checked + div {
      color: var(--color-charcoal);
    }
    input:checked + div:after {
      opacity: 1;
    }

    .content {
      --time: calc(var(--ease-time) * 0.8);
      display: flex;
      width: calc(100% * var(--tabs-count));
      pointer-events: none;
      transform: translateX(
        calc(var(--tabs-index) / var(--tabs-count) * -100%)
      );
      transition: transform var(--time);
      transition-delay: var(--time);
    }
  `;
__decorateClass([
  property72()
], NineTabs.prototype, "items", 2);
__decorateClass([
  property72()
], NineTabs.prototype, "selected", 2);
__decorateClass([
  property72()
], NineTabs.prototype, "name", 2);

// src/components/tabs/tabs.ts
var tabs_default = NineTabs;
NineTabs.define("nine-tabs");

// src/components/task/task.component.ts
import { html as html90, unsafeCSS as unsafeCSS25 } from "lit";
import { property as property73 } from "lit/decorators.js";

// src/components/task/task.global.scss?inline
import { css as css114 } from "lit-element/lit-element.js";
var task_global_default = css114`nine-task [slot=content] > :not(:last-child) {
  position: relative;
  margin-right: calc(var(--space-sm) * 1.5);
}
nine-task [slot=content] > :not(:last-child)::after {
  content: "";
  position: absolute;
  right: calc(var(--space-sm) * -1.5);
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: calc(var(--space-sm) * 1.825);
  background-color: var(--color-gray-lighter);
  pointer-events: none;
}`;

// src/components/task/task.scss?inline
import { css as css115 } from "lit-element/lit-element.js";
var task_default = css115`:host {
  display: block;
}

::slotted([slot=title]) {
  font-weight: 500;
  font-size: calc(var(--font-size) * 1.125);
  line-height: 140%;
  letter-spacing: -0.02em;
}

::slotted([slot=subtitle]) {
  font-weight: 400;
  font-size: var(--font-size);
  line-height: 140%;
  letter-spacing: -0.02em;
  margin-top: calc(var(--space-sm) * 0.25);
}

::slotted([slot=content]) {
  font-weight: 400;
  margin-top: var(--space-sm);
  margin-bottom: calc(var(--space-sm) * 0.25);
  display: flex;
  align-items: center;
  gap: calc(var(--space-sm) * 1.5);
}

.wrapper div {
  position: relative;
  padding-top: 5px;
  padding-left: calc(var(--space-lg) + var(--space-sm) * 1.5);
  padding-bottom: calc(var(--space-sm) * 1.25);
  color: var(--color-charcoal-60);
}

.wrapper[status=in-progress] div {
  color: var(--color-charcoal);
}

.wrapper[status=done] div {
  color: var(--color-gray);
  text-decoration: line-through;
}

.absolute {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--space-lg);
  height: var(--space-lg);
  border-radius: 50%;
  background: var(--color-gray-lighter);
}

.wrapper:not([status=to-do]) .absolute {
  --gradient-dir: 180.56deg;
  background-image: var(--wcl-bg-gradient-sunrise, linear-gradient(var(--gradient-dir), var(--color-sunrise-blue) 13.49%, var(--color-sunrise-pink) 51.22%, var(--color-sunrise-orange) 85.11%));
}

.wrapper[status=in-progress] .absolute::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  width: calc(var(--space-sm) * 1.1);
  height: calc(var(--space-sm) * 1.1);
  border-radius: 50%;
  --gradient-dir: 0deg;
  background-image: var(--wcl-bg-gradient-dusk, linear-gradient(var(--gradient-dir), #0e3763 0%, #5b4855 52.6%, #8a6947 100%));
}

.wrapper[status=done] .absolute::before {
  content: url('data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24"><path fill="%23212121" d="M9.225 18 4 12.775l.775-.75 4.45 4.45L18.675 7l.8.775L9.225 18Z"/></svg>');
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  width: calc(var(--space-sm) * 1.125);
  height: calc(var(--space-sm) * 1.125);
}

.absolute::after {
  content: "";
  position: absolute;
  inset: 1px;
  border-radius: 50%;
  background: #fff;
}

.wrapper:not([status=to-do]) .absolute::after {
  --gradient-dir: 180.56deg;
  background-image: var(--wcl-bg-gradient-sunrise-lightest, linear-gradient(var(--gradient-dir), #c1d7fb 13.49%, #fddee9 50.42%, #ffdfb4 85.11%));
}

.wrapper div::after {
  content: "";
  position: absolute;
  top: var(--space-lg);
  left: calc(var(--space-sm) - 0.5px);
  width: 1px;
  height: calc(100% - var(--space-lg));
  background: var(--color-gray-lighter);
}

.wrapper[status=done] div::after {
  transform: rotate(-180deg);
  --gradient-dir: 180.56deg;
  background-image: var(--wcl-bg-gradient-sunrise, linear-gradient(var(--gradient-dir), var(--color-sunrise-blue) 13.49%, var(--color-sunrise-pink) 51.22%, var(--color-sunrise-orange) 85.11%));
}

:host(:last-of-type) .wrapper div::after {
  display: none;
}

@media screen and (min-width: 960px) {
  .wrapper div {
    padding-bottom: calc(var(--space-sm) * 1.5);
  }
  ::slotted([slot=title]) {
    font-size: var(--font-size-h5);
  }
  ::slotted([slot=content]) {
    margin-top: var(--space-sm);
    margin-bottom: calc(var(--space-sm) * 0.5);
  }
}`;

// src/components/task/task.component.ts
styleInject_default(task_global_default);
var NineTask = class extends NineElement {
  constructor() {
    super(...arguments);
    this.status = "to-do";
  }
  render() {
    return html90`
            <div class="wrapper" status="${this.status}">
                <div>
                    <span class="absolute"></span>
                    <slot name="title"></slot>
                    <slot name="subtitle"></slot>
                    <slot name="content"></slot>
                </div>
            </div>
        `;
  }
};
NineTask.styles = unsafeCSS25(task_default);
__decorateClass([
  property73({ type: String })
], NineTask.prototype, "status", 2);

// src/components/task/task.ts
var task_default2 = NineTask;
NineTask.define("nine-task");

// src/components/tooltip/tooltip.component.ts
import { html as html91, css as css116 } from "lit";
import { property as property74 } from "lit/decorators.js";
var Tooltip = class extends NineElement {
  constructor() {
    super(...arguments);
    this.text = "";
  }
  render() {
    return html91`
      <div class="hoveredElement">
        <slot></slot>
      </div>
      <div class="tooltip"><span class="tooltiptext">${this.text}</span></div>
    `;
  }
};
Tooltip.styles = css116`
    :host {
      position: relative;
    }

    .tooltip {
      position: absolute;
      z-index: 1;
      background: var(--greys-charcoal, #212121);
      color: #fff;
      border-radius: 2px;
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
      margin-top: 8px;
      display: flex;
      max-width: 250px;
      padding: 4px 8px;
      align-items: flex-start;
      gap: 10px;

      color: var(--greys-white, #fff);
      font-family: STK Bureau;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
    }

    .hoveredElement {
      cursor: pointer;
    }

    .tooltip .tooltiptext::after {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent var(--greys-charcoal, #212121) transparent;
    }

    :host(:hover) .tooltip {
      visibility: visible;
      opacity: 1;
    }
  `;
__decorateClass([
  property74({ type: String })
], Tooltip.prototype, "text", 2);

// src/components/tooltip/tooltip.ts
var tooltip_default = Tooltip;
Tooltip.define("nine-tooltip");

// src/components/upload/upload.component.ts
import { css as css117, html as html92 } from "lit";
import { property as property75 } from "lit/decorators.js";
var i = 10;
var rndImage = () => {
  i++;
  return `https://picsum.photos/id/${i}/800/800`;
};
var NineUpload = class extends NineElement {
  constructor() {
    super(...arguments);
    this.variant = "photo";
  }
  handleChange(e) {
    var _a2, _b, _c, _d;
    const file = (_b = (_a2 = e.target.files) == null ? void 0 : _a2[0]) != null ? _b : null;
    if (file) {
      const img = (_c = this.shadowRoot) == null ? void 0 : _c.querySelector("img");
      if (img) {
        img.setAttribute("src", rndImage());
        img.style.display = "block";
      }
      const label = (_d = this.shadowRoot) == null ? void 0 : _d.querySelector("label");
      if (label) {
        label.style.display = "block";
      }
    }
  }
  render() {
    return html92`
      <div class="flex">
        <input id="file" type="file" @change=${this.handleChange} />
        ${this.variant === "photo" ? html92`
              ${UploadPictureIcon}
              <p class="hide-mobile">Drop or <u>upload photo</u></p>
              <p class="hide-desktop"><u>Upload photo</u></p>
            ` : html92`
              ${UploadIDIcon}
              <p class="hide-mobile">Drop or <u>upload ID</u></p>
              <p class="hide-desktop"><u>Upload ID</u></p>
            `}
        <img src="" alt="" />
      </div>

      <label for="file">
        <small>Re-upload photo</small>
      </label>
    `;
  }
};
NineUpload.styles = css117`
    :host {
      display: block;
      text-align: center;
      max-width: 327px;
    }

    .flex {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: calc(var(--space-sm) * 11.25);
      background: var(--color-cream-dark);
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: calc(var(--space-sm) * 0.5);
    }

    svg {
      width: calc(var(--space-sm) * 4.5);
      height: calc(var(--space-sm) * 4.5);
    }

    svg path {
      fill: var(--color-charcoal-60);
    }

    p {
      margin: calc(var(--space-sm) * 0.25) 0 0;
    }

    small {
      font-weight: 500;
      /* font-size: 14px; */
      font-size: calc(var(--sm-scale) * 0.88);
      line-height: 140%;
      letter-spacing: -0.02em;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      display: none;
    }

    label {
      display: none;
      cursor: pointer;
      margin-top: var(--space-sm);
    }

    input[type="file"] {
      width: 100%;
      height: 100%;
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    input[type="file"]::file-selector-button {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    .hide-mobile {
      display: none;
    }

    @media screen and (min-width: 740px) {
      .flex {
        height: calc(var(--space-sm) * 13.75);
        margin-top: 0;
      }

      .hide-desktop {
        display: none;
      }

      .hide-mobile {
        display: initial;
      }
    }
  `;
__decorateClass([
  property75({ type: String })
], NineUpload.prototype, "variant", 2);

// src/components/upload/upload.ts
var upload_default = NineUpload;
NineUpload.define("nine-upload");

// src/components/viewport/viewport.component.ts
import { css as css118, html as html93 } from "lit";
import { property as property76 } from "lit/decorators.js";
import { createRef as createRef20, ref as ref20 } from "lit/directives/ref.js";
var NineViewport = class extends NineElement {
  constructor() {
    super();
    this.elRef = createRef20();
    this.relatedLink = [];
    // contentChangeObserver: MutationObserver | null = null;
    this.lastContentHeight = 0;
    this.checkContentContainerHeightInterval = 0;
    this.scrollAnimation = null;
    this.ignoreSiblingChange = false;
    this.siblingChangeDebounce = 0;
    this.animateScrollIntoView = (animationTime = 1200) => {
      const screenHeight = getMainScrollElementHeight();
      const el = this.elRef.value;
      const elPos = el.getBoundingClientRect();
      const activeBuffer = screenHeight * this.activeBuffer;
      if (this.scrollAnimation) {
        this.scrollAnimation.stop();
      }
      this.scrollAnimation = animate(
        animationTime,
        (progress) => {
          scrollMainTo(0, progress);
        },
        {
          range: [
            getMainScrollPosition().y,
            getMainScrollPosition().y + elPos.top - activeBuffer
          ]
        }
      );
    };
    this.checkIfLinkMatchesHash = () => {
      const hash = window.location.hash;
      const match = hash === `#${this.name}`;
      return match;
    };
    this.setupLinks = () => {
      this.relatedLink = Array.from(
        document.querySelectorAll(`a[href="#${this.name}"]`)
      );
      for (const link of this.relatedLink) {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          window.location.hash = this.name;
          this.ignoreSiblingChange = true;
          this.animateScrollIntoView();
          setTimeout(() => {
            this.animateScrollIntoView();
            this.ignoreSiblingChange = false;
          }, 500);
        });
        if (this.checkIfLinkMatchesHash()) {
          this.animateScrollIntoView();
        }
      }
      window.addEventListener("load", () => {
        if (this.checkIfLinkMatchesHash()) {
          this.animateScrollIntoView();
        }
      });
    };
    this.checkFocus = () => {
      try {
        const screenHeight = window.innerHeight;
        const activeBuffer = screenHeight * this.activeBuffer;
        const fullActivePercent = screenHeight * this.fullActivePercent;
        let setFocused = this.focused;
        const el = this.elRef.value;
        const rect = el == null ? void 0 : el.getBoundingClientRect();
        if (rect) {
          const elPercentTop = Math.max(
            (rect.top - fullActivePercent) / (screenHeight - fullActivePercent),
            0
          );
          this.style.setProperty(
            "--active-p",
            `${1 - elPercentTop * this.fadeScale}`
          );
          if (rect.top + rect.height - activeBuffer > 0 && rect.bottom < window.innerHeight + rect.height - activeBuffer && rect.top + rect.height > activeBuffer * 1.2) {
            setFocused = "true";
          } else {
            setFocused = "false";
          }
          if (setFocused !== this.focused) {
            this.focused = setFocused;
            this.onFocusesChanged(setFocused === "true");
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    this.focused = "false";
    this.fade = "false";
    this.margin = "";
    this.marginDesktop = "";
    this.name = "";
    this.activeBuffer = 0.25;
    this.fullActivePercent = 0.25;
    this.fadeScale = 1;
  }
  firstUpdated() {
    this.setupLinks();
    addScrollListener(this.checkFocus, {
      passive: true
    });
    window.addEventListener("resize", this.checkFocus, { passive: true });
    window.addEventListener("DOMContentLoaded", this.checkFocus);
    this.addContentChangeListener();
    this.checkFocus();
  }
  addContentChangeListener() {
    const contentEl = this.closest("nine-content");
    if (contentEl) {
      this.checkContentContainerHeightInterval = window.setInterval(() => {
        if (this.lastContentHeight !== contentEl.clientHeight) {
          this.handleSiblingContentChange();
          this.lastContentHeight = contentEl.clientHeight;
        }
      }, 200);
    }
  }
  handleSiblingContentChange() {
    clearTimeout(this.siblingChangeDebounce);
    this.siblingChangeDebounce = window.setTimeout(() => {
      if (this.checkIfLinkMatchesHash() && !this.ignoreSiblingChange) {
        this.animateScrollIntoView(200);
      }
    }, 20);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    removeScrollListener(this.checkFocus);
    window.removeEventListener("resize", this.checkFocus);
    window.clearInterval(this.checkContentContainerHeightInterval);
  }
  onFocusesChanged(newValue) {
    for (const link of this.relatedLink) {
      link.setAttribute("data-active", `${newValue}`);
      const parentEl = link.parentElement;
      if (parentEl && parentEl.tagName === "LI") {
        parentEl.setAttribute("data-active", `${newValue}`);
      }
    }
  }
  render() {
    return html93`
            <div
                    class="el"
                    focus=${this.focused}
                    fade="${this.fade}"
                    style="
          --margin: var(--space-${this.margin});
          --margin-desktop: var(--space-${this.marginDesktop})
        "
                    ${ref20(this.elRef)}
            >
                <slot></slot>
            </div>
        `;
  }
};
NineViewport.styles = css118`
      :host {
        display: block;
        width: 100%;
      }

      .el {
        height: 100%;
        margin: var(--margin) 0;
      }

      :host(:first-of-type) .el {
        margin-top: 0;
      }

      :host(:last-of-type) .el {
        margin-bottom: 0;
      }

      .el[fade="true"] {
        opacity: var(--active-p);
      }

      @media screen and (min-width: ${LAYOUT_SWITCH_AT}px) {
        .el {
          margin: var(--margin-desktop, var(--margin)) 0;
        }
      }
    `;
__decorateClass([
  property76({ type: String })
], NineViewport.prototype, "focused", 2);
__decorateClass([
  property76()
], NineViewport.prototype, "fade", 2);
__decorateClass([
  property76()
], NineViewport.prototype, "margin", 2);
__decorateClass([
  property76()
], NineViewport.prototype, "marginDesktop", 2);
__decorateClass([
  property76()
], NineViewport.prototype, "name", 2);
__decorateClass([
  property76()
], NineViewport.prototype, "activeBuffer", 2);
__decorateClass([
  property76()
], NineViewport.prototype, "fullActivePercent", 2);
__decorateClass([
  property76({ type: Number })
], NineViewport.prototype, "fadeScale", 2);

// src/components/viewport/viewport.ts
var viewport_default = NineViewport;
NineViewport.define("nine-viewport");

// src/components/virtual-list/virtual-list.ts
var virtual_list_default2 = NineVirtualList;
NineVirtualList.define("nine-virtual-list");

// src/components/wrapper/wrapper.component.ts
import { css as css119, html as html94 } from "lit";
var NineWrapper = class extends NineElement {
  render() {
    return html94`
      <div class="wrapper">
        <slot></slot>
      </div>
    `;
  }
};
NineWrapper.styles = css119`
    :host {
      display: block;
    }

    .wrapper {
      display: flex;
      flex-direction: column;
    }
  `;

// src/components/wrapper/wrapper.ts
var wrapper_default = NineWrapper;
NineWrapper.define("nine-wrapper");
export {
  actionButton_default2 as NineActionButton,
  actions_default as NineActions,
  additional_benefits_default as NineAdditionalBenefits,
  answer_item_default2 as NineAnswerItem,
  answer_item_list_default2 as NineAnswerItemList,
  article_card_default as NineArticleCard,
  article_detail_default2 as NineArticleDetail,
  article_filter_default as NineArticleFilter,
  article_grid_default as NineArticleGrid,
  article_preview_default as NineArticlePreview,
  avatar_default2 as NineAvatar,
  avatar_list_default as NineAvatarList,
  benefit_default as NineBenefit,
  bg_default2 as NineBg,
  bottom_navbar_default as NineBottomNavbar,
  breadcrumbs_default as NineBreadcrumbs,
  button_default2 as NineButton,
  card_default2 as NineCard,
  card_grid_default as NineCardGrid,
  card_list_default as NineCardList,
  cell_default as NineCell,
  center_default as NineCenter,
  checkbox_default2 as NineCheckbox,
  checklist_default as NineChecklist,
  circle_default as NineCircle,
  content_default as NineContent,
  datepicker_default as NineDatepicker,
  dropdown_default as NineDropdown,
  embed_default as NineEmbed,
  emoji_to_bullet_default as NineEmojiToBullet,
  feature_card_default as NineFeatureCard,
  feature_card_list_default as NineFeatureCardList,
  form_default as NineForm,
  grid_default as NineGrid,
  grid_item_default as NineGridItem,
  heading_default as NineHeading,
  helper_default as NineHelper,
  highlights_default as NineHighlights,
  icon_default as NineIcon,
  icon_link_default as NineIconLink,
  icon_list_default as NineIconList,
  identify_default as NineIdentify,
  iframe_default as NineIframe,
  image_list_default as NineImageList,
  info_container_default as NineInfoContainer,
  info_row_default as NineInfoRow,
  info_section_default as NineInfoSection,
  infobar_default2 as NineInfobar,
  inline_cta_default as NineInlineCta,
  input_default2 as NineInput,
  item_default as NineItem,
  lab_value_default as NineLabValue,
  language_select_default2 as NineLanguageSelect,
  layout_grid_default as NineLayoutGrid,
  loading_overlay_default as NineLoadingOverlay,
  logo_default as NineLogo,
  logo_list_default as NineLogoList,
  message_default2 as NineMessage,
  messageList_default as NineMessageList,
  nav_menu_default2 as NineNavMenu,
  navigation_default2 as NineNavigation,
  overlay_default2 as NineOverlay,
  overlay_trigger_default as NineOverlayTrigger,
  parse_text_default as NineParseText,
  person_default as NinePerson,
  pill_default as NinePill,
  progress_default as NineProgress,
  progress_bar_default as NineProgressBar,
  promotion_default as NinePromotion,
  roi_calculator_result_default as NineRoiCalculatorResult,
  row_default2 as NineRow,
  scrolling_default as NineScrolling,
  select_default2 as NineSelect,
  select_menu_default2 as NineSelectMenu,
  side_step_row_default as NineSideStepRow,
  slider_default2 as NineSlider,
  slider_with_input_default2 as NineSliderWithInput,
  spacer_default as NineSpacer,
  stat_item_default2 as NineStatItem,
  statistics_default as NineStatistics,
  stepper_default as NineStepper,
  sticky_default as NineSticky,
  switch_default2 as NineSwitch,
  table_default as NineTable,
  tabs_default as NineTabs,
  tabs_item_default as NineTabsItem,
  task_default2 as NineTask,
  tooltip_default as NineTooltip,
  upload_default as NineUpload,
  viewport_default as NineViewport,
  virtual_list_default2 as NineVirtualList,
  wrapper_default as NineWrapper,
  ParseTextElements
};
